import { InvalidStateError, UnsupportedError } from "mediasoup-client/lib/errors";

import ConstData from "./ConstData";
import { relayLive } from "./relay/PentalkRelayCamera"; // 20261020 C3 송출 소유자 판정
import { stCallKind } from "./ConstCommand";
import { enFrame, enImage, enP2PMode } from "./classTalk/CodeEnum";
import { isSmartTVMediaTraceEnabled, recordSmartTVMediaTrace } from "./SmartTVMediaTrace";
import { addMediaError } from "./MediaErrorLog"; // 20260904 미디어수프 통신/재생 오류 누적 로그 ... by claude
import { sendLiveConsumeOnce, resetLiveConsume } from "./helper/LiveConsumeGuard"; // 20261028 선생님 live consume 중복 방지 (web-relay R-207)

import {
    callCurrentFuncProc
} from "./rbmq/rcvMsgFromRbmq";

import {
    disconnectRbmq,
    getIsNeedCleanUp,
    getIsSmartTVCurrentPage,
    sendCommandToRbmq,
    sendObjectToRbmq,
    sendP2PSoundOn,
    sendP2PSoundOff,
    reconnectLive,
    sendHandsUpInitDone,
    xmitCmd_AndroidInitDone,
    sendStartPentalkOnScreenForIOS,
} from "./RabbitmqClient";

import {
    checkIOSPenCamService,
    checkAndroidPenCamService,
    checkAndroidScreenValue,
    clearAudioInput,
    clearVideoInput,
    getIsForPblModeBrowser,
    getIsPblGroupProAudioMode,
    getMicStatusEnabled,
    isAndroidWebView,
    isIOSWebView,
    sendChangeViewKindToApp,
    sendMicStatus
} from "./HandsUpClient";

import {
    listenAudioConsumeHelper,
    listenMicConsumeHelper,
    liveConnectionStateHelper,
    mediaConsumeReadyHelper,
    muteAudioConsumeHelper,
    muteMicConsumeHelper
} from "./helper/MediaSoupPblHelper";

import {
    mqRcvMediaInfo
} from "../modules/admin";

import {
    changeLiveStatusInfo,
    toggleReadyLiveConsume
} from "../modules/live";

import { isDevVersion, isUsableArrayObj, sendToStudentApp } from "./func/ExportFunction";

import { createIceRestartCoordinator } from "./mediasoup/iceRestartCoordinator";
import { createAndroidSendIceRestart } from "./mediasoup/androidSendIceRestart";
import { createSendRecreateWatch, SEND_RECREATE_WATCH_MS, SEND_CONNECT_TIMEOUT_REASON } from "./mediasoup/sendRecreateWatch";
import { createSendExitGuard } from "./mediasoup/sendExitGuard"; // 20261028 학생 송출 종료 owner·종료 작업 판단 (web-relay R-224)
import { createSendExitHooks, closeObject } from "./mediasoup/sendExitCleanup"; // 20261028 학생 송출 종료 정리 (web-relay R-224)
import { createSendOpGuard, SEND_OP_RESULT } from "./mediasoup/sendOpGuard"; // 20261030 송출 SDK 작업 대상·트랙 사용 판정 (web-relay R-264·R-266·R-267)
import { beginMixerExitSnapshot, releaseMixerExitSnapshot, endMixerExitSnapshot } from "./helper/HandsUpMixerInputCleanup"; // 20261029 캡처 입력 종료 스냅샷 (web-relay R-257)

const mediasoup = require("mediasoup-client");

let isDevVer = false;           // 20251113 ... 임시 for 안드로이드 Pro 앱 테스트를 위한 디버그 버전용인지 여부를 나타내는 값 ... by hjkim

// let delayTimeOffet = 100;       // 20250811 ... 스마트TV와 모둠 수업 멤버 joinConsume 요청 delayTime 멤버 배열 인덱스에 곱해줄 기본값 ... by hjkim
// let delayTimeOffet = 2000;      // 20250811 ... 스마트TV와 모둠 수업 멤버 joinConsume 요청 delayTime 멤버 배열 인덱스에 곱해줄 기본값 ... by hjkim
// let delayTimeOffet = 1000;      // 20250811 ... 스마트TV와 모둠 수업 멤버 joinConsume 요청 delayTime 멤버 배열 인덱스에 곱해줄 기본값 ... by hjkim
let delayTimeOffet = 500;      // 20250811 ... 스마트TV와 모둠 수업 멤버 joinConsume 요청 delayTime 멤버 배열 인덱스에 곱해줄 기본값 ... by hjkim
let reConsumeDelayTime = 1000;  // 20250811 ... 스마트TV에서 영상 재생 오류 발생 시 unsubscribe 요청 후 다시 cosume 요청할 때 사용할 delayTime ... by hjkim

let videoStateIntervalTime = 2500;   // 20250811 ... 스마트TV에서 영상 재생에 성공했는지 확인하기 위한 interval의 시간 ... by hjkim

let resolutionChangeInProgress = false;

let smartTVMediaTraceRequestSeq = 0;

// 20260805 Phase 0 진단 규격: media_soup/server와 로그를 대조하기 위한 공통 접두사 및 requestId 생성기.
// 진단(추적) 전용이며 재시도/멱등성 판단에는 아직 사용하지 않는다.
const SMARTTV_MEDIA_TRACE_PREFIX = "[SMARTTV_MEDIA_TRACE]";

// 20260807 코덱 미지원 실패를 현재 수신 화면의 중앙 모달로 전달한다.
export const MEDIA_SOUP_UNSUPPORTED_CODEC_EVENT = "hiclasstv:media-unsupported-codec";

// 20260910 실제 -90도 화면 공유 producer 생성 완료 상태를 하단 툴바에 전달한다.
export const MEDIA_SOUP_DISPLAY_ROTATION_STATUS_EVENT = "hiclasstv-display-rotation-status";

/**
 * mediasoup 기기/전송 관련 예외 중 UnsupportedError를 화면 표시용 이벤트로 전달한다.
 * 
 * @param {Object} rtnValue - UnsupportedError 관련 정보 객체
 * @since 2026-08-07.
 */
const notifyUnsupportedMediaCodec = (rtnValue) => {
    if (typeof window === "undefined" || typeof window.dispatchEvent !== "function") return;
    window.dispatchEvent(new CustomEvent(MEDIA_SOUP_UNSUPPORTED_CODEC_EVENT, { detail: rtnValue }));
}

/**
 * mimeType(예: "video/vp9")을 화면 표시용 { kindLabel, codecName } 형태로 변환한다.
 * config.js의 mediaCodecs가 바뀌어도 하드코딩 매핑 없이 그대로 대응하기 위해 문자열만 파싱한다.
 * 
 * @param {String} mimeType - MIME 유형
 * @returns {Object|null} 변환된 코덱 정보 또는 null
 * @since 2026-09-04.
 */
export const formatCodecInfo = (mimeType) => {
    if (!mimeType || typeof mimeType !== "string" || mimeType.indexOf("/") === -1) return null;
    const [kind, codec] = mimeType.split("/");
    return {
        kindLabel: kind === "audio" ? "음성" : "영상",
        codecName: codec ? codec.toUpperCase() : "알 수 없음"
    };
}

/**
 * 오류 로그 패널에서 userSeq만으로도 닉네임을 보여줄 수 있도록 clientInfo/Redux store를 순서대로 조회한다.
 * 스마트TV(clientInfo)와 PC(Redux store) 양쪽에서 값이 있을 수 있어 둘 다 확인하며, 못 찾으면 null을 반환한다.
 * 
 * @param {Number} userSeq 
 * @returns {String|null} 닉네임 또는 null
 * @since 2026-09-04.
 */
export const getUserNicknameBySeq = (userSeq) => {
    if (userSeq === undefined || userSeq === null || userSeq === -1) return null;

    if (clientInfo.rcvTeacherInfo && clientInfo.rcvTeacherInfo.userSeq === userSeq && clientInfo.rcvTeacherInfo.userNickname) {
        return clientInfo.rcvTeacherInfo.userNickname;
    }

    if (Array.isArray(clientInfo.userSeqArr)) {
        const found = clientInfo.userSeqArr.find(user => user && user.userSeq === userSeq);
        if (found && found.userNickname) return found.userNickname;
    }

    try {
        const store = window.hiclasstv && window.hiclasstv.store;
        const performLiveInfo = store && store.getState().live && store.getState().live.performLiveInfo;
        if (performLiveInfo) {
            if (performLiveInfo.teacher_info && performLiveInfo.teacher_info.userSeq === userSeq && performLiveInfo.teacher_info.userNickname) {
                return performLiveInfo.teacher_info.userNickname;
            }
            if (Array.isArray(performLiveInfo.list_member)) {
                const memberFound = performLiveInfo.list_member.find(member => member && member.userSeq === userSeq);
                if (memberFound && memberFound.userNickname) return memberFound.userNickname;
            }
        }
    } catch (err) {
        // 조회 실패 시 폴백(사용자 #seq)을 그대로 사용한다.
    }

    return null;
}

/**
 * mediasoup 기기/전송 관련 예외를 MediaErrorLog에 기록한다.
 * mediasoup 기기/전송 관련 예외를 alert()로 노출하는 대신 누적 오류 로그(MediaErrorLog)에 기록한다.
 * 기존 콘솔 로그와 재시도/상태 변경 로직은 그대로 두고, 사용자 알림 수단만 팝업에서 로그로 바꾼다.
 * 
 * @param {Error} err - mediasoup 기기/전송 관련 예외 객체
 * @param {Object} extra - 추가 정보(예: { userSeq, liveSeq, mediaKind, codecInfo })
 * @since 2026-09-04.
 */
const logMediaDeviceError = (err, extra = {}) => {
    let errorCode = "UNEXPECTED_SERVER_ERROR";
    if (err instanceof UnsupportedError) errorCode = "UnsupportedError";
    else if (err instanceof InvalidStateError) errorCode = "InvalidStateError";
    else if (err instanceof TypeError) errorCode = "TypeError";
    addMediaError({ errorCode, ...extra });
}

/**
 * 스마트TV 미디어 추적 requestId를 생성한다.
 * 
 * @returns {String} requestId - 스마트TV 미디어 추적 requestId
 * @since 2026-08-06.
 */
const generateSmartTVMediaTraceRequestId = () => {
    // 20260806 운영 접속에서는 진단용 requestId 생성과 전송을 생략한다.
    if (!isSmartTVMediaTraceEnabled()) return undefined;
    smartTVMediaTraceRequestSeq += 1;
    return `${Date.now()}-${smartTVMediaTraceRequestSeq}`;
}

/**
 * 서버가 전달했거나 사용자가 직접 선택한 화면 회전값을 영상 DOM에만 적용하며, 잘못되거나 누락된 값은 0도로 처리한다.
 * 260916 화면 보정 기능 확장: 기존 크롬북 전용 이진값(0/-90)에서 0/90/180/270 4단계로 확장한다.
 * 기존 -90 값(크롬북)은 270으로 정규화하여 시각적으로 동일하게 -90도 회전된 것처럼 처리한다.
 * 
 * @param {Number} displayRotation - 화면 회전값
 * @returns {Number} 정규화된 화면 회전값 (0 | 90 | 180 | 270)
 * @since 2026-09-08. (260916 4단계로 확장)
 */
const VALID_DISPLAY_ROTATIONS = [0, 90, 180, 270];
const normalizeDisplayRotation = displayRotation => {
    const rotation = displayRotation === -90 ? 270 : displayRotation;
    return VALID_DISPLAY_ROTATIONS.includes(rotation) ? rotation : 0;
};

/**
 * 스마트TV 화면 공유 원본 트랙의 수신 화면 보정값을 하단 툴바에 전달한다.
 * 260916 이 상태 배지는 크롬북 전용(0/-90 이진) 기능 그대로이므로, 4단계로 확장된
 * normalizeDisplayRotation에 의존하지 않고 원본 값을 직접 -90과 비교한다.
 * 
 * @param {Number} displayRotation - 화면 회전값
 * @since 2026-09-10.
 */
const notifyDisplayRotationSendStatus = displayRotation => {
    if (typeof window === "undefined" || typeof window.dispatchEvent !== "function") return;
    const isRotationSending = displayRotation === -90;
    window.dispatchEvent(new CustomEvent(MEDIA_SOUP_DISPLAY_ROTATION_STATUS_EVENT, {
        detail: { displayRotation: isRotationSending ? -90 : 0 }
    }));
}

/**
 * 서버가 전달했거나 사용자가 직접 선택한 화면 회전값을 영상 DOM에 적용한다.
 * 260916 화면 보정 기능 확장: 0/90/180/270 4단계 회전을 모두 지원하도록 일반화.
 * - 0도: 원래 스타일로 복원
 * - 90도/270도: 폭·높이를 서로 바꿔 배치한 뒤 회전 적용 (기존 -90도 로직과 동일)
 * - 180도: 폭·높이 교체 없이 제자리에서 180도 회전만 적용
 * 
 * @param {HTMLVideoElement} videoEl - 영상 DOM 요소
 * @param {Number} displayRotation - 화면 회전값
 * @since 2026-09-08. (260916 4단계로 확장)
 */
const applyVideoDisplayRotation = (videoEl, displayRotation) => {
    if (!videoEl) return;
    const rotation = normalizeDisplayRotation(displayRotation);
    videoEl.dataset.displayRotation = String(rotation);

    const videoWrapper = videoEl.parentElement;
    if (!videoWrapper) return;

    const originalVideoStyleKeys = {
        position: "displayRotationOriginalVideoPosition",
        left: "displayRotationOriginalVideoLeft",
        top: "displayRotationOriginalVideoTop",
        width: "displayRotationOriginalVideoWidth",
        height: "displayRotationOriginalVideoHeight",
        transform: "displayRotationOriginalVideoTransform",
        transformOrigin: "displayRotationOriginalVideoTransformOrigin"
    };

    const resetVideoDisplayRotation = () => {
        if (videoEl.displayRotationResizeObserver) {
            videoEl.displayRotationResizeObserver.disconnect();
            delete videoEl.displayRotationResizeObserver;
        }

        Object.entries(originalVideoStyleKeys).forEach(([styleName, datasetName]) => {
            if (videoEl.dataset[datasetName] !== undefined) {
                videoEl.style[styleName] = videoEl.dataset[datasetName];
                delete videoEl.dataset[datasetName];
            }
        });

        if (videoWrapper.dataset.displayRotationOriginalPosition !== undefined) {
            videoWrapper.style.position = videoWrapper.dataset.displayRotationOriginalPosition;
            delete videoWrapper.dataset.displayRotationOriginalPosition;
        }
    };

    if (rotation === 0) {
        resetVideoDisplayRotation();
        return;
    }

    // 260916 90/180/270도 공통: 원래 스타일을 백업(이미 백업돼 있으면 유지)한다.
    Object.entries(originalVideoStyleKeys).forEach(([styleName, datasetName]) => {
        if (videoEl.dataset[datasetName] === undefined) {
            videoEl.dataset[datasetName] = videoEl.style[styleName];
        }
    });

    // 260916 90도/270도는 회전 후 가로세로가 뒤바뀌므로 폭·높이를 서로 바꿔 배치하고,
    // 180도는 가로세로 비율이 그대로이므로 폭·높이 교체 없이 제자리에서 뒤집기만 한다.
    const needsSizeSwap = rotation === 90 || rotation === 270;

    const applyRotatedVideoSize = () => {
        const wrapperWidth = videoWrapper.clientWidth;
        const wrapperHeight = videoWrapper.clientHeight;
        if (wrapperWidth <= 0 || wrapperHeight <= 0) return;

        videoEl.style.position = "absolute";
        videoEl.style.left = "50%";
        videoEl.style.top = "50%";
        if (needsSizeSwap) {
            videoEl.style.width = `${wrapperHeight}px`;
            videoEl.style.height = `${wrapperWidth}px`;
        } else {
            videoEl.style.width = `${wrapperWidth}px`;
            videoEl.style.height = `${wrapperHeight}px`;
        }
        videoEl.style.transform = `translate(-50%, -50%) rotate(${rotation}deg)`;
        videoEl.style.transformOrigin = "center center";
    };

    if (videoWrapper.dataset.displayRotationOriginalPosition === undefined) {
        videoWrapper.dataset.displayRotationOriginalPosition = videoWrapper.style.position;
    }
    if (window.getComputedStyle(videoWrapper).position === "static") {
        videoWrapper.style.position = "relative";
    }
    applyRotatedVideoSize();

    if (!videoEl.displayRotationResizeObserver && typeof ResizeObserver !== "undefined") {
        videoEl.displayRotationResizeObserver = new ResizeObserver(applyRotatedVideoSize);
        videoEl.displayRotationResizeObserver.observe(videoWrapper);
    }
}

/**
 * 스마트TV 미디어 추적 로그를 기록한다.
 * 
 * @param {String} stage - 현재 단계(stage) 이름
 * @param {Object} fields - 추적할 필드 객체
 * @since 2026-08-06.
 */
export const smartTVMediaTraceLog = (stage, fields) => {
    // 20260806 개발 mediaTrace 세션에서만 console 및 원격 진단 버퍼를 기록한다.
    if (!isSmartTVMediaTraceEnabled()) return;
    console.log(`${SMARTTV_MEDIA_TRACE_PREFIX} ${stage}`, fields);
    recordSmartTVMediaTrace(stage, fields);
}

/**
 * 학생 video 이벤트가 해당 consume 요청까지 추적될 수 있도록 현재 진단 문맥을 제공한다.
 * 
 * @param {Number} prodUserSeq - 학생 프로듀스 사용자 시퀀스 번호
 * @returns {Object} 스마트TV 미디어 추적 문맥 객체
 * @since 2026-08-05.
 */
export const getSmartTVMediaTraceContext = prodUserSeq => {
    const consumeInfo = getConsumeInfoBySeq(prodUserSeq)
        || getP2pConsumeInfoBySeq(prodUserSeq);
    return {
        requestId: consumeInfo ? consumeInfo.smartTVVideoTraceRequestId : undefined,
        liveSeq: clientInfo.liveSeq,
        prodUserSeq,
        consumUserSeq: clientInfo.userSeq,
        roomKind: "handsup",
        mediaKind: "video"
    };
}

let clientInfo = {
    monitorSessionId             : "",          // 20260728 클래스 모니터 페이지 인스턴스별 mediasoup 세션 식별자이다.

    rcvTeacherSeq               : -1,
    rcvTeacherInfo              : {
        userSeq                 : -1,
        userNickname            : "",
        userProfile             : "",
        profileImgUrl           : "",
        userGateWay             : ""
    },

    liveSeq                     : -1,
    userSeq                     : -1,
    userSeqArr                  : [],
    groupSeq                    : -1,

    routingKey                  : "",
    routingKeyArr               : [],

    device                      : null,
    rtpCapabilities             : null,

    sendTransportStatus         : "ended",
    rcvTransportStatus          : "ended",
    handsupRcvTransportStatus   : "ended",

    sendTransport               : null,
    rcvTransport                : null,
    handsupRcvTransport         : null,

    sendTransportCallback       : null,
    sendTransportErrback        : null,
    rcvTransportCallback        : null,
    rcvTransportErrback         : null,
    handsupRcvTransportCallback : null,
    handsupRcvTransportErrback  : null,

    isForSmartTV                : false,

    produceInfo                 : {
        mediaKind               : null,     // 20251113 ... 프로듀스할 미디어 유형 변수 추가 ... by hjkim
        currentMediaKind        : null,     // 20251113 ... 현재 프로듀스 중인 미디어 유형 확인용 변수 추가 (꼬임 방지) ... by hjkim

        canProduceVideo         : false,    // 20251113 ... 비디오 프로듀스 가능 여부 변수 추가 ... by hjkim
        canProduceAudio         : false,    // 20251113 ... 오디오 프로듀스 가능 여부 변수 추가 ... by hjkim

        isVideoProduced         : false,    // 20251113 ... 현재 비디오 프로듀스 중인지 여부 확인용 변수 추가 ... by hjkim
        isAudioProduced         : false,    // 20251113 ... 현재 오디오 프로듀스 중인지 여부 확인용 변수 추가 ... by hjkim

        videoStatus             : "ended",
        audioStatus             : "ended",

        videoProducer           : null,
        audioProducer           : null,

        videoTrack              : null,
        audioTrack              : null,

        videoSource             : null,     // 20260731 Android WebView에 실제 카메라 Producer 상태만 전달하기 위한 소스 구분값.
        displayRotation         : 0,        // 20260908 화면 공유 원본 트랙의 수신 화면 보정값
    },

    consumeInfo                 : {
        isReceived              : false,

        mediaKind               : null,

        isAudioStop             : false,
        isMuteAudio             : true,
        isMuteMic               : true,     // default
        isSelectedMode          : false,    // handsup 체크 or p2p 선택되었는지 여부

        isNeedReConsume         : false,    // 20250811 ... 스마트TV에서 unsubscribe 후 다시 consume 요청을 해야 하는지 여부 ... by hjkim
        isExitConsume           : false,

        isVideoReceiveable      : false,
        displayRotation         : 0,
        isAudioReceiveable      : false,
        isMicReceiveable        : false,

        isVideoReceived         : false,
        isAudioReceived         : false,
        isMicReceived           : false,

        videoConsumer           : null,
        audioConsumer           : null,
        micConsumer             : null,

        videoStream             : null,
        audioStream             : null,
        micStream               : null,

        videoEl                 : null,
        audioEl                 : null,
        micEl                   : null,

        // audioVolume             : 1,
        // micVolume               : 0,
        savedVolume             : 0,

        lastVideoState          : null,     // 20250811 ... 스마트TV에서 영상 재생에 성공했는지 확인한 마지막 상태 값을 저장하는 변수 ... by hjkim
        videoStateInterval      : null,     // 20250811 ... 스마트TV에서 영상 재생에 성공했는지 확인하기 위한 interval ... by hjkim
        testInterval            : null,
        videoResumeRetryCount   : 0,        // 20260807 live video resume 실패/프레임 미수신 시 재시도 횟수 ... by claude
    },

    handsupInfo                 : {
        mediaKind               : null,
        list_p2pConsumeInfo     : [],       // 1명 보기/2명 보기/4명 보기/학생 강의에서 다른 멤버들을 컨슘할 때 사용 (오디오 체크와 구분됨)
        list_consumeInfo        : []        // 펜톡 모니터에서 학생 오디오 체크했을 때 & 스몰 그룹 등 클래스의 다른 멤버들을 컨슘할 때 사용
    },
};

// 20260928 오디오 관련 설정 변경: PBL 학생 듣기는 현재 라이브의 그룹 오디오 요소에만 적용한다.
let pblStudentAudioListenLiveSeq = -1;
let isPblStudentAudioListenOn = true;

const applyPblStudentAudioListenToElement = audioEl => {
    if (audioEl && pblStudentAudioListenLiveSeq === clientInfo.liveSeq && !getIsForPblModeBrowser()) {
        audioEl.muted = !isPblStudentAudioListenOn;
    }
};

export const setPblStudentAudioListen = (liveSeq, isEnabled) => {
    if (typeof isEnabled !== "boolean") return;
    pblStudentAudioListenLiveSeq = liveSeq;
    isPblStudentAudioListenOn = isEnabled;
    if (clientInfo.liveSeq !== liveSeq || getIsForPblModeBrowser()) return;

    // 20260928 오디오 관련 설정 변경: 이미 재생 중인 그룹 오디오와 이후 생성될 요소에 같은 상태를 적용한다.
    [...clientInfo.handsupInfo.list_consumeInfo, ...clientInfo.handsupInfo.list_p2pConsumeInfo]
        .forEach(info => applyPblStudentAudioListenToElement(info.audioEl));
};

const BandConstraints = {
    Thumbnail: {
        ...enImage.nHD,                         // <nHD ... 640 x 360>
        // frameRate: enFrame.FIVE_FRAMES,         // 4 Frame(Cloud) or 5 Frame(Local)
        frameRate: enFrame.FOUR_FRAMES,         // 3 Frame(Cloud) or 4 Frame(Local)
        resizeMode: "crop-and-scale"
    },
    Camera: {
        ...enImage.HD,                          // <HD ... 1280 x 720>
        frameRate: enFrame.FOURTEEN_FRAMES,     // 14 Frame
        resizeMode: "crop-and-scale"
    },
    CameraPBL: {
        ...enImage.HD,                          // <HD ... 1280 x 720>
        frameRate: enFrame.FOURTEEN_FRAMES,     // 14 Frame
        resizeMode: "crop-and-scale"
    },
    Screen: {
        ...enImage.FHD,                         // <FHD ... 1920 x 1080>
        frameRate: enFrame.EIGHTEEN_FRAMES,     // 18 Frame
        resizeMode: "crop-and-scale"
    },
    ScreenPBL: {
        ...enImage.FHD,                         // <FHD ... 1920 x 1080>
        frameRate: enFrame.TWENTY_FOUR_FRAMES,  // 24 Frame
        resizeMode: "crop-and-scale"
    },
    ScreenLowSpec: {
        ...enImage.FHD,                         // <FHD ... 1920 x 1080>
        frameRate: enFrame.FOURTEEN_FRAMES,     // 14 Frame
        resizeMode: "crop-and-scale"
    },
    ScreenV2: {
        ...enImage.HD,                          // <HD ... 1280 x 720>
        frameRate: enFrame.EIGHTEEN_FRAMES,     // 18 Frame
        resizeMode: "crop-and-scale"
    },
    ScreenV4: {
        ...enImage.qHD,                         // <qHD ... 960 x 540>
        frameRate: enFrame.EIGHTEEN_FRAMES,     // 18 Frame
        resizeMode: "crop-and-scale"
    },
    SmartTV: {
        ...enImage.FHD,                         // <FHD ... 1920 x 1080>
        frameRate: enFrame.EIGHTEEN_FRAMES,     // 18 Frame
        resizeMode: "crop-and-scale"
    }
};

/**
 * 미디어 클라이언트의 Consumer & Producer & Transport 등
 * 미디어 서버 통신과 관련된 변수의 상태 값을 초기화하는 메서드
 * 
 * @returns {Promise<Boolean>} 변수 초기화 성공 여부 반환
 * @since 2025-11-13.
 */
const initMediaClientStateValue = async () => {
    return new Promise(async (resolve, reject) => {
        try {
            console.log("initMediaClientStateValue - 미디어 클라이언트 변수 초기화 시작 ...");

            // Mic Stream 정리
            if (clientInfo.consumeInfo.micStream !== null) {
                console.log("Consume Mic Stream 정리 시작");
                // console.log("clientInfo.consumeInfo.micStream not null");
                // console.log("set the value clientInfo.consumeInfo.micStream = null");
                clientInfo.consumeInfo.micStream = null;
                console.log("Consume Mic Stream 정리 완료");
            }

            // Mic Consumer 정리
            if (clientInfo.consumeInfo.micConsumer !== null) {
                console.log("Consume Mic Consumer 정리 시작");
                // console.log("clientInfo.consumeInfo.micConsumer not null");
                // console.log("set the value clientInfo.consumeInfo.isMicReceiveable = false");
                clientInfo.consumeInfo.isMicReceiveable = false;
                // console.log("set the value clientInfo.consumeInfo.isMicReceived = false");
                clientInfo.consumeInfo.isMicReceived = false;
                // console.log("set the value clientInfo.consumeInfo.micConsumer = null");
                clientInfo.consumeInfo.micConsumer = null;
                console.log("Consume Mic Consumer 정리 완료");
            }

            // Audio Stream 정리
            if (clientInfo.consumeInfo.audioStream !== null) {
                console.log("Consume Audio Stream 정리 시작");
                // console.log("clientInfo.consumeInfo.audioStream not null");
                // console.log("set the value clientInfo.consumeInfo.audioStream = null");
                clientInfo.consumeInfo.audioStream = null;
                console.log("Consume Audio Stream 정리 완료");
            }

            // Audio Consumer 정리
            if (clientInfo.consumeInfo.audioConsumer !== null) {
                console.log("Consume Audio Consumer 정리 시작");
                // console.log("clientInfo.consumeInfo.audioConsumer not null");
                // console.log("set the value clientInfo.consumeInfo.isAudioReceiveable = false");
                clientInfo.consumeInfo.isAudioReceiveable = false;
                // console.log("set the value clientInfo.consumeInfo.isAudioReceived = false");
                clientInfo.consumeInfo.isAudioReceived = false;
                // console.log("set the value clientInfo.consumeInfo.audioConsumer = null");
                clientInfo.consumeInfo.audioConsumer = null;
                console.log("Consume Audio Consumer 정리 완료");
            }

            // Video Stream 정리
            if (clientInfo.consumeInfo.videoStream !== null) {
                console.log("Consume Video Stream 정리 시작");
                // console.log("clientInfo.consumeInfo.videoStream not null");
                // console.log("set the value clientInfo.consumeInfo.videoStream = null");
                clientInfo.consumeInfo.videoStream = null;
                console.log("Consume Video Stream 정리 완료");
            }

            // Video Consumer 정리
            if (clientInfo.consumeInfo.videoConsumer !== null) {
                console.log("Consume Video Consumer 정리 시작");
                // console.log("clientInfo.consumeInfo.videoConsumer not null");
                // console.log("set the value clientInfo.consumeInfo.isVideoReceiveable = false");
                clientInfo.consumeInfo.isVideoReceiveable = false;
                // console.log("set the value clientInfo.consumeInfo.isVideoReceived = false");
                clientInfo.consumeInfo.isVideoReceived = false;
                // console.log("set the value clientInfo.consumeInfo.videoConsumer = null");
                clientInfo.consumeInfo.videoConsumer = null;
                console.log("Consume Video Consumer 정리 완료");
            }

            // Rcv Transport 정리
            if (clientInfo.rcvTransport !== null) {
                console.log("Consume Rcv Transport 정리 시작");
                // console.log("clientInfo.rcvTransport not null");
                // console.log("set the value clientInfo.rcvTransportStatus = 'ended'");
                clientInfo.rcvTransportStatus = "ended";
                // console.log("set the value clientInfo.rcvTransport = null");
                resetLiveConsume("init"); // 20261028 받기 연결 정리/생성 시 consume 대기 초기화 (web-relay R-207)
                clientInfo.rcvTransport = null;
                // console.log("set the value clientInfo.rcvTransportCallback = null");
                clientInfo.rcvTransportCallback = null;
                // console.log("set the value clientInfo.rcvTransportErrback = null");
                clientInfo.rcvTransportErrback = null;
                console.log("Consume Rcv Transport 정리 완료");
            } else {
                console.log("clientInfo.rcvTransportStatus[", clientInfo.rcvTransportStatus, "]");
                console.log("set the value clientInfo.rcvTransportStatus = 'ended'");
                clientInfo.rcvTransportStatus = "ended";
                // console.log("set the value clientInfo.rcvTransportCallback = null");
                clientInfo.rcvTransportCallback = null;
                // console.log("set the value clientInfo.rcvTransportErrback = null");
                clientInfo.rcvTransportErrback = null;
            }

            // HandsUp Rcv Transport 정리
            if (clientInfo.handsupRcvTransport !== null) {
                console.log("Consume HandsUp Rcv Transport 정리 시작");
                // console.log("clientInfo.handsupRcvTransport not null");
                // console.log("set the value clientInfo.handsupRcvTransportStatus = 'ended'");
                clientInfo.handsupRcvTransportStatus = "ended";
                // console.log("set the value clientInfo.handsupRcvTransport = null");
                clientInfo.handsupRcvTransport = null;
                // console.log("set the value clientInfo.handsupRcvTransportCallback = null");
                clientInfo.handsupRcvTransportCallback = null;
                // console.log("set the value clientInfo.handsupRcvTransportErrback = null");
                clientInfo.handsupRcvTransportErrback = null;
                console.log("Consume HandsUp Rcv Transport 정리 완료");
            } else {
                console.log("clientInfo.handsupRcvTransportStatus[", clientInfo.handsupRcvTransportStatus, "]");
                console.log("set the value clientInfo.handsupRcvTransportStatus = 'ended'");
                clientInfo.handsupRcvTransportStatus = "ended";
                // console.log("set the value clientInfo.handsupRcvTransportCallback = null");
                clientInfo.handsupRcvTransportCallback = null;
                // console.log("set the value clientInfo.handsupRcvTransportErrback = null");
                clientInfo.handsupRcvTransportErrback = null;
            }

            // ConsumeInfo mediaKind 정리
            console.log("Consume mediaKind 정리 시작");
            clientInfo.consumeInfo.mediaKind = null;
            console.log("Consume mediaKind 정리 완료");

            // 260928 ⚠ 송출이 살아 있으면 이 아래를 건드리지 않는다.
            // 수신 fallback 이 connectLive → initLiveInfo 로 여기까지 오는데, 그때 송출은
            // ICE 재시작을 기다리는 중일 수 있다. 예전에는 트랙·status·sendTransport 를 다
            // 지워서 송출 복구가 두 가지로 깨졌다 — 조금 늦으면 트랙이 없어 produce 를 못 하고
            // (Pro 실기 69차), 많이 늦으면 sendTransport 가 비어 isStale() 에 걸려 아무것도
            // 안 했다(70차, 1.376초 차). 둘 다 「쓰이고 있는 상태를 리셋한」 같은 원인이다.
            // 이 함수는 참조만 버리는 방어적 리셋이고 실제 정리는 unpublishAfter 가 하므로,
            // 살아 있는 송출을 건너뛰어도 잃는 것이 없다.
            const isSendActive = clientInfo.sendTransport !== null && !clientInfo.sendTransport.closed;
            console.log("initMediaClientStateValue - isSendActive[", isSendActive, "] — true 면 송출 정리를 건너뛴다");

            if (!isSendActive) {

            // Audio Track 정리
            if (clientInfo.produceInfo.audioTrack !== null) {
                console.log("Produce Audio Track 정리 시작");
                // console.log("clientInfo.produceInfo.audioTrack not null");
                // console.log("set the value clientInfo.produceInfo.audioTrack = null");
                clientInfo.produceInfo.audioTrack = null;
                console.log("Produce Audio Track 정리 완료");
            }

            // Audio Producer 정리
            if (clientInfo.produceInfo.audioProducer !== null) {
                console.log("Produce Audio Producer 정리 시작");
                // console.log("clientInfo.produceInfo.audioProducer not null");
                // console.log("set the value clientInfo.produceInfo.canProduceAudio = false");
                clientInfo.produceInfo.canProduceAudio = false;
                // console.log("set the value clientInfo.produceInfo.isAudioProduced = false");
                clientInfo.produceInfo.isAudioProduced = false;
                // console.log("set the value clientInfo.produceInfo.audioStatus = 'ended'");
                clientInfo.produceInfo.audioStatus = "ended";
                // console.log("set the value clientInfo.produceInfo.audioProducer = null");
                clientInfo.produceInfo.audioProducer = null;
                console.log("Produce Audio Producer 정리 완료");
            } else {
                console.log("clientInfo.produceInfo.audioStatus[", clientInfo.produceInfo.audioStatus, "]");
                console.log("set the value clientInfo.produceInfo.audioStatus = 'ended'");
                clientInfo.produceInfo.audioStatus = "ended";
                // console.log("set the value clientInfo.produceInfo.canProduceAudio = false");
                clientInfo.produceInfo.canProduceAudio = false;
                // console.log("set the value clientInfo.produceInfo.isAudioProduced = false");
                clientInfo.produceInfo.isAudioProduced = false;
            }

            // Video Track 정리
            if (clientInfo.produceInfo.videoTrack !== null) {
                console.log("Produce Video Track 정리 시작");
                // console.log("clientInfo.produceInfo.videoTrack not null");
                // console.log("set the value clientInfo.produceInfo.videoTrack = null");
                clientInfo.produceInfo.videoTrack = null;
                console.log("Produce Video Track 정리 완료");
            }

            // Video Producer 정리
            if (clientInfo.produceInfo.videoProducer !== null) {
                console.log("Produce Video Producer 정리 시작");
                // console.log("clientInfo.produceInfo.videoProducer not null");
                // console.log("set the value clientInfo.produceInfo.canProduceVideo = false");
                clientInfo.produceInfo.canProduceVideo = false;
                // console.log("set the value clientInfo.produceInfo.isVideoProduced = false");
                clientInfo.produceInfo.isVideoProduced = false;
                // console.log("set the value clientInfo.produceInfo.videoStatus = 'ended'");
                clientInfo.produceInfo.videoStatus = "ended";
                // console.log("set the value clientInfo.produceInfo.videoProducer = null");
                clientInfo.produceInfo.videoProducer = null;
                console.log("Produce Video Producer 정리 완료");
            } else {
                console.log("clientInfo.produceInfo.videoStatus[", clientInfo.produceInfo.videoStatus, "]");
                console.log("set the value clientInfo.produceInfo.videoStatus = 'ended'");
                clientInfo.produceInfo.videoStatus = "ended";
                // console.log("set the value clientInfo.produceInfo.canProduceVideo = false");
                clientInfo.produceInfo.canProduceVideo = false;
                // console.log("set the value clientInfo.produceInfo.isVideoProduced = false");
                clientInfo.produceInfo.isVideoProduced = false;
            }

            // Send Transport 정리
            if (clientInfo.sendTransport !== null) {
                console.log("Produce Send Transport 정리 시작");
                // console.log("clientInfo.sendTransport not null");
                console.log("(1) set the value clientInfo.sendTransportStatus = 'ended'");
                clientInfo.sendTransportStatus = "ended";
                // console.log("set the value clientInfo.sendTransport = null");
                clientInfo.sendTransport = null;
                // console.log("set the value clientInfo.sendTransportCallback = null");
                clientInfo.sendTransportCallback = null;
                // console.log("set the value clientInfo.sendTransportErrback = null");
                clientInfo.sendTransportErrback = null;
                console.log("Produce Send Transport 정리 완료");
            } else {
                console.log("clientInfo.sendTransportStatus[", clientInfo.sendTransportStatus, "]");
                console.log("(2) set the value clientInfo.sendTransportStatus = 'ended'");
                clientInfo.sendTransportStatus = "ended";
                // console.log("set the value clientInfo.sendTransportCallback = null");
                clientInfo.sendTransportCallback = null;
                // console.log("set the value clientInfo.sendTransportErrback = null");
                clientInfo.sendTransportErrback = null;
            }

            }   // if (!isSendActive) 끝 — 260928

            // ProduceInfo mediaKind 정리
            console.log("Produce mediaKind 정리 시작");
            clientInfo.produceInfo.mediaKind = null;
            clientInfo.produceInfo.currentMediaKind = null;
            clientInfo.produceInfo.displayRotation = 0; // 20260908 producer 종료 시 화면 회전 정보도 초기화한다.
            notifyDisplayRotationSendStatus(0); // 20260910 송신 상태 배지도 producer 초기화와 함께 숨긴다.
            console.log("Produce mediaKind 정리 완료");

            console.log("initMediaClientStateValue - 미디어 클라이언트 변수 초기화 완료 ...");

            resolve(true);
        } catch (err) {
            console.log("");
            resolve(false);
        }
    });
}

/**
 * 클라이언트의 초기 정보를 설정
 * 
 * @param {Number} userSeq - 사용자 시퀀스 번호
 * @param {String} routingKey - 사용자 라우팅 키
 */
export const initClientInfo = (userSeq, routingKey) => {
    isDevVer = isDevVersion();

    clientInfo.userSeq = userSeq;
    clientInfo.routingKey = routingKey;

    if (!ConstData.IS_LOCAL_VERSION) { // Cloud 버전 default frameRate value
        // BandConstraints.Thumbnail.frameRate = enFrame.FOUR_FRAMES;  // 4 Frame (Cloud)
        BandConstraints.Thumbnail.frameRate = enFrame.THREE_FRAMES;  // 3 Frame (Cloud)
    } else { // Local 버전 default frameRate value
        // BandConstraints.Thumbnail.frameRate = enFrame.FIVE_FRAMES;  // 5 Frame (Local)
        BandConstraints.Thumbnail.frameRate = enFrame.FOUR_FRAMES;  // 4 Frame (Local)
    }

    console.log("initClientInfo - isDevVer[", isDevVer, "], userSeq[", clientInfo.userSeq, "], routingKey[", clientInfo.routingKey, "]");
}

/**
 * 클라이언트의 라이브(= 클래스) 정보 설정 및 기타 변수 초기화
 * 
 * @param {Number} liveSeq - 라이브 시퀀스 번호 (= 클래스 시퀀스)
 * @param {Number} rcvSeq - 선생님 사용자 시퀀스 번호 (= teacherSeq)
 */
export const initLiveInfo = async (liveSeq, rcvSeq, teacher_info) => {
    // 20260928 오디오 관련 설정 변경: 다른 클래스에 이전 PBL 듣기 설정이 남지 않게 한다.
    if (pblStudentAudioListenLiveSeq !== liveSeq) {
        pblStudentAudioListenLiveSeq = -1;
        isPblStudentAudioListenOn = true;
    }
    clientInfo.liveSeq = liveSeq;
    clientInfo.rcvTeacherSeq = rcvSeq;
    clientInfo.rcvTeacherInfo = teacher_info;

    if (!ConstData.IS_LOCAL_VERSION) {
        // 20251110 ... 로컬 버전이 아닐 경우 오디오 볼륨의 기본값 설정 ... by hjkim
        // clientInfo.consumeInfo.audioVolume = 1;
        // clientInfo.consumeInfo.micVolume = 0;
        clientInfo.consumeInfo.savedVolume = 1;
    } else {
        // 20251110 ... 로컬 버전일 경우 오디오 볼륨의 기본값 설정 ... by hjkim
        // clientInfo.consumeInfo.audioVolume = 0;
        // clientInfo.consumeInfo.micVolume = 0;
        clientInfo.consumeInfo.savedVolume = 0;
    }

    console.log("initLiveInfo - savedVolume[", clientInfo.consumeInfo.savedVolume, "]");

    await initMediaClientStateValue();
    registerMediaSoupDebug();
}

/**
 * 스마트TV 정보 설정 및 기타 변수 초기화
 * 
 * @param {Number} userSeq - 사용자 시퀀스 번호
 * @param {String} routingKey - 사용자 라우팅 키
 */
export const initClientInfoForSmartTV = (userSeq, routingKey) => {
    isDevVer = isDevVersion();

    clientInfo.userSeq = userSeq;
    clientInfo.routingKey = routingKey;

    console.log("initClientInfoForSmartTV - isDevVer[", isDevVer, "], userSeq[", clientInfo.userSeq, "], routingKey[", clientInfo.routingKey, "]");

    clientInfo.handsupInfo.list_consumeInfo = []; // 재접속을 위해 값 초기화
    clientInfo.handsupInfo.list_p2pConsumeInfo = []; // 재접속을 위해 값 초기화

    initSubscribeHandsUpConsumeInfo(userSeq, "video");
}

/**
 * 그룹 스마트TV 정보 설정 및 기타 변수 초기화
 * 
 * @param {Number} groupSeq - 그룹 시퀀스 번호
 * @param {Array} list_member - 그룹 스마트TV 멤버 배열
 * @param {Array} routingKeyArr - 그룹 스마트TV 멤버 라우팅 키 배열
 */
export const initClientInfoForGroupSmartTV = (groupSeq, list_member, routingKeyArr) => {
    isDevVer = isDevVersion();

    clientInfo.groupSeq = groupSeq;
    clientInfo.userSeqArr = list_member;
    clientInfo.routingKeyArr = routingKeyArr;

    console.log("initClientInfoForGroupSmartTV - isDevVer[", isDevVer, "], groupSeq[", clientInfo.groupSeq, "], userSeqArr => ", clientInfo.userSeqArr, ", routingKeyArr => ", clientInfo.routingKeyArr);

    clientInfo.handsupInfo.list_consumeInfo = []; // 재접속을 위해 값 초기화
    clientInfo.handsupInfo.list_p2pConsumeInfo = []; // 재접속을 위해 값 초기화

    if (clientInfo.userSeqArr && clientInfo.userSeqArr.length > 0) {
        for (let i = 0; i < clientInfo.userSeqArr.length; i++) {
            let user_info = clientInfo.userSeqArr[i];
            initSubscribeHandsUpConsumeInfo(user_info.userSeq, "video");
        }
    }
}

/**
 * 기존 SmartTV 상태와 분리해 클래스 모니터의 고유 수신자와 전체 학생을 초기화한다.
 * 
 * @param {Number} receiverSeq - 수신자 시퀀스 번호
 * @param {String} monitorSessionId - 모니터 세션 ID
 * @param {String} routingKey - 라우팅 키
 * @param {Array} list_member - 멤버 배열
 * @since 2026-07-28.
 */
export const initClientInfoForClassMonitor = (receiverSeq, monitorSessionId, routingKey, list_member) => {
    isDevVer = isDevVersion();
    clientInfo.userSeq = receiverSeq;
    clientInfo.monitorSessionId = monitorSessionId;
    clientInfo.routingKey = routingKey;
    clientInfo.groupSeq = -1;
    clientInfo.userSeqArr = list_member || [];
    clientInfo.handsupInfo.list_consumeInfo = [];
    clientInfo.handsupInfo.list_p2pConsumeInfo = [];
    clientInfo.userSeqArr.forEach(user_info => initSubscribeHandsUpConsumeInfo(user_info.userSeq, "video"));
}

/**
 * 그룹 스마트TV 멤버별 idx, uSeq, videoEl, audioEl 설정
 * 
 * @param {Number} idx - 그룹 스마트TV 멤버 배열 인덱스 번호
 * @param {Number} uSeq - 사용자 시퀀스 번호
 * @param {HTMLVideoElement} videoEl - HTML 비디오 요소 객체
 * @param {HTMLAudioElement} audioEl - HTML 오디오 요소 객체
 */
export const setElementForGroupSmartTV = (idx, userSeq, videoEl, audioEl) => {
    console.log("setElementForGroupSmartTV - idx[", idx, "], userSeq[", userSeq, "]");
    // console.log("setElementForGroupSmartTV - videoEl => ", videoEl);
    // console.log("setElementForGroupSmartTV - audioEl => ", audioEl);
    console.log("setElementForGroupSmartTV - list_consumeInfo => ", clientInfo.handsupInfo.list_consumeInfo);
    console.log("setElementForGroupSmartTV - list_p2pConsumeInfo => ", clientInfo.handsupInfo.list_p2pConsumeInfo);

    const consumeInfo = getConsumeInfoBySeq(userSeq);
    if (consumeInfo) {
        consumeInfo.videoEl = videoEl;
        consumeInfo.audioEl = audioEl;

        if (typeof idx === "number" && idx >= 0) {
            let delayTime = (idx + 1) * delayTimeOffet;
            console.log("setElementForGroupSmartTV case 1-1:) idx[", idx, "], userSeq[", userSeq, "], delayTime[", delayTime, "]");
            sendJoinConsumeWithTimeout(stCallKind.SmartTV, "handsup", userSeq, delayTime);
        } else {
            console.log("setElementForGroupSmartTV case 1-2:) idx[", idx, "], userSeq[", userSeq, "]");
            sendJoinConsume("handsup", userSeq);
        }
    } else {
        const p2pInfo = getP2pConsumeInfoBySeq(userSeq);
        if (p2pInfo) {
            p2pInfo.videoEl = videoEl;
            p2pInfo.audioEl = audioEl;

            if (typeof idx === "number" && idx >= 0) {
                let delayTime = (idx + 1) * delayTimeOffet;
                console.log("setElementForGroupSmartTV case 2-1:) idx[", idx, "], userSeq[", userSeq, "], delayTime[", delayTime, "]");
                sendJoinConsumeWithTimeout(stCallKind.SmartTV, "handsup", userSeq, delayTime);
            } else {
                console.log("setElementForGroupSmartTV case 2-2:) idx[", idx, "], userSeq[", userSeq, "]");
                sendJoinConsume("handsup", userSeq);
            }
        } else {
            if (typeof idx === "number" && idx >= 0) {
                let delayTime = (idx + 1) * delayTimeOffet;
                console.log("setElementForGroupSmartTV case 3-1:) idx[", idx, "], userSeq[", userSeq, "], delayTime[", delayTime, "] ... 이럴 땐 어떻게 해야..?ㅁ?");
            } else {
                console.log("setElementForGroupSmartTV case 3-2:) idx[", idx, "], userSeq[", userSeq, "] ... 이럴 땐 어떻게 해야..?ㅁ?");
            }
        }
    }
}

/**
 * 클래스 모니터는 4개 단위로 요청을 시작해 기존 500ms 누적 지연 없이 순간 부하만 제한한다.
 * 
 * @param {Number} idx - 클래스 모니터 멤버 배열 인덱스 번호
 * @param {Number} userSeq - 사용자 시퀀스 번호
 * @param {HTMLVideoElement} videoEl - HTML 비디오 요소 객체
 * @param {HTMLAudioElement} audioEl - HTML 오디오 요소 객체
 * @since 2026-07-28.
 */
export const setElementForClassMonitor = (idx, userSeq, videoEl, audioEl) => {
    const consumeInfo = getConsumeInfoBySeq(userSeq) || getP2pConsumeInfoBySeq(userSeq);
    if (!consumeInfo) return;

    consumeInfo.videoEl = videoEl;
    consumeInfo.audioEl = audioEl;

    // 20260728 보기 모드 전환으로 DOM만 바뀐 경우 기존 consumer를 중복 생성하지 않고 스트림을 새 요소에 연결한다.
    if (consumeInfo.videoStream && videoEl) videoEl.srcObject = consumeInfo.videoStream;
    if (consumeInfo.audioStream && audioEl) audioEl.srcObject = consumeInfo.audioStream;
    if (consumeInfo.videoConsumer || consumeInfo.audioConsumer) return;

    const batchDelay = Math.floor(Math.max(idx, 0) / 4) * 50;
    setTimeout(() => sendJoinConsume("handsup", userSeq), batchDelay);
}

/**
 * 교사 화면도 모드 전환 시 기존 스트림을 새 video/audio 요소에 다시 연결한다.
 * 
 * @param {HTMLVideoElement} videoEl - HTML 비디오 요소 객체
 * @param {HTMLAudioElement} audioEl - HTML 오디오 요소 객체
 * @param {HTMLAudioElement} micEl - HTML 마이크 요소 객체
 * @returns {Boolean} - 성공 여부
 * @since 2026-07-28.
 */
export const setTeacherElementForClassMonitor = (videoEl, audioEl, micEl) => {
    clientInfo.consumeInfo.videoEl = videoEl;
    clientInfo.consumeInfo.audioEl = audioEl;
    clientInfo.consumeInfo.micEl = micEl;
    if (clientInfo.consumeInfo.videoStream && videoEl) videoEl.srcObject = clientInfo.consumeInfo.videoStream;
    if (clientInfo.consumeInfo.audioStream && audioEl) audioEl.srcObject = clientInfo.consumeInfo.audioStream;
    if (clientInfo.consumeInfo.micStream && micEl) micEl.srcObject = clientInfo.consumeInfo.micStream;
    return Boolean(clientInfo.consumeInfo.videoConsumer || clientInfo.consumeInfo.audioConsumer || clientInfo.consumeInfo.micConsumer);
}

/**
 * 소그룹 멤버별 idx, uSeq, videoEl, audioEl 설정
 * 
 * @param {Number} idx - 소그룹 멤버 배열 인덱스 번호
 * @param {Number} uSeq - 사용자 시퀀스 번호
 * @param {HTMLVideoElement} videoEl - HTML 비디오 요소 객체
 * @param {HTMLAudioElement} audioEl - HTML 오디오 요소 객체
 */
export const setElementForSmallGroup = (idx, uSeq, videoEl, audioEl) => {
    console.log("setElementForSmallGroup - idx[", idx, "], uSeq[", uSeq, "]");
    // console.log("setElementForSmallGroup - videoEl => ", videoEl);
    // console.log("setElementForSmallGroup - audioEl => ", audioEl);

    const consumeInfo = getConsumeInfoBySeq(uSeq);
    if (consumeInfo) {
        consumeInfo.videoEl = videoEl;
        // consumeInfo.audioEl = audioEl; // 다른 곳에서 HTML 오디오 요소 생성하는 것 같음

        if (typeof idx === "number" && idx >= 0) {
            let delayTime = (idx + 1) * delayTimeOffet;
            console.log("setElementForSmallGroup case 1-1:) idx[", idx, "], uSeq[", uSeq, "], delayTime[", delayTime, "]");
            sendJoinConsumeWithTimeout(stCallKind.SmallGroup, "handsup", uSeq, delayTime);
        } else { 
            console.log("setElementForSmallGroup case 1-2:) idx[", idx, "], uSeq[", uSeq, "]");
            sendJoinConsume("handsup", uSeq);
        }
    } else {
        const p2pInfo = getP2pConsumeInfoBySeq(uSeq);
        if (p2pInfo) {
            p2pInfo.videoEl = videoEl;
            // p2pInfo.audioEl = audioEl; // 다른 곳에서 HTML 오디오 요소 생성하는 것 같음

            if (typeof idx === "number" && idx >= 0) {
                let delayTime = (idx + 1) * delayTimeOffet;
                console.log("setElementForSmallGroup case 2-1:) idx[", idx, "], uSeq[", uSeq, "], delayTime[", delayTime, "]");
                sendJoinConsumeWithTimeout(stCallKind.SmallGroup, "handsup", uSeq, delayTime);
            } else {
                console.log("setElementForSmallGroup case 2-2:) idx[", idx, "], uSeq[", uSeq, "]");
                sendJoinConsume("handsup", uSeq);
            }
        } else { // pbl group인 경우
            if (typeof idx === "number" && idx >= 0) {
                let delayTime = (idx + 1) * delayTimeOffet;
                console.log("setElementForSmallGroup case 3-1:) idx[", idx, "], uSeq[", uSeq, "], delayTime[", delayTime, "], videoEl => ", videoEl, ", audioEl => ", audioEl);
            } else {
                console.log("setElementForSmallGroup case 3-2:) idx[", idx, "], uSeq[", uSeq, "], videoEl => ", videoEl, ", audioEl => ", audioEl);
            }
        }
    }
}

/**
 * handsup consume 정보 클리어
 * 
 * @param {Object} info - 핸즈업 멤버 consume 정보
 * @returns {Promise<Boolean | Error>}
 */
const clearHandsUpInfo = (info) => {
    return new Promise((resolve, reject) => {
        try {
            if (info.audioConsumer) {
                if (info.audioStream) {
                    info.audioStream.removeTrack(info.audioConsumer.track);
                    info.audioStream = null;
                }

                if (!info.audioConsumer.closed) {
                    info.audioConsumer.close();
                }

                info.audioConsumer = null;
            }

            info.audioStream = null;

            if (info.audioEl) {
                if (!info.audioEl.paused) {
                    info.audioEl.pause();
                }

                if (info.audioEl.parentNode) {
                    console.log("info.audioEl.parentNode.removeChild(info.audioEl). // info.audioEl => ", info.audioEl);
                    info.audioEl.parentNode.removeChild(info.audioEl);
                }

                info.audioEl = null;
            }

            resolve(true);
        } catch (err) {
            console.log("clearHandsUpInfo() - err => ", err);
            reject(err);
        }
    });
}

/**
 * 모든 handsup consume 정보 클리어
 * 
 * @returns {Promise<Boolean | Error>}
 */
export const initHandsUpConsumeInfo = () => {
    return new Promise(async (resolve, reject) => {
        try {
            if (clientInfo.handsupInfo.list_consumeInfo && clientInfo.handsupInfo.list_consumeInfo.length > 0) {
                const promises = clientInfo.handsupInfo.list_consumeInfo.map((info) => clearHandsUpInfo(info));
                await Promise.all(promises);

                clientInfo.handsupInfo.list_consumeInfo = [];
            }

            if (clientInfo.handsupInfo.list_p2pConsumeInfo && clientInfo.handsupInfo.list_p2pConsumeInfo.length > 0) {
                const promises = clientInfo.handsupInfo.list_p2pConsumeInfo.map((info) => clearHandsUpInfo(info));
                await Promise.all(promises);

                clientInfo.handsupInfo.list_p2pConsumeInfo = [];
            }
            resolve(true);
        } catch (err) {
            console.log(`initHandsUpConsumeInfo - err => `, err);
            resolve(false);
        }
    });
}

/**  MEDIA SOUP */
/**
 * Create a new Device to connect to mediasoup server.
 * device가 null일 경우 서버와 연결할 수 없음
 * 
 * @returns {Promise<Boolean>}
 * @private
 */

// function getIOSWebKitMajorVersion(userAgent?: string): number | undefined {
// 	if (!isIOS(userAgent)) {
// 		logger.debug('getIOSWebKitMajorVersion() | this is not iOS => undefined');

// 		return undefined;
// 	}

// 	if (isReactNative()) {
// 		logger.debug(
// 			'getIOSWebKitMajorVersion() | this is React-Native => undefined'
// 		);

// 		return undefined;
// 	}

// 	const match = userAgent?.match(/AppleWebKit\/(\w+)/i);

// 	if (match?.[1]) {
// 		const majorVersion = Number(match[1]);

// 		logger.debug(
// 			`getIOSWebKitMajorVersion() | WebKit major version based on User-Agent => ${majorVersion}`
// 		);

// 		return majorVersion;
// 	}

// 	logger.debug('getIOSWebKitMajorVersion() | this is not WebKit => undefined');

// 	return undefined;
// }

// function isIOS(userAgent?: string, userAgentData?: NavigatorUAData): boolean {
// 	if (userAgentData?.platform === 'iOS') {
// 		logger.debug(
// 			'isIOS() | this is iOS based on NavigatorUAData.platform => true'
// 		);

// 		return true;
// 	}

// 	if (userAgentData?.platform) {
// 		logger.debug(
// 			'isIOS() | this is not iOS based on NavigatorUAData.platform => false'
// 		);

// 		return false;
// 	}

// 	if (userAgent && /iPad|iPhone|iPod/.test(userAgent)) {
// 		logger.debug('isIOS() | this is iOS based on User-Agent => true');

// 		return true;
// 	}

// 	// iPadOS 13+ identifies itself as Mac (to force desktop view mode in some
// 	// websites) but we know it's iOS if it has touch screen.
// 	if (
// 		typeof navigator === 'object' &&
// 		navigator.platform === 'MacIntel' &&
// 		navigator.maxTouchPoints > 1
// 	) {
// 		logger.debug('isIOS() | this is iPadOS 13+ based on User-Agent => true');

// 		return true;
// 	}

// 	logger.debug('isIOS() | this is not iOS => false');

// 	return false;
// }

const getIOSWebKitMajorVersion = (userAgent) => {
	if (!isIOS(userAgent)) {
		console.debug('getIOSWebKitMajorVersion() | this is not iOS => undefined');

		return undefined;
	}

	if (isReactNative()) {
		console.debug(
			'getIOSWebKitMajorVersion() | this is React-Native => undefined'
		);

		return undefined;
	}

	const match = userAgent?.match(/AppleWebKit\/(\w+)/i);

	if (match && match[1]) {
		const majorVersion = Number(match[1]);

		console.debug(
			`getIOSWebKitMajorVersion() | WebKit major version based on User-Agent => ${majorVersion}`
		);

		return majorVersion;
	}

	console.debug('getIOSWebKitMajorVersion() | this is not WebKit => undefined');

	return undefined;
}

const isIOS = (userAgent, userAgentData) => {
	if (userAgentData && userAgentData.platform === 'iOS') {
		console.debug(
			'isIOS() | this is iOS based on NavigatorUAData.platform => true'
		);

		return true;
	}

	if (userAgentData && userAgentData.platform) {
		console.debug(
			'isIOS() | this is not iOS based on NavigatorUAData.platform => false'
		);

		return false;
	}

	if (userAgent && /iPad|iPhone|iPod/.test(userAgent)) {
		console.debug('isIOS() | this is iOS based on User-Agent => true');

		return true;
	}

	// iPadOS 13+ identifies itself as Mac (to force desktop view mode in some
	// websites) but we know it's iOS if it has touch screen.
	if (
		typeof navigator === 'object' &&
		navigator.platform === 'MacIntel' &&
		navigator.maxTouchPoints > 1
	) {
		console.debug('isIOS() | this is iPadOS 13+ based on User-Agent => true');

		return true;
	}

	console.debug('isIOS() | this is not iOS => false');

	return false;
}

const isReactNative = () =>{
	return (
		typeof navigator === 'object' &&
		typeof navigator.product === 'string' &&
		navigator.product === 'ReactNative'
	);
}

const loadDevice = async () => {
    return new Promise(async (resolve, reject) => {
        if (clientInfo.device === undefined || clientInfo.device === null) {
            try {
                if (isIOSWebView()) {
                    const iOSWebKitMajorVersion = getIOSWebKitMajorVersion(navigator.userAgent);

                    let handlerName;
                    if (iOSWebKitMajorVersion) {
                        if (iOSWebKitMajorVersion >= 605) {
                            console.log('detectDeviceImpl() | using Safari12 handler');

                            handlerName = 'Safari12';
                        } else {
                            console.log('detectDeviceImpl() | unsupported iOS Safari based browser/version');
                        }
                    }
                    
                    clientInfo.device = new mediasoup.Device({ handlerName });
                } else {
                    clientInfo.device = new mediasoup.Device();
                }
            } catch (err) {
                console.log("(1)loadDevice() - err => ", err);
                if (err.name === "UnsupportedError") {
                    console.log("(1)browser not supported mediasoup client device");
                }

                reject(err);
            } finally {
                console.log("(1)loadDevice clientInfo.rtpCapabilities => ", clientInfo.rtpCapabilities);
                // 이 부분이 기존에는 왜 없었지...?
                if (clientInfo.device !== undefined && clientInfo.device !== null) {
                    await clientInfo.device.load({ routerRtpCapabilities: clientInfo.rtpCapabilities });
                }

                resolve(true);
            }
        } else {
            if (!clientInfo.device.loaded) {
                console.log("loadDevice - device not loaded");
                console.log("(2)loadDevice clientInfo.rtpCapabilities => ", clientInfo.rtpCapabilities);
                try {
                    await clientInfo.device.load({ routerRtpCapabilities: clientInfo.rtpCapabilities });
                } catch (err) {
                    console.log("(2)loadDevice() - err => ", err);
                    if (err.name === "UnsupportedError") {
                        console.log("(2)browser not supported mediasoup client device");
                    }

                    reject(err);
                }
            }

            resolve(true);
        }
    });
}

/**  MEDIA SOUP (consume) */
/**
 * live subscribe (= consume) 요청 (기본은 video 부터 consume 요청)
 * 
 * @param {HTMLVideoElement} vElm - HTML 비디오 요소 객체
 * @param {HTMLAudioElement} aElm - HTML 오디오 요소 객체
 * @param {HTMLAudioElement} mElm - HTML 오디오 요소 객체
 */
export const subscribe = async (vElm, aElm, mElm) => {
    try {
        clientInfo.consumeInfo.videoEl = vElm;
        clientInfo.consumeInfo.videoStream = null;

        clientInfo.consumeInfo.audioEl = aElm;
        clientInfo.consumeInfo.audioStream = null;

        clientInfo.consumeInfo.micEl = mElm;
        clientInfo.consumeInfo.micStream = null;

        await loadDevice();

        if (clientInfo.consumeInfo.isVideoReceiveable) {
            clientInfo.consumeInfo.mediaKind = "video";

            if (clientInfo.rcvTransport === null) {
                sendCreateConsumerTransport(clientInfo.rcvTeacherSeq);
            } else {
                sendConsume("video", "live", clientInfo.rcvTeacherSeq);
            }
        } else if (clientInfo.consumeInfo.isAudioReceiveable) {
            if (clientInfo.consumeInfo.isAudioStop) {
                clientInfo.consumeInfo.mediaKind = null;

                let store = window.hiclasstv.store;
                store.dispatch(changeLiveStatusInfo({ kind: "audio", status: "off" }));
            } else {
                clientInfo.consumeInfo.mediaKind = "audio";

                if (clientInfo.rcvTransport === null) {
                    sendCreateConsumerTransport(clientInfo.rcvTeacherSeq);
                } else {
                    sendConsume("audio", "live", clientInfo.rcvTeacherSeq);
                }

                // let store = window.hiclasstv.store;
                // store.dispatch(changeLiveStatusInfo({ kind: "audio", status: "on" }));
            }
        } else if (clientInfo.consumeInfo.isMicReceiveable) {
            clientInfo.consumeInfo.mediaKind = "mic";

            if (clientInfo.rcvTransport === null) {
                sendCreateConsumerTransport(clientInfo.rcvTeacherSeq);
            } else {
                sendConsume("mic", "live", clientInfo.rcvTeacherSeq);
            }

            // let store = window.hiclasstv.store;
            // store.dispatch(changeLiveStatusInfo({ kind: "mic", status: "on" }));
        }
    } catch (err) {
        console.log("subscribe(loadDevice) - err => ", err);
        // 20260904 alert() 대신 누적 오류 로그에 기록 ... by claude
        logMediaDeviceError(err);
    }
}

/**
 * live audio subscribe (= consume) 요청
 */
export const subscribeAudio = async () => {
    try {
        await loadDevice();

        if (clientInfo.consumeInfo.isAudioReceiveable) {
            clientInfo.consumeInfo.mediaKind = "audio";

            if (clientInfo.rcvTransport === null) {
                sendCreateConsumerTransport(clientInfo.rcvTeacherSeq);
            } else {
                sendConsume("audio", "live", clientInfo.rcvTeacherSeq);
            }
        }
    } catch (err) {
        console.log("subscribeAudio(loadDevice) - err => ", err);
        // 20260904 alert() 대신 누적 오류 로그에 기록 ... by claude
        logMediaDeviceError(err);
    }
}

/**
 * live unsubscribe 요청
 * isForSoundOnly가 true일 경우 mic/audio 만 unsubscribe
 * isForSoundOnly가 false일 경우 mic/audio/video 모두 unsubscribe
 * 
 * @param {Boolean} isForSoundOnly - 오디오만 처리하면 되는지 여부
 * @param {Boolean} isExitConsume - exitConsume 요청을 보내야 하는지 여부
 * @param {Boolean} isForSmartTV - 스마트TV를 위한 요청인지 여부
 * @param {Boolean} isNeedReConsume - unsubscribe 요청 후 다시 consume 요청이 필요한지 여부
 */
export const unsubscribe = (isForSoundOnly, isExitConsume, isForSmartTV, isNeedReConsume) => {
    console.log(`unsubscribe - isForSoundOnly[${isForSoundOnly}], isExitConsume[${isExitConsume}]`);
    
    if (isNeedReConsume && isIOSWebView()) {
        const videoEl = clientInfo.consumeInfo.videoEl;
        const isVideoActuallyPlaying = clientInfo.consumeInfo.isVideoReceived && videoEl && !videoEl.paused && videoEl.readyState >= 3;

        if (isVideoActuallyPlaying) {
            console.log("unsubscribe - video actually playing - skip");
            return;
        }

        clientInfo.consumeInfo.isNeedReConsume = true;
    }
    
    if (isForSoundOnly) {
        // clientInfo.consumeInfo.isAudioStop = true; // 기존 선생님 소리를 끄는 기능. 현재 사용하지 않으므로 주석처리 by hjkim 201008
        // clientInfo.consumeInfo.isMicStop = true;
    }

    if (isForSmartTV) {
        clientInfo.consumeInfo.isExitConsume = false;
        sendUnsubscribe(false, "live", clientInfo.rcvTeacherSeq);
        unsubscribeAfterForSmartTV();

        /* if (isNeedReConsume) {
            clientInfo.consumeInfo.isNeedReConsume = true;
            // unsubscribeAfterReConsumeForSmartTV();
            console.log("SmartTV에서 reconsume이 필요한 케이스");
        } else {
            unsubscribeAfterForSmartTV();
        } */
    } else {
        console.log(`unsubscribe - consumeInfo.isVideoReceived[${clientInfo.consumeInfo.isVideoReceived}], consumeInfo.isAudioReceived[${clientInfo.consumeInfo.isAudioReceived}], consumeInfo.isMicReceived[${clientInfo.consumeInfo.isMicReceived}]`);
        if (clientInfo.consumeInfo.isVideoReceived || clientInfo.consumeInfo.isAudioReceived || clientInfo.consumeInfo.isMicReceived) {
            if (isExitConsume) {
                console.log("unsubscribe case 1");
                clientInfo.consumeInfo.isExitConsume = true;
                sendUnsubscribe(false, "live", clientInfo.rcvTeacherSeq);
            } else {
                console.log("unsubscribe case 2");
                clientInfo.consumeInfo.isExitConsume = false;
                sendUnsubscribe(isForSoundOnly, "live", clientInfo.rcvTeacherSeq);
            }
        } else {
            if (isExitConsume) {
                console.log("unsubscribe case 3");
                clientInfo.consumeInfo.isExitConsume = true;
                sendExitConsume(clientInfo.rcvTeacherSeq);
            }
        }
    }
}

/** MEDIA SOUP (handsUp consume) */
/**
 * for handsup p2p consume control.
 * listen / mute / unsubscribe
 * 
 * @param {Number} rcvSeq - 선생님 사용자 시퀀스 번호 (= teacherSeq)
 * @param {Array} list_user - 핸즈업 멤버 consume 정보 배열
 * @param {Boolean} isP2PStop - p2p 모드를 멈춰야 하는지 여부
 * @returns {Promise<Boolean | Error>}
 * @private
 */
const handleHandsUpConsumeForP2P = async (rcvSeq, list_user, isP2PStop) => {
    return new Promise(async (resolve, reject) => {
        try {
            if (list_user && list_user.length > 0) {
                const check_info = list_user.find(uSeq => uSeq === rcvSeq);
                if (check_info === undefined || check_info === null) { // list_user 에 포함되지 않는 경우 unsubscribe/mute.. by hjkim 20220224
                    const consumeInfo = getConsumeInfoBySeq(rcvSeq);
                    if (consumeInfo === undefined || consumeInfo === null) { // audio consume 중이 아닌 case by hjkim 20220224
                        const p2pConsumeInfo = getP2pConsumeInfoBySeq(rcvSeq);
                        if (p2pConsumeInfo === undefined || p2pConsumeInfo === null) { // p2p consume 중이 아닌 case by hjkim 20220224
                            console.log(`handleHandsUpConsumeForP2P case 1 rcvSeq[${rcvSeq}] not doing`);
                        } else { // list_user 에 포함되지 않는 경우 unsubscribe 한다... by hjkim 20220224
                            console.log(`handleHandsUpConsumeForP2P case 2 rcvSeq[${p2pConsumeInfo.rcvSeq}] unsubscribe`);
                            sendUnsubscribe(true, "handsup", p2pConsumeInfo.rcvSeq);
                        }
                    } else { // audio consume 중이지만 list_user 에 포함되지 않는 경우 mute 한다... by hjkim 20220224
                        console.log(`handleHandsUpConsumeForP2P case 3 rcvSeq[${consumeInfo.rcvSeq}] mute`);
                        consumeInfo.isP2PMode = false;
                        await muteAudioConsume(consumeInfo.rcvSeq);
                    }
                    resolve(true);
                } else { // list_user 에 포함되는 경우 그대로 듣는다.. by hjkim 20220224
                    const consumeInfo = getConsumeInfoBySeq(rcvSeq);
                    if (consumeInfo === undefined || consumeInfo === null) { // audio consume 중이 아닌 case by hjkim 20220224
                        const p2pConsumeInfo = getP2pConsumeInfoBySeq(rcvSeq);
                        if (p2pConsumeInfo === undefined || p2pConsumeInfo === null) { // p2p consume 중이 아닌 case by hjkim 20220224
                            console.log(`handleHandsUpConsumeForP2P case 4 rcvSeq[${rcvSeq}] not doing`);
                        } else { // 이미 p2p consume 중이던 경우 그대로 듣는다... by hjkim 20220224
                            console.log(`handleHandsUpConsumeForP2P case 5 rcvSeq[${p2pConsumeInfo.rcvSeq}] p2p continue listen`);
                            p2pConsumeInfo.isP2PMode = true;
                        }
                    } else { // audio consume 중이고 list_user 에 포함되는 경우 그대로 listen 한다... by hjkim 20220224
                        console.log(`handleHandsUpConsumeForP2P case 6 rcvSeq[${consumeInfo.rcvSeq}] audio listen`);
                        consumeInfo.isP2PMode = true;
                        await listenAudioConsume(consumeInfo.rcvSeq);
                    }
                    resolve(true);
                }
            } else { // list_user가 아무도 없거나 내가 포함되지 않은 경우 by hjkim 20220224
                const consumeInfo = getConsumeInfoBySeq(rcvSeq);
                if (consumeInfo === undefined || consumeInfo === null) { // audio consume 중이 아닌 case by hjkim 20220224
                    const p2pConsumeInfo = getP2pConsumeInfoBySeq(rcvSeq);
                    if (p2pConsumeInfo === undefined || p2pConsumeInfo === null) { // p2p consume 중이 아닌 case by hjkim 20220224
                        console.log(`handleHandsUpConsumeForP2P case 7 rcvSeq[${rcvSeq}] not doing`);
                    } else { // 이미 p2p consume 중이던 경우 unsubscribe 한다... by hjkim 20220224
                        console.log(`handleHandsUpConsumeForP2P case 8 rcvSeq[${p2pConsumeInfo.rcvSeq}] unsubscribe`);
                        sendUnsubscribe(true, "handsup", p2pConsumeInfo.rcvSeq);
                    }
                } else { // list_user가 아무도 없거나 내가 포함되지 않은 경우 by hjkim 20220224
                    if (isP2PStop) { // list_user가 아무도 없는 경우 p2p 종료 모드 기존 audio 들을 다시 듣는다 by hjkim 20220224
                        console.log(`handleAudioConsumeForP2P case 9 rcvSeq[${consumeInfo.rcvSeq}] audio listen`);
                        consumeInfo.isP2PMode = false;
                        await listenAudioConsume(consumeInfo.rcvSeq);
                    } else { // 내가 포함되지 않은 경우 audio consume 중이지만 mute 한다... by hjkim 20220224
                        consumeInfo.isP2PMode = false;
                        await muteAudioConsume(consumeInfo.rcvSeq);
                    }
                }
                resolve(true);
            }
        } catch (err) {
            console.log("handleHandsUpConsumeForP2P err => ", err);
            reject(err);
        }
    });
}

/**
 * for handsup p2p consume control.
 * 
 * @param {Array} list_user - 핸즈업 멤버 consume 정보 배열
 * @param {Boolean} isP2PStop - p2p 모드를 멈춰야 하는지 여부
 * @returns {Promise<Boolean | Error>}
 */
export const handleP2PConsume = async (list_user, isP2PStop) => {
    return new Promise(async (resolve, reject) => {
        try {
            if (clientInfo.handsupInfo.list_consumeInfo && clientInfo.handsupInfo.list_consumeInfo.length > 0) {
                const promises = clientInfo.handsupInfo.list_consumeInfo.map((info) => handleHandsUpConsumeForP2P(info.rcvSeq, list_user, isP2PStop));
                await Promise.all(promises);
            }

            if (clientInfo.handsupInfo.list_p2pConsumeInfo && clientInfo.handsupInfo.list_p2pConsumeInfo.length > 0) {
                const promises = clientInfo.handsupInfo.list_p2pConsumeInfo.map((info) => handleHandsUpConsumeForP2P(info.rcvSeq, list_user, isP2PStop));
                await Promise.all(promises);
            }
            resolve();
        } catch (err) {
            console.log("handleP2PConsume err => ", err);
            reject(err);
        }
    });
}

/**
 * handsup p2p subscribe (= consume)
 * - audio만 consume
 * 
 * @param {Number} rcvSeq - 선생님 사용자 시퀀스 번호 (= teacherSeq)
 * @param {Number} idx - 핸즈업 멤버 배열 인덱스 번호
 * @returns {Promise<Boolean>}
 */
export const subscribeHandsUpP2P = async (rcvSeq, idx) => {
    return new Promise(async (resolve, reject) => {
        if (rcvSeq === undefined || rcvSeq === null || rcvSeq < 0) {
            console.log(`------subscribeHandsUpP2P------ rcvSeq[${rcvSeq}]`);
            resolve(true);
        } else {
            const consumeInfo = getConsumeInfoBySeq(rcvSeq);
            if (consumeInfo === undefined || consumeInfo === null) { // 기존 audio consume에 없는 경우이므로 p2p consume check ... by hjkim 20220224
                const p2pConsumeInfo = getP2pConsumeInfoBySeq(rcvSeq);
                if (p2pConsumeInfo === undefined || p2pConsumeInfo === null) { // 기존 audio, p2p consume에 없는 경우이므로 joinConsume... by hjkim 20220224
                    const handsAudioConsumeDiv = document.getElementById("handsAudioConsumeDiv");
                    if (handsAudioConsumeDiv) {
                        console.log(`subscribeHandsUpP2P case 1 rcvSeq[${rcvSeq}] join consume`);

                        let audioEl = document.createElement("audio");
                        audioEl.id = "handsAudioCousumeEl-" + rcvSeq;
                        audioEl.style.display = "none";
                        audioEl.autoPlay = true;
                        audioEl.autoplay = true;
                        applyPblStudentAudioListenToElement(audioEl);
                        handsAudioConsumeDiv.appendChild(audioEl);

                        let consumeInfo = {
                            rcvSeq              : rcvSeq,
                            isMixedClassMember  : false,

                            mediaKind           : "",

                            audioConsumer       : null,
                            audioStream         : null,
                            audioEl             : audioEl,

                            videoConsumer       : null,
                            videoStream         : null,
                            videoEl             : null,

                            // isMicStop           : false,
                            isMuteAudio         : false,
                            isMicReceiveable    : false,
                            isAudioReceiveable  : false,
                            isAudioReceived     : false,

                            isVideoReceiveable  : false,
                            displayRotation     : 0,
                            isVideoReceived     : false,

                            isP2PMode           : false,

                            lastVideoState      : null,     // 20250811 ... 스마트TV에서 영상 재생에 성공했는지 확인한 마지막 상태 값을 저장하는 변수 ... by hjkim
                            videoStateInterval  : null,     // 20250811 ... 스마트TV에서 영상 재생에 성공했는지 확인하기 위한 interval ... by hjkim
                        };

                        clientInfo.handsupInfo.list_p2pConsumeInfo.push(consumeInfo);
                        sendJoinConsume("handsup", rcvSeq);
                    } else {
                        console.log(`subscribeHandsUpP2P case 1-1 rcvSeq[${rcvSeq}] handsAudioConsumeDiv is `, handsAudioConsumeDiv);
                    }
                } else { // 기존 p2p consume에 포함되어 있는 경우 그대로 둔다... (아마도 계속 재생중일 것이다...) by hjkim 20220224
                    if (p2pConsumeInfo.isAudioReceived) {
                        console.log(`subscribeHandsUpP2P case 2-1 rcvSeq[${p2pConsumeInfo.rcvSeq}], isP2PMode[${p2pConsumeInfo.isP2PMode}]`);
                        console.log(`isAudioReceived[${p2pConsumeInfo.isAudioReceived}], isAudioReceiveable[${p2pConsumeInfo.isAudioReceiveable}]`);
                    } else {
                        console.log(`subscribeHandsUpP2P case 2-2 rcvSeq[${p2pConsumeInfo.rcvSeq}], isP2PMode[${p2pConsumeInfo.isP2PMode}]`);
                        console.log(`isAudioReceived[${p2pConsumeInfo.isAudioReceived}], isAudioReceiveable[${p2pConsumeInfo.isAudioReceiveable}]`);
                    }
                }
            } else { // 기존 audio consume에 포함된 경우 그대로 둔다... (아마도 계속 재생중일 것이다...) by hjkim 20220224
                console.log(`subscribeHandsUpP2P case 3 rcvSeq[${consumeInfo.rcvSeq}], isP2PMode[${consumeInfo.isP2PMode}]`);
                if (!consumeInfo.isP2PMode) consumeInfo.isP2PMode = true;
                if (consumeInfo.isAudioReceived) {
                    console.log(`subscribeHandsUpP2P case 3-1 rcvSeq[${consumeInfo.rcvSeq}], isP2PMode[${consumeInfo.isP2PMode}]`);
                    console.log(`isAudioReceived[${consumeInfo.isAudioReceived}], isAudioReceiveable[${consumeInfo.isAudioReceiveable}]`);
                } else {
                    console.log(`subscribeHandsUpP2P case 3-2 rcvSeq[${consumeInfo.rcvSeq}], isP2PMode[${consumeInfo.isP2PMode}]`);
                    console.log(`isAudioReceived[${consumeInfo.isAudioReceived}], isAudioReceiveable[${consumeInfo.isAudioReceiveable}]`);
                }
            }
            resolve(true);
        }
    });
}

/**
 * handsup audio subscribe (= consume)
 * 
 * @param {Number} rcvSeq - 선생님 사용자 시퀀스 번호 (= teacherSeq)
 * @param {String | undefined} kind - 미디어 유형 또는 함수 호출 유형
 * @returns {Promise<Boolean>}
 */
export const subscribeHandsUpAudio = async (rcvSeq, isMixedClassMember, kind) => {
    console.log("subscribeHandsUpAudio - ", rcvSeq, isMixedClassMember, kind);

    return new Promise(async (resolve, reject) => {
        if (rcvSeq === undefined || rcvSeq === null || rcvSeq < 0) {
            console.log(`------subscribeHandsUpAudio------ rcvSeq[${rcvSeq}]`);
            resolve(true);
        } else {
            const consumeInfo = getConsumeInfoBySeq(rcvSeq);
            if (consumeInfo === undefined || consumeInfo === null) { // 기존 audio consume에 없는 경우이므로 p2p consume check ... by hjkim 20220224
                const p2pConsumeInfo = getP2pConsumeInfoBySeq(rcvSeq);
                if (p2pConsumeInfo === undefined || p2pConsumeInfo === null) { // 기존 audio, p2p consume에 없는 경우이므로 joinConsume... by hjkim 20220224
                    const handsAudioConsumeDiv = document.getElementById("handsAudioConsumeDiv");
                    if (handsAudioConsumeDiv) {
                        console.log(`subscribeHandsUpAudio case 1 rcvSeq[${rcvSeq}] join consume`);

                        let audioEl = document.createElement("audio");
                        audioEl.id = "handsAudioCousumeEl-" + rcvSeq;
                        audioEl.style.display = "none";
                        audioEl.autoPlay = true;
                        audioEl.autoplay = true;
                        applyPblStudentAudioListenToElement(audioEl);
                        handsAudioConsumeDiv.appendChild(audioEl);

                        let consumeInfo = {
                            rcvSeq              : rcvSeq,
                            isMixedClassMember  : isMixedClassMember,

                            mediaKind           : kind,

                            audioConsumer       : null,
                            audioStream         : null,
                            audioEl             : audioEl,

                            videoConsumer       : null,
                            videoStream         : null,
                            videoEl             : null,

                            // isMicStop           : false,
                            isMuteAudio         : false,
                            isMicReceiveable    : false,
                            isAudioReceiveable  : false,
                            isAudioReceived     : false,

                            isVideoReceiveable  : false,
                            displayRotation     : 0,
                            isVideoReceived     : false,

                            isP2PMode           : false,

                            lastVideoState      : null,     // 20250811 ... 스마트TV에서 영상 재생에 성공했는지 확인한 마지막 상태 값을 저장하는 변수 ... by hjkim
                            videoStateInterval  : null,     // 20250811 ... 스마트TV에서 영상 재생에 성공했는지 확인하기 위한 interval ... by hjkim
                        };

                        clientInfo.handsupInfo.list_consumeInfo.push(consumeInfo);

                        // if (kind !== "video") {
                            sendJoinConsume("handsup", rcvSeq);
                        // }
                    } else {
                        console.log(`subscribeHandsUpAudio case 1-1 rcvSeq[${rcvSeq}] handsAudioConsumeDiv is `, handsAudioConsumeDiv);
                    }
                } else { // 기존 p2p 중에 체크된 경우이므로 audio consume 으로 이동한다... by hjkim 20220224
                    p2pConsumeInfo.isP2PMode = true;
                    clientInfo.handsupInfo.list_consumeInfo.push(p2pConsumeInfo);
                    clientInfo.handsupInfo.list_p2pConsumeInfo = clientInfo.handsupInfo.list_p2pConsumeInfo.filter(info => info.rcvSeq !== rcvSeq);

                    if (p2pConsumeInfo.isAudioReceived) {
                        console.log(`subscribeHandsUpAudio case 2-1 rcvSeq[${p2pConsumeInfo.rcvSeq}], isP2PMode[${p2pConsumeInfo.isP2PMode}] list_p2pConsumeInfo 에서 list_consumeInfo 이동`);
                        console.log(`isAudioReceived[${p2pConsumeInfo.isAudioReceived}], isAudioReceiveable[${p2pConsumeInfo.isAudioReceiveable}]`);
                    } else {
                        console.log(`subscribeHandsUpAudio case 2-2 rcvSeq[${p2pConsumeInfo.rcvSeq}], isP2PMode[${p2pConsumeInfo.isP2PMode}] list_p2pConsumeInfo 에서 list_consumeInfo 이동`);
                        console.log(`isAudioReceived[${p2pConsumeInfo.isAudioReceived}], isAudioReceiveable[${p2pConsumeInfo.isAudioReceiveable}]`);
                    }
                }
            } else { // 이미 audio consume 중인 유저이므로 아무것도 하지 않는다... by hjkim 20220224
                if (consumeInfo.isAudioReceived) {
                    console.log(`subscribeHandsUpAudio case 3-1 rcvSeq[${consumeInfo.rcvSeq}], isP2PMode[${consumeInfo.isP2PMode}] already consume user. not doing`);
                    console.log(`isAudioReceived[${consumeInfo.isAudioReceived}], isAudioReceiveable[${consumeInfo.isAudioReceiveable}]`);
                } else {
                    console.log(`subscribeHandsUpAudio case 3-2 rcvSeq[${consumeInfo.rcvSeq}], isP2PMode[${consumeInfo.isP2PMode}] already consume user. not doing`);
                    console.log(`isAudioReceived[${consumeInfo.isAudioReceived}], isAudioReceiveable[${consumeInfo.isAudioReceiveable}]`);
                }
            }
            resolve(true);
        }
    });
}

/**
 * handsup audio subscribe (= consume) with array
 * 
 * @param {Array} list_user - 핸즈업 멤버 consume 정보 배열
 * @returns {Promise<Boolean | Error>}
 */
export const subscribeHandsUpAudioArray = async (list_user) => {
    return new Promise(async (resolve, reject) => {
        try {
            if (list_user && list_user.length > 0) {
                if (clientInfo.handsupInfo) {
                   const promises = list_user.map((rcvSeq) => {
                        if (typeof rcvSeq === "number") {
                            subscribeHandsUpAudio(rcvSeq, false, "array");
                        } else {
                            subscribeHandsUpAudio(rcvSeq.userSeq, rcvSeq.isMixedClassMember, "array");
                        }
                    });
                    await Promise.all(promises);
                }
            } else {
                console.log(`------subscribeHandsUpAudioArray------ list_user[${list_user}]`);
            }
            resolve(true);
        } catch (err) {
            console.log("subscribeHandsUpAudioArray err => ", err);
            reject(err);
        }
    });
}

/**
 * handsup audio subscribe (= consume)
 * 
 * @param {Number} rcvSeq - 선생님 사용자 시퀀스 번호 (= teacherSeq)
 * @param {String} kind - 미디어 유형
 * @returns {Promise<Boolean>}
 */
export const initSubscribeHandsUpConsumeInfo = async (rcvSeq, kind) => {
    console.log(`initSubscribeHandsUpConsumeInfo - rcvSeq[${rcvSeq}], kind[${kind}]`);

    return new Promise(async (resolve, reject) => {
        if (rcvSeq === undefined || rcvSeq === null || rcvSeq < 0) {
            console.log(`------initSubscribeHandsUpConsumeInfo------ rcvSeq[${rcvSeq}]`);
            resolve(true);
        } else {
            const consumeInfo = getConsumeInfoBySeq(rcvSeq);
            if (consumeInfo === undefined || consumeInfo === null) { // 기존 audio consume에 없는 경우이므로 p2p consume check ... by hjkim 20220224
                const p2pConsumeInfo = getP2pConsumeInfoBySeq(rcvSeq);
                if (p2pConsumeInfo === undefined || p2pConsumeInfo === null) { // 기존 audio, p2p consume에 없는 경우이므로 joinConsume... by hjkim 20220224
                    console.log(`initSubscribeHandsUpConsumeInfo case 1 rcvSeq[${rcvSeq}] init consume info`);

                    let consumeInfo = {
                        rcvSeq              : rcvSeq,
                        isMixedClassMember  : false,

                        mediaKind           : kind,

                        audioConsumer       : null,
                        audioStream         : null,
                        audioEl             : null,

                        videoConsumer       : null,
                        videoStream         : null,
                        videoEl             : null,

                        // isMicStop           : false,
                        isMuteAudio         : false,
                        isMicReceiveable    : false,
                        isAudioReceiveable  : false,
                        isAudioReceived     : false,

                        isVideoReceiveable  : false,
                        displayRotation     : 0,
                        isVideoReceived     : false,

                        isP2PMode           : false,

                        lastVideoState      : null,     // 20250811 ... 스마트TV에서 영상 재생에 성공했는지 확인한 마지막 상태 값을 저장하는 변수 ... by hjkim
                        videoStateInterval  : null,     // 20250811 ... 스마트TV에서 영상 재생에 성공했는지 확인하기 위한 interval ... by hjkim
                    };

                    clientInfo.handsupInfo.list_consumeInfo.push(consumeInfo);
                } else { // 기존 p2p 중에 체크된 경우이므로 audio consume 으로 이동한다... by hjkim 20220224
                    p2pConsumeInfo.isP2PMode = true;
                    clientInfo.handsupInfo.list_consumeInfo.push(p2pConsumeInfo);
                    clientInfo.handsupInfo.list_p2pConsumeInfo = clientInfo.handsupInfo.list_p2pConsumeInfo.filter(info => info.rcvSeq !== rcvSeq);

                    if (p2pConsumeInfo.isAudioReceived) {
                        console.log(`initSubscribeHandsUpConsumeInfo case 2-1 rcvSeq[${p2pConsumeInfo.rcvSeq}], isP2PMode[${p2pConsumeInfo.isP2PMode}] list_p2pConsumeInfo 에서 list_consumeInfo 이동`);
                        console.log(`isAudioReceived[${p2pConsumeInfo.isAudioReceived}], isAudioReceiveable[${p2pConsumeInfo.isAudioReceiveable}]`);
                    } else {
                        console.log(`initSubscribeHandsUpConsumeInfo case 2-2 rcvSeq[${p2pConsumeInfo.rcvSeq}], isP2PMode[${p2pConsumeInfo.isP2PMode}] list_p2pConsumeInfo 에서 list_consumeInfo 이동`);
                        console.log(`isAudioReceived[${p2pConsumeInfo.isAudioReceived}], isAudioReceiveable[${p2pConsumeInfo.isAudioReceiveable}]`);
                    }
                }
            } else { // 이미 audio consume 중인 유저이므로 아무것도 하지 않는다... by hjkim 20220224
                if (consumeInfo.isAudioReceived) {
                    console.log(`initSubscribeHandsUpConsumeInfo case 3-1 rcvSeq[${consumeInfo.rcvSeq}], isP2PMode[${consumeInfo.isP2PMode}] already consume user. not doing`);
                    console.log(`isAudioReceived[${consumeInfo.isAudioReceived}], isAudioReceiveable[${consumeInfo.isAudioReceiveable}]`);
                } else {
                    console.log(`initSubscribeHandsUpConsumeInfo case 3-2 rcvSeq[${consumeInfo.rcvSeq}], isP2PMode[${consumeInfo.isP2PMode}] already consume user. not doing`);
                    console.log(`isAudioReceived[${consumeInfo.isAudioReceived}], isAudioReceiveable[${consumeInfo.isAudioReceiveable}]`);
                }
            }
            resolve(true);
        }
    });
}

/**
 * handsup audio unsubscribe
 * 
 * @param {Boolean} isForSoundOnly - 오디오만 처리하면 되는지 여부
 * @param {Number} rcvSeq - 선생님 사용자 시퀀스 번호 (= teacherSeq)
 * @returns {Promise<Boolean | Error>}
 * @private
 */
const unsubscribeHandsUpAudioConsume = async (isForSoundOnly, rcvSeq) => {
    return new Promise((resolve, reject) => {
        try {
            const consumeInfo = getConsumeInfoBySeq(rcvSeq);
            if (consumeInfo) { // audio consume 중인 case by hjkim 20220224
                if (consumeInfo.isP2PMode) { // p2p 중에 체크 해제된 경우이므로 p2p consume 으로 이동한다... by hjkim 20220224
                    console.log(`unsubscribeHandsUpAudioConsume case 1 rcvSeq[${consumeInfo.rcvSeq}], isP2PMode[${consumeInfo.isP2PMode}] list_consumeInfo 에서 list_p2pConsumeInfo 이동`);
                    clientInfo.handsupInfo.list_p2pConsumeInfo.push(consumeInfo);
                    clientInfo.handsupInfo.list_consumeInfo = clientInfo.handsupInfo.list_consumeInfo.filter(info => info.rcvSeq !== rcvSeq);
                } else { // p2p 중이 아니고, 그냥 체크 해제된 경우이므로 unsubscribe 한다... by hjkim 20220224
                    console.log(`unsubscribeHandsUpAudioConsume case 2 rcvSeq[${consumeInfo.rcvSeq}], isP2PMode[${consumeInfo.isP2PMode}] unsubscribe`);
                    sendUnsubscribe(isForSoundOnly, "handsup", consumeInfo.rcvSeq);
                }
            } else { // audio consume 중이 아닌 경우인데 이런 경우가 있을까..? by hjkim 20220224
                console.log(`unsubscribeHandsUpAudioConsume case 3 rcvSeq[${rcvSeq}]`);
            }
            resolve(true);
        } catch (err) {
            console.log("unsubscribeHandsUpAudioConsume err => ", err);
            reject(err);
        }
    });
}

/**
 * handsup audio unsubscribe
 * rcvSeq 있을 경우 rcvSeq만 unsubscribe
 * rcvSeq 없을 경우 모든 handsup audio unsubscribe
 * 
 * @param {Number | null} rcvSeq - 선생님 사용자 시퀀스 번호 (= teacherSeq)
 * @returns {Promise<Boolean | Error>}
 */
export const unsubscribeHandsUpAudio = async (rcvSeq) => {
    //console.log("unsubscribeHandsUpAudio - rcvSeq => ", rcvSeq);
    return new Promise(async (resolve, reject) => {
        try {
            if (clientInfo.handsupInfo.list_consumeInfo && clientInfo.handsupInfo.list_consumeInfo.length > 0) {
                if (rcvSeq === undefined || rcvSeq === null) {
                    const promises = clientInfo.handsupInfo.list_consumeInfo.map((info) => unsubscribeHandsUpAudioConsume(true, info.rcvSeq));
                    await Promise.all(promises);
                } else {
                    await unsubscribeHandsUpAudioConsume(true, rcvSeq);
                }
            }

            resolve(true);
        } catch (err) {
            console.log("unsubscribeHandsUpAudio err => ", err);
            reject(err);
        }
    });
}

/**
 * handsup audio, p2p consume - unsubscribe / mute
 * 
 * @param {Boolean} isForSoundOnly - 오디오만 처리하면 되는지 여부
 * @param {Number} rcvSeq - 선생님 사용자 시퀀스 번호 (= teacherSeq)
 * @returns {Promise<Boolean | Error>}
 * @private
 */
export const unsubscribeHandsUpConsume = async (isForSoundOnly, rcvSeq) => {
    return new Promise(async (resolve, reject) => {
        try {
            console.log("unsubscribeHandsUpConsume - rcvSeq[", rcvSeq, "], isForSoundOnly[", isForSoundOnly, "]");
            if (isUsableArrayObj(clientInfo.handsupInfo.list_consumeInfo) || isUsableArrayObj(clientInfo.handsupInfo.list_p2pConsumeInfo)) {
                const consumeInfo = getConsumeInfoBySeq(rcvSeq);
                if (consumeInfo === undefined || consumeInfo === null) { // p2p check 해야하는 case
                    const p2pConsumeInfo = getP2pConsumeInfoBySeq(rcvSeq);
                    if (p2pConsumeInfo === undefined || p2pConsumeInfo === null) {
                        console.log("unsubscribeHandsUpConsume case 1 - 아무 것도 하지 않는 경우");  // 이런 경우가 있어선 안 되겠지만.. 혹시라도 있을까..?
                    } else {
                        console.log("unsubscribeHandsUpConsume case 2");
                        await muteHandsUpP2PConsume(p2pConsumeInfo.rcvSeq);
                        sendUnsubscribe(isForSoundOnly, "handsup", p2pConsumeInfo.rcvSeq);
                    }
                } else {
                    console.log("unsubscribeHandsUpConsume case 3");
                    await muteAudioConsume(consumeInfo.rcvSeq);
                    sendUnsubscribe(isForSoundOnly, "handsup", consumeInfo.rcvSeq);
                }
            } else {
                console.log("unsubscribeHandsUpConsume case 4 - 사용 가능한 handsUp consume/p2pConsume 정보가 없음");
            }
            resolve(true);
        } catch (err) {
            console.log("unsubscribeHandsUpP2PConsume err => ", err);
            reject(err);
        }
    });
}

/**
 * handsup audio, p2p consume 정리
 * 
 * @param {Boolean} isForSoundOnly - 오디오만 처리하면 되는지 여부
 * @returns {Promise<Boolean | Error>}
 */
export const unsubscribeHandsUpConsumeAll = async (isForSoundOnly) => {
    return new Promise(async (resolve, reject) => {
        try {
            if (clientInfo.handsupInfo.list_p2pConsumeInfo && clientInfo.handsupInfo.list_p2pConsumeInfo.length > 0) {
                const promises = clientInfo.handsupInfo.list_p2pConsumeInfo.map((info) => unsubscribeHandsUpConsume(isForSoundOnly, info.rcvSeq));
                await Promise.all(promises);
            }

            if (clientInfo.handsupInfo.list_consumeInfo && clientInfo.handsupInfo.list_consumeInfo.length > 0) {
                const promises = clientInfo.handsupInfo.list_consumeInfo.map((info) => unsubscribeHandsUpConsume(isForSoundOnly, info.rcvSeq));
                await Promise.all(promises);
            }

            resolve(true);
        } catch (err) {
            console.log("unsubscribeHandsUpConsumeAll err => ", err);
            reject(err);
        }
    });
}

/**
 * p2p mute
 * 
 * @param {Number} rcvSeq - 선생님 사용자 시퀀스 번호 (= teacherSeq)
 * @returns {Promise<Boolean | Error>}
 * @private
 */
const muteHandsUpP2PConsume = async (rcvSeq) => {
    return new Promise(async (resolve, reject) => {
        try {
            if (clientInfo.handsupInfo.list_p2pConsumeInfo && clientInfo.handsupInfo.list_p2pConsumeInfo.length > 0) {
                const p2pConsumeInfo = getP2pConsumeInfoBySeq(rcvSeq);
                if (p2pConsumeInfo) {
                    console.log(`muteHandsUpP2PConsume - rcvSeq[${p2pConsumeInfo.rcvSeq}], isAudioReceived[${p2pConsumeInfo.isAudioReceived}], isMuteAudio[${p2pConsumeInfo.isMuteAudio}]`);
                    if (p2pConsumeInfo.audioConsumer) {
                        if (p2pConsumeInfo.audioEl) {
                            console.log(`(1)muteHandsUpP2PConsume - audioEl paused[${p2pConsumeInfo.audioEl.paused}], muted[${p2pConsumeInfo.audioEl.muted}], volume[${p2pConsumeInfo.audioEl.volume}]`);
                            if (p2pConsumeInfo.audioEl.srcObject) {
                                if (!p2pConsumeInfo.audioEl.paused) {
                                    p2pConsumeInfo.audioEl.pause();
                                }
                                p2pConsumeInfo.audioEl.srcObject = null;
                            }
                        }

                        if (p2pConsumeInfo.audioStream !== null) {
                            p2pConsumeInfo.audioStream.removeTrack(p2pConsumeInfo.audioConsumer.track);
                            p2pConsumeInfo.audioStream = null;
                        }
                    }

                    p2pConsumeInfo.isMuteAudio = true;
                }
            }

            resolve(true);
        } catch (err) {
            console.log("------muteHandsUpP2PConsume------error => ", err);
            reject(err);
        }
    });
}

/**
 * audio consume mute
 * 
 * @param {Number} rcvSeq - 선생님 사용자 시퀀스 번호 (= teacherSeq)
 * @returns {Promise<Boolean | Error>}
 * @private
 */
const muteAudioConsume = async (rcvSeq) => {
    return new Promise(async (resolve, reject) => {
        try {
            if (clientInfo.handsupInfo.list_consumeInfo && clientInfo.handsupInfo.list_consumeInfo.length > 0) {
                const consumeInfo = getConsumeInfoBySeq(rcvSeq);
                if (consumeInfo) {
                    console.log(`muteAudioConsume - rcvSeq[${consumeInfo.rcvSeq}], isAudioReceived[${consumeInfo.isAudioReceived}], isMuteAudio[${consumeInfo.isMuteAudio}]`);
                    if (consumeInfo.audioConsumer) {
                        if (consumeInfo.audioEl) {
                            console.log(`(1)muteAudioConsume - audioEl paused[${consumeInfo.audioEl.paused}], muted[${consumeInfo.audioEl.muted}], volume[${consumeInfo.audioEl.volume}]`);
                            let result = await pauseAudio(consumeInfo.audioEl);
                            console.log("muteAudioConsume - pauseAudio result => ", result);

                            if (result && getIsForPblModeBrowser()) {
                                console.log("muteAudioConsume - muteAudioConsumeHelper(handsup, consumeInfo.rcvSeq).");
                                muteAudioConsumeHelper("handsup", consumeInfo.rcvSeq);
                            }

                            if (consumeInfo.audioEl.srcObject) {
                                // if (!consumeInfo.audioEl.paused) {
                                //     consumeInfo.audioEl.pause();
                                // }
                                consumeInfo.audioEl.srcObject = null;
                            }
                        }

                        if (consumeInfo.audioStream !== null) {
                            consumeInfo.audioStream.removeTrack(consumeInfo.audioConsumer.track);
                            consumeInfo.audioStream = null;
                        }
                    }

                    consumeInfo.isMuteAudio = true;
                }
            }

            resolve(true);
        } catch (err) {
            console.log("------muteAudioConsume------error => ", err);
            reject(err);
        }
    });
}

/**
 * 모든 audio consume mute
 * 
 * @returns {Promise<Boolean | Error>}
 */
export const muteAudioConsumeAll = async () => {
    return new Promise(async (resolve, reject) => {
        try {
            if (clientInfo.handsupInfo.list_consumeInfo && clientInfo.handsupInfo.list_consumeInfo.length > 0) {
                const promises = clientInfo.handsupInfo.list_consumeInfo.map((info) => muteAudioConsume(info.rcvSeq));
                await Promise.all(promises);
            }

            resolve(true);
        } catch (err) {
            console.log("------muteAudioConsumeAll------error => ", err);
            reject(err);
        }
    });
}

/**
 * 모든 consume clear
 * 
 * @param {Boolean} isRemoveAudioEl - HTML 오디오 요소 객체 제거 여부
 * @param {Boolean} isForSoundOnly - 오디오만 처리하면 되는지 여부
 * @param {Number} rcvSeq - 선생님 사용자 시퀀스 번호 (= teacherSeq)
 * @returns {Promise<Boolean | Error>}
 */
const clearHandsUpConsume = async (isRemoveAudioEl, isForSoundOnly, rcvSeq) => {
    console.log("clearHandsUpConsume - isForSoundOnly[", isForSoundOnly, "], rcvSeq[", rcvSeq, "]");
    return new Promise(async (resolve, reject) => {
        try {
            const consumeInfo = getConsumeInfoBySeq(rcvSeq);
            if (consumeInfo) {
                // isForSoundOnly 값과 상관없이 audio 는 항상 unsubscribe 해야 하기 때문에 true인지 체크 안하고 바로 처리... by hjkim 20231108
                // let idx = clientInfo.handsupInfo.list_consumeInfo.indexOf(consumeInfo);
                if (consumeInfo.audioConsumer) {
                    if (consumeInfo.audioStream) {
                        consumeInfo.audioStream.removeTrack(consumeInfo.audioConsumer.track);
                        consumeInfo.audioStream = null;
                    }

                    if (!consumeInfo.audioConsumer.closed) {
                        consumeInfo.audioConsumer.close();
                    }

                    consumeInfo.audioConsumer = null;
                }

                if (consumeInfo.audioEl) { // audioEl은 항상 기본으로 생성하기 때문에 audio consumer 존재 유무와 관계없이 먼저 제거! ...by hjkim 20250812
                    let result = await pauseAudio(consumeInfo.audioEl);
                    console.log("clearHandsUpConsume - pauseAudio result => ", result);

                    if (result && getIsForPblModeBrowser()) {
                        console.log("clearHandsUpConsume - muteAudioConsumeHelper(handsup, consumeInfo.rcvSeq).");
                        muteAudioConsumeHelper("handsup", consumeInfo.rcvSeq);
                    }

                    if (consumeInfo.audioEl.srcObject) {
                        consumeInfo.audioEl.srcObject = null;
                    }

                    // 20250811 ... 스마트TV에서 영상 재생 오류 발생 시, 다시 consume 요청을 하기 위해 audio 요소를 제거하지 않는 변수 추가 ... by hjkim
                    if (isRemoveAudioEl) {
                        console.log("clearHandsUpConsume(consumeInfo.audioEl) - isRemoveAudioEl is true.");

                        if (consumeInfo.audioEl.parentNode) {
                            console.log("consumeInfo.audioEl.parentNode.removeChild(consumeInfo.audioEl). consumeInfo.audioEl => ", consumeInfo.audioEl);
                            consumeInfo.audioEl.parentNode.removeChild(consumeInfo.audioEl);
                        }

                        consumeInfo.audioEl = null;
                    } else {
                        console.log("clearHandsUpConsume(consumeInfo.audioEl) - isRemoveAudioEl is false.");
                    }
                }

                if (isForSoundOnly === false) { // isForSoundOnly 가 false 면 all unsubscribe 이기 때문에 video 를 여기서 처리... by hjkim 20231108
                    if (consumeInfo.videoConsumer) {
                        if (consumeInfo.videoStream) {
                            consumeInfo.videoStream.removeTrack(consumeInfo.videoConsumer.track);
                            consumeInfo.videoStream = null;
                        }

                        if (!consumeInfo.videoConsumer.closed) {
                            consumeInfo.videoConsumer.close();
                        }

                        consumeInfo.videoConsumer = null;
                    }

                    if (consumeInfo.videoEl) {
                        if (!consumeInfo.videoEl.paused) {
                            consumeInfo.videoEl.pause();
                            consumeInfo.videoEl.currentTime = 0;
                            consumeInfo.videoEl.poster = "/images/connect.png";
                            // consumeInfo.videoEl.poster = "/images/android_notconnected.png";
                        }
                    }
                }
            } else {
                const p2pInfo = getP2pConsumeInfoBySeq(rcvSeq);
                if (p2pInfo) {
                    // isForSoundOnly 값과 상관없이 audio 는 항상 unsubscribe 해야 하기 때문에 true인지 체크 안하고 바로 처리... by hjkim 20231108
                    // let idx = clientInfo.handsupInfo.list_p2pConsumeInfo.indexOf(p2pInfo);
                    if (p2pInfo.audioConsumer) {
                        if (p2pInfo.audioStream) {
                            p2pInfo.audioStream.removeTrack(p2pInfo.audioConsumer.track);
                            p2pInfo.audioStream = null;
                        }

                        if (!p2pInfo.audioConsumer.closed) {
                            p2pInfo.audioConsumer.close();
                        }

                        p2pInfo.audioConsumer = null;
                    }

                    if (p2pInfo.audioEl) { // audioEl은 항상 기본으로 생성하기 때문에 audio consumer 존재 유무와 관계없이 먼저 제거! ...by hjkim 20250812
                        let result = await pauseAudio(p2pInfo.audioEl);
                        console.log("clearHandsUpConsume - pauseAudio result => ", result);

                        if (result && getIsForPblModeBrowser()) {
                            console.log("clearHandsUpConsume - muteAudioConsumeHelper(handsup, p2pInfo.rcvSeq).");
                            muteAudioConsumeHelper("handsup", p2pInfo.rcvSeq);
                        }

                        if (p2pInfo.audioEl.srcObject) {
                            p2pInfo.audioEl.srcObject = null;
                        }

                        // 20250811 ... 스마트TV에서 영상 재생 오류 발생 시, 다시 consume 요청을 하기 위해 audio 요소를 제거하지 않는 변수 추가 ... by hjkim
                        if (isRemoveAudioEl) {
                            console.log("clearHandsUpConsume(p2pInfo.audioEl) - isRemoveAudioEl is true.");

                            if (p2pInfo.audioEl.parentNode) {
                                console.log("p2pInfo.audioEl.parentNode.removeChild(p2pInfo.audioEl). p2pInfo.audioEl => ", p2pInfo.audioEl);
                                p2pInfo.audioEl.parentNode.removeChild(p2pInfo.audioEl);
                            }

                            p2pInfo.audioEl = null;
                        } else {
                            console.log("clearHandsUpConsume(p2pInfo.audioEl) - isRemoveAudioEl is false.");
                        }
                    }

                    if (isForSoundOnly === false) { // isForSoundOnly 가 false 면 all unsubscribe 이기 때문에 video 를 여기서 처리... by hjkim 20231108
                        if (p2pInfo.videoConsumer) {
                            if (p2pInfo.videoStream) {
                                p2pInfo.videoStream.removeTrack(p2pInfo.videoConsumer.track);
                                p2pInfo.videoStream = null;
                            }

                            if (!p2pInfo.videoConsumer.closed) {
                                p2pInfo.videoConsumer.close();
                            }

                            p2pInfo.videoConsumer = null;
                        }

                        if (p2pInfo.videoEl) {
                            if (!p2pInfo.videoEl.paused) {
                                p2pInfo.videoEl.pause();
                                p2pInfo.videoEl.currentTime = 0;
                                p2pInfo.videoEl.poster = "/images/connect.png";
                                // p2pInfo.videoEl.poster = "/images/android_notconnected.png";
                            }
                        }
                    }
                }
            }
            resolve(true);
        } catch (err) {
            console.log("clearHandsUpConsume err => ", err);
            reject(err);
        }
    });
}

/**
 * 모든 consume clear
 * 
 * @param {Boolean} isRemoveAudioEl - HTML 오디오 요소 객체 제거 여부
 * @param {Boolean} isForSoundOnly - 오디오만 처리하면 되는지 여부
 * @returns {Promise<Boolean | Error>}
 */
const clearHandsUpConsumeAll = async (isRemoveAudioEl, isForSoundOnly) => {
    return new Promise(async (resolve, reject) => {
        try {
            if (clientInfo.handsupInfo.list_p2pConsumeInfo && clientInfo.handsupInfo.list_p2pConsumeInfo.length > 0) {
                const promises = clientInfo.handsupInfo.list_p2pConsumeInfo.map((info) => clearHandsUpConsume(isRemoveAudioEl, isForSoundOnly, info.rcvSeq));
                await Promise.all(promises);
            }

            if (clientInfo.handsupInfo.list_consumeInfo && clientInfo.handsupInfo.list_consumeInfo.length > 0) {
                const promises = clientInfo.handsupInfo.list_consumeInfo.map((info) => clearHandsUpConsume(isRemoveAudioEl, isForSoundOnly, info.rcvSeq));
                await Promise.all(promises);
            }

            resolve(true);
        } catch (err) {
            console.log("clearHandsUpConsumeAll err => ", err);
            reject(err);
        }
    });
}

/**
 * audio consume 을 가지고 있는지 체크
 * 
 * @returns {Boolean}
 */
export const hasAudioConsume = () => {
    if (clientInfo.handsupInfo.list_consumeInfo && clientInfo.handsupInfo.list_consumeInfo.length > 0) {
        return true;
    } else {
        return false;
    }
}

/**
 * audio consume listen
 * 
 * @param {Number} rcvSeq - 선생님 사용자 시퀀스 번호 (= teacherSeq)
 * @returns {Promise<Boolean | Error>}
 */
export const listenAudioConsume = async (rcvSeq) => {
    console.log(`listenAudioConsume - rcvSeq[${rcvSeq}]`);
    return new Promise(async (resolve, reject) => {
        try {
            if (clientInfo.handsupInfo.list_consumeInfo && clientInfo.handsupInfo.list_consumeInfo.length > 0) {
                const consumeInfo = getConsumeInfoBySeq(rcvSeq);
                if (consumeInfo) {
                    console.log(`listenAudioConsume - rcvSeq[${consumeInfo.rcvSeq}], isAudioReceived[${consumeInfo.isAudioReceived}], isMuteAudio[${consumeInfo.isMuteAudio}]`);
                    if (consumeInfo.audioConsumer) {
                        if (consumeInfo.audioStream === null) {
                            consumeInfo.audioStream = new MediaStream();
                            consumeInfo.audioStream.addTrack(consumeInfo.audioConsumer.track);
                        } else {
                            if (consumeInfo.audioStream.getTracks().length > 0) {
                                console.log("listenAudioConsume - consumeInfo.audioStream getTracks.length > 0");
                            } else {
                                consumeInfo.audioStream.addTrack(consumeInfo.audioConsumer.track);
                            }
                        }

                        if (consumeInfo.audioEl) {
                            applyPblStudentAudioListenToElement(consumeInfo.audioEl);
                            if (consumeInfo.audioEl.srcObject === null) {
                                consumeInfo.audioEl.srcObject = consumeInfo.audioStream;
                                /* if (ConstData.IS_LOCAL_VERSION) consumeInfo.audioEl.volume = 0;
                                // 20251017 ... play() 오류 방지를 위해 paused 상태 값 체크 추가 ... by hjkim
                                if (consumeInfo.audioEl.paused) {
                                    await consumeInfo.audioEl.play();
                                } else {
                                    console.log("consumeAfter - Audio element already playing audio source.");
                                } */

                                // let volume = ConstData.IS_LOCAL_VERSION && !getIsForPblModeBrowser() ? 0 : undefined;
                                let volume = ConstData.IS_LOCAL_VERSION && !getIsForPblModeBrowser() ? clientInfo.consumeInfo.savedVolume : undefined;
                                console.log("listenAudioConsume -  volume[", volume, "]");
                                if (ConstData.IS_LOCAL_VERSION && isIOSWebView()) { // ios 는 volume = 0 이 동작하지 않아서 track 비활성화/활성화로 처리 .... by ykhan 251013
                                    const stream = consumeInfo.audioEl.srcObject;
                                    stream.getAudioTracks().forEach(track => {
                                        if (volume === 0) track.enabled = false;
                                        else track.enabled = true;
                                    });
                                }

                                let result = await playAudio(consumeInfo.audioEl, volume);
                                console.log("listenAudioConsume - playAudio result => ", result);

                                if (result && getIsForPblModeBrowser()) {
                                    console.log("listenAudioConsume - listenAudioConsumeHelper(consumeInfo.rcvSeq, consumeInfo.audioStream, volume).");
                                    listenAudioConsumeHelper("handsup", consumeInfo.rcvSeq, consumeInfo.audioStream, volume);
                                }
                                console.log(`(1)listenAudioConsume - audioEl paused[${consumeInfo.audioEl.paused}], muted[${consumeInfo.audioEl.muted}], volume[${consumeInfo.audioEl.volume}]`);
                            } else {
                                console.log("listenAudioConsume - audioEl.srcObject not null. already listen");
                                console.log(`(2)listenAudioConsume - audioEl paused[${consumeInfo.audioEl.paused}], muted[${consumeInfo.audioEl.muted}], volume[${consumeInfo.audioEl.volume}]`);
                            }
                        }
                    }

                    consumeInfo.isMuteAudio = false;
                }
            }

            resolve(true);
        } catch (err) {
            console.log("------listenAudioConsume------error => ", err);
            reject(err);
        }
    });
}

/**
 * 모든 audio consume listen
 * 
 * @returns {Promise<Boolean | Error>}
 */
export const listenAudioConsumeAll = async () => {
    return new Promise(async (resolve, reject) => {
        try {
            if (clientInfo.handsupInfo.list_consumeInfo && clientInfo.handsupInfo.list_consumeInfo.length > 0) {
                const promises = clientInfo.handsupInfo.list_consumeInfo.map((info) => listenAudioConsume(info.rcvSeq));
                await Promise.all(promises);
            }

            resolve(true);
        } catch (err) {
            console.log("------listenAudioConsumeAll------error => ", err);
            reject(err);
        }
    });
}

/**  MEDIA SOUP (선생님 audio/mic consume-cotrol) */
/**
 * 선생님(클래스 진행자) 마이크 mute
 * 
 * @returns {Promise<Boolean | Error>}
 * @private
 */
const muteMicTrack = () => {
    console.log(`muteMicTrack - rcvTeacherSeq[${clientInfo.rcvTeacherSeq}], isMicReceived[${clientInfo.consumeInfo.isMicReceived}], isSelectedMode[${clientInfo.consumeInfo.isSelectedMode}]`);
    return new Promise(async (resolve, reject) => {
        try {
            if (clientInfo.consumeInfo.micConsumer) { // mic consumer 체크 ... by hjkim 20220222
                if (clientInfo.consumeInfo.micEl) {
                    let result = await pauseAudio(clientInfo.consumeInfo.micEl);
                    console.log("muteMicTrack - pauseAudio result => ", result);

                    if (result && getIsForPblModeBrowser()) {
                        console.log("muteMicTrack - muteMicConsumeHelper(rcvTeacherSeq).");
                        muteMicConsumeHelper(clientInfo.rcvTeacherSeq);
                    }

                    if (clientInfo.consumeInfo.micEl.srcObject) {
                        // if (!clientInfo.consumeInfo.micEl.paused) {
                        //     clientInfo.consumeInfo.micEl.pause();
                        // }
                        clientInfo.consumeInfo.micEl.srcObject = null;
                    }
                }

                if (clientInfo.consumeInfo.micStream !== null) {
                    clientInfo.consumeInfo.micStream.removeTrack(clientInfo.consumeInfo.micConsumer.track);
                    clientInfo.consumeInfo.micStream = null;
                }
            }

            resolve(true);
        } catch (err) {
            console.log("------muteMicTrack------error => ", err);
            reject(err);
        }
    });
}

/**
 * 선생님(클래스 진행자) 마이크 listen
 * 
 * @returns {Promise<Boolean | Error>}
 * @private
 */
const listenMicTrack = () => {
    console.log(`listenMicTrack - rcvTeacherSeq[${clientInfo.rcvTeacherSeq}], isMicReceived[${clientInfo.consumeInfo.isMicReceived}], isSelectedMode[${clientInfo.consumeInfo.isSelectedMode}]`);
    return new Promise(async (resolve, reject) => {
        try {
            if (clientInfo.consumeInfo.micConsumer) { // mic consumer 체크 ... by hjkim 20220222
                if (clientInfo.consumeInfo.micStream === null) {
                    clientInfo.consumeInfo.micStream = new MediaStream();
                    clientInfo.consumeInfo.micStream.addTrack(clientInfo.consumeInfo.micConsumer.track);
                } else {
                    if (clientInfo.consumeInfo.micStream.getTracks().length > 0) {
                        console.log(`listenMicTrack - micStream already has audio track. length[${clientInfo.consumeInfo.micStream.getTracks().length}]`);
                    } else {
                        clientInfo.consumeInfo.micStream.addTrack(clientInfo.consumeInfo.micConsumer.track);
                    }
                }

                if (clientInfo.consumeInfo.micEl) {
                    if (clientInfo.consumeInfo.micEl.srcObject === null) {
                        clientInfo.consumeInfo.micEl.srcObject = clientInfo.consumeInfo.micStream;
                        /* if (ConstData.IS_LOCAL_VERSION) clientInfo.consumeInfo.micEl.volume = 0;
                        // 20251017 ... play() 오류 방지를 위해 paused 상태 값 체크 추가 ... by hjkim
                        if (clientInfo.consumeInfo.micEl.paused) {
                            await clientInfo.consumeInfo.micEl.play();
                        } else {
                            console.log("consumeAfter - Mic Audio element already playing mic audio source.");
                        } */

                        // let volume = ConstData.IS_LOCAL_VERSION && !getIsForPblModeBrowser() ? 0 : undefined;
                        let volume = ConstData.IS_LOCAL_VERSION && !getIsForPblModeBrowser() ? clientInfo.consumeInfo.savedVolume : undefined;
                        console.log("listenMicTrack case 1 -  volume[", volume, "]");
                        if (isIOSWebView()) { // ios 는 volume = 0 이 동작하지 않아서 track 비활성화/활성화로 처리 .... by ykhan 251013
                            const stream = clientInfo.consumeInfo.micEl.srcObject;
                            stream.getAudioTracks().forEach(track => {
                                if (volume === 0) track.enabled = false;
                                else track.enabled = true;
                            });
                        }

                        let result = await playAudio(clientInfo.consumeInfo.micEl, volume);
                        console.log("listenMicTrack - playAudio result => ", result);

                        if (result && getIsForPblModeBrowser()) {
                            console.log("listenMicTrack - listenMicConsumeHelper(rcvTeacherSeq, micStream, volume).");
                            listenMicConsumeHelper(clientInfo.rcvTeacherSeq, clientInfo.consumeInfo.micStream, volume);
                        }
                    } else {
                        // 이미 재생 중 → play는 필요 없지만 volume은 최신값으로 맞춰줌
                        console.log("listenMicTrack - micEl.srcObject not null. already listen");
                        const volume = ConstData.IS_LOCAL_VERSION && !getIsForPblModeBrowser() ? clientInfo.consumeInfo.savedVolume : 1; // 첫 볼륨 설정이 아니므로 undefined 대신 1 사용 ... by hjkim 20260326
                        console.log("listenMicTrack case 2 -  volume[", volume, "]");
                        clientInfo.consumeInfo.micEl.volume = volume;
                        if (isIOSWebView()) { // ios 는 volume = 0 이 동작하지 않아서 track 비활성화/활성화로 처리 .... by ykhan 251013
                            const stream = clientInfo.consumeInfo.micEl.srcObject;
                            stream.getAudioTracks().forEach(track => {
                                if (volume === 0) track.enabled = false;
                                else track.enabled = true;
                            });
                        }
                    }
                }
            }

            resolve(true);
        } catch (err) {
            console.log("------listenMicTrack------error => ", err);
            reject(err);
        }
    });
}

/**
 * 선생님(클래스 진행자) 오디오 mute
 * 
 * @returns {Promise<Boolean | Error>}
 * @private
 */
const muteAudioTrack = () => {
    console.log(`muteAudioTrack - rcvTeacherSeq[${clientInfo.rcvTeacherSeq}], isAudioReceived[${clientInfo.consumeInfo.isAudioReceived}], isSelectedMode[${clientInfo.consumeInfo.isSelectedMode}]`);
    return new Promise(async (resolve, reject) => {
        try {
            if (clientInfo.consumeInfo.audioConsumer) {
                if (clientInfo.consumeInfo.audioEl) {
                    let result = await pauseAudio(clientInfo.consumeInfo.audioEl);
                    console.log("muteAudioTrack - pauseAudio result => ", result);

                    if (result && getIsForPblModeBrowser()) {
                        console.log("muteAudioTrack - muteAudioConsumeHelper(live, rcvTeacherSeq).");
                        muteAudioConsumeHelper("live", clientInfo.rcvTeacherSeq);
                    }

                    if (clientInfo.consumeInfo.audioEl.srcObject) {
                        // if (!clientInfo.consumeInfo.audioEl.paused) {
                        //     clientInfo.consumeInfo.audioEl.pause();
                        // }
                        clientInfo.consumeInfo.audioEl.srcObject = null;
                    }
                }

                if (clientInfo.consumeInfo.audioStream !== null) {
                    clientInfo.consumeInfo.audioStream.removeTrack(clientInfo.consumeInfo.audioConsumer.track);
                    clientInfo.consumeInfo.audioStream = null;
                }
            }

            resolve(true);
        } catch (err) {
            console.log("------muteAudioTrack------error => ", err);
            reject(err);
        }
    });
}

/**
 * 선생님(클래스 진행자) 오디오 listen
 * 
 * @returns {Promise<Boolean | Error>}
 * @private
 */
const listenAudioTrack = () => {
    console.log(`listenAudioTrack - rcvTeacherSeq[${clientInfo.rcvTeacherSeq}], isAudioReceived[${clientInfo.consumeInfo.isAudioReceived}], isSelectedMode[${clientInfo.consumeInfo.isSelectedMode}]`);
    return new Promise(async (resolve, reject) => {
        try {
            if (clientInfo.consumeInfo.audioConsumer) { // audio consume 중인지 체크 ... by hjkim 20220211
                if (clientInfo.consumeInfo.audioStream === null) {
                    clientInfo.consumeInfo.audioStream = new MediaStream();
                    clientInfo.consumeInfo.audioStream.addTrack(clientInfo.consumeInfo.audioConsumer.track);
                } else {
                    if (clientInfo.consumeInfo.audioStream.getTracks().length > 0) {
                        console.log(`listenAudioTrack - audioStream already has audio track. length[${clientInfo.consumeInfo.audioStream.getTracks().length}]`);
                    } else {
                        clientInfo.consumeInfo.audioStream.addTrack(clientInfo.consumeInfo.audioConsumer.track);
                    }
                }

                if (clientInfo.consumeInfo.audioStream !== null) {
                    if (clientInfo.consumeInfo.audioEl) {
                        if (clientInfo.consumeInfo.audioEl.srcObject === null) {
                            if (!clientInfo.consumeInfo.audioEl.paused) {
                                clientInfo.consumeInfo.audioEl.pause();
                            }
                            clientInfo.consumeInfo.audioEl.srcObject = clientInfo.consumeInfo.audioStream;
                            /* if (ConstData.IS_LOCAL_VERSION) clientInfo.consumeInfo.audioEl.volume = 0;
                            // 20251017 ... play() 오류 방지를 위해 paused 상태 값 체크 추가 ... by hjkim
                            if (clientInfo.consumeInfo.audioEl.paused) {
                                await clientInfo.consumeInfo.audioEl.play();
                            } else {
                                console.log("consumeAfter - Audio element already playing audio source.");
                            } */

                            // let volume = ConstData.IS_LOCAL_VERSION && !getIsForPblModeBrowser() ? 0 : undefined;
                            let volume = ConstData.IS_LOCAL_VERSION && !getIsForPblModeBrowser() ? clientInfo.consumeInfo.savedVolume : undefined;
                            console.log("listenAudioTrack case 1 -  volume[", volume, "]");
                            if (ConstData.IS_LOCAL_VERSION && isIOSWebView()) { // ios 는 volume = 0 이 동작하지 않아서 track 비활성화/활성화로 처리 .... by ykhan 251013
                                const stream = clientInfo.consumeInfo.audioEl.srcObject;
                                stream.getAudioTracks().forEach(track => {
                                    if (volume === 0) track.enabled = false;
                                    else track.enabled = true;
                                });
                            }

                            let result = await playAudio(clientInfo.consumeInfo.audioEl, volume);
                            console.log("listenAudioTrack - playAudio result => ", result);

                            if (result && getIsForPblModeBrowser()) {
                                console.log("listenAudioTrack - listenAudioConsumeHelper(rcvTeacherSeq, micStream, volume).");
                                listenAudioConsumeHelper("live", clientInfo.rcvTeacherSeq, clientInfo.consumeInfo.audioStream, volume);
                            }
                        } else { // 이미 audio 듣고 있는 상태 ... 20220211
                            // 이미 재생 중 → play는 필요 없지만 volume은 최신값으로 맞춰줌
                            console.log("listenAudioTrack - audioEl.srcObject not null. already listen");
                            const volume = ConstData.IS_LOCAL_VERSION && !getIsForPblModeBrowser() ? clientInfo.consumeInfo.savedVolume : 1; // 첫 볼륨 설정이 아니므로 undefined 대신 1 사용 ... by hjkim 20260326
                            console.log("listenAudioTrack case 2 -  volume[", volume, "]");
                            clientInfo.consumeInfo.audioEl.volume = volume;
                            if (ConstData.IS_LOCAL_VERSION && isIOSWebView()) { // ios 는 volume = 0 이 동작하지 않아서 track 비활성화/활성화로 처리 .... by ykhan 251013
                                const stream = clientInfo.consumeInfo.audioEl.srcObject;
                                stream.getAudioTracks().forEach(track => {
                                    if (volume === 0) track.enabled = false;
                                    else track.enabled = true;
                                });
                            }
                        }
                    }
                }
            }

            resolve(true);
        } catch (err) {
            console.log("------listenAudioTrack------error => ", err);
            reject(err);
        }
    });
}

/**
 * handsup 창에서 선택 또는 p2p 중일 때
 * audio mute / mic listen / isSelectedMode = true.
 * 
 * @returns {Promise<Boolean>}
 */
export const setSelectedMode = async () => {
    return new Promise(async (resolve) => {
        try {
            clientInfo.consumeInfo.isSelectedMode = true;
            await muteAudioTrack();
            await listenMicTrack();
            resolve(true);
        } catch (err) {
            console.log("setSelectedMode err => ", err);
            resolve(false);
        }
    });
}

/**
 * handsup 창에서 선택되지 않고 p2p도 아닐 때
 * default : audio listen / mic off / isSelectedMode = false.
 * 예외 : isNeedMuteAudio가 true면 audio listen 하지 않는다.
 * 
 * @param {Boolean} isNeedMuteAudio - HTML 오디오 요소를 Mute해야 하는지 여부
 * @returns {Promise<Boolean>}
 */
export const setUnselectedMode = async (isNeedMuteAudio) => {
    return new Promise(async (resolve) => {
        try {
            clientInfo.consumeInfo.isSelectedMode = false;
            await muteMicTrack();
            if (isNeedMuteAudio !== true) {
                await listenAudioTrack();
            }
            resolve(true);
        } catch (err) {
            console.log("setUnselectedMode err => ", err);
            resolve(false);
        }
    });
}
/********************************/

/********************************/
/**  MEDIA SOUP SEND (consume) */
/********************************/

/**
 * send joinConsume request to mediaSoup server
 * 
 * @param {String} roomKind - 미디어 서버 룸 유형
 * @param {Number} rcvSeq - 선생님 사용자 시퀀스 번호 (= teacherSeq)
 */
export const sendJoinConsume = (roomKind, rcvSeq) => {
    console.log("sendJoinConsume - roomKind[", roomKind, "], rcvSeq[", rcvSeq, "], clientInfo - userSeq[", clientInfo.userSeq, "], liveSeq[", clientInfo.liveSeq, "], routingKey[", clientInfo.routingKey, "]");

    // 20260805 Phase 0 진단: 요청마다 requestId를 발급하고 전송 시점을 기록한다(추적 전용).
    const requestId = generateSmartTVMediaTraceRequestId();
    smartTVMediaTraceLog(roomKind === "handsup" ? "HANDSUP_JOIN_REQUEST" : "JOIN_REQUEST", {
        requestId, liveSeq: clientInfo.liveSeq, prodUserSeq: rcvSeq, consumUserSeq: clientInfo.userSeq, roomKind
    });

    const data = {
        kind            : "mediaSoup",
        action          : "joinConsume",
        requestId       : requestId,
        prodUserSeq     : rcvSeq,
        roomKind        : roomKind,     // live or handsup
        liveSeq         : clientInfo.liveSeq,
        consumUserSeq   : clientInfo.userSeq,
        sendRotingKey   : clientInfo.routingKey,
        monitorSessionId: clientInfo.monitorSessionId || undefined
    };

    sendObjectToRbmq(data);
}

/**
 * send joinConsume request to mediaSoup server with delay time
 * 
 * @param {String} callKind - 호출 유형
 * @param {String} roomKind - 미디어 서버 룸 유형
 * @param {Number} rcvSeq - 선생님 사용자 시퀀스 번호 (= teacherSeq)
 * @param {Number} delayTime - 지연 시간
 * @since 2025-08-08.
 * @private
 */
const sendJoinConsumeWithTimeout = (callKind, roomKind, rcvSeq, delayTime) => {
    console.log("sendJoinConsumeWithTimeout called - callKind[", callKind, "], roomKind[", roomKind, "], rcvSeq[", rcvSeq, "]");

    setTimeout(() => {
        console.log("setTimeout:) call sendJoinConsume - callKind[", callKind, "], roomKind[", roomKind, "], rcvSeq[", rcvSeq, "] after delayTime[", delayTime, "]");

        sendJoinConsume(roomKind, rcvSeq);
    }, delayTime);

    console.log("sendJoinConsumeWithTimeout - callKind[", callKind, "], roomKind[", roomKind, "], rcvSeq[", rcvSeq, "] ... Timer setting completed after delayTime[", delayTime, "]");
}

/**
 * send exitConsume request to mediaSoup server for live
 * 
 * @param {Number} rcvSeq - 선생님 사용자 시퀀스 번호 (= teacherSeq)
 */
export const sendExitConsume = (rcvSeq) => {
    console.log(`sendExitConsume - rcvSeq[${rcvSeq}], clientInfo - userSeq[${clientInfo.userSeq}], liveSeq[${clientInfo.liveSeq}], routingKey[${clientInfo.routingKey}]`);
    const data = {
        kind            : "mediaSoup",
        action          : "exitConsume",
        prodUserSeq     : rcvSeq,
        roomKind        : "live",
        liveSeq         : clientInfo.liveSeq,
        consumUserSeq   : clientInfo.userSeq,
        sendRotingKey   : clientInfo.routingKey
    };

    sendObjectToRbmq(data);
}

/**
 * send exitConsume request to mediaSoup server for handsup
 * 
 * @param {Boolean} isAudioReceiveable - 미디어 서버에서 오디오 스트림의 consume이 가능한지 여부
 * @param {Number} rcvSeq - 선생님 사용자 시퀀스 번호 (= teacherSeq)
 * @returns {Promise<Boolean>}
 * @private
 */
const sendExitConsumeHandsUp = (isAudioReceiveable, rcvSeq) => {
    console.log(`sendExitConsumeHandsUp - rcvSeq[${rcvSeq}], isAudioReceiveable[${isAudioReceiveable}], clientInfo - userSeq[${clientInfo.userSeq}], liveSeq[${clientInfo.liveSeq}], routingKey[${clientInfo.routingKey}]`);

    return new Promise((resolve, reject) => {
        const data = {
            kind            : "mediaSoup",
            action          : "exitConsume",
            prodUserSeq     : rcvSeq,
            roomKind        : "handsup",
            liveSeq         : clientInfo.liveSeq,
            consumUserSeq   : clientInfo.userSeq,
            sendRotingKey   : clientInfo.routingKey
        };

        sendObjectToRbmq(data);
        resolve(true);
    });
}

/**
 * send unsubscribe request to mediaSoup server
 * 
 * @param {Boolean} isForSoundOnly - 오디오만 처리하면 되는지 여부
 * @param {String} roomKind - 미디어 서버 룸 유형
 * @param {Number} rcvSeq - 선생님 사용자 시퀀스 번호 (= teacherSeq)
 * @private
 */
const sendUnsubscribe = (isForSoundOnly, roomKind, rcvSeq) => {
    console.log(`sendUnsubscribe - rcvSeq[${rcvSeq}], roomKind[${roomKind}], isForSoundOnly[${isForSoundOnly}], clientInfo - userSeq[${clientInfo.userSeq}], liveSeq[${clientInfo.liveSeq}], routingKey[${clientInfo.routingKey}]`);
    const data = {
        kind            : "mediaSoup",
        action          : "unsubscrib",
        prodUserSeq     : rcvSeq,
        roomKind        : roomKind,     // live or handsup
        liveSeq         : clientInfo.liveSeq,
        consumUserSeq   : clientInfo.userSeq,
        isForSoundOnly  : isForSoundOnly,
        sendRotingKey   : clientInfo.routingKey
    };

    sendObjectToRbmq(data);
}

/**
 * send consume request to mediaSoup server
 * 
 * @param {String} mediaKind - 미디어 유형
 * @param {String} roomKind - 미디어 서버 룸 유형
 * @param {Number} rcvSeq - 선생님 사용자 시퀀스 번호 (= teacherSeq)
 * @private
 */
const sendConsume = (mediaKind, roomKind, rcvSeq) => {
    const { rtpCapabilities } = clientInfo.device;
    console.log(`sendConsume - rcvSeq[${rcvSeq}], roomKind[${roomKind}], mediaKind[${mediaKind}], clientInfo - userSeq[${clientInfo.userSeq}], liveSeq[${clientInfo.liveSeq}], routingKey[${clientInfo.routingKey}]`);
    console.log("rtpCapabilities => ", rtpCapabilities);

    // 20260805 Phase 0 진단: 요청마다 requestId를 발급하고 전송 시점을 기록한다(추적 전용).
    const requestId = generateSmartTVMediaTraceRequestId();
    smartTVMediaTraceLog(roomKind === "handsup" ? "HANDSUP_CONSUME_REQUEST" : "CONSUME_REQUEST", {
        requestId, liveSeq: clientInfo.liveSeq, prodUserSeq: rcvSeq, consumUserSeq: clientInfo.userSeq, roomKind, mediaKind
    });

    const data = {
        kind            : "mediaSoup",
        action          : "consume",
        requestId       : requestId,
        mediaKind       : mediaKind,
        prodUserSeq     : rcvSeq,
        roomKind        : roomKind,     // live or handsup
        liveSeq         : clientInfo.liveSeq,
        rtpCapabilities : rtpCapabilities,
        consumUserSeq   : clientInfo.userSeq,
        sendRotingKey   : clientInfo.routingKey
    };

    sendLiveConsumeOnce(roomKind, mediaKind, requestId, getIsSmartTVCurrentPage(), () => sendObjectToRbmq(data)); // 20261028 같은 종류 live consume 대기 중이면 중복 요청 안 함 (web-relay R-207)
}

/**
 * send consume request to mediaSoup server with delay time
 * 
 * @param {String} callKind - 호출 유형
 * @param {String} mediaKind - 미디어 유형
 * @param {String} roomKind - 미디어 서버 룸 유형
 * @param {Number} rcvSeq - 선생님 사용자 시퀀스 번호 (= teacherSeq)
 * @param {Number} delayTime - 지연 시간
 * @since 2025-08-11.
 * @private
 */
const sendConsumeWithTimeout = (callKind, mediaKind, roomKind, rcvSeq, delayTime) => {
    console.log("sendConsumeWithTimeout called - callKind[", callKind, "], mediaKind[", mediaKind, "], roomKind[", roomKind, "], rcvSeq[", rcvSeq, "]");

    setTimeout(() => {
        console.log("setTimeout:) call sendConsume - callKind[", callKind, "], mediaKind[", mediaKind, "], roomKind[", roomKind, "], rcvSeq[", rcvSeq, "] after delayTime[", delayTime, "]");

        sendConsume(mediaKind, roomKind, rcvSeq);
    }, delayTime);

    console.log("sendConsumeWithTimeout - callKind[", callKind, "], mediaKind[", mediaKind, "], roomKind[", roomKind, "], rcvSeq[", rcvSeq, "] ... Timer setting completed after delayTime[", delayTime, "]");
}

/**
 * send resume request to mediaSoup server
 * 
 * @param {String} mediaKind - 미디어 유형
 * @param {String} roomKind - 미디어 서버 룸 유형
 * @param {Number} rcvSeq - 선생님 사용자 시퀀스 번호 (= teacherSeq)
 * @private
 */
const sendResume = (mediaKind, roomKind, rcvSeq) => {
    console.log(`sendResume - rcvSeq[${rcvSeq}], roomKind[${roomKind}], mediaKind[${mediaKind}], clientInfo - userSeq[${clientInfo.userSeq}], liveSeq[${clientInfo.liveSeq}], routingKey[${clientInfo.routingKey}]`);

    const data = {
        kind            : "mediaSoup",
        action          : "resume",
        mediaKind       : mediaKind,
        prodUserSeq     : rcvSeq,
        roomKind        : roomKind,     // live or handsup
        liveSeq         : clientInfo.liveSeq,
        consumUserSeq   : clientInfo.userSeq,
        sendRotingKey   : clientInfo.routingKey
    };

    sendObjectToRbmq(data);
}

/********************************/
/** 260923 ICE 재시작 복구 (설계: docs/superpowers/specs/2026-09-23-mediasoup-ice-restart-design.md) */
/********************************/

// transport 하나에 조정자 하나. transport 를 새로 만들 때마다 갈아 끼운다.
let rcvIceRestart = null;
let rcvIceRestartTimer = null;

/**
 * 수신 transport 용 ICE 재시작 조정자를 만든다.
 * 판단은 iceRestartCoordinator 가 하고, 여기서는 부작용만 묶는다.
 *
 * @param {Transport} transport - 방금 만든 수신 transport
 * @param {Number} rcvSeq - 선생님 사용자 시퀀스 번호 (= teacherSeq)
 * @private
 */
const createRcvIceRestart = (transport, rcvSeq) => {
    const clearWake = () => {
        if (rcvIceRestartTimer !== null) {
            clearTimeout(rcvIceRestartTimer);
            rcvIceRestartTimer = null;
        }
    };

    // 260923 transport.close()는 connectionstatechange("closed")를 쏘지 않는다
    // (mediasoup-client Transport.close()는 observer "close"만 emit한다).
    // 그래서 보류 중에 disconnectLive() 등으로 닫히면 조정자가 그것을 모른 채 남고,
    // 30초 뒤 깨어난 타이머가 이미 끝난 수업에 exitConsume을 보내 connectLive를 다시 건다.
    // 지금 살아 있는 수신 transport가 아니면 아무 일도 하지 않는다.
    const isStale = () => transport.closed || clientInfo.rcvTransport !== transport;

    let coordinator = null;

    coordinator = createIceRestartCoordinator({
        sendRequest : () => sendRestartConsumerTransport(transport.id, rcvSeq),
        restartIce  : (iceParameters) => transport.restartIce({ iceParameters }),
        // 예전 흐름 그대로다 — teardown → exitConsume → connectStatus "disable" → connectLive 재호출
        fallback    : (reason) => {
            console.log(`createRcvIceRestart - fallback reason[${reason}]`);   // 260930 포기 이유(로그용)
            if (isStale()) {
                console.log("createRcvIceRestart - fallback 건너뜀. 이미 지난 transport다.");
                return;
            }

            // 260923 미디어가 정말 죽었다고 확정된 자리다. 기기 망까지 끊긴 경우에만 학생 앱에
            // 알린다 — 앱은 이 신호로 세션을 내리고 사고 복귀를 기억한다.
            // ⚠ navigator.onLine 조건이 핵심이다. 미디어만 죽고 MQ 는 살아 있는 갈래(이 복구층이
            //   노린 바로 그 경우)에 보내면 앱이 멀쩡한 세션을 잘못 내린다.
            // 이것이 있어야 Android capture.pro 가 OS 네트워크 3초 유예를 걷을 수 있다.
            // (Pro 실기 61차 §6-2 · Pro 회신 254 §3-1 · 공동작업 계획 규칙 ③의 선행분)
            // 앱은 이 신호를 멱등으로 받는다 — OS 감시와 겹쳐도 해가 없다.
            if (navigator.onLine === false) {
                console.log("createRcvIceRestart - fallback 진입, 기기 망도 끊겼다. call sendToStudentApp({ kind: 'disconnect', reason: 'conn-lost' }).");
                sendToStudentApp({ kind: "disconnect", reason: "conn-lost" });
            }

            // 20261002 r15110 선생님 영상 자동 재접속과 합침 — 조정자가 실제로 포기한 이 자리에서 재시도 1회로 센다.
            // 20261002 [재검토 요청] 여기서 감시 타이머(LIVE_RECONNECT_WATCH_MS, 40초)를 함께 건다.
            //  - 왜: 조정자는 한 번 connected 된 transport 의 disconnected / failed 만 다룬다(connecting 은 보지 않는다).
            //    여기서 새로 만든 transport 가 망이 끊긴 채 connecting 에서 멈추면 상태 이벤트가 더 오지 않아 조정자가 깨어나지 않는다.
            //    MQ 까지 끊겨 새 transport 자체가 안 만들어지는 경우도 같다. 감시가 없으면 "재연결 중…" 이 영구히 남고
            //    망이 돌아와도 복구되지 않는다(재현: 100초 차단 → 재연결 1회 후 connecting 정지 → 해제 30초 뒤에도 정지, [다시 연결] 없음).
            //  - 언제: 감시는 이 자리(조정자 포기 뒤)와 [다시 연결] 에서만 켜진다. 정상 연결 중의 첫 끊김은 조정자 혼자 처리한다.
            //    새 transport 가 40초 안에 connected 되면 onLiveReceiveConnected 가 타이머를 끄고, 이후 끊김은 그 transport 의 조정자가 맡는다.
            //  - 중복: 조정자 fallback 과 감시 타이머는 같은 registerLiveReceiveLost 로 센다. 이 함수는 시작할 때 이전 타이머를 지우므로
            //    한 번의 재시도가 두 번 세지지 않는다. 타이머가 조정자의 restartIce 도중에 울려 transport 를 정리해도
            //    isStale() 검사와 새 transport 생성 시 rcvIceRestart.reset() 으로 옛 조정자는 아무 일도 하지 않는다.
            //  - 시간(긴 끊김): 끊김 → 조정자 포기 약 20초(1회) → 40초마다 재시도(약 60초 2회, 약 100초 3회) → 약 140초에 failed + [다시 연결].
            //    망이 약 100초 안에 돌아오면 자동 복구된다(90초 끊김 포함). 망 복구 뒤 영상이 돌아오기까지는 최대 약 40초.
            //  - 연결 agent(학생 앱) 사용 여부와 무관하다. 이 fallback 에서 agent 관련은 위 sendToStudentApp 한 줄뿐이다.
            if (isLiveAutoReconnectTarget()) {
                registerLiveReceiveLost(reason);
            }

            changeConnectionStateConsumerTransportAfter("disconnected");
        },
        setWake     : (ms) => {
            clearWake();
            rcvIceRestartTimer = setTimeout(() => {
                rcvIceRestartTimer = null;

                if (isStale()) {
                    console.log("createRcvIceRestart - 타이머 발화 시점에 이미 지난 transport다. 아무것도 하지 않는다.");
                    coordinator.reset();
                    return;
                }

                coordinator.onWake();
            }, ms);
        },
        clearWake
    });

    return coordinator;
}

/**
 * send restartConsumerTransport request to mediaSoup server
 * 필드는 sendCreateConsumerTransport 와 같고 action 과 transportId 만 다르다.
 *
 * @param {String} transportId - 클라이언트 transport.id. 서버가 자기 것과 대조한다
 * @param {Number} rcvSeq - 선생님 사용자 시퀀스 번호 (= teacherSeq)
 * @private
 */
const sendRestartConsumerTransport = (transportId, rcvSeq) => {
    console.log(`sendRestartConsumerTransport - transportId[${transportId}], rcvSeq[${rcvSeq}], clientInfo - userSeq[${clientInfo.userSeq}], liveSeq[${clientInfo.liveSeq}], routingKey[${clientInfo.routingKey}]`);

    const data = {
        kind            : "mediaSoup",
        action          : "restartConsumerTransport",
        prodUserSeq     : rcvSeq,
        roomKind        : "live",
        liveSeq         : clientInfo.liveSeq,
        consumUserSeq   : clientInfo.userSeq,
        sendRotingKey   : clientInfo.routingKey,
        transportId     : transportId
    };

    sendObjectToRbmq(data);
}

/**
 * restartConsumerTransport 요청 후 서버에서 받은 데이터 처리
 *
 * @param {JSON} rtnValue - 서버에서 받은 JSON 데이터 객체
 */
export const restartConsumerTransportAfter = (rtnValue) => {
    console.log("restartConsumerTransportAfter - rtnValue => ", rtnValue);

    if (rcvIceRestart === null) return;

    // 260923 조정자가 잡은 transport 와 같은 것이다 — 조정자는 transport 를 새로 만들 때마다 갈아 끼운다.
    const currentTransportId = clientInfo.rcvTransport ? clientInfo.rcvTransport.id : null;
    rcvIceRestart.onResponse(rtnValue, currentTransportId);
}

// 송출 transport 용. 손 든 학생(handsUp)만 가진다.
let sendIceRestart = null;
let sendIceRestartTimer = null;

// 260930 Android 네이티브 송출 transport 용. JS 에 transport 객체가 없으므로 transportId 로 세대를 가른다.
// createProducerTransportAfter 의 Android 갈래에서 만들고 갈아 끼운다(mediasoup/androidSendIceRestart.js).
let androidSendIceRestart = null;

/**
 * 260930 Android 송출 ICE 재시작 어댑터를 멈춘다.
 *
 * @param {String} why - 로그용
 * @private
 */
const retireAndroidSendIceRestart = (why) => {
    if (androidSendIceRestart === null) return;
    console.log(`retireAndroidSendIceRestart - ${why}, transportId[${androidSendIceRestart.transportId}]`);
    androidSendIceRestart.retire();
    androidSendIceRestart = null;
}

/**
 * 260930 Android 네이티브가 알려 준 송출 transport 상태 (pro-producerTransportState)
 *
 * @param {String} state       - "connected" | "disconnected" | "failed" | "closed"
 * @param {String} transportId - 서버가 준 transport id
 */
export const producerTransportStateFromNative = (state, transportId) => {
    console.log(`producerTransportStateFromNative - state[${state}], transportId[${transportId}]`);

    if (androidSendIceRestart === null) {
        console.log("producerTransportStateFromNative - 지켜보는 송출 transport 가 없다. 버린다.");
        return;
    }

    // 261002 지켜보는 송출 transport 가 붙었다 — 재생성 감시를 끈다.
    if (state === "connected" && androidSendIceRestart.transportId === transportId) {
        sendRecreateWatch.connected();
    }

    androidSendIceRestart.onNativeState(state, transportId);

    // 네이티브가 스스로 정리했다(유예 만료 · unpublish). 이 transport 는 끝났으니 어댑터를 내린다.
    // 261027 유예 만료(복구 중의 closed)면 바로 위 onNativeState 에서 어댑터가 이미 「포기 신호 → 생성」을 보내고
    // 재생성 감시까지 걸었다(Pro 95-3 · androidSendIceRestart.js). 다시 세운 transport 는 응답에서 새 어댑터가 맡는다.
    if (state === "closed" && androidSendIceRestart !== null && androidSendIceRestart.transportId === transportId) {
        retireAndroidSendIceRestart("네이티브 transport closed");
    }
}

/**
 * 261027 Android 네이티브가 MQ 를 새 clientId 로 스스로 되살렸다 (pro-rbmqRevived · 구독 복구 뒤에 온다).
 * 앱 유예 만료(끊김 +32초)가 MQ 복구보다 먼저 오면 native-closed 의 재생성 요청이 버려진다(Pro 97-1).
 * 재생성 감시가 아직 걸려 있으면 = 송출이 아직 안 붙었으면 한 번 더 보낸다. 복원 표시는 앞선 포기 신호 때
 * 이미 섰고 다음 생성까지 남는다(Android 98차 답 §3) — 포기 신호는 다시 보내지 않는다.
 * relay 가 송출을 쥔 수업은 relay-mq-recovered 가 같은 일을 하므로 건드리지 않는다 — 둘이 하면 생성이 겹친다.
 *
 * @param {Object} data - { reason: "self-reconnect", connLostReported }
 */
export const rbmqRevivedFromNative = (data) => {
    console.log(`rbmqRevivedFromNative - reason[${data && data.reason}], connLostReported[${data && data.connLostReported}]`);

    if (relayLive.keepsAudio()) {
        console.log("rbmqRevivedFromNative - relay 가 MQ 복구 뒤 송출을 다시 세운다. 여기서는 하지 않는다.");
        return;
    }

    sendRecreateWatch.resendIfWaiting("mq-revived", sendCreateProducerTransport);
}

// 260928 송출 fallback 이 붙잡아 두는 트랙.
// ⚠ 경쟁 조건 때문에 필요하다 — 수신 fallback 이 곧바로 connectLive → initLiveInfo →
// initMediaClientStateValue 로 가면서 produceInfo 의 트랙과 status 를 지운다.
// 우리 live_createProducerTransport 응답은 그보다 98밀리초 늦게 와서(Pro 실기 69차 §2)
// createProducerTransportAfter 의 게이트가 빈 값을 보고 produce 를 한 번도 안 부른다.
// 그러면 transport.on(connect) 도 안 불려 ICE 가 시작되지 않고, 조정자를 깨울 이벤트도 없다.
let pendingProducerRestore = null;

/**
 * 261002 송출 transport 재생성 감시 (mediasoup/sendRecreateWatch.js).
 * 재생성을 요청한 뒤 40초 안에 송출 transport 가 connected 되지 않으면 다시 세운다 —
 * 새 transport 가 connecting 에서 멈추거나 MQ 가 끊겨 요청이 사라지면 조정자를 깨울 이벤트가 없다.
 * PC(createSendIceRestart fallback) · Android(어댑터 recreate) · PBL 그룹 송출이 모두 이 길을 탄다.
 * 첫 참여 때는 걸지 않는다. 해제는 송출 transport connected · unpublish ALL.
 */
const sendRecreateWatch = createSendRecreateWatch({
    onTimeout: (why) => {
        console.log(`sendRecreateWatch - 재생성 뒤 ${SEND_RECREATE_WATCH_MS / 1000}초 안에 송출이 붙지 않았다(직전 이유 ${why}). 다시 세운다.`);

        if (relayLive.nativeScreen(checkAndroidScreenValue())) { // 20261020 C3 relay는 기존 웹 transport/Producer 경로 사용
            // 지켜보던 transport 가 있으면 어댑터가 네이티브 정리 → 재생성(→ 감시 재시작)까지 한다.
            if (androidSendIceRestart !== null && androidSendIceRestart.abandon(SEND_CONNECT_TIMEOUT_REASON)) {
                return;
            }

            // 재생성 응답이 아예 안 왔다(어댑터가 없거나 이미 멈춤). 네이티브에 복원 표시를 세우게 한 뒤 다시 요청한다
            // — 네이티브는 sendTransport 가 없어도 포기 신호에 복원 표시를 세운다(Android 4b6181b).
            window.callRestartProducerTransportFailed(SEND_CONNECT_TIMEOUT_REASON);
            sendCreateProducerTransport();
            sendRecreateWatch.arm(SEND_CONNECT_TIMEOUT_REASON);
            return;
        }

        recreateSendTransport(SEND_CONNECT_TIMEOUT_REASON);
    }
});

// 20261028 학생 송출 종료 owner·정리 연결 (web-relay R-224, milestone_42 §3.14·§3.16). 판단·정리는 mediasoup/sendExitGuard·sendExitCleanup.
const sendExitGuard = createSendExitGuard();
const sendExitHooks = createSendExitHooks(sendExitGuard, {
    clientInfo,
    stopRecovery: (why) => {
        sendRecreateWatch.cancel();
        if (sendIceRestartTimer !== null) { clearTimeout(sendIceRestartTimer); sendIceRestartTimer = null; }
        if (sendIceRestart !== null) { sendIceRestart.reset(); sendIceRestart = null; }
        retireAndroidSendIceRestart(why);
    },
    takePendingRestore: () => { const kept = pendingProducerRestore; pendingProducerRestore = null; return kept; },
    hasPendingRestore: () => pendingProducerRestore !== null, // 20261028 앱 웹뷰의 미완성 웹 복원 판정 (R-241)
    traceAudio: (producer) => relayLive.traceAudio(producer, "send-exit-close", clientInfo.sendTransport),
    notifyCameraStopped: () => notifyCameraCaptureState({ source: "camera", state: "stopped" }),
    notifyRotationOff: () => notifyDisplayRotationSendStatus(0),
    clearAudioInput: () => clearAudioInput(),
    clearVideoInput: () => clearVideoInput(),
    isNativeWebView: () => isAndroidWebView() || isIOSWebView(),
    snapshotExitInputs: (token) => beginMixerExitSnapshot(token), // 20261029 믹서 입력·마이캠 종료 스냅샷 (R-257)
    releaseExitInputs: (token, skipMyCam) => releaseMixerExitSnapshot(token, { skipMyCam }), // 20261029 스냅샷 전체 반환 (R-257)
    endExitInputs: (token) => endMixerExitSnapshot(token) // 20261029 스냅샷 닫기 (R-258)
});
export const runLiveSendExit = (why, isTarget, body) => ((sendExitGuard.getState() === "exiting" || isTarget) ? sendExitGuard.runExit(why, { onBegin: sendExitHooks.onBegin, onFinish: sendExitHooks.onFinish, waitAcquires: () => sendExitGuard.waitAcquires(), onSettled: (token) => { try { return sendExitHooks.onSettled(token); } finally { sendOpGuard.sweep("exit-settled"); } }, body }) : body(null)); // 20261030 획득 ticket 대기·회수 후보 재판정 연결 (R-240·R-267) // 20261028 대상 값 초기화 뒤에도 진행 중 종료를 먼저 공유 (R-243) // 20261029 종료 job 끝까지 캡처 스냅샷 보호 (R-259)
export const finishLiveSendExit = (token) => sendExitGuard.finishOnce(token, sendExitHooks.onFinish);
export const noteLiveSendRelayUnknown = (token, err) => sendExitGuard.noteRelayUnknown(token, err);
export const openLiveSendOwner = (liveSeq, userSeq) => sendExitGuard.openOwner(liveSeq, userSeq);
export const deferLiveSendStart = (run, isValid) => sendExitGuard.deferStart(run, isValid);
export const isStaleLiveSendResponse = (kind, action, liveSeq) => sendExitGuard.isStaleResponse(kind, action, liveSeq);
// 20261030 획득 2단계 연결 (web-relay R-238~R-240·R-262·R-264·R-266·R-267, milestone_42 §3.37·§3.39·§3.41·§3.44·§3.46)
const sendOpGuard = createSendOpGuard({
    isIntentValid: (intent) => sendExitGuard.isIntentValid(intent),
    getCurrent: () => ({
        transport: clientInfo.sendTransport,
        audioProducer: clientInfo.produceInfo.audioProducer,
        videoProducer: clientInfo.produceInfo.videoProducer,
        audioTrack: clientInfo.produceInfo.audioTrack,
        videoTrack: clientInfo.produceInfo.videoTrack,
        pending: pendingProducerRestore
    })
});
export const beginLiveSendAcquire = (kind) => sendExitGuard.beginAcquire(kind);
export const endLiveSendAcquire = (ticket) => sendExitGuard.endAcquire(ticket);
export const isLiveSendIntentValid = (intent) => sendExitGuard.isIntentValid(intent);
export const isLiveSendTrackInUse = (track) => sendOpGuard.isTrackInUse(track);
export const reclaimLiveSendTrack = (track, name) => sendOpGuard.reclaimTrack(track, name);

/**
 * 261002 PC 송출 transport 를 닫고 다시 세운다. 송출 조정자의 fallback 과 재생성 감시 만료가 함께 쓴다.
 *
 * 트랙과 *Status 는 건드리지 않는다 — createProducerTransportAfter 가 붙잡아 둔 트랙을 그대로 다시 싣는다.
 * 서버는 live_createProducerTransport 때 옛 세대를 닫아 주므로 live_unpublish 를 따로 보내지 않아도
 * 교사에게 close→new 가 간다(미디어 서버 세대 교체, 09-28 배포).
 *
 * @param {String} why - 로그용 · 감시 이유
 * @private
 */
const recreateSendTransport = (why) => {
    if (!sendExitGuard.canRequestSend()) { console.log(`recreateSendTransport - 송출 종료 상태라 다시 세우지 않는다(${why}).`); return; } // 20261028 (web-relay R-224)
    // 260928 전역이 지워져도 되도록 트랙을 붙잡아 둔다(위 pendingProducerRestore 주석).
    // status 는 붙잡지 않는다 — 평시 값이 ended 라 붙잡아도 게이트를 못 넘는다.
    // 되돌리는 자리에서 "start" 로 새로 세운다(Pro 실기 71차 §2-2).
    // 261002 앞선 재생성의 응답이 안 와 아직 쓰지 않은 것이 있으면 그것도 받는다(감시 만료로 다시 세울 때).
    const prev = pendingProducerRestore;
    const audioTrack = clientInfo.produceInfo.audioTrack || (prev !== null ? prev.audioTrack : null);
    const videoTrack = clientInfo.produceInfo.videoTrack || (prev !== null ? prev.videoTrack : null);

    // 261002 실을 것이 없으면 세우지 않는다 — 그 사이 정상 정리(unpublishAfter)가 트랙을 멈췄다.
    const isAlive = (track) => track !== null && track !== undefined && track.readyState === "live";
    if (!isAlive(audioTrack) && !isAlive(videoTrack)) {
        console.log(`recreateSendTransport - 실을 트랙이 없다. 다시 세우지 않는다(${why}).`);
        sendRecreateWatch.cancel();
        return;
    }

    const transport = clientInfo.sendTransport;
    relayLive.traceAudio(clientInfo.produceInfo.audioProducer, "transport-recreate:" + why, transport); // 20261021 R-148 복구 원인
    if (transport !== null && !transport.closed) {
        transport.close();
    }

    pendingProducerRestore = { audioTrack, videoTrack };

    clientInfo.produceInfo.audioProducer = null;
    clientInfo.produceInfo.videoProducer = null;
    clientInfo.sendTransport = null;
    clientInfo.sendTransportStatus = "ended";

    sendCreateProducerTransport();
    sendRecreateWatch.arm(why);
}

/**
 * 송출 transport 용 ICE 재시작 조정자를 만든다.
 *
 * @param {Transport} transport - 방금 만든 송출 transport
 * @private
 */
const createSendIceRestart = (transport) => {
    const clearWake = () => {
        if (sendIceRestartTimer !== null) {
            clearTimeout(sendIceRestartTimer);
            sendIceRestartTimer = null;
        }
    };

    // 260923 transport.close()는 connectionstatechange("closed")를 쏘지 않는다
    // (mediasoup-client Transport.close()는 observer "close"만 emit한다).
    // 그래서 보류 중에 닫히면 조정자가 그것을 모른 채 남고, 뒤늦게 깨어난 타이머가
    // 이미 지난 transport에 대고 요청을 보내거나 정리를 돈다.
    // 지금 살아 있는 송출 transport가 아니면 아무 일도 하지 않는다. (수신 쪽 createRcvIceRestart와 같은 모양)
    const isStale = () => transport.closed || clientInfo.sendTransport !== transport;

    let coordinator = null;

    coordinator = createIceRestartCoordinator({
        sendRequest : () => sendRestartProducerTransport(transport.id),
        restartIce  : (iceParameters) => transport.restartIce({ iceParameters }),
        // 260928 예전에는 transport.close()가 전부였다. 그러면 재생성 방아쇠가 없어
        // 송출이 영영 안 돌아온다 — 교사 화면에 「참여 중인데 검은 타일」로 남는다
        // (Pro 실기 68차 §2). 수신이 changeConnectionStateConsumerTransportAfter로
        // 재생성까지 가는 것처럼, 송출도 여기서 transport를 다시 세운다.
        //
        // 트랙과 *Status는 건드리지 않는다 — createProducerTransportAfter가
        // produceInfo.audioTrack/videoTrack을 그대로 다시 싣는다.
        // 서버는 live_createProducerTransport 때 옛 세대를 닫아 주므로 live_unpublish를
        // 따로 보내지 않아도 교사에게 close→new가 간다(미디어 서버 세대 교체, 09-28 배포).
        fallback    : (reason) => {
            console.log(`createSendIceRestart - fallback reason[${reason}]`);   // 260930 포기 이유(로그용)
            if (isStale()) {
                console.log("createSendIceRestart - fallback 건너뜀. 이미 지난 transport다.");
                return;
            }

            console.log("createSendIceRestart - fallback 진입, 송출 transport 를 다시 세운다.");

            recreateSendTransport(reason);
        },
        setWake     : (ms) => {
            clearWake();
            sendIceRestartTimer = setTimeout(() => {
                sendIceRestartTimer = null;

                if (isStale()) {
                    console.log("createSendIceRestart - 타이머 발화 시점에 이미 지난 transport다. 아무것도 하지 않는다.");
                    coordinator.reset();
                    return;
                }

                coordinator.onWake();
            }, ms);
        },
        clearWake
    });

    return coordinator;
}

/**
 * send live_restartProducerTransport request to mediaSoup server
 * 필드는 sendCreateProducerTransport 와 같고 action 과 transportId 만 다르다.
 *
 * @param {String} transportId - 클라이언트 transport.id
 * @private
 */
const sendRestartProducerTransport = (transportId) => {
    console.log(`sendRestartProducerTransport - transportId[${transportId}], clientInfo - userSeq[${clientInfo.userSeq}], liveSeq[${clientInfo.liveSeq}], routingKey[${clientInfo.routingKey}]`);

    const data = {
        kind            : "mediaSoup",
        action          : "live_restartProducerTransport",
        prodUserSeq     : clientInfo.userSeq,
        liveSeq         : clientInfo.liveSeq,
        sendRotingKey   : clientInfo.routingKey,
        transportId     : transportId
    };

    sendObjectToRbmq(data);
}

/**
 * live_restartProducerTransport 요청 후 서버에서 받은 데이터 처리
 *
 * @param {JSON} rtnValue - 서버에서 받은 JSON 데이터 객체
 */
export const restartProducerTransportAfter = (rtnValue) => {
    console.log("restartProducerTransportAfter - rtnValue => ", rtnValue);

    // 260930 Android 는 송출 transport 를 네이티브가 쥔다. 어댑터가 응답을 네이티브에 넘긴다.
    if (androidSendIceRestart !== null) {
        androidSendIceRestart.onResponse(rtnValue);
        return;
    }

    if (sendIceRestart === null) return;

    // 260923 조정자가 잡은 transport 와 같은 것이다 — 조정자는 transport 를 새로 만들 때마다 갈아 끼운다.
    const currentTransportId = clientInfo.sendTransport ? clientInfo.sendTransport.id : null;
    sendIceRestart.onResponse(rtnValue, currentTransportId);
}
/********************************/

/**
 * send createConsumerTransport request to mediaSoup server
 *
 * @param {Number} rcvSeq - 선생님 사용자 시퀀스 번호 (= teacherSeq)
 * @private
 */
const sendCreateConsumerTransport = (rcvSeq) => {
    console.log(`sendCreateConsumerTransport - rcvSeq[${rcvSeq}], clientInfo - userSeq[${clientInfo.userSeq}], liveSeq[${clientInfo.liveSeq}], routingKey[${clientInfo.routingKey}]`);

    const data = {
        kind            : "mediaSoup",
        action          : "createConsumerTransport",
        prodUserSeq     : rcvSeq,
        roomKind        : "live",
        liveSeq         : clientInfo.liveSeq,
        consumUserSeq   : clientInfo.userSeq,
        sendRotingKey   : clientInfo.routingKey
    };

    sendObjectToRbmq(data);
}

/**
 * send connectConsumerTransport request to mediaSoup server
 * 
 * @param {DtlsParameters} dtlsParameters - 미디어 수프 서버 DTLS(데이터 그램 전송 계층 보안) 매개변수
 * @param {Number} rcvSeq - 선생님 사용자 시퀀스 번호 (= teacherSeq)
 * @private
 */
const sendConnectConsumerTransport = (dtlsParameters, rcvSeq) => {
    console.log(`sendConnectConsumerTransport - rcvSeq[${rcvSeq}], clientInfo - userSeq[${clientInfo.userSeq}], liveSeq[${clientInfo.liveSeq}], routingKey[${clientInfo.routingKey}]`);
    console.log("dtlsParameters => ", dtlsParameters);

    const data = {
        kind            : "mediaSoup",
        action          : "connectConsumerTransport",
        prodUserSeq     : rcvSeq,
        roomKind        : "live",
        liveSeq         : clientInfo.liveSeq,
        dtlsParameters  : dtlsParameters,
        consumUserSeq   : clientInfo.userSeq,
        sendRotingKey   : clientInfo.routingKey
    };

    sendObjectToRbmq(data);
}
/********************************/

/********************************/
/**  MEDIA SOUP RCV (consume-callback) */
/********************************/

/**
 * joinConsume 요청 후 서버에서 받은 데이터 처리
 * 
 * @param {JSON} rtnValue - 서버에서 받은 JSON 데이터 객체
 */
export const joinConsumeAfter = (rtnValue) => {
    // 20260805 Phase 1(media_soup/server)이 보낸 명시적 실패 응답을 기존 성공 후처리로 넘기지 않고 진단 로그만 남긴다.
    // 아직 재시도하지 않으며 화면/상태도 변경하지 않는다.
    if (rtnValue && rtnValue.isSuccess === false) {
        smartTVMediaTraceLog(rtnValue.roomKind === "handsup" ? "HANDSUP_JOIN_RESPONSE_FAILED" : "JOIN_RESPONSE_FAILED", {
            requestId: rtnValue.requestId, errorCode: rtnValue.errorCode, errorStage: rtnValue.errorStage,
            liveSeq: rtnValue.liveSeq, prodUserSeq: rtnValue.prodUserSeq, consumUserSeq: rtnValue.consumUserSeq, roomKind: rtnValue.roomKind
        });
        return;
    }

    const { rcvUserSeq, roomKind, isVideoReceiveable, isAudioReceiveable, isMicReceiveable } = rtnValue;
    const displayRotation = normalizeDisplayRotation(rtnValue.displayRotation);
    // console.log(`joinConsumeAfter - roomKind[${roomKind}], rcvUserSeq[${rcvUserSeq}], isVideoReceiveable[${isVideoReceiveable}], isAudioReceiveable[${isAudioReceiveable}], isMicReceiveable[${isMicReceiveable}]`);
    smartTVMediaTraceLog(roomKind === "handsup" ? "HANDSUP_JOIN_RESPONSE" : "JOIN_RESPONSE", {
        requestId: rtnValue.requestId, prodUserSeq: rcvUserSeq, roomKind, isVideoReceiveable, isAudioReceiveable, isMicReceiveable
    });
    console.log("joinConsumeAfter --- ", rtnValue);
    console.log(`joinConsumeAfter(${roomKind}) - rcvUserSeq[${rcvUserSeq}], isVideoReceiveable[${isVideoReceiveable}], isAudioReceiveable[${isAudioReceiveable}], isMicReceiveable[${isMicReceiveable}]`);

    if (roomKind === "handsup") { // handsup case
        const consumeInfo = getConsumeInfoBySeq(rcvUserSeq);
        if (consumeInfo) {
            consumeInfo.isAudioReceiveable = isAudioReceiveable;
            consumeInfo.isVideoReceiveable = isVideoReceiveable;
            consumeInfo.displayRotation = displayRotation;
            console.log(`joinConsumeAfter(handsup) - mediaKind[${consumeInfo.mediaKind}]`);

            if (isVideoReceiveable || isAudioReceiveable) {
                if (clientInfo.rcvTransport !== null) {
                    if (consumeInfo.mediaKind === "video" || (consumeInfo.mediaKind === "ALL" || consumeInfo.mediaKind === "all")) { // for smart tv & small group - video consume case by hjkim 20231108
                        if (!isVideoReceiveable) {
                            console.log("joinConsumeAfter(handsup) case 1-1 - sendConsume(audio)");
                            sendConsume("audio", "handsup", rcvUserSeq);
                        } else {
                            console.log("joinConsumeAfter(handsup) case 1-2 - sendConsume(video)");
                            sendConsume("video", "handsup", rcvUserSeq);
                            // console.log("joinConsumeAfter(handsup) case 1-1 - consumeInfo.mediaKind init");
                            // consumeInfo.mediaKind = "";
                        }
                    } else { // default handsup - audio consume case by hjkim 20231108
                        console.log("joinConsumeAfter(handsup) case 2 - sendConsume(audio)");
                        sendConsume("audio", "handsup", rcvUserSeq);
                        // console.log("joinConsumeAfter(handsup) case 2-1 - consumeInfo.mediaKind init");
                        // consumeInfo.mediaKind = "";
                    }
                } else {
                    console.log("joinConsumeAfter(handsup) case 3 ... 이럴 땐 어떻게 해야 하지..?");
                }
            } else {
                console.log("joinConsumeAfter(handsup) case 4");
            }
        } else {
            const p2pInfo = getP2pConsumeInfoBySeq(rcvUserSeq);
            if (p2pInfo) {
                p2pInfo.isAudioReceiveable = isAudioReceiveable;
                p2pInfo.isVideoReceiveable = isVideoReceiveable;
                p2pInfo.displayRotation = displayRotation;
                console.log(`joinConsumeAfter(handsup) - mediaKind[${p2pInfo.mediaKind}]`);

                if (isVideoReceiveable || isAudioReceiveable) {
                    if (clientInfo.rcvTransport !== null) {
                        if (p2pInfo.mediaKind === "video" || (p2pInfo.mediaKind === "ALL" || p2pInfo.mediaKind === "all")) { // for smart tv & small group - video consume case by hjkim 20231108
                            console.log("joinConsumeAfter(handsup) case 5 - sendConsume(video)");
                            sendConsume("video", "handsup", rcvUserSeq);
                            // console.log("joinConsumeAfter(handsup) case 5-1 - p2pInfo.mediaKind init");
                            // p2pInfo.mediaKind = "";
                        } else { // default handsup - audio consume case by hjkim 20231108
                            console.log("joinConsumeAfter(handsup) case 6 - sendConsume(audio)");
                            sendConsume("audio", "handsup", rcvUserSeq);
                            // console.log("joinConsumeAfter(handsup) case 6-1 - p2pInfo.mediaKind init");
                            // p2pInfo.mediaKind = "";
                        }
                    } else {
                        console.log("joinConsumeAfter(handsup) case 7 ... 이럴 땐 어떻게 해야 하지..?");
                    }
                } else {
                    console.log("joinConsumeAfter(handsup) case 8");
                }
            }
        }
    } else {
        clientInfo.consumeInfo.isVideoReceiveable = isVideoReceiveable;
        clientInfo.consumeInfo.displayRotation = displayRotation;
        clientInfo.consumeInfo.isAudioReceiveable = isAudioReceiveable;
        clientInfo.consumeInfo.isMicReceiveable = isMicReceiveable;

        if (isVideoReceiveable || isAudioReceiveable || isMicReceiveable) {
            console.log("joinConsumeAfter(live) case 1");
            console.log("clientInfo.rtpCapabilities => ", clientInfo.rtpCapabilities, ", rtnValue.rtpCapabilities => ", rtnValue.rtpCapabilities);
            if (clientInfo.rtpCapabilities === undefined || clientInfo.rtpCapabilities === null) {
                clientInfo.rtpCapabilities = rtnValue.rtpCapabilities;
            }

            let store = window.hiclasstv.store;
            store.dispatch(changeLiveStatusInfo({ kind: "connect" }));
        } else {
            console.log("joinConsumeAfter(live) case 2");
            // 20260929 선생님이 송출 중이 아니면(수업 종료 등) 자동 복구 대상이 아니다.
            resetLiveReconnect("join-not-receivable");
            relayLive.rejoin(); // 20261023 끊긴 사이 수업 종료면 서버 확인 후 기존 LIVE_OFF 처리(로그인 페이지) (web-relay R-183)
            let store = window.hiclasstv.store;
            // store.dispatch(changeLiveStatusInfo({ kind: "unconnectable", status: "off" }));
            store.dispatch(changeLiveStatusInfo({ kind: "unconnectable", status: "disable" }));
            store.dispatch(toggleReadyLiveConsume({ isReadyLiveConsume: false }));
        }
    }
}

/**
 * exitConsume 요청 후 서버에서 받은 데이터 처리
 * 
 * @param {JSON} rtnValue - 서버에서 받은 JSON 데이터 객체
 */
export const exitConsumeAfter = (rtnValue) => {
    const { roomKind, prodUserSeq } = rtnValue;
    console.log(`exitConsumeAfter - roomKind[${roomKind}], prodUserSeq[${prodUserSeq}]`);

    if (roomKind === "handsup") {
        console.log("exitConsumeAfter - 학생 케이스");
        const consumeInfo = getConsumeInfoBySeq(prodUserSeq);
        if (consumeInfo) {
            console.log(`exitConsumeAfter - remove list_consumeInfo case prodUserSeq[${prodUserSeq}]`);
            let idx = clientInfo.handsupInfo.list_consumeInfo.indexOf(consumeInfo);
            clientInfo.handsupInfo.list_consumeInfo.splice(idx, 1);
        } else {
            const p2pInfo = getP2pConsumeInfoBySeq(prodUserSeq);
            if (p2pInfo) {
                console.log(`exitConsumeAfter - remove list_consumeInfo case prodUserSeq[${prodUserSeq}]`);
                let idx = clientInfo.handsupInfo.list_p2pConsumeInfo.indexOf(p2pInfo);
                clientInfo.handsupInfo.list_p2pConsumeInfo.splice(idx, 1);
            } else {
                console.log(`exitConsumeAfter - already removed case prodUserSeq[${prodUserSeq}]`);
            }
        }
    } else {
        console.log(`exitConsumeAfter - prodUserSeq[${prodUserSeq}], rcvTeacherSeq[${clientInfo.rcvTeacherSeq}]`);
        if (prodUserSeq === clientInfo.rcvTeacherSeq) {
            console.log("exitConsumeAfter - 선생님 케이스");

            // 20250812 ... 스마트TV 페이지이고, exitConsume 요청 후 다시 consume 요청이 필요하면 다른 메서드에서 처리 ... by hjkim
            if (getIsSmartTVCurrentPage() && clientInfo.consumeInfo.isNeedReConsume) {
                exitConsumeAfterReConsumeForSmartTV();
                clientInfo.consumeInfo.isNeedReConsume = false;
                return;
            }

            console.log("exitConsumeAfter - prodUserSeq and rcvTeacherSeq are the same values.");

            clientInfo.consumeInfo.isExitConsume = false;

            let store = window.hiclasstv.store;
            store.dispatch(changeLiveStatusInfo({ kind: "unconnectable", status: "disable" }));

            let isNeedCleanUp = getIsNeedCleanUp();
            console.log("exitConsumeAfter - isNeedCleanUp => ", isNeedCleanUp);
            if (isNeedCleanUp) {
                console.log("exitConsumeAfter - Need to clean up the rbmq connection.");
                disconnectRbmq("exit-user2103");
            } else {
                console.log("exitConsumeAfter - The rbmq connection has already been cleaned up or does not need to be cleaned up.");
            }
        } else {
            console.log("exitConsumeAfter - prodUserSeq and rcvTeacherSeq are different values.");
        }

        /* let isNeedCleanUp = getIsNeedCleanUp();
        console.log("exitConsumeAfter - isNeedCleanUp => ", isNeedCleanUp);
        if (isNeedCleanUp) {
            console.log("exitConsumeAfter - Need to clean up the rbmq connection.");
            disconnectRbmq("exit-user2103");
        } else {
            console.log("exitConsumeAfter - The rbmq connection has already been cleaned up or does not need to be cleaned up.");
        } */
    }
}

/**
 * 스마트TV & QR 로그인의 케이스에서 exitConsume 요청 후
 * 서버에서 데이터를 받지 못한 경우 처리
 * 
 * @param {String} roomKind - 미디어 서버 룸 유형
 * @param {Number} prodUserSeq - 프로듀서 사용자 시퀀스 번호
 */
const exitConsumeAfterForCleaning = (roomKind, prodUserSeq) => {
    console.log(`exitConsumeAfterForCleaning - roomKind[${roomKind}], prodUserSeq[${prodUserSeq}]`);

    if (roomKind === "handsup") {
        const consumeInfo = getConsumeInfoBySeq(prodUserSeq);
        if (consumeInfo) {
            console.log(`exitConsumeAfterForCleaning - remove list_consumeInfo case prodUserSeq[${prodUserSeq}]`);
            let idx = clientInfo.handsupInfo.list_consumeInfo.indexOf(consumeInfo);
            clientInfo.handsupInfo.list_consumeInfo.splice(idx, 1);
        } else {
            const p2pInfo = getP2pConsumeInfoBySeq(prodUserSeq);
            if (p2pInfo) {
                console.log(`exitConsumeAfterForCleaning - remove list_consumeInfo case prodUserSeq[${prodUserSeq}]`);
                let idx = clientInfo.handsupInfo.list_p2pConsumeInfo.indexOf(p2pInfo);
                clientInfo.handsupInfo.list_p2pConsumeInfo.splice(idx, 1);
            } else {
                console.log(`exitConsumeAfterForCleaning - already removed case prodUserSeq[${prodUserSeq}]`);
            }
        }
    } else {
        if (prodUserSeq === clientInfo.rcvTeacherSeq) {
            clientInfo.consumeInfo.isExitConsume = false;
    
            if (window.hiclasstv) {
                let store = window.hiclasstv.store;
                store.dispatch(changeLiveStatusInfo({ kind: "unconnectable", status: "disable" }));
            }
        }

        let isNeedCleanUp = getIsNeedCleanUp();
        console.log("exitConsumeAfterForCleaning - isNeedCleanUp => ", isNeedCleanUp);
        if (isNeedCleanUp) {
            console.log("exitConsumeAfterForCleaning - Need to clean up the rbmq connection.");
            disconnectRbmq("exit-user2148");
        } else {
            console.log("exitConsumeAfterForCleaning - The rbmq connection has already been cleaned up or does not need to be cleaned up.");
        }
    }
}

/**
 * 스마트TV 영상 재생 오류 발생 시 먼저 exitConsume 요청하고,
 * 서버에서 받은 데이터 처리 후에 서버에 다시 해당 사용자(= 선생님)
 * consume 요청
 * 
 * @param {JSON} rtnValue - 서버에서 받은 JSON 데이터 객체
 * @since 2025-08-12.
 */
const exitConsumeAfterReConsumeForSmartTV = (rtnValue) => {
    const { roomKind, prodUserSeq } = rtnValue;
    console.log(`exitConsumeAfterReConsumeForSmartTV - roomKind[${roomKind}], prodUserSeq[${prodUserSeq}]`);

    if (roomKind === "live") {
        console.log(`exitConsumeAfterReConsumeForSmartTV - prodUserSeq[${prodUserSeq}], rcvTeacherSeq[${clientInfo.rcvTeacherSeq}]`);
        if (prodUserSeq === clientInfo.rcvTeacherSeq) {
            console.log("exitConsumeAfterReConsumeForSmartTV - prodUserSeq and rcvTeacherSeq are the same values.");

            clientInfo.consumeInfo.isExitConsume = false;

            let store = window.hiclasstv.store;
            store.dispatch(changeLiveStatusInfo({ kind: "reconnect", status: "disable" }));

            sendJoinConsume("live", clientInfo.rcvTeacherSeq);
        } else {
            console.log("exitConsumeAfterReConsumeForSmartTV - prodUserSeq and rcvTeacherSeq are different values.");
        }
    } else {
        console.log("exitConsumeAfterReConsumeForSmartTV - roomKind is else ... ", roomKind);
    }
}

/**
 * 20260929 선생님 영상(live) 수신 연결 자동 복구
 * - 수신 연결이 끊기면(disconnected/failed/연결 대기 시간 초과) 기존 정리 흐름(changeConnectionStateConsumerTransportAfter)으로
 *   정리한 뒤, 화면 상태(unconnectable) 변경에 따라 LiveMediaSoupRcv가 connectLive로 다시 접속하는 기존 흐름을 그대로 사용한다.
 * - 재시도 횟수를 관리하고, 3회 모두 실패하면 자동 재접속을 멈추고 [다시 연결] 안내를 표시한다.
 * - 수업 종료(liveStatus N)나 선생님 송출 종료는 복구 대상이 아니다.
 * - 안내 상태는 웹은 window 이벤트(LIVE_RECONNECT_STATE_EVENT), PBL은 opener(master.html) 헬퍼로 전달한다.
 */
export const LIVE_RECONNECT_STATE_EVENT = "hiclasstv:live-reconnect-state";
const LIVE_RECONNECT_MAX_ATTEMPTS = 3;
// 20261002 25초 → 40초: 90초 끊김도 자동 복구되게 한다(재시도 3회 = 끊김 후 약 20·60·100초, failed 약 140초).
//          횟수를 늘리는 대신 간격을 늘려, 동시 끊김(예: 학교 와이파이 → 그룹 20개) 때 서버의 transport 재생성 부담을 줄인다.
//          시간표와 감시가 필요한 이유는 createRcvIceRestart fallback 주석 참고.
const LIVE_RECONNECT_WATCH_MS = 40000;
const liveReconnectInfo = { attempt: 0, state: "idle", isBlocked: false, watchTimer: null };

const isLiveAutoReconnectTarget = () => {
    // 스마트TV / iOS / Android 네이티브 화면은 각자의 재연결 흐름을 사용하므로 제외한다.
    // 20261002 Android WebView 는 다시 넣는다(Pro 86차 §3-4). 태블릿은 송출만 네이티브가 맡고 수신(선생님 화면)은
    //          이 JS 가 한다 — capture.pro 에 수신 transport 코드가 없다. 빼 두면 차단 중 다시 만든 수신 연결이
    //          connecting 에 멈췄을 때 다시 시도할 주체가 없어, 해제 뒤 77초 늦게 돌아왔다(86차).
    //          이 검사는 수신 감시에만 쓰인다. 송출(Android 브릿지 경로)과는 무관하다.
    return !getIsSmartTVCurrentPage() && !isIOSWebView();
}

const isLiveStillOnAir = () => {
    try {
        const store = window.hiclasstv && window.hiclasstv.store;
        const performLiveInfo = store && store.getState().live && store.getState().live.performLiveInfo;
        return !!performLiveInfo && performLiveInfo.liveStatus === "Y";
    } catch (err) {
        return false;
    }
}

const notifyLiveReconnectState = (state) => {
    liveReconnectInfo.state = state;
    console.log(`[LiveRecovery] state[${state}], attempt[${liveReconnectInfo.attempt}]`);

    try {
        window.dispatchEvent(new CustomEvent(LIVE_RECONNECT_STATE_EVENT, { detail: { state, attempt: liveReconnectInfo.attempt } }));
    } catch (err) {
        console.log("[LiveRecovery] dispatch event err => ", err);
    }

    if (getIsForPblModeBrowser()) {
        liveConnectionStateHelper(state, liveReconnectInfo.attempt);
    }
}

const clearLiveReconnectWatch = () => {
    if (liveReconnectInfo.watchTimer !== null) {
        clearTimeout(liveReconnectInfo.watchTimer);
        liveReconnectInfo.watchTimer = null;
    }
}

/**
 * 자동 재접속이 막혔는지 여부 (LiveMediaSoupRcv에서 connectLive 호출 전에 확인)
 */
export const isLiveAutoReconnectBlocked = () => liveReconnectInfo.isBlocked;

/**
 * 20261104 [iOS] 앱 복귀(pro-reconnectMediasoup) 시 선생님 영상 수신이 실제로 살아있는지 판단 (iOS 전용)
 * - 영상 요소의 paused 가 아니라 연결·데이터 기준으로 본다 (유튜브 등 다른 앱 소리로 WebKit 이 영상을 멈춰도 연결은 살아있음)
 * - ① 수신 transport connectionState === "connected" ② 선생님 영상 consumer track live ③ 1.5초 동안 수신 바이트 증가
 * - 셋 다 만족해야 alive. 애매하면 alive=false (기존처럼 다시 받기)
 *
 * @returns {Promise<{alive: Boolean, reason: String}>}
 */
export const checkLiveReceiveAliveIOS = async () => {
    try {
        if (!isIOSWebView()) return { alive: false, reason: "not-ios" };
        const ci = clientInfo.consumeInfo;
        const transport = clientInfo.rcvTransport;
        if (!transport || transport.closed) return { alive: false, reason: "no-transport" };
        if (transport.connectionState !== "connected") return { alive: false, reason: "transport-" + transport.connectionState };

        const isLive = (c) => !!c && !c.closed && !!c.track && c.track.readyState === "live";
        if (!ci || !ci.isVideoReceived || !isLive(ci.videoConsumer)) return { alive: false, reason: "no-live-video-consumer" };

        const consumers = [ci.videoConsumer, ci.audioConsumer, ci.micConsumer].filter(isLive);
        const getBytes = async () => {
            let sum = 0;
            for (const c of consumers) {
                try {
                    const report = await c.getStats();
                    report.forEach((s) => { if (s.type === "inbound-rtp" && typeof s.bytesReceived === "number") sum += s.bytesReceived; });
                } catch (err) { /* 통계 실패는 무시 */ }
            }
            return sum;
        };

        const before = await getBytes();
        await new Promise((r) => setTimeout(r, 1500));
        const after = await getBytes();
        if (after > before) return { alive: true, reason: `rtp+${after - before}B/1.5s` };
        return { alive: false, reason: `no-rtp(${before}->${after})` };
    } catch (err) {
        console.log("[iOS] checkLiveReceiveAliveIOS err => ", err);
        return { alive: false, reason: "error" };
    }
}

export const getLiveReconnectState = () => liveReconnectInfo.state;

/**
 * 자동 복구 상태 초기화 (수업 종료, 선생님 송출 종료, 화면 이탈 시)
 * 
 * @param {String} reason - 초기화 사유 (로그용)
 */
export const resetLiveReconnect = (reason) => {
    const prevState = liveReconnectInfo.state;
    clearLiveReconnectWatch();
    liveReconnectInfo.attempt = 0;
    liveReconnectInfo.isBlocked = false;

    if (prevState !== "idle") {
        console.log(`[LiveRecovery] reset - reason[${reason}]`);
        notifyLiveReconnectState("ended");
        liveReconnectInfo.state = "idle";
    }
}

/**
 * 수신 연결이 끊겼을 때 재시도 횟수를 올리고 안내 상태를 갱신한다.
 * 재시도 한도를 넘으면 자동 재접속을 막고 'failed'를 알린다.
 */
const registerLiveReceiveLost = (reason, { watch = true } = {}) => {
    clearLiveReconnectWatch();

    if (!isLiveStillOnAir()) {
        resetLiveReconnect("not-on-air:" + reason);
        return;
    }

    liveReconnectInfo.attempt++;
    console.log(`[LiveRecovery] receive lost - reason[${reason}], attempt[${liveReconnectInfo.attempt}/${LIVE_RECONNECT_MAX_ATTEMPTS}]`);

    if (liveReconnectInfo.attempt > LIVE_RECONNECT_MAX_ATTEMPTS) {
        liveReconnectInfo.isBlocked = true;
        notifyLiveReconnectState("failed");
        return;
    }

    notifyLiveReconnectState("reconnecting");

    // 20261002 watch:false 는 감시를 끄는 옵션으로 남겨 두지만 현재 쓰는 곳은 없다.
    //          fallback · [다시 연결] 모두 감시를 켠다(이유는 createRcvIceRestart fallback 주석 참고 [재검토 요청]).
    if (!watch) return;

    // 다시 접속한 뒤 일정 시간 안에 수신 연결이 'connected'가 되지 않으면 다시 시도한다.
    liveReconnectInfo.watchTimer = setTimeout(() => {
        liveReconnectInfo.watchTimer = null;
        console.log("[LiveRecovery] reconnect watch timeout.");
        handleLiveReceiveLost("timeout");
    }, LIVE_RECONNECT_WATCH_MS);
}

/**
 * 수신 연결 끊김 처리: 재시도 횟수 갱신 후 기존 정리 흐름으로 정리한다.
 * (정리 중 unconnectable 상태로 바뀌면 LiveMediaSoupRcv가 connectLive로 다시 접속한다. 막힌 경우 접속하지 않는다.)
 */
const handleLiveReceiveLost = (reason, options) => {
    // 20261002 수업이 이미 끝났으면(liveStatus N) 횟수·안내만 정리하고, 수신 정리는 수업 종료 흐름에 맡긴다.
    if (!isLiveStillOnAir()) {
        resetLiveReconnect("not-on-air:" + reason);
        return;
    }
    registerLiveReceiveLost(reason, options);
    changeConnectionStateConsumerTransportAfter("disconnected");
}

const onLiveReceiveConnected = () => {
    clearLiveReconnectWatch();

    if (liveReconnectInfo.state !== "idle" || liveReconnectInfo.attempt > 0) {
        liveReconnectInfo.attempt = 0;
        liveReconnectInfo.isBlocked = false;
        notifyLiveReconnectState("connected");
        liveReconnectInfo.state = "idle";
    }
}

/**
 * [다시 연결] 버튼: 재시도 횟수를 초기화하고 기존 접속 흐름을 다시 시작한다.
 */
export const retryLiveReconnect = () => {
    console.log("[LiveRecovery] manual retry");

    if (!isLiveStillOnAir()) {
        resetLiveReconnect("manual-retry-not-on-air");
        return;
    }

    liveReconnectInfo.attempt = 0;
    liveReconnectInfo.isBlocked = false;
    // 20261002 [재검토 요청] [다시 연결] 도 감시 타이머를 켠다. 누른 시점에 망이 아직 끊겨 있으면 새 transport 가 connecting 에서
    //          멈추므로 감시가 없으면 "재연결 중…" 에 다시 갇힌다(createRcvIceRestart fallback 주석 참고).
    handleLiveReceiveLost("manual");
}

/**
 * createConsumerTransport 요청 후 서버에서 받은 데이터 처리
 * 
 * @param {JSON} rtnValue - 서버에서 받은 JSON 데이터 객체
 */
export const createConsumerTransportAfter = async (rtnValue) => {
    const { rcvUserSeq, transportParams } = rtnValue;
    console.log(`createConsumerTransportAfter -  rcvUserSeq[${rcvUserSeq}], transportParams => `, transportParams);

    try {
        await loadDevice();
    } catch (err) {
        console.log("createConsumerTransportAfter(loadDevice) - err => ", err);
        // 20260904 alert() 대신 누적 오류 로그에 기록 ... by claude
        logMediaDeviceError(err, { prodUserSeq: rcvUserSeq });
    } finally {
        if (clientInfo.device === undefined || clientInfo.device === null) {
            console.log("createConsumerTransportAfter - clientInfo.device is => ", clientInfo.device);
            return;
        }

        let transport = null;

        try {
            transport = clientInfo.device.createRecvTransport({
                id: transportParams.id,
                dtlsParameters: transportParams.dtlsParameters,
                iceCandidates: transportParams.iceCandidates,
                iceParameters: transportParams.iceParameters
            });

            if (transport !== null) {
                transport.on("connect", ({ dtlsParameters }, callback, errback) => {
                    console.log("Consumer - transport.on(connect) - dtlsParameters => ", dtlsParameters);
                    clientInfo.rcvTransportCallback = callback;
                    clientInfo.rcvTransportErrback = errback;
                    sendConnectConsumerTransport(dtlsParameters, rcvUserSeq);
                });

                // 260923 transport 를 새로 만들었으니 옛 조정자의 타이머부터 끊는다.
                if (rcvIceRestart !== null) rcvIceRestart.reset();
                rcvIceRestart = createRcvIceRestart(transport, rcvUserSeq);
                // 260923 아래 핸들러는 이 transport 의 조정자만 움직여야 한다. 모듈 변수를 읽으면
                // transport 가 교체됐을 때 옛 transport 의 이벤트가 새 조정자를 밀어 버린다.
                const iceRestart = rcvIceRestart;

                transport.on("connectionstatechange", (state) => {
                    console.log(`Consumer - transport.on(connectionstatechange) ... state[${state}]`);

                    switch (state) {
                        case "connecting": break;
                        // 260923 disconnected 에서 바로 정리하지 않는다. 짧은 흔들림이면 connected 로 돌아오고,
                        // 정말 깨졌으면 failed 에서 ICE 재시작을 한 번 시도한 뒤 예전 정리로 떨어진다.
                        // 예전 동작(failed → close, disconnected → 정리)은 조정자의 fallback 안에 그대로 있다.
                        // 20261002 r15110 의 선생님 영상 자동 재접속과 합쳤다 — 재시도 횟수·안내는 조정자의 fallback 에서 세고,
                        //          fallback/[다시 연결] 뒤 새 transport 가 40초 안에 connected 되지 않으면 감시 타이머가 센다([재검토 요청]).
                        case "connected":
                            // 20260929 선생님 영상 수신 연결이 (다시) 연결되면 자동 복구 상태를 정리한다.
                            if (clientInfo.rcvTransport === transport) {
                                onLiveReceiveConnected();
                            }
                            iceRestart.onState(state);
                            break;
                        case "disconnected":
                        case "closed":
                            iceRestart.onState(state);
                            break;
                        case "failed":
                            // 20260904 수신 transport 연결 실패를 누적 오류 로그에 기록한다 ... by claude
                            addMediaError({ prodUserSeq: rcvUserSeq, errorCode: "TRANSPORT_FAILED" });
                            iceRestart.onState(state);
                            break;
                        default:
                            // 20260929 disconnected는 기존 정리/재접속 흐름을 그대로 쓰고, 재시도 횟수와 안내 상태만 관리한다.
                            // 20261002 ⚠ disconnected 는 위 case 가 조정자로 받으므로 이 갈래에 오지 않는다(ICE 재시작 병합). 횟수는 createRcvIceRestart fallback 에서 센다.
                            if (state === "disconnected" && isLiveAutoReconnectTarget() && clientInfo.rcvTransport === transport) {
                                registerLiveReceiveLost("disconnected");
                            }
                            changeConnectionStateConsumerTransportAfter(state);
                            break;
                    }
                });

                resetLiveConsume("new-rcv-transport"); // 20261028 받기 연결 정리/생성 시 consume 대기 초기화 (web-relay R-207)
                clientInfo.rcvTransport = transport;
                sendConsume(clientInfo.consumeInfo.mediaKind, "live", rcvUserSeq); // 20241202 ... consume 위치 수정 -> 다시 되돌림 ... by hjkim
                // sendConnectConsumerTransport(transportParams.dtlsParameters, rcvUserSeq); // 20241202 ... connect consumer transport 위치 수정 -> 다시 되돌림 ... by hjkim
            } else {
                console.log(`[Unsupported] can not create recv transport ... id[${transportParams.id}], transport => `, transport);
                // 20260904 alert() 대신 누적 오류 로그에 기록 ... by claude
                addMediaError({ prodUserSeq: rcvUserSeq, errorCode: "UnsupportedError" });
            }
        } catch (err) {
            console.log("createConsumerTransportAfter(createRecvTransport) - err => ", err);
            // 20260904 alert() 대신 누적 오류 로그에 기록 ... by claude
            logMediaDeviceError(err, { prodUserSeq: rcvUserSeq });
        }
    }
}

/**
 * connectConsumerTransport 요청 후 서버에서 받은 데이터 처리
 * 
 * @param {JSON} rtnValue - 서버에서 받은 JSON 데이터 객체
 */
export const connectConsumerTransportAfter = (rtnValue) => {
    const { rcvUserSeq } = rtnValue;
    console.log(`connectConsumerTransportAfter -  rcvUserSeq[${rcvUserSeq}]`);

    if (clientInfo.rcvTransportCallback) {
        console.log("clientInfo.rcvTransportCallback call.");
        clientInfo.rcvTransportCallback();
    }

    // sendConsume(clientInfo.consumeInfo.mediaKind, "live", rcvUserSeq); // 20241202 ... consume 위치 수정 -> 다시 되돌림 ... by hjkim

    let store = window.hiclasstv.store;
    store.dispatch(toggleReadyLiveConsume({ isReadyLiveConsume: true }));
}

/**
 * consume 요청 후 서버에서 받은 데이터 처리
 * 
 * @param {JSON} rtnValue - 서버에서 받은 JSON 데이터 객체
 */
export const consumeAfter = async (rtnValue) => {
    // 20260805 Phase 1(media_soup/server)이 보낸 명시적 실패 응답을 기존 성공 후처리로 넘기지 않고 진단 로그만 남긴다.
    // 아직 재시도하지 않으며 화면/상태도 변경하지 않는다. (parm이 없어 기존 로직대로 진행하면 예외가 발생하므로 반드시 여기서 먼저 걸러낸다)
    if (rtnValue && rtnValue.isSuccess === false) {
        smartTVMediaTraceLog(rtnValue.roomKind === "handsup" ? "HANDSUP_CONSUME_RESPONSE_FAILED" : "CONSUME_RESPONSE_FAILED", {
            requestId: rtnValue.requestId, errorCode: rtnValue.errorCode, errorStage: rtnValue.errorStage,
            liveSeq: rtnValue.liveSeq, prodUserSeq: rtnValue.prodUserSeq, consumUserSeq: rtnValue.consumUserSeq, roomKind: rtnValue.roomKind, mediaKind: rtnValue.mediaKind
        });
        // 20260904 코덱 미지원 외의 모든 실패도 누적 오류 로그에 기록한다(팝업 없이 벨/로그 패널로만 노출). 연결 상태와 재시도 정책은 변경하지 않는다. ... by claude
        addMediaError({
            roomKind: rtnValue.roomKind,
            mediaKind: rtnValue.mediaKind,
            prodUserSeq: rtnValue.prodUserSeq,
            consumUserSeq: rtnValue.consumUserSeq,
            errorCode: rtnValue.errorCode,
            producerCodecs: rtnValue.producerCodecs
        });
        // 20260807 영상 코덱 미지원만 중앙 팝업 안내 대상으로 구분하며 연결 상태와 재시도 정책은 변경하지 않는다.
        if (rtnValue.errorCode === "UNSUPPORTED_CODEC" && rtnValue.mediaKind === "video") {
            notifyUnsupportedMediaCodec(rtnValue);
        }
        return;
    }

    const { roomKind, mediaKind, rcvUserSeq, parm } = rtnValue;
    const displayRotation = normalizeDisplayRotation(rtnValue.displayRotation);
    const { producerId, id, rtpParameters } = parm;
    console.log("consumeAfter - roomKind[", roomKind, "], mediaKind[", mediaKind, "], rcvUserSeq[", rcvUserSeq, "]");
    smartTVMediaTraceLog(roomKind === "handsup" ? "HANDSUP_CONSUME_RESPONSE" : "CONSUME_RESPONSE", {
        requestId: rtnValue.requestId, prodUserSeq: rcvUserSeq, roomKind, mediaKind
    });
    console.log("consumeAfter - producerId[", producerId, "], id[", id, "], rtpParameters => ", rtpParameters);

    if (clientInfo.rcvTransport === null) {
        console.log("consumeAfter() - clientInfo.rcvTransport is null");
        return;
    }

    let codecOptions = {};
    let consumer = null;

    try {
        consumer = await clientInfo.rcvTransport.consume({
            id,
            producerId,
            kind: mediaKind === "mic" ? "audio" : mediaKind,
            rtpParameters,
            codecOptions,
        });

        if (consumer !== null) {
            if (roomKind === "handsup") {
                consumer.on("transportclose", () => {
                    const consumeInfo = clientInfo.handsupInfo.list_consumeInfo.find(info => info.audioConsumer === consumer);
                    if (consumeInfo) {
                        if (consumeInfo.audioConsumer) {
                            if (consumeInfo.audioStream) {
                                try {
                                    if (consumeInfo.audioEl) {
                                        if (!consumeInfo.audioEl.paused) {
                                            consumeInfo.audioEl.pause();
                                        }
                                    }
                                    consumeInfo.audioStream.removeTrack(consumer.track);

                                    if (!consumeInfo.audioConsumer.closed) {
                                        consumeInfo.audioConsumer.close();
                                    }

                                    consumeInfo.audioConsumer = null;
                                } catch (err) {
                                    console.log("------consumer.transportclose------error => ", err);
                                } finally {
                                    consumeInfo.audioStream = null;
                                }
                            }
                        }

                        // for smart tv & small group video ... by hjkim 20231108
                        if (consumeInfo.videoConsumer) {
                            if (consumeInfo.videoStream) {
                                try {
                                    if (consumeInfo.videoEl) {
                                        if (!consumeInfo.videoEl.paused) {
                                            consumeInfo.videoEl.pause();
                                            consumeInfo.videoEl.currentTime = 0;
                                        }
                                    }
                                    consumeInfo.videoStream.removeTrack(consumer.track);

                                    if (!consumeInfo.videoConsumer.closed) {
                                        consumeInfo.videoConsumer.close();
                                    }

                                    consumeInfo.videoConsumer = null;
                                } catch (err) {
                                    console.log("------consumer.transportclose------error => ", err);
                                } finally {
                                    consumeInfo.videoStream = null;
                                    // consumeInfo.videoEl.currentTime = 0;
                                    consumeInfo.videoEl.poster = "/images/connect.png";
                                    // consumeInfo.videoEl.poster = "/images/android_notconnected.png";
                                }
                            }
                        }
                    } else {
                        const p2pInfo = clientInfo.handsupInfo.list_p2pConsumeInfo.find(info => info.audioConsumer === consumer);
                        if (p2pInfo) {
                            if (p2pInfo.audioConsumer) {
                                if (p2pInfo.audioStream) {
                                    try {
                                        if (!p2pInfo.audioEl.paused) {
                                            p2pInfo.audioEl.pause();
                                        }
                                        p2pInfo.audioStream.removeTrack(consumer.track);

                                        if (!consumeInfo.audioConsumer.closed) {
                                            consumeInfo.audioConsumer.close();
                                        }

                                        consumeInfo.audioConsumer = null;
                                    } catch (err) {
                                        console.log("------consumer.transportclose------error => ", err);
                                    } finally {
                                        p2pInfo.audioStream = null;
                                    }
                                }
                            }

                            // for smart tv & small group video ... by hjkim 20231108
                            if (p2pInfo.videoConsumer) {
                                if (p2pInfo.videoStream) {
                                    try {
                                        if (!p2pInfo.videoEl.paused) {
                                            p2pInfo.videoEl.pause();
                                        }
                                        p2pInfo.videoStream.removeTrack(consumer.track);

                                        if (!consumeInfo.videoConsumer.closed) {
                                            consumeInfo.videoConsumer.close();
                                        }

                                        consumeInfo.videoConsumer = null;
                                    } catch (err) {
                                        console.log("------consumer.transportclose------error => ", err);
                                    } finally {
                                        p2pInfo.videoStream = null;
                                        p2pInfo.videoEl.currentTime = 0;
                                        p2pInfo.videoEl.poster = "/images/connect.png";
                                        // p2pInfo.videoEl.poster = "/images/android_notconnected.png";
                                    }
                                }
                            }
                        }
                    }
                });

                if (mediaKind === "video") {
                    const consumeInfo = getConsumeInfoBySeq(rcvUserSeq);
                    if (consumeInfo) {
                        console.log(`(1) consumeAfter - rcvSeq[${consumeInfo.rcvSeq}], isVideoReceived[${consumeInfo.isVideoReceived}], isVideoReceiveable[${consumeInfo.isVideoReceiveable}]`);
                        if (consumeInfo.isVideoReceiveable && !consumeInfo.isVideoReceived) { // for smart tv & small group video ... by hjkim 20231108
                            // 20260805 실제로 연결되는 consumer의 requestId만 STREAM_ATTACHED 및 video 이벤트에 연결한다.
                            consumeInfo.smartTVVideoTraceRequestId = rtnValue.requestId;
                            consumeInfo.isVideoReceived = true;
                            consumeInfo.videoConsumer = consumer;

                            if (consumeInfo.videoStream === null) {
                                consumeInfo.videoStream = new MediaStream();
                            }

                            console.log(`(1) consumeAfter - rcvSeq[${consumeInfo.rcvSeq}], consumer.track => `, consumer.track);
                            consumeInfo.videoStream.addTrack(consumer.track);
                            console.log(`(1) consumeAfter - rcvSeq[${consumeInfo.rcvSeq}] addTrack done.`);

                            if (consumeInfo.videoEl === null) {
                                // const handsSmallVideoConsumeDiv = document.getElementById("handsSmallVideoConsumeDiv");

                                // let videoEl = document.createElement("video");
                                // videoEl.id = "handsSmallVideoConsumeEl-" + rcvUserSeq;
                                // videoEl.autoplay = true;
                                // videoEl.autoPlay = true;
                                // handsSmallVideoConsumeDiv.appendChild(videoEl);
                                const videoEl = document.getElementById("small-group-item-" + rcvUserSeq);
                                videoEl.autoplay = true;
                                videoEl.autoPlay = true;
                                consumeInfo.videoEl = videoEl;
                            }

                            console.log(`(1) consumeAfter - rcvSeq[${consumeInfo.rcvSeq}], consumeInfo.videoEl => `, consumeInfo.audioEl);
                            console.log(`(1) consumeAfter - rcvSeq[${consumeInfo.rcvSeq}], consumeInfo.videoStream => `, consumeInfo.videoStream);

                            consumeInfo.videoEl.srcObject = consumeInfo.videoStream;
                            consumeInfo.displayRotation = displayRotation;
                            applyVideoDisplayRotation(consumeInfo.videoEl, consumeInfo.displayRotation);
                            // 20260805 Phase 0 진단: 학생 영상 stream이 <video> 요소에 실제로 연결된 시점을 기록한다.
                            smartTVMediaTraceLog("STREAM_ATTACHED", getSmartTVMediaTraceContext(rcvUserSeq));

                            if (consumeInfo.isAudioReceiveable) {
                                if (consumeInfo.isAudioReceiveable && !consumeInfo.isAudioReceived) { // audio consume 해야하는 case ... by hjkim 20231108
                                    if (consumeInfo.isMuteAudio) { // audio mute mode 일 경우 audio consume 하지 않는다 ... by hjkim 20231108
                                        console.log("handsup(video) consumeAfter case 1");
                                        sendResume("video", roomKind, rcvUserSeq);
                                    } else { // audio consume ...
                                        console.log("handsup(video) consumeAfter case 2 - consumeInfo.videoConsumer.paused[", consumeInfo.videoConsumer.paused, "]");
                                        sendConsume("audio", roomKind, rcvUserSeq);
                                    }
                                } else { // 이미 audio consume 중이거나 audio 없는 case ... by hjkim 20231108
                                    console.log("handsup(video) consumeAfter case 3");
                                    sendResume("video", roomKind, rcvUserSeq);
                                }
                            } else { // audio 없는 case ... by hjkim 20231108
                                console.log("handsup(video) consumeAfter case 4");
                                sendResume("video", roomKind, rcvUserSeq);
                            }
                        } else {
                            console.log("handsup(video) consumeAfter case 5");
                            sendResume("video", roomKind, rcvUserSeq);
                        }
                    } else {
                        const p2pInfo = getP2pConsumeInfoBySeq(rcvUserSeq);
                        if (p2pInfo) {
                            console.log(`(2) consumeAfter - rcvSeq[${p2pInfo.rcvSeq}], isVideoReceived[${p2pInfo.isVideoReceived}], isVideoReceiveable[${p2pInfo.isVideoReceiveable}]`);
                            if (p2pInfo.isVideoReceiveable && !p2pInfo.isVideoReceived) { // for smart tv & small group video ... by hjkim 20231108
                                // 20260805 P2P 목록도 실제로 연결되는 consumer의 requestId만 재생 단계까지 추적한다.
                                p2pInfo.smartTVVideoTraceRequestId = rtnValue.requestId;
                                p2pInfo.isVideoReceived = true;
                                p2pInfo.videoConsumer = consumer;

                                if (p2pInfo.videoStream === null) {
                                    p2pInfo.videoStream = new MediaStream();
                                }

                                console.log(`(2) consumeAfter - rcvSeq[${p2pInfo.rcvSeq}], consumer.track => `, consumer.track);
                                p2pInfo.videoStream.addTrack(consumer.track);
                                console.log(`(2) consumeAfter - rcvSeq[${p2pInfo.rcvSeq}] addTrack done.`);

                                if (p2pInfo.videoEl === null) {
                                    // const handsSmallVideoConsumeDiv = document.getElementById("handsSmallVideoConsumeDiv");

                                    // let videoEl = document.createElement("video");
                                    // videoEl.id = "handsSmallVideoConsumeEl-" + rcvUserSeq;
                                    // videoEl.autoplay = true;
                                    // videoEl.autoPlay = true;
                                    // handsSmallVideoConsumeDiv.appendChild(videoEl);

                                    const videoEl = document.getElementById("small-group-item-" + rcvUserSeq);
                                    videoEl.autoplay = true;
                                    videoEl.autoPlay = true;
                                    p2pInfo.videoEl = videoEl;

                                    // p2pInfo.videoEl = videoEl;
                                }

                                console.log(`(2) consumeAfter - rcvSeq[${p2pInfo.rcvSeq}], p2pInfo.videoEl => `, p2pInfo.audioEl);
                                console.log(`(2) consumeAfter - rcvSeq[${p2pInfo.rcvSeq}], p2pInfo.videoStream => `, p2pInfo.videoStream);

                                p2pInfo.videoEl.srcObject = p2pInfo.videoStream;
                                p2pInfo.displayRotation = displayRotation;
                                applyVideoDisplayRotation(p2pInfo.videoEl, p2pInfo.displayRotation);
                                smartTVMediaTraceLog("STREAM_ATTACHED", getSmartTVMediaTraceContext(rcvUserSeq));

                                if (p2pInfo.isAudioReceiveable) {
                                    if (p2pInfo.isAudioReceiveable && !p2pInfo.isAudioReceived) { // audio consume 해야하는 case ... by hjkim 20231108
                                        if (p2pInfo.isMuteAudio) { // audio mute mode 일 경우 audio consume 하지 않는다 ... by hjkim 20231108
                                            console.log("handsup(video) consumeAfter case 6");
                                            sendResume("video", roomKind, rcvUserSeq);
                                        } else { // audio consume ...
                                            console.log("handsup(video) consumeAfter case 7 - consumeInfo.videoConsumer.paused[", consumeInfo.videoConsumer.paused, "]");
                                            sendConsume("audio", roomKind, rcvUserSeq);
                                        }
                                    } else { // 이미 audio consume 중이거나 audio 없는 case ... by hjkim 20231108
                                        console.log("handsup(video) consumeAfter case 8");
                                        sendResume("video", roomKind, rcvUserSeq);
                                    }
                                } else { // audio 없는 case ... by hjkim 20231108
                                    console.log("handsup(video) consumeAfter case 9");
                                    sendResume("video", roomKind, rcvUserSeq);
                                }
                            } else {
                                console.log("handsup(video) consumeAfter case 10");
                                sendResume("video", roomKind, rcvUserSeq);
                            }
                        } else {
                            console.log("handsup(video) consumeAfter case 11");
                            sendResume("video", roomKind, rcvUserSeq);
                        }
                    }
                } else if (mediaKind === "audio") {
                    const consumeInfo = getConsumeInfoBySeq(rcvUserSeq);
                    if (consumeInfo) {
                        console.log(`(3) consumeAfter - rcvSeq[${consumeInfo.rcvSeq}], isAudioReceived[${consumeInfo.isAudioReceived}], isAudioReceiveable[${consumeInfo.isAudioReceiveable}], isMuteAudio[${consumeInfo.isMuteAudio}]`);
                        if (consumeInfo.isAudioReceiveable && !consumeInfo.isAudioReceived) {
                            consumeInfo.isAudioReceived = true;
                            consumeInfo.audioConsumer = consumer;

                            if (consumeInfo.isMuteAudio) {
                                console.log("handsup(audio) consumeAfter case 1");

                                if (consumeInfo.isVideoReceiveable && consumeInfo.isVideoReceived) {
                                    console.log("handsup(audio) consumeAfter case 1-1 - consumeInfo.videoConsumer.paused[", consumeInfo.videoConsumer.paused, "]");
                                    sendResume("video", roomKind, rcvUserSeq);
                                } else {
                                    console.log("handsup(audio) consumeAfter case 1-2 이때 뭘 해야 하나요???");
                                }
                            } else {
                                if (consumeInfo.audioStream === null) {
                                    consumeInfo.audioStream = new MediaStream();
                                }

                                console.log(`(3) consumeAfter - rcvSeq[${consumeInfo.rcvSeq}], consumer.track => `, consumer.track);
                                consumeInfo.audioStream.addTrack(consumer.track);
                                console.log(`(3) consumeAfter - rcvSeq[${consumeInfo.rcvSeq}] addTrack done.`);

                                if (consumeInfo.audioEl === null) {
                                    const handsAudioConsumeDiv = document.getElementById("handsAudioConsumeDiv");

                                    let audioEl = document.createElement("audio");
                                    audioEl.id = "handsAudioCousumeEl-" + rcvUserSeq;
                                    audioEl.style.display = "none";
                                    audioEl.autoPlay = true;
                                    audioEl.autoplay = true;
                                    handsAudioConsumeDiv.appendChild(audioEl);

                                    consumeInfo.audioEl = audioEl;
                                }

                                console.log(`(3) consumeAfter - rcvSeq[${consumeInfo.rcvSeq}], consumeInfo.audioEl => `, consumeInfo.audioEl);
                                console.log(`(3) consumeAfter - rcvSeq[${consumeInfo.rcvSeq}], consumeInfo.audioStream => `, consumeInfo.audioStream);

                                // 20260929 PBL 오디오 수정: OFF 이후 생성된 그룹 오디오도 재생 전에 음소거한다.
                                applyPblStudentAudioListenToElement(consumeInfo.audioEl);
                                consumeInfo.audioEl.srcObject = consumeInfo.audioStream;
                                if (ConstData.IS_LOCAL_VERSION && !getIsForPblModeBrowser()) {
                                    if (consumeInfo.isMixedClassMember) {
                                        console.log("consumeAfter - consumeInfo.isMixedClassMember");
                                        consumeInfo.audioEl.volume = 1;
                                        console.log("(1) consumeAfter -  volume = 1");
                                        if (isIOSWebView()) { // ios 는 volume = 1 이 동작하지 않아서 track 활성화로 처리 .... by ykhan 251013
                                            const stream = consumeInfo.audioEl.srcObject;
                                            stream.getAudioTracks().forEach(track => {
                                                track.enabled = true;
                                            });
                                        }
                                    } else {
                                        console.log("consumeAfter - not consumeInfo.isMixedClassMember");
                                        let volume = ConstData.IS_LOCAL_VERSION && !getIsForPblModeBrowser() ? clientInfo.consumeInfo.savedVolume : undefined;
                                        console.log("(1) consumeAfter -  volume[", volume, "]");
                                        consumeInfo.audioEl.volume = volume; // 20251110 ... 로컬 버전에서는 현재 저장되어있는 볼륨값으로 설정되도록 수정 ... by hjkim
                                        if (isIOSWebView()) { // ios 는 volume = 0 이 동작하지 않아서 track 비활성화/활성화로 처리 .... by ykhan 251013
                                            const stream = consumeInfo.audioEl.srcObject;
                                            stream.getAudioTracks().forEach(track => {
                                                if (volume === 0) track.enabled = false;
                                                else track.enabled = true;
                                            });
                                        }
                                    }
                                }

                                // 20251017 ... play() 오류 방지를 위해 paused 상태 값 체크 추가 ... by hjkim
                                if (consumeInfo.audioEl.paused) {
                                    await consumeInfo.audioEl.play();
                                } else {
                                    console.log("consumeAfter - Audio element already playing audio source.");
                                }

                                // 20260325 기존 코드 주석 처리 ... by hjkim
                                /* if (consumeInfo.isVideoReceiveable && consumeInfo.isVideoReceived) {
                                    if (consumeInfo.videoEl && consumeInfo.videoEl.srcObject !== null) {
                                        console.log("handsup(audio) consumeAfter case 2");
                                        sendResume("video", roomKind, rcvUserSeq);
                                    } else {
                                        console.log("handsup(audio) consumeAfter case 3");
                                        sendResume("audio", roomKind, rcvUserSeq);
                                    }
                                } else {
                                    console.log("handsup(audio) consumeAfter case 4");
                                    sendResume("audio", roomKind, rcvUserSeq);
                                } */

                                // 20260325 여기부터 수정 코드
                                if (consumeInfo.isVideoReceiveable && consumeInfo.isVideoReceived) {
                                    console.log("handsup(audio) consumeAfter case 2 - consumeInfo.videoConsumer.paused[", consumeInfo.videoConsumer.paused, "]");
                                    sendResume("video", roomKind, rcvUserSeq);
                                }

                                // audio resume을 항상 보내도록 수정 ... by hjkim 20260325
                                console.log("handsup(audio) consumeAfter case 3 & 4");
                                sendResume("audio", roomKind, rcvUserSeq);
                            }
                        } else {
                            console.log("handsup(audio) consumeAfter case 5");
                            sendResume("video", roomKind, rcvUserSeq);
                        }
                    } else {
                        const p2pInfo = getP2pConsumeInfoBySeq(rcvUserSeq);
                        if (p2pInfo) {
                            console.log(`(4) consumeAfter - rcvSeq[${p2pInfo.rcvSeq}], isAudioReceived[${p2pInfo.isAudioReceived}], isAudioReceiveable[${p2pInfo.isAudioReceiveable}], , isMuteAudio[${p2pInfo.isMuteAudio}]`);
                            if (p2pInfo.isAudioReceiveable && !p2pInfo.isAudioReceived) {
                                p2pInfo.isAudioReceived = true;
                                p2pInfo.audioConsumer = consumer;

                                if (p2pInfo.isMuteAudio) {
                                    console.log("handsup(audio) consumeAfter case 6");

                                    if (p2pInfo.isVideoReceiveable && p2pInfo.isVideoReceived) {
                                        console.log("handsup(audio) consumeAfter case 6-1 - p2pInfo.videoConsumer.paused[", p2pInfo.videoConsumer.paused, "]");
                                        sendResume("video", roomKind, rcvUserSeq);
                                    } else {
                                        console.log("handsup(audio) consumeAfter case 6-2 이때 뭘 해야 하나요???");
                                    }
                                } else {
                                    if (p2pInfo.audioStream === null) {
                                        p2pInfo.audioStream = new MediaStream();
                                    }

                                    console.log(`(4) consumeAfter - rcvSeq[${p2pInfo.rcvSeq}], consumer.track => `, consumer.track);
                                    p2pInfo.audioStream.addTrack(consumer.track);
                                    console.log(`(4) consumeAfter - rcvSeq[${p2pInfo.rcvSeq}] addTrack done.`);

                                    if (p2pInfo.audioEl === null) {
                                        const handsAudioConsumeDiv = document.getElementById("handsAudioConsumeDiv");

                                        let audioEl = document.createElement("audio");
                                        audioEl.id = "handsAudioCousumeEl-" + rcvUserSeq;
                                        audioEl.style.display = "none";
                                        audioEl.autoPlay = true;
                                        audioEl.autoplay = true;
                                        applyPblStudentAudioListenToElement(audioEl);
                                        handsAudioConsumeDiv.appendChild(audioEl);

                                        p2pInfo.audioEl = audioEl;
                                    }

                                    console.log(`(3) consumeAfter - rcvSeq[${p2pInfo.rcvSeq}], p2pInfo.audioEl => `, p2pInfo.audioEl);
                                    console.log(`(3) consumeAfter - rcvSeq[${p2pInfo.rcvSeq}], p2pInfo.audioStream => `, p2pInfo.audioStream);

                                    applyPblStudentAudioListenToElement(p2pInfo.audioEl);
                                    p2pInfo.audioEl.srcObject = p2pInfo.audioStream;
                                    if (ConstData.IS_LOCAL_VERSION && !getIsForPblModeBrowser()) {
                                        if (p2pInfo.isMixedClassMember) {
                                            console.log("consumeAfter - p2pInfo.isMixedClassMember");
                                            p2pInfo.audioEl.volume = 1;
                                            console.log("(2) consumeAfter - volume = 1");
                                            if (isIOSWebView()) { // ios 는 volume = 1 이 동작하지 않아서 track 활성화로 처리 .... by ykhan 251013
                                                const stream = p2pInfo.audioEl.srcObject;
                                                stream.getAudioTracks().forEach(track => {
                                                    track.enabled = true;
                                                });
                                            }
                                        } else {
                                            console.log("consumeAfter - not p2pInfo.isMixedClassMember");
                                            let volume = ConstData.IS_LOCAL_VERSION && !getIsForPblModeBrowser() ? clientInfo.consumeInfo.savedVolume : undefined;
                                            console.log("(2) consumeAfter - volume[", volume, "]");
                                            p2pInfo.audioEl.volume = volume; // 20251110 ... 로컬 버전에서는 현재 저장되어있는 볼륨값으로 설정되도록 수정 ... by hjkim
                                            if (isIOSWebView()) { // ios 는 volume = 0 이 동작하지 않아서 track 비활성화/활성화로 처리 .... by ykhan 251013
                                                const stream = p2pInfo.audioEl.srcObject;
                                                stream.getAudioTracks().forEach(track => {
                                                    if (volume === 0) track.enabled = false;
                                                    else track.enabled = true;
                                                });
                                            }
                                        }
                                    }

                                    // 20251017 ... play() 오류 방지를 위해 paused 상태 값 체크 추가 ... by hjkim
                                    if (p2pInfo.audioEl.paused) {
                                        await p2pInfo.audioEl.play();
                                    } else {
                                        console.log("consumeAfter - Audio element already playing audio source.");
                                    }

                                    // 20260325 기존 코드 주석 처리 ... by hjkim
                                    /* if (p2pInfo.isVideoReceiveable && p2pInfo.isVideoReceived) {
                                        if (p2pInfo.videoEl && p2pInfo.videoEl.srcObject === null) {
                                            console.log("handsup(audio) consumeAfter case 7");
                                            sendResume("video", roomKind, rcvUserSeq);
                                        } else {
                                            console.log("handsup(audio) consumeAfter case 8");
                                            sendResume("audio", roomKind, rcvUserSeq);
                                        }
                                    } else {
                                        console.log("handsup(audio) consumeAfter case 9");
                                        sendResume("audio", roomKind, rcvUserSeq);
                                    } */

                                    // 20260325 여기부터 수정 코드
                                    if (p2pInfo.isVideoReceiveable && p2pInfo.isVideoReceived) {
                                        console.log("handsup(audio) consumeAfter case 7 - p2pInfo.videoConsumer.paused[", p2pInfo.videoConsumer.paused, "]");
                                        sendResume("video", roomKind, rcvUserSeq);
                                    }

                                    // audio resume을 항상 보내도록 수정 ... by hjkim 20260325
                                    console.log("handsup(audio) consumeAfter case 8 & 9");
                                    sendResume("audio", roomKind, rcvUserSeq);
                                }
                            } else {
                                console.log("handsup(audio) consumeAfter case 10");
                            }
                        } else {
                            console.log("handsup(audio) consumeAfter case 11");
                        }
                    }
                }
            } else {
                consumer.on("transportclose", closeTransportAfter);
                if (mediaKind === "mic") {
                    console.log(`consumeAfter - mediaKind[${mediaKind}], isMicReceiveable[${clientInfo.consumeInfo.isMicReceiveable}], isMicReceived[${clientInfo.consumeInfo.isMicReceived}], isSelectedMode[${clientInfo.consumeInfo.isSelectedMode}]`);
                    if (!clientInfo.consumeInfo.isMicReceived) { // 중복 consume 방지용 ... by hjkim 20200210
                        clientInfo.consumeInfo.isMicReceived = true;
                        clientInfo.consumeInfo.micConsumer = consumer;

                        // 선생님 오디오가 mute 모드인 경우에만 micStream을 생성
                        if (clientInfo.consumeInfo.isSelectedMode) {
                            if (clientInfo.consumeInfo.micStream === null) {
                                clientInfo.consumeInfo.micStream = new MediaStream();
                            }

                            clientInfo.consumeInfo.micStream.addTrack(clientInfo.consumeInfo.micConsumer.track);
                            clientInfo.consumeInfo.micEl.srcObject = clientInfo.consumeInfo.micStream;
                            if (ConstData.IS_LOCAL_VERSION && !getIsForPblModeBrowser()) {
                                let volume = ConstData.IS_LOCAL_VERSION && !getIsForPblModeBrowser() ? clientInfo.consumeInfo.savedVolume : undefined;
                                console.log("(3) consumeAfter - volume[", volume, "]");
                                clientInfo.consumeInfo.micEl.volume = volume; // 20251110 ... 로컬 버전에서는 현재 저장되어있는 볼륨값으로 설정되도록 수정 ... by hjkim

                                if (isIOSWebView()) { // ios 는 volume = 0 이 동작하지 않아서 track 비활성화로 처리 .... by ykhan 251013
                                    const stream = clientInfo.consumeInfo.micEl.srcObject;
                                    stream.getAudioTracks().forEach(track => {
                                        if (volume === 0) track.enabled = false;
                                        else track.enabled = true;
                                    });
                                }
                            }

                            // 20251017 ... play() 오류 방지를 위해 paused 상태 값 체크 추가 ... by hjkim
                            if (clientInfo.consumeInfo.micEl.paused) {
                                await clientInfo.consumeInfo.micEl.play();
                            } else {
                                console.log("consumeAfter - Mic Audio element already playing mic audio source.");
                            }

                            let store = window.hiclasstv.store;
                            store.dispatch(changeLiveStatusInfo({ kind: "mic", status: "on" }));
                        } else {
                            let store = window.hiclasstv.store;
                            store.dispatch(changeLiveStatusInfo({ kind: "mic", status: "off" }));
                        }

                        // 20260325 기존 코드 주석 처리 ... by hjkim
                        /* if (clientInfo.consumeInfo.isVideoReceiveable && clientInfo.consumeInfo.isVideoReceived) {
                            if (clientInfo.consumeInfo.videoEl && clientInfo.consumeInfo.videoEl.srcObject === null) {
                                sendResume("video", roomKind, rcvUserSeq);
                            }
                        } */

                        // 20260325 여기부터 수정 코드
                        if (clientInfo.consumeInfo.isVideoReceiveable && clientInfo.consumeInfo.isVideoReceived) {
                            console.log("live(mic) consumeAfter case 1 - clientInfo.consumeInfo.videoConsumer.paused[", clientInfo.consumeInfo.videoConsumer.paused, "]");
                            sendResume("video", roomKind, rcvUserSeq);
                        }

                        if (clientInfo.consumeInfo.isSelectedMode) {
                            console.log("live(mic) consumeAfter case 2 - clientInfo.consumeInfo.micConsumer.paused[", clientInfo.consumeInfo.micConsumer.paused, "]");
                            sendResume("mic", roomKind, rcvUserSeq);
                        } else {
                            if (clientInfo.consumeInfo.isAudioReceiveable && clientInfo.consumeInfo.isAudioReceived) {
                                console.log("live(mic) consumeAfter case 3 - clientInfo.consumeInfo.audioConsumer.paused[", clientInfo.consumeInfo.audioConsumer.paused, "]");
                                sendResume("audio", roomKind, rcvUserSeq);
                            }
                        }
                    }
                } else {
                    if (mediaKind === "video") {
                        console.log(`consumeAfter - mediaKind[${mediaKind}], isVideoReceiveable[${clientInfo.consumeInfo.isVideoReceiveable}], isVideoReceived[${clientInfo.consumeInfo.isVideoReceived}]`);
                        if (!clientInfo.consumeInfo.isVideoReceived) { // 중복 consume 방지용 ... by hjkim 20200210
                            clientInfo.consumeInfo.isVideoReceived = true;
                            clientInfo.consumeInfo.videoConsumer = consumer;
                            clientInfo.consumeInfo.displayRotation = displayRotation;

                            // console.log(`addTrack kind[${consumer.kind}] mediaKind[${mediaKind}]`);
                            if (clientInfo.consumeInfo.videoStream === null) {
                                clientInfo.consumeInfo.videoStream = new MediaStream();
                            }

                            clientInfo.consumeInfo.videoStream.addTrack(clientInfo.consumeInfo.videoConsumer.track);

                            // 20260325 기존 코드 주석 처리 ... by hjkim
                            /* if (clientInfo.consumeInfo.isAudioReceiveable || clientInfo.consumeInfo.isMicReceiveable) {
                                if (clientInfo.consumeInfo.isAudioReceiveable && !clientInfo.consumeInfo.isAudioReceived) { // audio consume 해야하는 case ... by hjkim 20220210
                                    if (clientInfo.consumeInfo.isAudioStop) { // 지금은 안 쓰는 기능이지만 선생님 소리 끄기용 ... by hjkim 20220210
                                        sendResume("video", roomKind, rcvUserSeq);

                                        let store = window.hiclasstv.store;
                                        store.dispatch(changeLiveStatusInfo({ kind: "audio", status: "off" }));
                                    } else { // audio consume ...
                                        sendConsume("audio", roomKind, rcvUserSeq);

                                        let store = window.hiclasstv.store;
                                        store.dispatch(changeLiveStatusInfo({ kind: "audio", status: "on" }));
                                    }
                                } else { // 이미 audio consume 중이거나 audio 없는 case ... by hjkim 20220210
                                    if (clientInfo.consumeInfo.isMicReceiveable && !clientInfo.consumeInfo.isMicReceived) { // mic consume 해야하는 case ... by hjkim 20220210
                                        sendConsume("mic", roomKind, rcvUserSeq);
                                    } else { // 이미 mic consume 중이거나 mic 없는 case ... by hjkim 20220210
                                        sendResume("video", roomKind, rcvUserSeq);
                                    }
                                }
                            } else { // audio, mic 없는 case 추가 ... by hjkim 20220210
                                sendResume("video", roomKind, rcvUserSeq);
                            } */

                            // 20260325 여기부터 수정 코드
                            if (clientInfo.consumeInfo.isAudioReceiveable || clientInfo.consumeInfo.isMicReceiveable) {
                                if (clientInfo.consumeInfo.isAudioReceiveable && !clientInfo.consumeInfo.isAudioReceived) { // audio consume 해야하는 case ... by hjkim 20220210
                                    if (clientInfo.consumeInfo.isAudioStop) { // 지금은 안 쓰는 기능이지만 선생님 소리 끄기용 ... by hjkim 20220210
                                        console.log("live(video) consumeAfter case 5-1 - clientInfo.consumeInfo.videoConsumer.paused[", clientInfo.consumeInfo.videoConsumer.paused, "]");
                                        sendResume("video", roomKind, rcvUserSeq);

                                        let store = window.hiclasstv.store;
                                        store.dispatch(changeLiveStatusInfo({ kind: "audio", status: "off" }));
                                    } else { // audio consume ...
                                        console.log("live(video) consumeAfter case 5-2");
                                        sendConsume("audio", roomKind, rcvUserSeq);

                                        let store = window.hiclasstv.store;
                                        store.dispatch(changeLiveStatusInfo({ kind: "audio", status: "on" }));
                                    }
                                } else { // 이미 audio consume 중이거나 audio 없는 case ... by hjkim 20220210
                                    if (clientInfo.consumeInfo.isMicReceiveable && !clientInfo.consumeInfo.isMicReceived) { // mic consume 해야하는 case ... by hjkim 20220210
                                        console.log("live(video) consumeAfter case 5-3");
                                        sendConsume("mic", roomKind, rcvUserSeq);
                                    } else {
                                        console.log("live(video) consumeAfter case 5-4 - clientInfo.consumeInfo.videoConsumer.paused[", clientInfo.consumeInfo.videoConsumer.paused, "]");
                                        sendResume("video", roomKind, rcvUserSeq);

                                        if (clientInfo.consumeInfo.isSelectedMode) {
                                            if (clientInfo.consumeInfo.isMicReceived) {
                                                console.log("live(video) consumeAfter case 5-5 - clientInfo.consumeInfo.micConsumer.paused[", clientInfo.consumeInfo.micConsumer.paused, "]");
                                                sendResume("audio", roomKind, rcvUserSeq);
                                            }
                                        } else {
                                            if (clientInfo.consumeInfo.isAudioReceived) {
                                                console.log("live(video) consumeAfter case 5-6 - clientInfo.consumeInfo.audioConsumer.paused[", clientInfo.consumeInfo.audioConsumer.paused, "]");
                                                sendResume("audio", roomKind, rcvUserSeq);
                                            }
                                        }
                                    }
                                }
                            } else { // audio, mic 없는 case 추가 ... by hjkim 20220210
                                console.log("live(video) consumeAfter case 5-7 - clientInfo.consumeInfo.videoConsumer.paused[", clientInfo.consumeInfo.videoConsumer.paused, "]");
                                sendResume("video", roomKind, rcvUserSeq);
                            }
                        }
                    } else if (mediaKind === "audio") {
                        console.log(`consumeAfter - mediaKind[${mediaKind}], isAudioReceiveable[${clientInfo.consumeInfo.isAudioReceiveable}], isAudioReceived[${clientInfo.consumeInfo.isAudioReceived}]`);
                        if (!clientInfo.consumeInfo.isAudioReceived) {
                            clientInfo.consumeInfo.isAudioReceived = true;

                            clientInfo.consumeInfo.audioConsumer = consumer;

                            if (clientInfo.consumeInfo.isMicReceiveable && !clientInfo.consumeInfo.isMicReceived) { // mic consume 해야하는 case ... by hjkim 20220210
                                if (clientInfo.consumeInfo.audioStream === null) {
                                    clientInfo.consumeInfo.audioStream = new MediaStream();
                                    // console.log(`(1)addTrack kind[${clientInfo.consumeInfo.audioConsumer.kind}] mediaKind[${mediaKind}]`);
                                    clientInfo.consumeInfo.audioStream.addTrack(clientInfo.consumeInfo.audioConsumer.track);
                                } else {
                                    if (clientInfo.consumeInfo.audioStream.getTracks().length > 0 || clientInfo.consumeInfo.audioStream.getTracks().length !== 0) {
                                        console.log(`(2)addTrack kind[${clientInfo.consumeInfo.audioConsumer.kind}] already has track`);
                                    } else {
                                        console.log(`(3)addTrack kind[${clientInfo.consumeInfo.audioConsumer.kind}] mediaKind[${mediaKind}]`);
                                        clientInfo.consumeInfo.audioStream.addTrack(clientInfo.consumeInfo.audioConsumer.track);
                                    }
                                }

                                if (clientInfo.consumeInfo.audioEl) {
                                    clientInfo.consumeInfo.audioEl.srcObject = clientInfo.consumeInfo.audioStream;
                                    if (ConstData.IS_LOCAL_VERSION && !getIsForPblModeBrowser()){
                                        let volume = ConstData.IS_LOCAL_VERSION && !getIsForPblModeBrowser() ? clientInfo.consumeInfo.savedVolume : undefined;
                                        console.log("(4) consumeAfter - volume[", volume, "]");
                                        clientInfo.consumeInfo.audioEl.volume = volume; // 20251110 ... 로컬 버전에서는 현재 저장되어있는 볼륨값으로 설정되도록 수정 ... by hjkim

                                        if (isIOSWebView()) { // ios 는 volume = 0 이 동작하지 않아서 track 비활성화/활성화로 처리 .... by ykhan 251013
                                            const stream = clientInfo.consumeInfo.audioEl.srcObject;
                                            stream.getAudioTracks().forEach(track => {
                                                if (volume === 0) track.enabled = false;
                                                else track.enabled = true;
                                            });
                                        }
                                    }

                                    // 20251017 ... play() 오류 방지를 위해 paused 상태 값 체크 추가 ... by hjkim
                                    if (clientInfo.consumeInfo.audioEl.paused) {
                                        //if (!isIOSWebView() || !clientInfo.consumeInfo.isMuteAudio) { //20260403 ... ios에서 앱 내부로 되돌아오는경우 
                                        if (!isIOSWebView() || (clientInfo.consumeInfo.savedVolume > 0 && !clientInfo.consumeInfo.isMuteAudio)) {
                                            await clientInfo.consumeInfo.audioEl.play();
                                        }
                                    } else {
                                        console.log("consumeAfter - Audio element already playing audio source.");
                                    }
                                }

                                console.log("live(audio) consumeAfter case 6-1");
                                sendConsume("mic", roomKind, rcvUserSeq);
                            } else { // 이미 mic consume 중이거나 mic 없는 case ... by hjkim 20220210
                                if (!clientInfo.consumeInfo.isSelectedMode) { // 셀렉트(선택) 안된 case ... by hjkim 20220210
                                    if (clientInfo.consumeInfo.audioStream === null) {
                                        clientInfo.consumeInfo.audioStream = new MediaStream();
                                        // console.log(`(4)addTrack kind[${clientInfo.consumeInfo.audioConsumer.kind}] mediaKind[${mediaKind}]`);
                                        clientInfo.consumeInfo.audioStream.addTrack(clientInfo.consumeInfo.audioConsumer.track);
                                    } else {
                                        if (clientInfo.consumeInfo.audioStream.getTracks().length > 0 || clientInfo.consumeInfo.audioStream.getTracks().length !== 0) {
                                            console.log(`(5)addTrack kind[${clientInfo.consumeInfo.audioConsumer.kind}] already has track`);
                                        } else {
                                            console.log(`(6)addTrack kind[${clientInfo.consumeInfo.audioConsumer.kind}] mediaKind[${mediaKind}]`);
                                            clientInfo.consumeInfo.audioStream.addTrack(clientInfo.consumeInfo.audioConsumer.track);
                                        }
                                    }

                                    if (clientInfo.consumeInfo.audioEl) {
                                        clientInfo.consumeInfo.audioEl.srcObject = clientInfo.consumeInfo.audioStream;
                                        if (ConstData.IS_LOCAL_VERSION && !getIsForPblModeBrowser()) {
                                            let volume = ConstData.IS_LOCAL_VERSION && !getIsForPblModeBrowser() ? clientInfo.consumeInfo.savedVolume : undefined;
                                            console.log("(5) consumeAfter - volume[", volume, "]");
                                            clientInfo.consumeInfo.audioEl.volume = volume; // 20251110 ... 로컬 버전에서는 현재 저장되어있는 볼륨값으로 설정되도록 수정 ... by hjkim

                                            if (isIOSWebView()) { // ios 는 volume = 0 이 동작하지 않아서 track 비활성화/활성화로 처리 .... by ykhan 251013
                                                const stream = clientInfo.consumeInfo.audioEl.srcObject;
                                                stream.getAudioTracks().forEach(track => {
                                                    if (volume === 0) track.enabled = false;
                                                    else track.enabled = true;
                                                });
                                            }
                                        }

                                        // 20251017 ... play() 오류 방지를 위해 paused 상태 값 체크 추가 ... by hjkim
                                        if (clientInfo.consumeInfo.audioEl.paused) {
                                            //if (!isIOSWebView() || !clientInfo.consumeInfo.isMuteAudio) { //20260403 ... ios에서 앱 내부로 되돌아오는경우 
                                            if (!isIOSWebView() || (clientInfo.consumeInfo.savedVolume > 0 && !clientInfo.consumeInfo.isMuteAudio)) {
                                                await clientInfo.consumeInfo.audioEl.play();
                                            }
                                        } else {
                                            console.log("consumeAfter - Audio element already playing audio source.");
                                        }
                                    }

                                    // 20260325 기존 코드 주석 처리 ... by hjkim
                                    /* if (clientInfo.consumeInfo.isVideoReceiveable && clientInfo.consumeInfo.isVideoReceived) {
                                        if (clientInfo.consumeInfo.videoEl && clientInfo.consumeInfo.videoEl.srcObject === null) {
                                            sendResume("video", roomKind, rcvUserSeq);
                                        } else {
                                            sendResume("audio", roomKind, rcvUserSeq);
                                        }
                                    } else {
                                        sendResume("audio", roomKind, rcvUserSeq);
                                    } */

                                    // 20260325 여기부터 수정 코드
                                    if (clientInfo.consumeInfo.isVideoReceiveable && clientInfo.consumeInfo.isVideoReceived) {
                                        console.log("live(audio) consumeAfter case 6-2 - clientInfo.consumeInfo.videoConsumer.paused[", clientInfo.consumeInfo.videoConsumer.paused, "]");
                                        sendResume("video", roomKind, rcvUserSeq);
                                    }

                                    console.log("live(audio) consumeAfter case 6-3 - clientInfo.consumeInfo.audioConsumer.paused[", clientInfo.consumeInfo.audioConsumer.paused, "]");
                                    sendResume("audio", roomKind, rcvUserSeq);
                                } else { // 셀렉트(선택)된 case ... by hjkim 20231113
                                    console.log("consumeAfter case else ... 셀렉트(선택)된 경우 ...");

                                    // 20260325 기존 코드 주석 처리 ... by hjkim
                                    /* // 이 경우 audio consume은 play하지 않아야 하므로 다음 단계로 넘어가기 위해 video 있는 경우 sendResume
                                    if (clientInfo.consumeInfo.isVideoReceiveable && clientInfo.consumeInfo.isVideoReceived) {
                                        if (clientInfo.consumeInfo.videoEl && clientInfo.consumeInfo.videoEl.srcObject === null) {
                                            sendResume("video", roomKind, rcvUserSeq);
                                        } else {
                                            console.log("consumeAfter case else ... (1)");
                                        }
                                    } else {
                                        console.log("consumeAfter case else ... (2)");
                                    } */

                                    // 20260325 여기부터 수정 코드
                                    // 이 경우 audio consume은 play하지 않아야 하므로 다음 단계로 넘어가기 위해 video 있는 경우 sendResume
                                    if (clientInfo.consumeInfo.isVideoReceiveable && clientInfo.consumeInfo.isVideoReceived) {
                                        console.log("live(audio) consumeAfter case 6-4 - clientInfo.consumeInfo.videoConsumer.paused[", clientInfo.consumeInfo.videoConsumer.paused, "]");
                                        sendResume("video", roomKind, rcvUserSeq);
                                    }

                                    // 이 경우 audio consume은 play하지 않아야 하고, mic를 consume한 상태라면 mic resume을 보내야 한다.
                                    if (clientInfo.consumeInfo.isMicReceived) {
                                        console.log("live(audio) consumeAfter case 6-5 - clientInfo.consumeInfo.micConsumer.paused[", clientInfo.consumeInfo.micConsumer.paused, "]");
                                        sendResume("mic", roomKind, rcvUserSeq);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        } else {
            console.log(`[Unsupported] cannot consume this Producer ... producerId[${producerId}]`);
            // 20260904 alert() 대신 누적 오류 로그에 기록 ... by claude
            addMediaError({ prodUserSeq: rcvUserSeq, errorCode: "UnsupportedError" });
        }
    } catch (err) {
        console.log("consumeAfter() - err => ", err);
        // 20261022 브라우저에서 직접 확인된 영상 코덱 미지원도 기존 서버 실패 안내와 동일하게 전달한다.
        if (consumer === null && mediaKind === "video" && err && (err.name === "UnsupportedError" || err instanceof UnsupportedError)) {
            notifyUnsupportedMediaCodec({
                roomKind, mediaKind, prodUserSeq: rcvUserSeq, errorCode: "UNSUPPORTED_CODEC",
                producerCodecs: (rtpParameters.codecs || []).map(codec => codec.mimeType)
                    .filter(mimeType => /^video\//i.test(mimeType || "") && !/^video\/rtx$/i.test(mimeType))
            });
        }
        // 20260904 alert() 대신 누적 오류 로그에 기록 ... by claude
        logMediaDeviceError(err);
    }
}

// 20260807 live 화상(video) resume 재시도 상한 및 기본 대기시간(ms).
// 지수 백오프 + 지터를 적용해서 여러 학생이 동시에 재시도할 때 서버로 몰리지 않도록 한다 ... by claude
const MAX_LIVE_VIDEO_RETRY = 4;
const LIVE_VIDEO_RETRY_BASE_DELAY = 500;

/**
 * 20260807 live 화상(video) resume 실패(서버의 명시적 실패 응답) 또는 프레임 미수신 시,
 * 죽은 consumer/stream/트랙 상태를 정리하고 sendConsume부터 다시 요청한다.
 * - 재시도 전에 지금도 영상을 받아야 하는 상태(isVideoReceiveable)인지 확인해서,
 *   애초에 받을 영상이 없는 경우(선생님이 카메라를 끈 경우 등)엔 재시도하지 않는다.
 * - 재시도 횟수 상한(MAX_LIVE_VIDEO_RETRY)을 넘으면 자동 재시도를 멈추고 화면 상태를 off로 반영한다.
 *
 * @param {Number} prodUserSeq - 선생님 사용자 시퀀스 번호
 */
const retryLiveVideoConsume = (prodUserSeq) => {
    if (clientInfo.consumeInfo.videoStateInterval) {
        clearInterval(clientInfo.consumeInfo.videoStateInterval);
        clientInfo.consumeInfo.videoStateInterval = null;
    }

    if (!clientInfo.consumeInfo.isVideoReceiveable) {
        console.log("retryLiveVideoConsume - isVideoReceiveable false. 재시도하지 않음.");
        clientInfo.consumeInfo.videoResumeRetryCount = 0;
        return;
    }

    const retryCount = (clientInfo.consumeInfo.videoResumeRetryCount || 0) + 1;
    clientInfo.consumeInfo.videoResumeRetryCount = retryCount;

    if (retryCount > MAX_LIVE_VIDEO_RETRY) {
        console.error(`retryLiveVideoConsume - 재시도 ${MAX_LIVE_VIDEO_RETRY}회 초과. 자동 재시도를 중단한다. prodUserSeq[${prodUserSeq}]`);
        clientInfo.consumeInfo.videoResumeRetryCount = 0;

        let store = window.hiclasstv.store;
        store.dispatch(changeLiveStatusInfo({ kind: "video", status: "off" }));
        return;
    }

    // 죽은 consumer/stream/트랙 정리. 정리하지 않으면 "이미 track 있음" 분기 때문에
    // 재시도로 새 consumer를 받아도 videoStream에 addTrack이 스킵되어 화면이 복구되지 않는다.
    try {
        if (clientInfo.consumeInfo.videoEl) {
            if (!clientInfo.consumeInfo.videoEl.paused) {
                clientInfo.consumeInfo.videoEl.pause();
            }
            clientInfo.consumeInfo.videoEl.srcObject = null;
        }

        if (clientInfo.consumeInfo.videoStream) {
            clientInfo.consumeInfo.videoStream.getTracks().forEach(track => {
                clientInfo.consumeInfo.videoStream.removeTrack(track);
            });
        }

        if (clientInfo.consumeInfo.videoConsumer && !clientInfo.consumeInfo.videoConsumer.closed) {
            clientInfo.consumeInfo.videoConsumer.close();
        }
    } catch (err) {
        console.log("retryLiveVideoConsume - cleanup err => ", err);
    } finally {
        clientInfo.consumeInfo.videoConsumer = null;
        clientInfo.consumeInfo.videoStream = null;
        clientInfo.consumeInfo.isVideoReceived = false;
    }

    // 지수 백오프 + 지터(여러 학생이 동시에 재시도로 몰리는 것 방지)
    const backoff = Math.min(LIVE_VIDEO_RETRY_BASE_DELAY * Math.pow(2, retryCount - 1), 8000) + Math.floor(Math.random() * 300);
    console.log(`retryLiveVideoConsume - ${retryCount}/${MAX_LIVE_VIDEO_RETRY}번째 재시도. ${backoff}ms 후 sendConsume 재요청. prodUserSeq[${prodUserSeq}]`);

    setTimeout(() => {
        sendConsume("video", "live", prodUserSeq);
    }, backoff);
};

/**
 * 20260807 live video가 play()까지는 성공했지만 실제 프레임이 오지 않는(테두리만 있고 화면이 멈춘) 상태를
 * 감지하기 위한 워치독. 일정 시간 동안 videoWidth/videoHeight가 0이면 프레임이 없는 것으로 보고 재시도한다.
 * clientInfo.consumeInfo.videoStateInterval / lastVideoState 필드는 원래 이 용도로 만들어져 있었지만
 * 미사용 상태였던 것을 이번에 실제로 채워 넣었다.
 *
 * @param {HTMLVideoElement} videoEl - 검사 대상 video element
 * @param {Number} prodUserSeq - 선생님 사용자 시퀀스 번호
 */
const watchLiveVideoFrame = (videoEl, prodUserSeq) => {
    if (clientInfo.consumeInfo.videoStateInterval) {
        clearInterval(clientInfo.consumeInfo.videoStateInterval);
        clientInfo.consumeInfo.videoStateInterval = null;
    }

    clientInfo.consumeInfo.lastVideoState = null;
    let checkCount = 0;
    const maxCheckCount = 3; // videoStateIntervalTime(2500ms) * 3 = 약 7.5초 유예

    clientInfo.consumeInfo.videoStateInterval = setInterval(() => {
        if (!videoEl || videoEl !== clientInfo.consumeInfo.videoEl) {
            // 그 사이에 video element가 교체/해제된 경우 워치독을 중단한다.
            clearInterval(clientInfo.consumeInfo.videoStateInterval);
            clientInfo.consumeInfo.videoStateInterval = null;
            return;
        }

        const hasFrame = videoEl.videoWidth > 0 && videoEl.videoHeight > 0;
        console.log(`watchLiveVideoFrame - checkCount[${checkCount}], videoWidth[${videoEl.videoWidth}], videoHeight[${videoEl.videoHeight}], hasFrame[${hasFrame}]`);

        if (hasFrame) {
            clientInfo.consumeInfo.lastVideoState = "playing";
            clientInfo.consumeInfo.videoResumeRetryCount = 0;
            clearInterval(clientInfo.consumeInfo.videoStateInterval);
            clientInfo.consumeInfo.videoStateInterval = null;
            return;
        }

        checkCount++;
        if (checkCount >= maxCheckCount) {
            clientInfo.consumeInfo.lastVideoState = "stuck";
            clearInterval(clientInfo.consumeInfo.videoStateInterval);
            clientInfo.consumeInfo.videoStateInterval = null;
            console.error(`watchLiveVideoFrame - ${maxCheckCount * videoStateIntervalTime}ms 동안 프레임 미수신. 재시도. prodUserSeq[${prodUserSeq}]`);
            retryLiveVideoConsume(prodUserSeq);
        }
    }, videoStateIntervalTime);
};

/**
 * resume 요청 후 서버에서 받은 데이터 처리
 *
 * @param {JSON} rtnValue - 서버에서 받은 JSON 데이터 객체
 */
export const resumeAfter = async (rtnValue) => {
    // 20260807 서버가 resume 대상 consumer를 찾지 못해 명시적으로 보낸 실패 응답 처리.
    // 성공 응답은 kind 필드를, 실패 응답(sendConsumeFailureResponse)은 mediaKind 필드를 쓰고 있어 여기서 맞춰준다 ... by claude
    const kind = rtnValue.kind ?? rtnValue.mediaKind;
    const { roomKind, prodUserSeq } = rtnValue;
    console.log(`resumeAfter - kind[${kind}], roomKind[${roomKind}], prodUserSeq[${prodUserSeq}]`);

    if (rtnValue.isSuccess === false) {
        console.error(`resumeAfter - 실패 응답 수신. errorCode[${rtnValue.errorCode}], errorStage[${rtnValue.errorStage}], roomKind[${roomKind}], kind[${kind}], prodUserSeq[${prodUserSeq}]`);

        // 20260807 지금은 live 화상(video)에 대해서만 자동 재시도한다.
        // handsup/p2p, audio/mic 케이스까지 확장은 live 쪽 동작 검증 후 별도 진행 ... by claude
        if (roomKind === "live" && kind === "video") {
            retryLiveVideoConsume(prodUserSeq);
        }
        return;
    }

    if (roomKind === "handsup") {
        console.log("resumeAfter roomKind is handsup");

        // let consumer;

        const consumeInfo = getConsumeInfoBySeq(prodUserSeq);
        if (consumeInfo) {
            if (kind === "video") {
                // consumer = consumeInfo.videoConsumer;

                // Consumer 상태 확인
                console.log(`(1) resumeAfter(handsup) - Consumer paused: ${consumeInfo.videoConsumer.paused}`);
                console.log(`(1) resumeAfter(handsup) - Producer paused: ${consumeInfo.videoConsumer.producerPaused}`);

                consumeInfo.videoConsumer.resume();
                console.log("(1) resumeAfter(handsup) - consumeInfo.videoConsumer.paused[", consumeInfo.videoConsumer.paused, "]");

                // Resume 후 잠시 대기 (Smart TV에서 필요할 수 있음)
                await new Promise(resolve => setTimeout(resolve, 100));

                if (consumeInfo.videoStream === null) {
                    console.log(`(1-1) resumeAfter(handsup) - prodUserSeq[${prodUserSeq}], videoStream is null. addTrack. consumer.kind[${consumeInfo.videoConsumer.kind}], [${kind}]`);
                    consumeInfo.videoStream = new MediaStream();
                    consumeInfo.videoStream.addTrack(consumeInfo.videoConsumer.track);

                    // Track 상태 확인 추가
                    console.log(`(1-1) resumeAfter(handsup) - Track readyState: ${consumeInfo.videoConsumer.track.readyState}`);
                    console.log(`(1-1) resumeAfter(handsup) - Track enabled: ${consumeInfo.videoConsumer.track.enabled}`);
                    console.log(`(1-1) resumeAfter(handsup) - Track settings:`, consumeInfo.videoConsumer.track.getSettings());
                } else {
                    if (consumeInfo.videoStream.getTracks().length > 0 || consumeInfo.videoStream.getTracks().length !== 0) {
                        console.log(`(1-2) resumeAfter(handsup) - prodUserSeq[${prodUserSeq}], addTrack consumer.kind[${consumeInfo.videoConsumer.kind}] already has track`);
                    } else {
                        console.log(`(1-3) resumeAfter(handsup) - prodUserSeq[${prodUserSeq}], addTrack consumer.kind[${consumeInfo.videoConsumer.kind}] kind[${kind}]`);
                        consumeInfo.videoStream.addTrack(consumeInfo.videoConsumer.track);

                        // Track 상태 확인 추가
                        console.log(`(1-3) resumeAfter(handsup) - Track readyState: ${consumeInfo.videoConsumer.track.readyState}`);
                        console.log(`(1-3) resumeAfter(handsup) - Track enabled: ${consumeInfo.videoConsumer.track.enabled}`);
                        console.log(`(1-3) resumeAfter(handsup) - Track settings:`, consumeInfo.videoConsumer.track.getSettings());
                    }
                }

                console.log(`(1) resumeAfter(handsup) - prodUserSeq[${prodUserSeq}], consumeInfo.videoEl => `, consumeInfo.videoEl);
                console.log(`(1) resumeAfter(handsup) - prodUserSeq[${prodUserSeq}], consumeInfo.videoStream => `, consumeInfo.videoStream);

                if (consumeInfo.videoEl === null) {
                    // const handsSmallVideoConsumeDiv = document.getElementById("handsSmallVideoConsumeDiv");
                    // let videoEl = document.createElement("video");
                    // videoEl.id = "handsSmallVideoConsumeEl-" + prodUserSeq;
                    // videoEl.autoplay = true;
                    // videoEl.autoPlay = true;
                    // handsSmallVideoConsumeDiv.appendChild(videoEl);
                    // consumeInfo.videoEl = videoEl;

                    const videoEl = document.getElementById("small-group-item-" + prodUserSeq);
                    videoEl.autoplay = true;
                    videoEl.autoPlay = true;
                    consumeInfo.videoEl = videoEl;
                }
                consumeInfo.videoEl.srcObject = consumeInfo.videoStream;
                consumeInfo.videoEl.key = "mediasoup-video-comp-" + Date.now();
                console.log("consumeInfo.videoEl.key => ", consumeInfo.videoEl.key);

                try {
                    let result = await playVideo(consumeInfo.videoEl);
                    console.log("(1) resumeAfter(handsup) - playVideo result => ", result);

                    if (result && getIsForPblModeBrowser()) {
                        const consumeData = {
                            mediaKind: kind,
                            roomKind,
                            userSeq: prodUserSeq,
                            stream: consumeInfo.videoStream
                        };

                        console.log("(1) resumeAfter(handsup) - mediaConsumeReadyHelper(consumeData, { data: null }).");
                        mediaConsumeReadyHelper(consumeData, { data: null });
                    }

                    callCurrentFuncProc(prodUserSeq, "connect-client");
                    // callCurrentFuncProc(prodUserSeq, "image_full_mode");
                } catch (err) {
                    console.log("(1) resumeAfter(handsup) - video play - err => ", err);
                    // 20260904 alert() 대신 누적 오류 로그에 기록 ... by claude
                    addMediaError({ roomKind, mediaKind: kind, prodUserSeq, errorCode: "PLAYBACK_FAILED" });
                }
            } else if (kind === "audio") {
                // consumer = consumeInfo.audioConsumer;

                // Consumer 상태 확인
                console.log(`(2) resumeAfter(handsup) - Consumer paused: ${consumeInfo.audioConsumer.paused}`);
                console.log(`(2) resumeAfter(handsup) - Producer paused: ${consumeInfo.audioConsumer.producerPaused}`);

                consumeInfo.audioConsumer.resume();
                console.log("(2) resumeAfter(handsup) - consumeInfo.audioConsumer.paused[", consumeInfo.audioConsumer.paused, "]");

                // Resume 후 잠시 대기 (Smart TV에서 필요할 수 있음)
                await new Promise(resolve => setTimeout(resolve, 100));

                if (consumeInfo.audioStream === null) {
                    consumeInfo.audioStream = new MediaStream();
                    console.log(`(2-1) resumeAfter(handsup) - prodUserSeq[${prodUserSeq}], audioStream is null. addTrack. consumer.kind[${consumeInfo.audioConsumer.kind}], [${kind}]`);
                    consumeInfo.audioStream.addTrack(consumeInfo.audioConsumer.track);
                } else {
                    if (consumeInfo.audioStream.getTracks().length > 0 || consumeInfo.audioStream.getTracks().length !== 0) {
                        console.log(`(2-2) resumeAfter(handsup) - prodUserSeq[${prodUserSeq}], addTrack consumer.kind[${consumeInfo.audioConsumer.kind}] already has track`);
                    } else {
                        console.log(`(2-3) resumeAfter(handsup) - prodUserSeq[${prodUserSeq}], addTrack consumer.kind[${consumeInfo.audioConsumer.kind}] kind[${kind}]`);
                        consumeInfo.audioStream.addTrack(consumeInfo.audioConsumer.track);
                    }
                }

                // 20260929 PBL 오디오 수정: 그룹 오디오 재연결에도 현재 듣기 설정을 유지한다.
                applyPblStudentAudioListenToElement(consumeInfo.audioEl);
                consumeInfo.audioEl.srcObject = consumeInfo.audioStream;
                consumeInfo.audioEl.key = "mediasoup-audio-comp-" + Date.now();
                console.log("consumeInfo.audioEl.key => ", consumeInfo.audioEl.key);

                try {
                    let volume = undefined;
                    if (ConstData.IS_LOCAL_VERSION && !getIsForPblModeBrowser()) {
                        if (consumeInfo.isMixedClassMember) {
                            console.log("(2) resumeAfter(handsup) - consumeInfo.isMixedClassMember");
                            volume = 1;
                            console.log("(2-1) resumeAfter - volume = 1");

                            if (isIOSWebView()) { // ios 는 volume = 1 이 동작하지 않아서 track 활성화로 처리 .... by ykhan 251013
                                const stream = consumeInfo.audioEl.srcObject;
                                stream.getAudioTracks().forEach(track => {
                                    track.enabled = true;
                                });
                            }
                        } else {
                            console.log("(2) resumeAfter(handsup) - not consumeInfo.isMixedClassMember");
                            // 20251110 ... 로컬 버전에서는 현재 저장되어있는 볼륨값으로 설정되도록 수정 ... by hjkim
                            volume = ConstData.IS_LOCAL_VERSION && !getIsForPblModeBrowser() ? clientInfo.consumeInfo.savedVolume : undefined;
                            console.log("(2-2) resumeAfter - volume[", volume, "]");

                            if (isIOSWebView()) { // ios 는 volume = 0 이 동작하지 않아서 track 비활성화/활성화로 처리 .... by ykhan 251013
                                const stream = consumeInfo.audioEl.srcObject;
                                stream.getAudioTracks().forEach(track => {
                                    if (volume === 0) track.enabled = false;
                                    else track.enabled = true;
                                });
                            }
                        }
                    }

                    let result = await playAudio(consumeInfo.audioEl, volume);
                    console.log("(2) resumeAfter(handsup) - playAudio result => ", result);

                    if (result && getIsForPblModeBrowser()) {
                        const consumeData = {
                            mediaKind: kind,
                            roomKind,
                            userSeq: prodUserSeq,
                            stream: consumeInfo.audioStream
                        };

                        console.log("(2) resumeAfter(handsup) - mediaConsumeReadyHelper(consumeData, { data: null }).");
                        mediaConsumeReadyHelper(consumeData, { data: null });
                    }
                } catch (err) {
                    console.log("(2) resumeAfter(handsup) - audio play err => ", err);
                    // 20260904 alert() 대신 누적 오류 로그에 기록 ... by claude
                    addMediaError({ roomKind, mediaKind: kind, prodUserSeq, errorCode: "PLAYBACK_FAILED" });
                }
            } else {
                console.log(`(3) resumeAfter(handsup) - No consumer information matching user sequence prodUserSeq[${prodUserSeq}] and media type kind[${kind}] was found.`);
            }
        } else {
            const p2pInfo = getP2pConsumeInfoBySeq(prodUserSeq);
            if (p2pInfo) {
                if (kind === "video") {
                    // consumer = p2pInfo.videoConsumer;

                    // Consumer 상태 확인
                    console.log(`(4) resumeAfter(handsup) - Consumer paused: ${p2pInfo.videoConsumer.paused}`);
                    console.log(`(4) resumeAfter(handsup) - Producer paused: ${p2pInfo.videoConsumer.producerPaused}`);

                    p2pInfo.videoConsumer.resume();
                    console.log("(4) resumeAfter(handsup) - p2pInfo.videoConsumer.paused[", p2pInfo.videoConsumer.paused, "]");

                    // Resume 후 잠시 대기 (Smart TV에서 필요할 수 있음)
                    await new Promise(resolve => setTimeout(resolve, 100));

                    if (p2pInfo.videoStream === null) {
                        console.log(`(4-1) resumeAfter(handsup) - prodUserSeq[${prodUserSeq}], videoStream is null. addTrack. consumer.kind[${p2pInfo.videoConsumer.kind}], [${kind}]`);
                        p2pInfo.videoStream = new MediaStream();
                        p2pInfo.videoStream.addTrack(p2pInfo.videoConsumer.track);

                        // Track 상태 확인 추가
                        console.log(`(4-1) resumeAfter(handsup) - Track readyState: ${p2pInfo.videoConsumer.track.readyState}`);
                        console.log(`(4-1) resumeAfter(handsup) - Track enabled: ${p2pInfo.videoConsumer.track.enabled}`);
                        console.log(`(4-1) resumeAfter(handsup) - Track settings:`, p2pInfo.videoConsumer.track.getSettings());
                    } else {
                        if (p2pInfo.videoStream.getTracks().length > 0 || p2pInfo.videoStream.getTracks().length !== 0) {
                            console.log(`(4-2) resumeAfter(handsup) - prodUserSeq[${prodUserSeq}], addTrack consumer.kind[${p2pInfo.videoConsumer.kind}] already has track`);
                        } else {
                            console.log(`(4-3) resumeAfter(handsup) - prodUserSeq[${prodUserSeq}], addTrack consumer.kind[${p2pInfo.videoConsumer.kind}] kind[${kind}]`);
                            p2pInfo.videoStream.addTrack(p2pInfo.videoConsumer.track);

                            // Track 상태 확인 추가
                            console.log(`(4-3) resumeAfter(handsup) - Track readyState: ${p2pInfo.videoConsumer.track.readyState}`);
                            console.log(`(4-3) resumeAfter(handsup) - Track enabled: ${p2pInfo.videoConsumer.track.enabled}`);
                            console.log(`(4-3) resumeAfter(handsup) - Track settings:`, p2pInfo.videoConsumer.track.getSettings());
                        }
                    }

                    console.log(`(4) resumeAfter(handsup) - prodUserSeq[${prodUserSeq}], p2pInfo.videoEl => `, p2pInfo.videoEl);
                    console.log(`(4) resumeAfter(handsup) - prodUserSeq[${prodUserSeq}], p2pInfo.videoStream => `, p2pInfo.videoStream);

                    if (p2pInfo.videoEl === null) {
                        // const handsSmallVideoConsumeDiv = document.getElementById("handsSmallVideoConsumeDiv");
                        // let videoEl = document.createElement("video");
                        // videoEl.id = "handsSmallVideoConsumeEl-" + prodUserSeq;
                        // videoEl.autoplay = true;
                        // videoEl.autoPlay = true;
                        // handsSmallVideoConsumeDiv.appendChild(videoEl);
                        // p2pInfo.videoEl = videoEl;

                        const videoEl = document.getElementById("small-group-item-" + prodUserSeq);
                        videoEl.autoplay = true;
                        videoEl.autoPlay = true;
                        p2pInfo.videoEl = videoEl;
                    }

                    p2pInfo.videoEl.srcObject = p2pInfo.videoStream;
                    p2pInfo.videoEl.key = "mediasoup-video-comp-" + Date.now();
                    console.log("p2pInfo.videoEl.key => ", p2pInfo.videoEl.key);

                    try {
                        let result = await playVideo(p2pInfo.videoEl);
                        console.log("(4) resumeAfter(handsup) - playVideo result => ", result);

                        if (result && getIsForPblModeBrowser()) {
                            const consumeData = {
                                mediaKind: kind,
                                roomKind,
                                userSeq: prodUserSeq,
                                stream: p2pInfo.videoStream
                            };

                            console.log("(4) resumeAfter(handsup) - mediaConsumeReadyHelper(consumeData, { data: null }).");
                            mediaConsumeReadyHelper(consumeData, { data: null });
                        }

                        callCurrentFuncProc(prodUserSeq, "connect-client");
                        // callCurrentFuncProc(prodUserSeq, "image_full_mode");
                    } catch (err) {
                        console.log("(4) resumeAfter(handsup) - video play err => ", err);
                        // 20260904 alert() 대신 누적 오류 로그에 기록 ... by claude
                        addMediaError({ roomKind, mediaKind: kind, prodUserSeq, errorCode: "PLAYBACK_FAILED" });
                    }
                } else if (kind === "audio") {
                    // consumer = p2pInfo.audioConsumer;

                    // Consumer 상태 확인
                    console.log(`(5) resumeAfter(handsup) - Consumer paused: ${p2pInfo.audioConsumer.paused}`);
                    console.log(`(5) resumeAfter(handsup) - Producer paused: ${p2pInfo.audioConsumer.producerPaused}`);

                    p2pInfo.audioConsumer.resume();
                    console.log("(5) resumeAfter(handsup) - p2pInfo.audioConsumer.paused[", p2pInfo.audioConsumer.paused, "]");

                    // Resume 후 잠시 대기 (Smart TV에서 필요할 수 있음)
                    await new Promise(resolve => setTimeout(resolve, 100));

                    if (p2pInfo.audioStream === null) {
                        p2pInfo.audioStream = new MediaStream();
                        console.log(`(5-1) resumeAfter(handsup) - prodUserSeq[${prodUserSeq}], audioStream is null. addTrack. consumer.kind[${p2pInfo.audioConsumer.kind}], [${kind}]`);
                        p2pInfo.audioStream.addTrack(p2pInfo.audioConsumer.track);
                    } else {
                        if (p2pInfo.audioStream.getTracks().length > 0 || p2pInfo.audioStream.getTracks().length !== 0) {
                            console.log(`(5-2) resumeAfter(handsup) - prodUserSeq[${prodUserSeq}], addTrack consumer.kind[${p2pInfo.audioConsumer.kind}] already has track`);
                        } else {
                            console.log(`(5-3) resumeAfter(handsup) - prodUserSeq[${prodUserSeq}], addTrack consumer.kind[${p2pInfo.audioConsumer.kind}] kind[${kind}]`);
                            p2pInfo.audioStream.addTrack(p2pInfo.audioConsumer.track);
                        }
                    }

                    applyPblStudentAudioListenToElement(p2pInfo.audioEl);
                    p2pInfo.audioEl.srcObject = p2pInfo.audioStream;
                    p2pInfo.audioEl.key = "mediasoup-audio-comp-" + Date.now();
                    console.log("p2pInfo.audioEl.key => ", p2pInfo.audioEl.key);

                    try {
                        let volume = undefined;
                        if (ConstData.IS_LOCAL_VERSION && !getIsForPblModeBrowser()) {
                            if (p2pInfo.isMixedClassMember) {
                                console.log("(5) resumeAfter(handsup) - p2pInfo.isMixedClassMember");
                                volume = 1;
                                console.log("(5-1) resumeAfter - volume = 1");

                                if (isIOSWebView()) { // ios 는 volume = 1 이 동작하지 않아서 track 활성화로 처리 .... by ykhan 251013
                                    const stream = p2pInfo.audioEl.srcObject;
                                    stream.getAudioTracks().forEach(track => {
                                        track.enabled = true;
                                    });
                                }
                            } else {
                                console.log("(5) resumeAfter(handsup) - not p2pInfo.isMixedClassMember");
                                // 20251110 ... 로컬 버전에서는 현재 저장되어있는 볼륨값으로 설정되도록 수정 ... by hjkim
                                volume = ConstData.IS_LOCAL_VERSION && !getIsForPblModeBrowser() ? clientInfo.consumeInfo.savedVolume : undefined;
                                console.log("(5-2) resumeAfter - volume[", volume, "]");

                                if (isIOSWebView()) { // ios 는 volume = 0 이 동작하지 않아서 track 비활성화/활성화로 처리 .... by ykhan 251013
                                    const stream = p2pInfo.audioEl.srcObject;
                                    stream.getAudioTracks().forEach(track => {
                                        if (volume === 0) track.enabled = false;
                                        else track.enabled = true;
                                    });
                                }
                            }
                        }

                        let result = await playAudio(p2pInfo.audioEl, volume);
                        console.log("(5) resumeAfter(handsup) - playAudio result => ", result);

                        if (result && getIsForPblModeBrowser()) {
                            const consumeData = {
                                mediaKind: kind,
                                roomKind,
                                userSeq: prodUserSeq,
                                stream: p2pInfo.audioStream
                            };

                            console.log("(5) resumeAfter(handsup) - mediaConsumeReadyHelper(consumeData, { data: null }).");
                            mediaConsumeReadyHelper(consumeData, { data: null });
                        }
                    } catch (err) {
                        console.log("(5) resumeAfter(handsup) - audio play err => ", err);
                        // 20260904 alert() 대신 누적 오류 로그에 기록 ... by claude
                        addMediaError({ roomKind, mediaKind: kind, prodUserSeq, errorCode: "PLAYBACK_FAILED" });
                    }
                } else {
                    console.log(`(6) resumeAfter(handsup) - No consumer information matching user sequence prodUserSeq[${prodUserSeq}] and media type kind[${kind}] was found.`);
                }
            } else {
                console.log(`(7) resumeAfter(handsup) - No consumer information matching user sequence prodUserSeq[${prodUserSeq}] was found.`);
            }
        }
    } else if (roomKind === "live") {
        console.log("resumeAfter roomKind is live");

        // let consumer;

        if (kind === "video") {
            // consumer = clientInfo.consumeInfo.videoConsumer;

            // Consumer 상태 확인
            console.log(`(8) resumeAfter(live) - Consumer paused: ${clientInfo.consumeInfo.videoConsumer.paused}`);
            console.log(`(8) resumeAfter(live) - Producer paused: ${clientInfo.consumeInfo.videoConsumer.producerPaused}`);

            clientInfo.consumeInfo.videoConsumer.resume();
            console.log("(8) resumeAfter(live) - clientInfo.consumeInfo.videoConsumer.paused[", clientInfo.consumeInfo.videoConsumer.paused, "]");

            // Resume 후 잠시 대기 (Smart TV에서 필요할 수 있음)
            await new Promise(resolve => setTimeout(resolve, 100));

            if (clientInfo.consumeInfo.videoStream === null) {
                console.log(`(8-1) resumeAfter(live) - prodUserSeq[${prodUserSeq}], videoStream is null. addTrack. consumer.kind[${clientInfo.consumeInfo.videoConsumer.kind}], [${kind}]`);
                clientInfo.consumeInfo.videoStream = new MediaStream();
                clientInfo.consumeInfo.videoStream.addTrack(clientInfo.consumeInfo.videoConsumer.track);

                // Track 상태 확인 추가
                console.log(`(8-1) resumeAfter(live) - Track readyState: ${clientInfo.consumeInfo.videoConsumer.track.readyState}`);
                console.log(`(8-1) resumeAfter(live) - Track enabled: ${clientInfo.consumeInfo.videoConsumer.track.enabled}`);
                console.log(`(8-1) resumeAfter(live) - Track settings:`, clientInfo.consumeInfo.videoConsumer.track.getSettings());
            } else {
                if (clientInfo.consumeInfo.videoStream.getTracks().length > 0 || clientInfo.consumeInfo.videoStream.getTracks().length !== 0) {
                    console.log(`(8-2) resumeAfter(live) - prodUserSeq[${prodUserSeq}], addTrack consumer.kind[${clientInfo.consumeInfo.videoConsumer.kind}] already has track`);
                } else {
                    console.log(`(8-3) resumeAfter(live) - prodUserSeq[${prodUserSeq}], addTrack consumer.kind[${clientInfo.consumeInfo.videoConsumer.kind}] kind[${kind}]`);
                    clientInfo.consumeInfo.videoStream.addTrack(clientInfo.consumeInfo.videoConsumer.track);

                    // Track 상태 확인 추가
                    console.log(`(8-3) resumeAfter(live) - Track readyState: ${clientInfo.consumeInfo.videoConsumer.track.readyState}`);
                    console.log(`(8-3) resumeAfter(live) - Track enabled: ${clientInfo.consumeInfo.videoConsumer.track.enabled}`);
                    console.log(`(8-3) resumeAfter(live) - Track settings:`, clientInfo.consumeInfo.videoConsumer.track.getSettings());
                }
            }

            console.log(`(8) resumeAfter(live) - prodUserSeq[${prodUserSeq}], clientInfo.consumeInfo.videoEl => `, clientInfo.consumeInfo.videoEl);
            console.log(`(8) resumeAfter(live) - prodUserSeq[${prodUserSeq}], clientInfo.consumeInfo.videoStream => `, clientInfo.consumeInfo.videoStream);

            clientInfo.consumeInfo.videoEl.autoplay = true;
            clientInfo.consumeInfo.videoEl.autoPlay = true;
            clientInfo.consumeInfo.videoEl.srcObject = clientInfo.consumeInfo.videoStream;
            applyVideoDisplayRotation(clientInfo.consumeInfo.videoEl, clientInfo.consumeInfo.displayRotation);
            clientInfo.consumeInfo.videoEl.key = "mediasoup-video-comp-" + Date.now();
            console.log("clientInfo.consumeInfo.videoEl.key => ", clientInfo.consumeInfo.videoEl.key);

            try {
                let result = await playVideo(clientInfo.consumeInfo.videoEl);
                console.log("(8) resumeAfter(live) - playVideo result => ", result);

                if (result && getIsForPblModeBrowser()) {
                    const consumeData = {
                        mediaKind: kind,
                        roomKind,
                        userSeq: prodUserSeq,
                        userNickname: clientInfo.rcvTeacherInfo.userNickname,
                        stream: clientInfo.consumeInfo.videoStream
                    };

                    console.log("(8) resumeAfter(live) - mediaConsumeReadyHelper(consumeData, { data: null }).");
                    mediaConsumeReadyHelper(consumeData, { data: null });
                }

                let store = window.hiclasstv.store;
                store.dispatch(changeLiveStatusInfo({ kind: "video", status: "on" }));

                // 20260807 play()는 성공했지만 실제 프레임이 안 들어오는(테두리만 있고 멈춘) 상태를
                // 감지하기 위한 워치독 시작. 프레임이 확인되면 자동으로 멈춘다 ... by claude
                watchLiveVideoFrame(clientInfo.consumeInfo.videoEl, prodUserSeq);
            } catch (err) {
                // 20260807 play() 자체가 실패한 경우도 회복 가능한 케이스이므로,
                // 사용자에게 alert로 막는 대신 재시도로 넘긴다. 재시도 상한 초과 시에만 최종 실패로 반영된다 ... by claude
                console.log("(8) resumeAfter(live) - video play err => ", err);
                retryLiveVideoConsume(prodUserSeq);
            }
        } else if (kind === "audio") {
            // consumer = clientInfo.consumeInfo.audioConsumer;

            // Consumer 상태 확인
            console.log(`(9) resumeAfter(live) - Consumer paused: ${clientInfo.consumeInfo.audioConsumer.paused}`);
            console.log(`(9) resumeAfter(live) - Producer paused: ${clientInfo.consumeInfo.audioConsumer.producerPaused}`);

            clientInfo.consumeInfo.audioConsumer.resume();
            console.log("(9) resumeAfter(live) - clientInfo.consumeInfo.audioConsumer.paused[", clientInfo.consumeInfo.audioConsumer.paused, "]");

            // Resume 후 잠시 대기 (Smart TV에서 필요할 수 있음)
            await new Promise(resolve => setTimeout(resolve, 100));

            if (clientInfo.consumeInfo.audioStream === null) {
                clientInfo.consumeInfo.audioStream = new MediaStream();
                console.log(`(9-1) resumeAfter(live) - prodUserSeq[${prodUserSeq}], audioStream is null. addTrack consumer.kind[${clientInfo.consumeInfo.audioConsumer.kind}] kind[${kind}]`);
                clientInfo.consumeInfo.audioStream.addTrack(clientInfo.consumeInfo.audioConsumer.track);
            } else {
                if (clientInfo.consumeInfo.audioStream.getTracks().length > 0 || clientInfo.consumeInfo.audioStream.getTracks().length !== 0) {
                    console.log(`(9-2) resumeAfter(live) - prodUserSeq[${prodUserSeq}], addTrack consumer.kind[${clientInfo.consumeInfo.audioConsumer.kind}] already has track`);
                } else {
                    console.log(`(9-3) resumeAfter(live) - prodUserSeq[${prodUserSeq}], addTrack consumer.kind[${clientInfo.consumeInfo.audioConsumer.kind}] kind[${kind}]`);
                    clientInfo.consumeInfo.audioStream.addTrack(clientInfo.consumeInfo.audioConsumer.track);
                }
            }

            clientInfo.consumeInfo.audioEl.srcObject = clientInfo.consumeInfo.audioStream;
            clientInfo.consumeInfo.audioEl.key = "mediasoup-audio-comp-" + Date.now();
            console.log("clientInfo.consumeInfo.audioEl.key => ", clientInfo.consumeInfo.audioEl.key);

            try {
                // let volume = ConstData.IS_LOCAL_VERSION && !getIsForPblModeBrowser() ? 0 : undefined;
                let volume = ConstData.IS_LOCAL_VERSION && !getIsForPblModeBrowser() ? clientInfo.consumeInfo.savedVolume : undefined;
                console.log("(9-4) resumeAfter - volume[", volume, "]");
                if (ConstData.IS_LOCAL_VERSION && isIOSWebView()) { // ios 는 volume = 0 이 동작하지 않아서 track 비활성화/활성화로 처리 .... by ykhan 251013
                    const stream = clientInfo.consumeInfo.audioEl.srcObject;
                    stream.getAudioTracks().forEach(track => {
                        if (volume === 0) track.enabled = false;
                        else track.enabled = true;
                    });
                }
                
                let result = await playAudio(clientInfo.consumeInfo.audioEl, volume);
                console.log("(9) resumeAfter(live) - playAudio result => ", result);

                if (result && getIsForPblModeBrowser()) {
                    const consumeData = {
                        mediaKind: kind,
                        roomKind,
                        userSeq: prodUserSeq,
                        userNickname: clientInfo.rcvTeacherInfo.userNickname,
                        stream: clientInfo.consumeInfo.audioStream
                    };

                    console.log("(9) resumeAfter(live) - mediaConsumeReadyHelper(consumeData, { data: null }).");
                    mediaConsumeReadyHelper(consumeData, { data: null });
                }

                let store = window.hiclasstv.store;
                store.dispatch(changeLiveStatusInfo({ kind: "audio", status: "on" }));
            } catch (err) {
                console.log("(9) resumeAfter(live) - audio play err => ", err);
                // 20260904 alert() 대신 누적 오류 로그에 기록 ... by claude
                addMediaError({ roomKind, mediaKind: kind, prodUserSeq, errorCode: "PLAYBACK_FAILED" });
            }
        } else if (kind === "mic") {
            // Consumer 상태 확인
            console.log(`(10) resumeAfter(live) - Consumer paused: ${clientInfo.consumeInfo.micConsumer.paused}`);
            console.log(`(10) resumeAfter(live) - Producer paused: ${clientInfo.consumeInfo.micConsumer.producerPaused}`);

            clientInfo.consumeInfo.micConsumer.resume();
            console.log("(10) resumeAfter(live) - clientInfo.consumeInfo.micConsumer.paused[", clientInfo.consumeInfo.micConsumer.paused, "]");
        } else {
            console.log(`(11) resumeAfter(live) - No consumer information matching user sequence prodUserSeq[${prodUserSeq}] and media type kind[${kind}] was found.`);
        }
    } else {
        console.log(`(12) resumeAfter - No consumer information matching user sequence prodUserSeq[${prodUserSeq}] and room type roomKind[${roomKind}] was found.`);
    }
}

/**
 * HTML 오디오 요소의 소리를 재생
 * 
 * @param {HTMLAudioElement} audioEl - 대상 HTML 오디오 요소 객체
 * @param {Number | undefined} volume - 대상 HTML 오디오 요소 객체 볼륨 크기
 * @returns {Promise<Boolean | Error>}
 */
const playAudio = async (audioEl, volume) => {
    return new Promise(async (resolve, reject) => {
        try {
            // 20261104 [iOS] A정책 - 다른 앱(유튜브 PiP 등)이 소리 사용 중이면 선생님 소리 재생을 보류 (다른 앱 소리를 끊지 않음)
            //          → 선생님 화면에 '터치하면 다시 재생' 안내, 다른 앱 소리가 멈추거나 터치하면 LiveMediaSoupRcv 가 재생
            if (isIOSWebView() && window.__hiclassIOSOtherAudioBusy === true && audioEl && audioEl.paused) {
                console.log("[iOS] 다른 앱 소리 사용 중 → 선생님 소리 재생 보류");
                if (volume !== undefined) audioEl.volume = volume;
                try { window.dispatchEvent(new CustomEvent("hiclass-ios-teacher-audio-deferred")); } catch (e) { }
                resolve(false);
                return;
            }

            if (volume !== undefined) {
                console.log("audioEl set the volume => ", volume);
                audioEl.volume = volume;   
            }
            
            if (isIOSWebView()) {// ios 는 volume = N 이 동작하지 않아서 track 활성화로 처리 .... by ykhan 251013
                const stream = audioEl.srcObject;
                stream.getAudioTracks().forEach(track => {
                    if (volume === 0) track.enabled = false;
                    else track.enabled = true;
                });
            }

            // 20251017 ... play() 오류 방지를 위해 paused 상태 값 체크 추가 ... by hjkim
            if (audioEl.paused) {
                await audioEl.play();
            } else {
                console.log("Audio element already playing audio source.");
            }

            resolve(true);
        } catch (err) {
            console.log("playAudio - err => ", err);
            reject(err);
        }
    });
}

/**
 * HTML 오디오 요소의 소리 재생을 멈춤
 * 
 * @param {HTMLAudioElement} audioEl - 대상 HTML 오디오 요소 객체
 * @returns {Promise<Boolean | Error>}
 */
const pauseAudio = async (audioEl) => {
    return new Promise(async (resolve, reject) => {
        try {
            if (audioEl) {
                if (audioEl.srcObject) {
                    if (!audioEl.paused) {
                        audioEl.pause();
                    }
                    audioEl.srcObject = null;
                    resolve(true);
                } else {
                    resolve(false);
                }
            } else {
                resolve(false);
            }
        } catch (err) {
            console.log("playAudio - err => ", err);
            reject(err);
        }
    });
}

/**
 * HTML 비디오 요소의 영상을 재생
 * 
 * @param {HTMLVideoElement} videoEl - 대상 HTML 비디오 요소 객체
 * @returns {Promise<Boolean | Error>}
 */
const playVideo = async (videoEl) => {
    return new Promise(async (resolve, reject) => {
        try {
            // Smart TV에서는 loadedmetadata 이벤트를 기다림
            if (videoEl.readyState < 1) { // HAVE_METADATA
                console.log("Waiting for video metadata...");
                await new Promise((metaResolve) => {
                    const onLoadedMetadata = () => {
                        videoEl.removeEventListener("loadedmetadata", onLoadedMetadata);
                        console.log(`Metadata loaded - dimensions: ${videoEl.videoWidth}x${videoEl.videoHeight}`);
                        metaResolve();
                    };
                    videoEl.addEventListener("loadedmetadata", onLoadedMetadata);

                    // 타임아웃 설정 (5초)
                    setTimeout(() => {
                        videoEl.removeEventListener("loadedmetadata", onLoadedMetadata);
                        console.log("Metadata timeout, proceeding anyway");
                        metaResolve();
                    }, 5000);
                });
            } else {
                console.log("No waiting for video metadata...");
            }

            // 재생 전 상태 확인
            console.log(`Video element readyState: ${videoEl.readyState}`);
            console.log(`Video dimensions: ${videoEl.videoWidth}x${videoEl.videoHeight}`);
            console.log(`Video srcObject:`, videoEl.srcObject);

            // 20251015 ... play() 재시도 로직 추가 ... by hjkim
            let retryCount = 0;
            const maxRetries = 3;

            while (retryCount < maxRetries) {
                try {
                    // 20251017 ... play() 오류 방지를 위해 paused 상태 값 체크 추가 ... by hjkim
                    if (videoEl.paused) {
                        await videoEl.play();
                    } else {
                        console.log("Video element already playing video source.");
                    }

                    // 재생 후 상태 확인
                    console.log(`After play - readyState: ${videoEl.readyState}`);
                    console.log(`After play - dimensions: ${videoEl.videoWidth}x${videoEl.videoHeight}`);

                    resolve(true);
                    return;
                } catch (playErr) {
                    if (playErr.name === "AbortError" && retryCount < maxRetries - 1) {
                        console.log(`Play aborted, retrying... (${retryCount + 1}/${maxRetries})`);
                        retryCount++;
                        await new Promise(resolve => setTimeout(resolve, 200));
                    } else {
                        throw playErr;
                    }
                }
            }
        } catch (err) {
            console.log("playVideo - err => ", err);
            reject(err);
        }
    });
}

// 20260807 list_consumeInfo / list_p2pConsumeInfo 조회 시 반복되던 .find(info => info.rcvSeq === X) 코드를
// 리스트별 헬퍼로 정리. 두 리스트는 저장 위치만 다른 게 아니라 용도가 다르므로(오디오 체크 vs p2p 보기 등)
// 구조는 합치지 않고, 각 리스트를 조회하는 부분의 중복만 제거한다 ... by claude
/**
 * list_consumeInfo(펜톡 모니터 오디오 체크 & 스몰그룹 등)에서 rcvSeq가 일치하는 정보를 반환
 *
 * @param {Number} rcvSeq - 사용자 시퀀스 번호
 * @returns list_consumeInfo에서 찾은 정보, 없으면 undefined
 */
const getConsumeInfoBySeq = (rcvSeq) => {
    return clientInfo.handsupInfo.list_consumeInfo.find(info => info.rcvSeq === rcvSeq);
}

/**
 * list_p2pConsumeInfo(1명/2명/4명 보기 등 p2p 컨슘)에서 rcvSeq가 일치하는 정보를 반환
 *
 * @param {Number} rcvSeq - 사용자 시퀀스 번호
 * @returns list_p2pConsumeInfo에서 찾은 정보, 없으면 undefined
 */
const getP2pConsumeInfoBySeq = (rcvSeq) => {
    return clientInfo.handsupInfo.list_p2pConsumeInfo.find(info => info.rcvSeq === rcvSeq);
}

/**
 * 핸즈업 멤버 배열에서 userSeq와 일치하는 consume 정보를 반환하는 함수
 * 
 * @param {Number} userSeq - 사용자 시퀀스 번호 (식별용)
 * @returns userSeq와 일치하는 consume 정보
 * @since 2025-08-12.
 */
const getHandsUpConsumeInfo = (userSeq) => {
    console.log("getHandsUpConsumeInfo - userSeq[", userSeq, "]");

    const consumeInfo = getConsumeInfoBySeq(userSeq);
    if (consumeInfo) {
        return consumeInfo;
    } else {
        const p2pInfo = getP2pConsumeInfoBySeq(userSeq);
        if (p2pInfo) {
            return p2pInfo;
        } else {
            return null;
        }
    }
}
/********************************/

/********************************/
// media soup consume 관련 메서드
/********************************/

/**
 * 이미 진행 중인 producer(학생 화면 공유)의 화면 회전값이 변경되었을 때 서버가 push 하는 데이터 처리.
 * producer 재생성 없이, 현재 그 화면을 보고 있는 videoEl에 즉시 새 회전값을 적용한다.
 *
 * @param {JSON} rtnValue - 서버에서 받은 JSON 데이터 객체 ({ userSeq, displayRotation })
 * @since 2026-09-16.
 */
export const displayRotationChangedAfter = (rtnValue) => {
    const { userSeq } = rtnValue;
    const displayRotation = normalizeDisplayRotation(rtnValue.displayRotation);
    console.log(`displayRotationChangedAfter - userSeq[${userSeq}], displayRotation[${displayRotation}]`);

    const consumeInfo = getConsumeInfoBySeq(userSeq);
    if (consumeInfo) {
        // 260916 smallgroup/스마트TV 학생 소그리드 등 list_consumeInfo에 videoEl이 등록된 경우
        // (small group, smartTV per-student view 포함 - consumeAfter에서 이미 이 구조를 공유해서 쓰고 있음)
        consumeInfo.displayRotation = displayRotation;
        applyVideoDisplayRotation(consumeInfo.videoEl, consumeInfo.displayRotation);
        return;
    }

    const p2pInfo = getP2pConsumeInfoBySeq(userSeq);
    if (p2pInfo) {
        p2pInfo.displayRotation = displayRotation;
        applyVideoDisplayRotation(p2pInfo.videoEl, p2pInfo.displayRotation);
        return;
    }

    // 260916 스마트TV 메인뷰 등 handsup 배열(list_consumeInfo/list_p2pConsumeInfo)이 아니라
    // clientInfo.consumeInfo 단일 구조(roomKind "live")에 videoEl이 저장되는 경우 대응.
    // joinConsumeAfter(live)/resumeAfter(live) 등 기존 코드와 동일한 패턴을 그대로 따른다.
    if (userSeq === clientInfo.rcvTeacherSeq && clientInfo.consumeInfo) {
        clientInfo.consumeInfo.displayRotation = displayRotation;
        applyVideoDisplayRotation(clientInfo.consumeInfo.videoEl, clientInfo.consumeInfo.displayRotation);
    }
}

/**
 * joinConsume 요청했던 사용자의 새로운 produce 이벤트 발생 시 서버에서 보내주는 데이터 처리
 * 
 * @param {String} roomKind - 미디어 서버 룸 유형
 * @param {JSON} rtnValue - 서버에서 받은 JSON 데이터 객체
 */
export const newProducerAfter = (roomKind, rtnValue) => {
    const { userSeq, isVideoReceiveable, isAudioReceiveable, isMicReceiveable } = rtnValue;
    const displayRotation = normalizeDisplayRotation(rtnValue.displayRotation);
    console.log(`newProducerAfter - roomKind[${roomKind}], userSeq[${userSeq}], isVideoReceiveable[${isVideoReceiveable}], isAudioReceiveable[${isAudioReceiveable}], isMicReceiveable[${isMicReceiveable}]`);

    console.log("clientInfo.rtpCapabilities => ", clientInfo.rtpCapabilities, ", rtnValue.rtpCapabilities => ", rtnValue.rtpCapabilities);
    if (clientInfo.rtpCapabilities === undefined || clientInfo.rtpCapabilities === null) {
        clientInfo.rtpCapabilities = rtnValue.rtpCapabilities;
    }

    if (roomKind === "handsup") {
        const consumeInfo = getConsumeInfoBySeq(userSeq);
        if (consumeInfo) {
            console.log(`(1) newProducerAfter - rcvSeq[${consumeInfo.rcvSeq}], isAudioReceived[${consumeInfo.isAudioReceived}], isAudioReceiveable[${consumeInfo.isAudioReceiveable}]`);
            console.log(`(1) newProducerAfter - rcvSeq[${consumeInfo.rcvSeq}], isVideoReceived[${consumeInfo.isVideoReceived}], isVideoReceiveable[${consumeInfo.isVideoReceiveable}]`);
            consumeInfo.isAudioReceiveable = isAudioReceiveable;
            consumeInfo.isVideoReceiveable = isVideoReceiveable;
            consumeInfo.displayRotation = displayRotation;

            if (isVideoReceiveable || isAudioReceiveable) {
                console.log(`(1) newProducerAfter - rcvSeq[${consumeInfo.rcvSeq}], isVideoReceived[${consumeInfo.isVideoReceived}], isAudioReceived[${consumeInfo.isAudioReceived}]`);
                if (clientInfo.rcvTransport !== null) {
                    if (consumeInfo.mediaKind === "video" || (consumeInfo.mediaKind === "ALL" || consumeInfo.mediaKind === "all")) { // for smart tv & small group - video + audio consume case by hjkim 20231108
                        if (isVideoReceiveable && !consumeInfo.isVideoReceived) { // for smart tv & small group - video consume 요청해야하는 case by hjkim 20231108
                            console.log("newProducerAfter(handsup) case 1 - sendConsume(video)");
                            sendConsume("video", "handsup", userSeq);
                        } else {
                            if (isAudioReceiveable && !consumeInfo.isAudioReceived) { // for smart tv & small group - audio consume 요청해야하는 case by hjkim 20231108
                                console.log("newProducerAfter(handsup) case 2 - sendConsume(audio)");
                                sendConsume("audio", "handsup", userSeq);
                            } else {
                                console.log("newProducerAfter(handsup) case 3 ... 이런 경우엔 뭘해야하지?ㅁ?");
                            }
                        }
                    } else { // default handsup - audio consume case by hjkim 20231108
                        if (isAudioReceiveable && !consumeInfo.isAudioReceived) { // default handsup - audio consume 요청해야하는 case by hjkim 20231108
                            console.log("newProducerAfter(handsup) case 4 - sendConsume(audio)");
                            sendConsume("audio", "handsup", userSeq);
                        } else {
                            console.log("newProducerAfter(handsup) case 5 ... 이런 경우엔 뭘해야하지?ㅁ?");
                        }
                    }
                } else {
                    console.log("newProducerAfter(handsup) case 6 ... 이럴 땐 어떻게 해야 하지..?");
                }
            } else {
                console.log("newProducerAfter(handsup) case 7");
            }
        } else {
            const p2pInfo = getP2pConsumeInfoBySeq(userSeq);
            if (p2pInfo) {
                console.log(`(2) newProducerAfter - rcvSeq[${p2pInfo.rcvSeq}], isAudioReceived[${p2pInfo.isAudioReceived}], isAudioReceiveable[${p2pInfo.isAudioReceiveable}]`);
                console.log(`(2) newProducerAfter - rcvSeq[${p2pInfo.rcvSeq}], isVideoReceived[${p2pInfo.isVideoReceived}], isVideoReceiveable[${p2pInfo.isVideoReceiveable}]`);
                p2pInfo.isAudioReceiveable = isAudioReceiveable;
                p2pInfo.isVideoReceiveable = isVideoReceiveable;
                p2pInfo.displayRotation = displayRotation;

                if (isVideoReceiveable || isAudioReceiveable) {
                    console.log(`(2) newProducerAfter - rcvSeq[${p2pInfo.rcvSeq}], isVideoReceived[${p2pInfo.isVideoReceived}], isAudioReceived[${p2pInfo.isAudioReceived}]`);
                    if (clientInfo.rcvTransport !== null) {
                        if (p2pInfo.mediaKind === "video" || (p2pInfo.mediaKind === "ALL" || p2pInfo.mediaKind === "all")) { // for smart tv & small group - video + audio consume case by hjkim 20231108
                            if (isVideoReceiveable && !p2pInfo.isVideoReceived) { // for smart tv & small group - video consume 요청해야하는 case by hjkim 20231108
                                console.log("newProducerAfter(handsup) case 8 - sendConsume(video)");
                                sendConsume("video", "handsup", userSeq);
                            } else {
                                if (isAudioReceiveable && !p2pInfo.isAudioReceived) { // for smart tv & small group - audio consume 요청해야하는 case by hjkim 20231108
                                    console.log("newProducerAfter(handsup) case 9 - sendConsume(audio)");
                                    sendConsume("audio", "handsup", userSeq);
                                } else {
                                    console.log("newProducerAfter(handsup) case 10 ... 이런 경우엔 뭘해야하지?ㅁ?");
                                }
                            }
                        } else { // default handsup - audio consume case by hjkim 20231108
                            if (isAudioReceiveable && !p2pInfo.isAudioReceived) { // default handsup - audio consume 요청해야하는 case by hjkim 20231108
                                console.log("newProducerAfter(handsup) case 11 - sendConsume(audio)");
                                sendConsume("audio", "handsup", userSeq);
                            } else {
                                console.log("newProducerAfter(handsup) case 12 ... 이런 경우엔 뭘해야하지?ㅁ?");
                            }
                        }
                    } else {
                        console.log("newProducerAfter(handsup) case 13 ... 이럴 땐 어떻게 해야 하지..?");
                    }
                } else {
                    console.log("newProducerAfter(handsup) case 14");
                }
            } else {
                console.log(`newProducerAfter(handsup) - No consumer information matching user sequence userSeq[${userSeq}] and roomKind type roomKind[${roomKind}] was found.`);
            }
        }
    } else {
        clientInfo.consumeInfo.isVideoReceiveable = isVideoReceiveable;
        clientInfo.consumeInfo.displayRotation = displayRotation;
        clientInfo.consumeInfo.isAudioReceiveable = isAudioReceiveable;
        clientInfo.consumeInfo.isMicReceiveable = isMicReceiveable;

        if (isVideoReceiveable || isAudioReceiveable || isMicReceiveable) {
            console.log(`newProducerAfter - isVideoReceived[${clientInfo.consumeInfo.isVideoReceived}], isAudioReceived[${clientInfo.consumeInfo.isAudioReceived}], isMicReceived[${clientInfo.consumeInfo.isMicReceived}]`);
            if (clientInfo.rcvTransport === null) { // 학생이 미리 입장 후 live 시작될 때 video, audio, mic consume 요청해야하는 case - by hjkim 20220209
                console.log("newProducerAfter - case 1");
                let store = window.hiclasstv.store;
                store.dispatch(changeLiveStatusInfo({ kind: "connect" }));
            } else { // 무언가 하나라도 consume 중인 case ... by hjkim 20220401
                if (isVideoReceiveable && !clientInfo.consumeInfo.isVideoReceived) { // video consume 요청해야하는 case by hjkim 20220401
                    console.log("newProducerAfter - case 2");
                    sendConsume("video", "live", clientInfo.rcvTeacherSeq);
                } else {
                    if (isAudioReceiveable && !clientInfo.consumeInfo.isAudioReceived) { // audio consume 요청해야하는 case by hjkim 20220401
                        console.log("newProducerAfter - case 3");
                        sendConsume("audio", "live", clientInfo.rcvTeacherSeq);
                    } else {
                        if (isMicReceiveable && !clientInfo.consumeInfo.isMicReceived) { // mic consume 요청해야하는 case - by hjkim 20220401
                            console.log("newProducerAfter - case 4");
                            sendConsume("mic", "live", clientInfo.rcvTeacherSeq);
                        } else {
                            console.log("newProducerAfter - case 5 ... 이런 경우엔 뭘해야하지?ㅁ?");
                        }
                    }
                }
            }
        } else {
            console.log("newProducerAfter - case 6");
            let store = window.hiclasstv.store;
            // store.dispatch(changeLiveStatusInfo({ kind: "unconnectable", status: "off" }));
            store.dispatch(changeLiveStatusInfo({ kind: "unconnectable", status: "disable" }));
            store.dispatch(toggleReadyLiveConsume({ isReadyLiveConsume: false }));
        }
    }
}

/**
 * joinConsume 요청했던 사용자의 produce 종료 이벤트 발생 시 서버에서 보내주는 데이터 처리
 * 
 * @param {String} roomKind - 미디어 서버 룸 유형
 * @param {JSON} rtnValue - 서버에서 받은 JSON 데이터 객체
 */
export const closeProducerAfter = async (roomKind, rtnValue) => {
    const { kind, userSeq } = rtnValue;
    console.log(`closeProducerAfter -  roomKind[${roomKind}], kind[${kind}], userSeq[${userSeq}], rtnValue => `, rtnValue);

    // 20260929 선생님 영상 송출이 종료된 경우는 연결 끊김이 아니므로 자동 복구 안내를 정리한다.
    if (roomKind !== "handsup" && userSeq === clientInfo.rcvTeacherSeq && (kind === "video" || kind === "ALL" || kind === "all")) {
        resetLiveReconnect("teacher-producer-closed");
    }

    if (roomKind === "handsup") {
        const consumeInfo = getConsumeInfoBySeq(userSeq);
        if (consumeInfo) {
            if (kind === "audio" || (kind === "ALL" || kind === "all")) {
                if (consumeInfo.audioConsumer) {
                    consumeInfo.isAudioReceived = false;
                    consumeInfo.isAudioReceiveable = false;

                    if (consumeInfo.audioEl) {
                        if (!consumeInfo.audioEl.paused) {
                            consumeInfo.audioEl.pause();
                        }
                        consumeInfo.audioEl.srcObject = null;
                    }

                    if (consumeInfo.audioStream !== null) {
                        console.log(`(1) closeProducerAfter -  kind[${kind}], userSeq[${userSeq}]`);
                        consumeInfo.audioStream.removeTrack(consumeInfo.audioConsumer.track);
                        consumeInfo.audioStream = null;
                    }

                    if (!consumeInfo.audioConsumer.closed) {
                        consumeInfo.audioConsumer.close();
                    }

                    consumeInfo.audioConsumer = null;
                }
            }

            if (kind === "video" || (kind === "ALL" || kind === "all")) {
                consumeInfo.displayRotation = 0;
                applyVideoDisplayRotation(consumeInfo.videoEl, 0); // 20260908 producer 종료 시 화면 회전 스타일을 정리한다.
                if (consumeInfo.videoConsumer) {
                    consumeInfo.isVideoReceived = false;
                    consumeInfo.isVideoReceiveable = false;

                    if (consumeInfo.videoStream) {
                        try {
                            console.log(`(2) closeProducerAfter -  kind[${kind}], userSeq[${userSeq}]`);
                            if (consumeInfo.videoEl) {
                                if (!consumeInfo.videoEl.paused) {
                                    consumeInfo.videoEl.pause();
                                }
                            }
                            consumeInfo.videoStream.removeTrack(consumeInfo.videoConsumer.track);
                        } catch (err) {
                            console.log("------closeProducerAfter------error => ", err);
                        } finally {
                            consumeInfo.videoStream = null;
                            if (consumeInfo.videoEl) {
                                consumeInfo.videoEl.srcObject = consumeInfo.videoStream;
                                consumeInfo.videoEl.currentTime = 0;
                                consumeInfo.videoEl.poster = "/images/connect.png";    
                                // consumeInfo.videoEl.poster = "/images/android_notconnected.png";
                            }
                        }
                    }

                    if (!consumeInfo.videoConsumer.closed) {
                        consumeInfo.videoConsumer.close();
                    }

                    consumeInfo.videoConsumer = null;
                }
            }
        } else {
            const p2pInfo = getP2pConsumeInfoBySeq(userSeq);
            if (p2pInfo) {
                if (kind === "audio" || (kind === "ALL" || kind === "all")) {
                    if (p2pInfo.audioConsumer) {
                        p2pInfo.isAudioReceived = false;
                        p2pInfo.isAudioReceiveable = false;

                        if (p2pInfo.audioEl) {
                            if (!p2pInfo.audioEl.paused) {
                                p2pInfo.audioEl.pause();
                            }
                            p2pInfo.audioEl.srcObject = null;
                        }

                        if (p2pInfo.audioStream !== null) {
                            console.log(`(3) closeProducerAfter -  kind[${kind}], userSeq[${userSeq}]`);
                            p2pInfo.audioStream.removeTrack(p2pInfo.audioConsumer.track);
                            p2pInfo.audioStream = null;
                        }

                        if (!p2pInfo.audioConsumer.closed) {
                            p2pInfo.audioConsumer.close();
                        }

                        p2pInfo.audioConsumer = null;
                    }
                }

                if (kind === "video" || (kind === "ALL" || kind === "all")) {
                    p2pInfo.displayRotation = 0;
                    applyVideoDisplayRotation(p2pInfo.videoEl, 0); // 20260908 producer 종료 시 화면 회전 스타일을 정리한다.
                    if (p2pInfo.videoConsumer) {
                        p2pInfo.isVideoReceived = false;
                        p2pInfo.isVideoReceiveable = false;

                        if (p2pInfo.videoStream) {
                            try {
                                console.log(`(4) closeProducerAfter -  kind[${kind}], userSeq[${userSeq}]`);
                                if (p2pInfo.videoEl) {
                                    if (!p2pInfo.videoEl.paused) {
                                        p2pInfo.videoEl.pause();
                                    }
                                }
                                p2pInfo.videoStream.removeTrack(p2pInfo.videoConsumer.track);
                            } catch (err) {
                                console.log("------closeProducerAfter------error => ", err);
                            } finally {
                                p2pInfo.videoStream = null;
                                p2pInfo.videoEl.currentTime = 0;
                                p2pInfo.videoEl.poster = "/images/connect.png";
                                // p2pInfo.videoEl.poster = "/images/android_notconnected.png";
                            }
                        }

                        if (!p2pInfo.videoConsumer.closed) {
                            p2pInfo.videoConsumer.close();
                        }

                        p2pInfo.videoConsumer = null;
                    }
                }
            } else {
                console.log(`closeProducerAfter(handsup) - No consumer information matching user sequence userSeq[${userSeq}] and roomKind type roomKind[${roomKind}], media type kind[${kind}] was found.`);
            }
        }
    } else {
        if (kind === "mic" || (kind === "ALL" || kind === "all")) {
            if (clientInfo.consumeInfo.micConsumer) {
                clientInfo.consumeInfo.isMicReceived = false;
                clientInfo.consumeInfo.isMicReceiveable = false;

                if (clientInfo.consumeInfo.micEl) {
                    if (!clientInfo.consumeInfo.micEl.paused) {
                        clientInfo.consumeInfo.micEl.pause();
                    }
                    clientInfo.consumeInfo.micEl.srcObject = null;
                }

                if (clientInfo.consumeInfo.micStream) {
                    clientInfo.consumeInfo.micStream.removeTrack(clientInfo.consumeInfo.micConsumer.track);
                }

                if (!clientInfo.consumeInfo.micConsumer.closed) {
                    clientInfo.consumeInfo.micConsumer.close();
                }

                clientInfo.consumeInfo.micStream = null;
                clientInfo.consumeInfo.micConsumer = null;
            }

            clientInfo.consumeInfo.isMuteMic = true;

            let store = window.hiclasstv.store;
            store.dispatch(changeLiveStatusInfo({ kind: "mic", status: "disable" }));
        }

        if (kind === "audio" || (kind === "ALL" || kind === "all")) {
            if (clientInfo.consumeInfo.audioConsumer) {
                clientInfo.consumeInfo.isAudioReceived = false;
                clientInfo.consumeInfo.isAudioReceiveable = false;

                if (clientInfo.consumeInfo.audioEl) {
                    if (!clientInfo.consumeInfo.audioEl.paused) {
                        clientInfo.consumeInfo.audioEl.pause();
                    }
                    clientInfo.consumeInfo.audioEl.srcObject = null;
                }

                if (clientInfo.consumeInfo.audioStream) {
                    clientInfo.consumeInfo.audioStream.removeTrack(clientInfo.consumeInfo.audioConsumer.track);
                }

                if (!clientInfo.consumeInfo.audioConsumer.closed) {
                    clientInfo.consumeInfo.audioConsumer.close();
                }

                clientInfo.consumeInfo.audioStream = null;
                clientInfo.consumeInfo.audioConsumer = null;
            }

            clientInfo.consumeInfo.isMuteAudio = false;

            let store = window.hiclasstv.store;
            store.dispatch(changeLiveStatusInfo({ kind: "audio", status: "disable" }));
        }

        if (kind === "video" || (kind === "ALL" || kind === "all")) {
            clientInfo.consumeInfo.displayRotation = 0;
            applyVideoDisplayRotation(clientInfo.consumeInfo.videoEl, 0); // 20260908 producer 종료 시 화면 회전 스타일을 정리한다.
            if (clientInfo.consumeInfo.videoConsumer) {
                clientInfo.consumeInfo.isVideoReceived = false;
                clientInfo.consumeInfo.isVideoReceiveable = false;

                if (clientInfo.consumeInfo.videoEl) {
                    if (!clientInfo.consumeInfo.videoEl.paused) {
                        clientInfo.consumeInfo.videoEl.pause();
                    }
                    clientInfo.consumeInfo.videoEl.srcObject = null;
                }

                if (clientInfo.consumeInfo.videoStream) {
                    clientInfo.consumeInfo.videoStream.removeTrack(clientInfo.consumeInfo.videoConsumer.track);
                }

                if (!clientInfo.consumeInfo.videoConsumer.closed) {
                    clientInfo.consumeInfo.videoConsumer.close();
                }

                clientInfo.consumeInfo.videoStream = null;
                clientInfo.consumeInfo.videoConsumer = null;
            }

            let store = window.hiclasstv.store;
            store.dispatch(changeLiveStatusInfo({ kind: "video", status: "disable" }));
        }

        if (clientInfo.consumeInfo.micConsumer === null && clientInfo.consumeInfo.audioConsumer === null && clientInfo.consumeInfo.videoConsumer === null) {
            if (clientInfo.rcvTransport) {
                if (!clientInfo.rcvTransport.closed) {
                    clientInfo.rcvTransport.close();
                }

                resetLiveConsume("teacher-producer-closed"); // 20261028 받기 연결 정리/생성 시 consume 대기 초기화 (web-relay R-207)
                clientInfo.rcvTransport = null;
            }

            let store = window.hiclasstv.store;
            // store.dispatch(changeLiveStatusInfo({ kind: "unconnectable", status: "off" }));
            store.dispatch(changeLiveStatusInfo({ kind: "unconnectable", status: "disable" }));
            store.dispatch(toggleReadyLiveConsume({ isReadyLiveConsume: false }));
        }
    }
}

/**
 * unsubscribe 요청 후 서버에서 받은 데이터 처리
 * 
 * @param {JSON} rtnValue - 서버에서 받은 JSON 데이터 객체
 */
export const unsubscribeAfter = async (rtnValue) => {
    const { consumUserSeq, isForSoundOnly, prodUserSeq, roomKind } = rtnValue;
    console.log(`unsubscribeAfter -  roomKind[${roomKind}], prodUserSeq[${prodUserSeq}], consumUserSeq[${consumUserSeq}], isForSoundOnly[${isForSoundOnly}]`);
    console.log(`★★★★★unsubscribeAfter - clientInfo.userSeq[${clientInfo.userSeq}], isNeedReconsume[${clientInfo.consumeInfo.isNeedReConsume}]`)

    if (consumUserSeq === clientInfo.userSeq) {
        if (roomKind === "handsup") {
            const consumeInfo = getConsumeInfoBySeq(prodUserSeq);
            if (consumeInfo) {
                // 20250812 ... 스마트TV 페이지이고, unsubscribe 요청 후 다시 consume 요청이 필요하면 다른 메서드에서 처리 ... by hjkim
                if (getIsSmartTVCurrentPage() && consumeInfo.isNeedReConsume) {
                    unsubscribeAfterReConsumeForSmartTV(rtnValue);
                    consumeInfo.isNeedReConsume = false;
                    return;
                }

                // isForSoundOnly 값과 상관없이 audio 는 항상 unsubscribe 해야 하기 때문에 true인지 체크 안하고 바로 처리... by hjkim 20231108
                if (consumeInfo.audioEl) { // audioEl은 항상 기본으로 생성하기 때문에 audio consumer 존재 유무와 관계없이 먼저 제거! ...by hjkim 20250812
                    if (!consumeInfo.audioEl.paused) {
                        consumeInfo.audioEl.pause();
                    }
                    consumeInfo.audioEl.srcObject = null;

                    if (consumeInfo.audioEl.parentNode) {
                        console.log("consumeInfo.audioEl.parentNode.removeChild(consumeInfo.audioEl). consumeInfo.audioEl => ", consumeInfo.audioEl);
                        consumeInfo.audioEl.parentNode.removeChild(consumeInfo.audioEl);
                    }

                    consumeInfo.audioEl = null;
                }

                // let idx = clientInfo.handsupInfo.list_consumeInfo.indexOf(consumeInfo);
                if (consumeInfo.audioConsumer) {
                    consumeInfo.isAudioReceived = false;

                    if (consumeInfo.audioStream) {
                        consumeInfo.audioStream.removeTrack(consumeInfo.audioConsumer.track);
                        consumeInfo.audioStream = null;
                    }

                    if (!consumeInfo.audioConsumer.closed) {
                        consumeInfo.audioConsumer.close();
                    }

                    consumeInfo.audioConsumer = null;
                }

                if (isForSoundOnly === false) { // isForSoundOnly 가 false 면 all unsubscribe 이기 때문에 video 를 여기서 처리... by hjkim 20231108
                    if (consumeInfo.videoConsumer) {
                        consumeInfo.isVideoReceived = false;

                        if (consumeInfo.videoEl) {
                            if (!consumeInfo.videoEl.paused) {
                                consumeInfo.videoEl.pause();
                                consumeInfo.videoEl.currentTime = 0;
                                consumeInfo.videoEl.poster = "/images/connect.png";
                                // consumeInfo.videoEl.poster = "/images/android_notconnected.png";
                            }
                        }

                        if (consumeInfo.videoStream) {
                            consumeInfo.videoStream.removeTrack(consumeInfo.videoConsumer.track);
                        }

                        if (!consumeInfo.videoConsumer.closed) {
                            consumeInfo.videoConsumer.close();
                        }

                        consumeInfo.videoStream = null;
                        consumeInfo.videoConsumer = null;
                    }
                }

                // if (consumeInfo.isExitConsume) {
                    sendExitConsumeHandsUp(consumeInfo.isAudioReceiveable, consumeInfo.rcvSeq);
                // }

                exitConsumeAfterForCleaning(roomKind, consumeInfo.rcvSeq);

                callCurrentFuncProc(prodUserSeq, "disconnect");
            } else {
                const p2pInfo = getP2pConsumeInfoBySeq(prodUserSeq);
                if (p2pInfo) {
                    // 20250812 ... 스마트TV 페이지이고, unsubscribe 요청 후 다시 consume 요청이 필요하면 다른 메서드에서 처리 ... by hjkim
                    if (getIsSmartTVCurrentPage() && p2pInfo.isNeedReConsume) {
                        unsubscribeAfterReConsumeForSmartTV(rtnValue);
                        p2pInfo.isNeedReConsume = false;
                        return;
                    }

                    // isForSoundOnly 값과 상관없이 audio 는 항상 unsubscribe 해야 하기 때문에 true인지 체크 안하고 바로 처리... by hjkim 20231108
                    if (p2pInfo.audioEl) { // audioEl은 항상 기본으로 생성하기 때문에 audio consumer 존재 유무와 관계없이 먼저 제거! ...by hjkim 20250812
                        if (!p2pInfo.audioEl.paused) {
                            p2pInfo.audioEl.pause();
                        }
                        p2pInfo.audioEl.srcObject = null;

                        if (p2pInfo.audioEl.parentNode) {
                            console.log("p2pInfo.audioEl.parentNode.removeChild(p2pInfo.audioEl). p2pInfo.audioEl => ", p2pInfo.audioEl);
                            p2pInfo.audioEl.parentNode.removeChild(p2pInfo.audioEl);
                        }

                        p2pInfo.audioEl = null;
                    }

                    // let idx = clientInfo.handsupInfo.list_p2pConsumeInfo.indexOf(p2pInfo);
                    if (p2pInfo.audioConsumer) {
                        p2pInfo.isAudioReceived = false;

                        if (p2pInfo.audioStream) {
                            p2pInfo.audioStream.removeTrack(p2pInfo.audioConsumer.track);
                        }

                        if (!p2pInfo.audioConsumer.closed) {
                            p2pInfo.audioConsumer.close();
                        }

                        p2pInfo.audioStream = null;
                        p2pInfo.audioConsumer = null;
                    }

                    if (isForSoundOnly === false) { // isForSoundOnly 가 false 면 all unsubscribe 이기 때문에 video 를 여기서 처리... by hjkim 20231108
                        if (p2pInfo.videoConsumer) {
                            p2pInfo.isVideoReceived = false;

                            if (p2pInfo.videoEl) {
                                if (!p2pInfo.videoEl.paused) {
                                    p2pInfo.videoEl.pause();
                                    p2pInfo.videoEl.currentTime = 0;
                                    p2pInfo.videoEl.poster = "/images/connect.png";
                                    // p2pInfo.videoEl.poster = "/images/android_notconnected.png";
                                }
                            }

                            if (p2pInfo.videoStream) {
                                p2pInfo.videoStream.removeTrack(p2pInfo.videoConsumer.track);
                            }

                            if (!p2pInfo.videoConsumer.closed) {
                                p2pInfo.videoConsumer.close();
                            }

                            p2pInfo.videoStream = null;
                            p2pInfo.videoConsumer = null;
                        }
                    }

                    // if (p2pInfo.isExitConsume) {
                        sendExitConsumeHandsUp(p2pInfo.isAudioReceiveable, p2pInfo.rcvSeq);
                    // }

                    exitConsumeAfterForCleaning(roomKind, p2pInfo.rcvSeq);

                    callCurrentFuncProc(prodUserSeq, "disconnect");
                }
            }
        } else {
            // 20250811 ... 스마트TV 페이지이고, unsubscribe 요청 후 다시 consume 요청이 필요하면 다른 메서드에서 처리 ... by hjkim
            // 20251010 ... iosWebView
            if (isIOSWebView() && clientInfo.consumeInfo.isNeedReConsume) {
                if (clientInfo.consumeInfo.isVideoReceived) {
                    return;
                }

                console.log("선생님 화면 연결이 끊어져서 재연결 하는 중....");
                clientInfo.consumeInfo.isNeedReConsume = false;

                // if (clientInfo.consumeInfo.videoConsumer) {
                //     if (!clientInfo.consumeInfo.videoConsumer.close) {
                //         clientInfo.consumeInfo.videoConsumer.close();
                //     }
                //     clientInfo.consumeInfo.videoConsumer = null;
                //     clientInfo.consumeInfo.videoStream = null;
                //     clientInfo.consumeInfo.isVideoReceiveable = false;
                // }

                // if (clientInfo.consumeInfo.audioConsumer) {
                //     if (!clientInfo.consumeInfo.audioConsumer.closed) {
                //         clientInfo.consumeInfo.audioConsumer.close();
                //     } 
                //     clientInfo.consumeInfo.audioConsumer = null;
                //     clientInfo.consumeInfo.audioStream = null;
                //     clientInfo.consumeInfo.isAudioReceiveable = false;
                // }
                
                // if (clientInfo.consumeInfo.micConsumer) {
                //     if (!clientInfo.consumeInfo.micConsumer.closed) {
                //         clientInfo.consumeInfo.micConsumer.close();
                //     }
                //     clientInfo.consumeInfo.micConsumer = null;
                //     clientInfo.consumeInfo.micStream = null;
                //     clientInfo.consumeInfo.isMicReceiveable = false;
                // }

                reconnectLive();
                return;
            } else if (getIsSmartTVCurrentPage() && clientInfo.consumeInfo.isNeedReConsume) {
                unsubscribeAfterReConsumeForSmartTV(rtnValue);
                
                return;
            }

            // isForSoundOnly 값과 상관없이 audio / mic 는 항상 unsubscribe 해야 하기 때문에 true인지 체크 안하고 바로 처리... by hjkim 20220209
            if (clientInfo.consumeInfo.micConsumer) {
                clientInfo.consumeInfo.isMicReceived = false;

                if (clientInfo.consumeInfo.micEl) {
                    if (!clientInfo.consumeInfo.micEl.paused) {
                        clientInfo.consumeInfo.micEl.pause();
                    }
                    clientInfo.consumeInfo.micEl.srcObject = null;
                }

                if (clientInfo.consumeInfo.micStream) {
                    clientInfo.consumeInfo.micStream.removeTrack(clientInfo.consumeInfo.micConsumer.track);
                }

                if (!clientInfo.consumeInfo.micConsumer.closed) {
                    clientInfo.consumeInfo.micConsumer.close();
                }

                clientInfo.consumeInfo.micStream = null;
                clientInfo.consumeInfo.micConsumer = null;

                let store = window.hiclasstv.store;
                store.dispatch(changeLiveStatusInfo({ kind: "mic", status: "off" }));
            }

            if (clientInfo.consumeInfo.audioConsumer) {
                clientInfo.consumeInfo.isAudioReceived = false;

                if (clientInfo.consumeInfo.audioEl) {
                    if (!clientInfo.consumeInfo.audioEl.paused) {
                        clientInfo.consumeInfo.audioEl.pause();
                    }
                    clientInfo.consumeInfo.audioEl.srcObject = null;
                }

                if (clientInfo.consumeInfo.audioStream) {
                    clientInfo.consumeInfo.audioStream.removeTrack(clientInfo.consumeInfo.audioConsumer.track);
                }

                if (!clientInfo.consumeInfo.audioConsumer.closed) {
                    clientInfo.consumeInfo.audioConsumer.close();
                }

                clientInfo.consumeInfo.audioStream = null;
                clientInfo.consumeInfo.audioConsumer = null;

                let store = window.hiclasstv.store;
                store.dispatch(changeLiveStatusInfo({ kind: "audio", status: "off" }));
            }

            if (isForSoundOnly === false) { // isForSoundOnly 가 false 면 all unsubscribe 이기 때문에 video 를 여기서 처리... by hjkim 20220209
                if (clientInfo.consumeInfo.videoConsumer) {
                    clientInfo.consumeInfo.isVideoReceived = false;

                    if (clientInfo.consumeInfo.videoEl) {
                        if (!clientInfo.consumeInfo.videoEl.paused) {
                            clientInfo.consumeInfo.videoEl.pause();
                        }
                        clientInfo.consumeInfo.videoEl.srcObject = null;
                    }

                    if (clientInfo.consumeInfo.videoStream) {
                        clientInfo.consumeInfo.videoStream.removeTrack(clientInfo.consumeInfo.videoConsumer.track);
                    }

                    if (!clientInfo.consumeInfo.videoConsumer.closed) {
                        clientInfo.consumeInfo.videoConsumer.close();
                    }

                    clientInfo.consumeInfo.videoStream = null;
                    clientInfo.consumeInfo.videoConsumer = null;

                    let store = window.hiclasstv.store;
                    store.dispatch(changeLiveStatusInfo({ kind: "video", status: "off" }));
                }

                if (clientInfo.rcvTransport) {
                    if (!clientInfo.rcvTransport.closed) {
                        clientInfo.rcvTransport.close();
                    }

                    resetLiveConsume("unsubscribe"); // 20261028 받기 연결 정리/생성 시 consume 대기 초기화 (web-relay R-207)
                    clientInfo.rcvTransport = null;

                    let store = window.hiclasstv.store;
                    store.dispatch(toggleReadyLiveConsume({ isReadyLiveConsume: false }));
                }

                if (clientInfo.consumeInfo.isExitConsume) {
                    sendExitConsume(prodUserSeq);
                }

                let store = window.hiclasstv.store;
                store.dispatch(changeLiveStatusInfo({ kind: "disconnect", status: "off" }));
            }
        }
    } else {
        console.log("------unsubscribeAfter------ consumUserSeq is ", consumUserSeq);
    }
}

/** 
 * unsubscribe 요청 후 서버에서 데이터 데이터 못 받는
 * smart tv handsup consumer 정리
 * 
 * @param {Boolean} isRemoveAudioEl - HTML 오디오 요소 객체 제거 여부
 */
const unsubscribeHandsUpConsumeAfterForClear = async (isRemoveAudioEl) => {
    return new Promise(async (resolve, reject) => {
        try {
            if (clientInfo.handsupInfo.list_p2pConsumeInfo && clientInfo.handsupInfo.list_p2pConsumeInfo.length > 0) {
                const promises = clientInfo.handsupInfo.list_p2pConsumeInfo.map((info) => clearHandsUpConsume(isRemoveAudioEl, false, info.rcvSeq));
                await Promise.all(promises);

                clientInfo.handsupInfo.list_p2pConsumeInfo = [];
            }

            if (clientInfo.handsupInfo.list_consumeInfo && clientInfo.handsupInfo.list_consumeInfo.length > 0) {
                const promises = clientInfo.handsupInfo.list_consumeInfo.map((info) => clearHandsUpConsume(isRemoveAudioEl, false, info.rcvSeq));
                await Promise.all(promises);

                clientInfo.handsupInfo.list_consumeInfo = [];
            }

            resolve(true);
        } catch (err) {
            console.log("unsubscribeHandsUpConsumeAfterForClear err => ", err);
            reject(err);
        }
    });
}

/**
 * unsubscribe 요청 후 서버에서 데이터 데이터 못 받는
 * smart tv consumer, transport 정리
 */
export const unsubscribeAfterForSmartTV = async () => {
    console.log("unsubscribeAfterForSmartTV");
    await unsubscribeHandsUpConsumeAfterForClear(true);

    // isForSoundOnly 값과 상관없이 audio / mic 는 항상 unsubscribe 해야 하기 때문에 true인지 체크 안하고 바로 처리... by hjkim 20220209
    if (clientInfo.consumeInfo.micConsumer) {
        clientInfo.consumeInfo.isMicReceived = false;

        if (clientInfo.consumeInfo.micEl) {
            if (!clientInfo.consumeInfo.micEl.paused) {
                clientInfo.consumeInfo.micEl.pause();
            }
            clientInfo.consumeInfo.micEl.srcObject = null;
        }

        if (clientInfo.consumeInfo.micStream) {
            clientInfo.consumeInfo.micStream.removeTrack(clientInfo.consumeInfo.micConsumer.track);
        }

        if (!clientInfo.consumeInfo.micConsumer.closed) {
            clientInfo.consumeInfo.micConsumer.close();
        }

        clientInfo.consumeInfo.micStream = null;
        clientInfo.consumeInfo.micConsumer = null;

        let store = window.hiclasstv.store;
        store.dispatch(changeLiveStatusInfo({ kind: "mic", status: "off" }));
    }

    if (clientInfo.consumeInfo.audioConsumer) {
        clientInfo.consumeInfo.isAudioReceived = false;

        if (clientInfo.consumeInfo.audioEl) {
            if (!clientInfo.consumeInfo.audioEl.paused) {
                clientInfo.consumeInfo.audioEl.pause();
            }
            clientInfo.consumeInfo.audioEl.srcObject = null;
        }

        if (clientInfo.consumeInfo.audioStream) {
            clientInfo.consumeInfo.audioStream.removeTrack(clientInfo.consumeInfo.audioConsumer.track);
        }

        if (!clientInfo.consumeInfo.audioConsumer.closed) {
            clientInfo.consumeInfo.audioConsumer.close();
        }

        clientInfo.consumeInfo.audioStream = null;
        clientInfo.consumeInfo.audioConsumer = null;

        let store = window.hiclasstv.store;
        store.dispatch(changeLiveStatusInfo({ kind: "audio", status: "off" }));
    }

    if (clientInfo.consumeInfo.videoConsumer) {
        clientInfo.consumeInfo.isVideoReceived = false;

        if (clientInfo.consumeInfo.videoEl) {
            if (!clientInfo.consumeInfo.videoEl.paused) {
                clientInfo.consumeInfo.videoEl.pause();
            }
            clientInfo.consumeInfo.videoEl.srcObject = null;
        }

        if (clientInfo.consumeInfo.videoStream) {
            clientInfo.consumeInfo.videoStream.removeTrack(clientInfo.consumeInfo.videoConsumer.track);
        }

        if (!clientInfo.consumeInfo.videoConsumer.closed) {
            clientInfo.consumeInfo.videoConsumer.close();
        }

        clientInfo.consumeInfo.videoStream = null;
        clientInfo.consumeInfo.videoConsumer = null;

        let store = window.hiclasstv.store;
        store.dispatch(changeLiveStatusInfo({ kind: "video", status: "off" }));
    }

    if (clientInfo.rcvTransport) {
        if (!clientInfo.rcvTransport.closed) {
            clientInfo.rcvTransport.close();
        }

        clientInfo.rcvTransport = null;

        console.log("call toggleReadyLiveConsume");
        let store = window.hiclasstv.store;
        store.dispatch(toggleReadyLiveConsume({ isReadyLiveConsume: false }));
    }

    /* if (clientInfo.consumeInfo.isExitConsume) {
        sendExitConsume(clientInfo.rcvTeacherSeq);
    } */

    sendExitConsume(clientInfo.rcvTeacherSeq);

    /* if (window.hiclasstv) {
        let store = window.hiclasstv.store;
        store.dispatch(changeLiveStatusInfo({ kind: "disconnect", status: "off" }));
    } */

    exitConsumeAfterForCleaning("live", clientInfo.rcvTeacherSeq);
}

/**
 * 스마트TV 영상 재생 오류 발생 시 먼저 unsubscribe 요청하고,
 * 서버에서 받은 데이터 처리 후에 서버에 다시 해당 사용자 consume 요청
 * 
 * @param {JSON} rtnValue - 서버에서 받은 JSON 데이터 객체
 */
const unsubscribeAfterReConsumeForSmartTV = async (rtnValue) => {
    const { consumUserSeq, isForSoundOnly, prodUserSeq, roomKind } = rtnValue;
    console.log(`unsubscribeAfterReConsumeForSmartTV -  roomKind[${roomKind}], prodUserSeq[${prodUserSeq}], consumUserSeq[${consumUserSeq}], isForSoundOnly[${isForSoundOnly}]`);

    if (consumUserSeq === clientInfo.userSeq) {
        if (roomKind === "handsup") {
            console.log("학생 케이스");

            const consumeInfo = getConsumeInfoBySeq(prodUserSeq);
            if (consumeInfo) {
                // isForSoundOnly 값과 상관없이 audio 는 항상 unsubscribe 해야 하기 때문에 true인지 체크 안하고 바로 처리... by hjkim 20231108
                if (consumeInfo.audioEl) { // audioEl은 항상 기본으로 생성하기 때문에 audio consumer 존재 유무와 관계없이 먼저 제거! ...by hjkim 20250812
                    if (!consumeInfo.audioEl.paused) {
                        consumeInfo.audioEl.pause();
                    }
                    consumeInfo.audioEl.srcObject = null;

                    // if (consumeInfo.audioEl.parentNode) {
                    //     console.log("consumeInfo.audioEl.parentNode.removeChild(consumeInfo.audioEl). consumeInfo.audioEl => ", consumeInfo.audioEl);
                    //     consumeInfo.audioEl.parentNode.removeChild(consumeInfo.audioEl);
                    // }

                    // consumeInfo.audioEl = null;
                }

                // let idx = clientInfo.handsupInfo.list_consumeInfo.indexOf(consumeInfo);
                if (consumeInfo.audioConsumer) {
                    consumeInfo.isAudioReceived = false;

                    if (consumeInfo.audioStream) {
                        consumeInfo.audioStream.removeTrack(consumeInfo.audioConsumer.track);
                    }

                    if (!consumeInfo.audioConsumer.closed) {
                        consumeInfo.audioConsumer.close();
                    }

                    consumeInfo.audioStream = null;
                    consumeInfo.audioConsumer = null;
                }

                if (isForSoundOnly === false) { // isForSoundOnly 가 false 면 all unsubscribe 이기 때문에 video 를 여기서 처리... by hjkim 20231108
                    if (consumeInfo.videoConsumer) {
                        consumeInfo.isVideoReceived = false;

                        if (consumeInfo.videoEl) {
                            if (!consumeInfo.videoEl.paused) {
                                consumeInfo.videoEl.pause();
                                consumeInfo.videoEl.currentTime = 0;
                                consumeInfo.videoEl.poster = "/images/connect.png";
                                // consumeInfo.videoEl.poster = "/images/android_notconnected.png";
                            }
                        }

                        if (consumeInfo.videoStream) {
                            consumeInfo.videoStream.removeTrack(consumeInfo.videoConsumer.track);
                        }

                        if (!consumeInfo.videoConsumer.closed) {
                            consumeInfo.videoConsumer.close();
                        }

                        consumeInfo.videoStream = null;
                        consumeInfo.videoConsumer = null;
                    }
                }

                // if (consumeInfo.isExitConsume) {
                    // sendExitConsumeHandsUp(consumeInfo.isAudioReceiveable, consumeInfo.rcvSeq);
                // }

                // exitConsumeAfterForCleaning(roomKind, consumeInfo.rcvSeq);

                callCurrentFuncProc(prodUserSeq, "disconnect");

                sendConsumeWithTimeout(stCallKind.SmartTV, "video", "handsup", prodUserSeq, reConsumeDelayTime);
            } else {
                const p2pInfo = getP2pConsumeInfoBySeq(prodUserSeq);
                if (p2pInfo) {
                    // isForSoundOnly 값과 상관없이 audio 는 항상 unsubscribe 해야 하기 때문에 true인지 체크 안하고 바로 처리... by hjkim 20231108
                    if (p2pInfo.audioEl) { // audioEl은 항상 기본으로 생성하기 때문에 audio consumer 존재 유무와 관계없이 먼저 제거! ...by hjkim 20250812
                        if (!p2pInfo.audioEl.paused) {
                            p2pInfo.audioEl.pause();
                        }
                        p2pInfo.audioEl.srcObject = null;

                        // if (p2pInfo.audioEl.parentNode) {
                        //     console.log("p2pInfo.audioEl.parentNode.removeChild(p2pInfo.audioEl). p2pInfo.audioEl => ", p2pInfo.audioEl);
                        //     p2pInfo.audioEl.parentNode.removeChild(p2pInfo.audioEl);
                        // }

                        // p2pInfo.audioEl = null;
                    }

                    // let idx = clientInfo.handsupInfo.list_p2pConsumeInfo.indexOf(p2pInfo);
                    if (p2pInfo.audioConsumer) {
                        p2pInfo.isAudioReceived = false;

                        if (p2pInfo.audioStream) {
                            p2pInfo.audioStream.removeTrack(p2pInfo.audioConsumer.track);
                        }

                        if (!p2pInfo.audioConsumer.closed) {
                            p2pInfo.audioConsumer.close();
                        }

                        p2pInfo.audioStream = null;
                        p2pInfo.audioConsumer = null;
                    }

                    if (isForSoundOnly === false) { // isForSoundOnly 가 false 면 all unsubscribe 이기 때문에 video 를 여기서 처리... by hjkim 20231108
                        if (p2pInfo.videoConsumer) {
                            p2pInfo.isVideoReceived = false;

                            if (p2pInfo.videoEl) {
                                if (!p2pInfo.videoEl.paused) {
                                    p2pInfo.videoEl.pause();
                                    p2pInfo.videoEl.currentTime = 0;
                                    p2pInfo.videoEl.poster = "/images/connect.png";
                                    // p2pInfo.videoEl.poster = "/images/android_notconnected.png";
                                }
                            }

                            if (p2pInfo.videoStream) {
                                p2pInfo.videoStream.removeTrack(p2pInfo.videoConsumer.track);
                            }

                            if (!p2pInfo.videoConsumer.closed) {
                                p2pInfo.videoConsumer.close();
                            }

                            p2pInfo.videoStream = null;
                            p2pInfo.videoConsumer = null;
                        }
                    }

                    // if (p2pInfo.isExitConsume) {
                        // sendExitConsumeHandsUp(p2pInfo.isAudioReceiveable, p2pInfo.rcvSeq);
                    // }

                    // exitConsumeAfterForCleaning(roomKind, p2pInfo.rcvSeq);

                    callCurrentFuncProc(prodUserSeq, "disconnect");

                    sendConsumeWithTimeout(stCallKind.SmartTV, "video", "handsup", prodUserSeq, reConsumeDelayTime);
                }
            }
        } else {
            console.log("선생님 케이스 - 학생까지 모두 정리 후 transport 부터 다시 생성!!");

            // 20250811 ... 스마트TV 페이지이고, unsubscribe 요청 후 다시 consume 요청이 필요하면
            // transport까지 정리 후 다시 transport 부터 생성 요청해야 함!! ... by hjkim

            // isForSoundOnly 값과 상관없이 audio / mic 는 항상 unsubscribe 해야 하기 때문에 true인지 체크 안하고 바로 처리... by hjkim 20220209
            if (clientInfo.consumeInfo.micConsumer) {
                clientInfo.consumeInfo.isMicReceived = false;

                if (clientInfo.consumeInfo.micEl) {
                    if (!clientInfo.consumeInfo.micEl.paused) {
                        clientInfo.consumeInfo.micEl.pause();
                    }
                    clientInfo.consumeInfo.micEl.srcObject = null;
                }

                if (clientInfo.consumeInfo.micStream) {
                    clientInfo.consumeInfo.micStream.removeTrack(clientInfo.consumeInfo.micConsumer.track);
                }

                if (!clientInfo.consumeInfo.micConsumer.closed) {
                    clientInfo.consumeInfo.micConsumer.close();
                }

                clientInfo.consumeInfo.micStream = null;
                clientInfo.consumeInfo.micConsumer = null;

                let store = window.hiclasstv.store;
                store.dispatch(changeLiveStatusInfo({ kind: "mic", status: "off" }));
            }

            if (clientInfo.consumeInfo.audioConsumer) {
                clientInfo.consumeInfo.isAudioReceived = false;

                if (clientInfo.consumeInfo.audioEl) {
                    if (!clientInfo.consumeInfo.audioEl.paused) {
                        clientInfo.consumeInfo.audioEl.pause();
                    }
                    clientInfo.consumeInfo.audioEl.srcObject = null;
                }

                if (clientInfo.consumeInfo.audioStream) {
                    clientInfo.consumeInfo.audioStream.removeTrack(clientInfo.consumeInfo.audioConsumer.track);
                }

                if (!clientInfo.consumeInfo.audioConsumer.closed) {
                    clientInfo.consumeInfo.audioConsumer.close();
                }

                clientInfo.consumeInfo.audioStream = null;
                clientInfo.consumeInfo.audioConsumer = null;

                let store = window.hiclasstv.store;
                store.dispatch(changeLiveStatusInfo({ kind: "audio", status: "off" }));
            }

            if (isForSoundOnly === false) { // isForSoundOnly 가 false 면 all unsubscribe 이기 때문에 video 를 여기서 처리... by hjkim 20220209
                if (clientInfo.consumeInfo.videoConsumer) {
                    clientInfo.consumeInfo.isVideoReceived = false;

                    if (clientInfo.consumeInfo.videoEl) {
                        if (!clientInfo.consumeInfo.videoEl.paused) {
                            clientInfo.consumeInfo.videoEl.pause();
                        }
                        clientInfo.consumeInfo.videoEl.srcObject = null;
                    }

                    if (clientInfo.consumeInfo.videoStream) {
                        clientInfo.consumeInfo.videoStream.removeTrack(clientInfo.consumeInfo.videoConsumer.track);
                    }

                    if (!clientInfo.consumeInfo.videoConsumer.closed) {
                        clientInfo.consumeInfo.videoConsumer.close();
                    }

                    clientInfo.consumeInfo.videoStream = null;
                    clientInfo.consumeInfo.videoConsumer = null;

                    let store = window.hiclasstv.store;
                    store.dispatch(changeLiveStatusInfo({ kind: "video", status: "off" }));
                }

                if (clientInfo.rcvTransport) {
                    if (!clientInfo.rcvTransport.closed) {
                        clientInfo.rcvTransport.close();
                    }

                    clientInfo.rcvTransport = null;

                    let store = window.hiclasstv.store;
                    store.dispatch(toggleReadyLiveConsume({ isReadyLiveConsume: false }));
                }

                if (clientInfo.consumeInfo.isExitConsume) {
                    sendExitConsume(prodUserSeq);
                }

                let store = window.hiclasstv.store;
                store.dispatch(changeLiveStatusInfo({ kind: "disconnect", status: "off" }));
            }
        }
    } else {
        console.log("------unsubscribeAfterReConsumeForSmartTV------ consumUserSeq is ", consumUserSeq);
    }
}

/**
 * consumer transport에서
 * connection state change event 발생 시 데이터 처리
 * 
 * @param {String} kind - 이벤트 발생 유형
 * @private
 */
const changeConnectionStateConsumerTransportAfter = async (kind) => {
    console.log(`changeConnectionStateConsumerTransportAfter -  kind[${kind}], prodUserSeq[${clientInfo.userSeq}], consumUserSeq[${clientInfo.rcvTeacherSeq}]`);

    if (kind === "disconnected") {
        await unsubscribeHandsUpConsumeAfterForClear(true);

        // isForSoundOnly 값과 상관없이 audio / mic 는 항상 unsubscribe 해야 하기 때문에 true인지 체크 안하고 바로 처리... by hjkim 20230403
        if (clientInfo.consumeInfo.micConsumer) {
            clientInfo.consumeInfo.isMicReceived = false;

            if (clientInfo.consumeInfo.micEl) {
                if (!clientInfo.consumeInfo.micEl.paused) {
                    clientInfo.consumeInfo.micEl.pause();
                }
                clientInfo.consumeInfo.micEl.srcObject = null;
            }

            if (clientInfo.consumeInfo.micStream) {
                clientInfo.consumeInfo.micStream.removeTrack(clientInfo.consumeInfo.micConsumer.track);
            }

            if (!clientInfo.consumeInfo.micConsumer.closed) {
                clientInfo.consumeInfo.micConsumer.close();
            }

            clientInfo.consumeInfo.micStream = null;
            clientInfo.consumeInfo.micConsumer = null;

            let store = window.hiclasstv.store;
            store.dispatch(changeLiveStatusInfo({ kind: "mic", status: "off" }));
        }

        if (clientInfo.consumeInfo.audioConsumer) {
            clientInfo.consumeInfo.isAudioReceived = false;

            if (clientInfo.consumeInfo.audioEl) {
                if (!clientInfo.consumeInfo.audioEl.paused) {
                    clientInfo.consumeInfo.audioEl.pause();
                }
                clientInfo.consumeInfo.audioEl.srcObject = null;
            }

            if (clientInfo.consumeInfo.audioStream) {
                clientInfo.consumeInfo.audioStream.removeTrack(clientInfo.consumeInfo.audioConsumer.track);
            }

            if (!clientInfo.consumeInfo.audioConsumer.closed) {
                clientInfo.consumeInfo.audioConsumer.close();
            }

            clientInfo.consumeInfo.audioStream = null;
            clientInfo.consumeInfo.audioConsumer = null;

            let store = window.hiclasstv.store;
            store.dispatch(changeLiveStatusInfo({ kind: "audio", status: "off" }));
        }

        if (clientInfo.consumeInfo.videoConsumer) {
            clientInfo.consumeInfo.isVideoReceived = false;

            if (clientInfo.consumeInfo.videoEl) {
                if (!clientInfo.consumeInfo.videoEl.paused) {
                    clientInfo.consumeInfo.videoEl.pause();
                }
                clientInfo.consumeInfo.videoEl.srcObject = null;
            }

            if (clientInfo.consumeInfo.videoStream) {
                clientInfo.consumeInfo.videoStream.removeTrack(clientInfo.consumeInfo.videoConsumer.track);
            }

            if (!clientInfo.consumeInfo.videoConsumer.closed) {
                clientInfo.consumeInfo.videoConsumer.close();
            }

            clientInfo.consumeInfo.videoStream = null;
            clientInfo.consumeInfo.videoConsumer = null;

            let store = window.hiclasstv.store;
            store.dispatch(changeLiveStatusInfo({ kind: "video", status: "off" }));
        }

        if (clientInfo.rcvTransport) {
            if (!clientInfo.rcvTransport.closed) {
                clientInfo.rcvTransport.close();
            }

            resetLiveConsume("rcv-transport-state"); // 20261028 받기 연결 정리/생성 시 consume 대기 초기화 (web-relay R-207)
            clientInfo.rcvTransport = null;

            let store = window.hiclasstv.store;
            store.dispatch(toggleReadyLiveConsume({ isReadyLiveConsume: false }));
        }

        /* if (clientInfo.consumeInfo.isExitConsume) {
            sendExitConsume(clientInfo.rcvTeacherSeq);
        } */

        sendExitConsume(clientInfo.rcvTeacherSeq);

        if (window.hiclasstv) {
            let store = window.hiclasstv.store;
            store.dispatch(changeLiveStatusInfo({ kind: "disconnect", status: "off" }));
        }

        exitConsumeAfterForCleaning("live", clientInfo.rcvTeacherSeq);
    }
}

/**
 * transport가 close되었을 경우 데이터 처리
 * 
 * @private
 */
const closeTransportAfter = async () => {
    await unsubscribeHandsUpConsumeAfterForClear(true);

    if (clientInfo.consumeInfo.micConsumer) {
        clientInfo.consumeInfo.isMicReceived = false;
        clientInfo.consumeInfo.isMuteMic = true;

        if (clientInfo.consumeInfo.micStream) {
            if (clientInfo.consumeInfo.micEl && clientInfo.consumeInfo.micEl.srcObject !== null) {
                if (!clientInfo.consumeInfo.micEl.paused) {
                    clientInfo.consumeInfo.micEl.pause();
                }
                clientInfo.consumeInfo.micEl.srcObject = null;
            }

            clientInfo.consumeInfo.micStream.removeTrack(clientInfo.consumeInfo.micConsumer.track);
            clientInfo.consumeInfo.micStream = null;
        }

        clientInfo.consumeInfo.micConsumer = null;
    }

    if (clientInfo.consumeInfo.audioConsumer) {
        clientInfo.consumeInfo.isAudioReceived = false;
        clientInfo.consumeInfo.isMuteAudio = true;

        if (clientInfo.consumeInfo.audioStream) {
            clientInfo.consumeInfo.audioStream.removeTrack(clientInfo.consumeInfo.audioConsumer.track);
        }

        clientInfo.consumeInfo.audioStream = null;
        clientInfo.consumeInfo.audioConsumer = null;
    }

    if (clientInfo.consumeInfo.videoConsumer) {
        clientInfo.consumeInfo.isVideoReceived = false;

        if (clientInfo.consumeInfo.videoStream) {
            clientInfo.consumeInfo.videoStream.removeTrack(clientInfo.consumeInfo.videoConsumer.track);
        }

        clientInfo.consumeInfo.videoStream = null;
        clientInfo.consumeInfo.videoConsumer = null;
    }

    resetLiveConsume("rcv-transport-close"); // 20261028 받기 연결 정리/생성 시 consume 대기 초기화 (web-relay R-207)
    clientInfo.rcvTransport = null;

    let store = window.hiclasstv.store;
    store.dispatch(changeLiveStatusInfo({ kind: "unconnectable", status: "disable" }));
    store.dispatch(toggleReadyLiveConsume({ isReadyLiveConsume: false }));
}

/********************************/
// MEDIA SOUP produce 관련 메서드
/********************************/

/** 260731 Android WebView가 제공하는 카메라 상태 브리지를 안전하게 호출한다. */
const notifyCameraCaptureState = (stateInfo) => {
    try {
        if (typeof window.callCaptureStateChanged === "function") {
            window.callCaptureStateChanged(stateInfo);
        }
    } catch (err) {
        // 20260731 상태 전달 실패가 기존 카메라 Producer 흐름에 영향을 주지 않도록 격리한다.
        console.warn("notifyCameraCaptureState - Android bridge error => ", err);
    }
}

/** 260731 Android WebView가 제공하는 카메라 통계 브리지를 안전하게 호출한다. */
const notifyCameraCaptureStats = (statsInfo) => {
    try {
        if (typeof window.callCaptureStatsUpdated === "function") {
            window.callCaptureStatsUpdated(statsInfo);
        }
    } catch (err) {
        // 20260731 통계 전달 실패가 기존 카메라 Producer 흐름에 영향을 주지 않도록 격리한다.
        console.warn("notifyCameraCaptureStats - Android bridge error => ", err);
    }
}

/**
 * producer를 생성 후 반환
 * 
 * @param {any} transport 
 * @param {MediaStreamTrack} track 
 * @param {Boolean} isSimulcast 
 */
// 20261022 영상 송출 코덱 미지원만 모달로 전달하며 코덱 선택·재연결 정책은 유지한다.
const notifyProduceCodecFailure = (track, err) => {
    if (!track || track.kind !== "video") return;
    if (err && err.name !== "UnsupportedError" && !(err instanceof UnsupportedError)) return;
    const deviceCodecs = clientInfo.device && clientInfo.device.loaded && clientInfo.device.rtpCapabilities
        ? clientInfo.device.rtpCapabilities.codecs : [];
    const codecs = deviceCodecs && deviceCodecs.length > 0
        ? deviceCodecs : (clientInfo.rtpCapabilities && clientInfo.rtpCapabilities.codecs) || [];
    const producerCodecs = [...new Set(codecs
        .map(codec => codec.mimeType)
        .filter(mimeType => /^video\//i.test(mimeType || "") && !/^video\/(rtx|red|ulpfec|flexfec-03)$/i.test(mimeType)))];
    notifyUnsupportedMediaCodec({
        direction: "produce",
        prodUserSeq: clientInfo.userSeq,
        mediaKind: "video",
        errorCode: err ? "UnsupportedError" : "PRODUCER_NOT_CREATED",
        producerCodecs
    });
};

const produce = async (transport, track, isSimulcast, opGuard) => { // 20261030 opGuard: intent 호출의 { intent, op, outcome } (web-relay R-262·R-264)
    // 260928 stopTracks:false — transport.close()가 트랙까지 멈추지 않게 한다.
    // mediasoup-client는 기본이 true라 transport를 닫으면 producer.transportClosed()가
    // _destroyTrack()으로 track.stop()까지 했다. 그래서 송출 fallback이 돌면 캡처가 사라져
    // 재생성할 것이 남지 않았다(Pro 실기 68차 §2-1 — 3초에 확정적으로 죽었다).
    // 트랙을 실제로 멈추는 자리는 unpublishAfter가 직접 하고 있고(videoTrack.stop() 등),
    // initMediaClientStateValue는 참조만 버린다 — 이 값에 기대던 곳은 송출 fallback 하나뿐이었다.
    const params = { track: track, stopTracks: false };
    let producer = null;

    if (isSimulcast) {
        params.encodings = [
            { maxBitrate: 100000 },
            { maxBitrate: 300000 },
            { maxBitrate: 900000 },
        ];
        params.codecOptions = {
            videoGoogleStartBitrate: 1000
        };
    }

    const releaseSendTrack = sendOpGuard.holdSendTrack(track); // 20261030 진행 중 SDK 참조 기록, 동작 무변경 (R-266)
    const opIntent = opGuard ? opGuard.intent : undefined;
    try {
        producer = await transport.produce(params);
        sendOpGuard.registerSendProducer(producer); // 20261030 반환 전 등록 — 인계 전 틈 없이 track 보호 (R-267)
        if (opGuard && (opGuard.outcome = sendOpGuard.checkSendOp(opIntent, opGuard.op)) !== "ok") { console.log(`produce() - ${opGuard.outcome}, 이 호출이 만든 Producer 를 닫는다.`); closeObject(producer); return null; } // 20261030 (R-262·R-264)
        await relayLive.produced(producer, "created", transport); // 20261021 최초/transport 복구 sender 설정 및 오디오 수명
        if (opGuard && (opGuard.outcome = sendOpGuard.checkSendOp(opIntent, opGuard.op)) !== "ok") { console.log(`produce() - ${opGuard.outcome}, 이 호출이 만든 Producer 를 닫는다.`); closeObject(producer); return null; } // 20261030 (R-262·R-264)

        // 20260731 카메라 Producer가 실제 생성된 시점과 종료 이벤트를 Android에 전달한다.
        if (producer !== null && track.kind === "video" && clientInfo.produceInfo.videoSource === "camera") {
            notifyCameraCaptureState({
                source: "camera",
                state: "started",
                producerId: producer.id || ""
            });

            producer.on("trackended", () => {
                if (sendExitGuard.isLaterOwnerActive(opIntent)) return; // 20261030 다른 owner 가 열려 있으면 이전 호출 알림을 막는다 (R-262)
                notifyCameraCaptureState({ source: "camera", state: "stopped" });
            });
            producer.on("transportclose", () => {
                if (sendExitGuard.isLaterOwnerActive(opIntent)) return; // 20261030 (R-262)
                notifyCameraCaptureState({
                    source: "camera",
                    state: "error",
                    message: "camera video transport closed"
                });
            });
        }

        if (producer === null) {
            // 20260731 예외 없이 Producer 생성이 거절된 경우도 Android 오류 상태에 반영한다.
            if (track.kind === "video" && clientInfo.produceInfo.videoSource === "camera") {
                notifyCameraCaptureState({
                    source: "camera",
                    state: "error",
                    message: "camera video producer is null"
                });
            }
            console.log(`[Unsupported] cannot produce this track ... isSimulcast[${isSimulcast}]`);
            // 20260904 alert() 대신 누적 오류 로그에 기록 ... by claude
            addMediaError({ consumUserSeq: clientInfo.userSeq, errorCode: "UnsupportedError" });
            notifyProduceCodecFailure(track);
        }
    } catch (err) {
        console.log("produce() - err => ", err);
        if (opGuard && (opGuard.outcome = sendOpGuard.checkSendOp(opIntent, opGuard.op)) !== "ok") { if (producer !== null) closeObject(producer); return null; } // 20261030 무효·대상 교체면 오류 알림 없음 (R-262·R-264)
        // 20261022 생성 이후 부가 처리 오류를 코덱 생성 실패로 오인하지 않는다.
        if (producer === null) notifyProduceCodecFailure(track, err);
        // 20260731 카메라 Producer 생성 실패를 Android 통합 상태에 전달한다.
        if (track && track.kind === "video" && clientInfo.produceInfo.videoSource === "camera") {
            notifyCameraCaptureState({
                source: "camera",
                state: "error",
                message: (err && err.message) || "camera video produce failed"
            });
        }
        // 20260904 alert() 대신 누적 오류 로그에 기록 ... by claude
        logMediaDeviceError(err);
    } finally {
        releaseSendTrack(); // 20261030 (R-266)
    }

    return producer;
}

/**
 * 현재 웹 카메라 Producer의 outbound RTP 통계를 한 번 조회해 Android에 전달합니다.
 * 앱 정보 화면이 요청할 때만 호출하며 내부 타이머는 사용하지 않습니다.
 *
 * @returns {Promise<Object|null>} 실제 송출 해상도 및 FPS
 * @since 2026-07-31.
 */
export const requestCameraOutboundRtpStats = async () => {
    const producer = clientInfo.produceInfo.videoProducer;
    if (clientInfo.produceInfo.videoSource !== "camera" || producer === null || producer.closed) return null;

    try {
        const report = await producer.getStats();
        let outboundVideo = null;

        report.forEach((stat) => {
            const isVideo = stat.kind === "video" || stat.mediaType === "video";
            if (outboundVideo === null && stat.type === "outbound-rtp" && isVideo && !stat.isRemote) {
                outboundVideo = stat;
            }
        });

        if (outboundVideo === null) return null;

        const statsInfo = {
            source: "camera",
            width: outboundVideo.frameWidth || 0,
            height: outboundVideo.frameHeight || 0,
            fps: outboundVideo.framesPerSecond || 0,
            timestamp: outboundVideo.timestamp || Date.now()
        };
        notifyCameraCaptureStats(statsInfo);
        return statsInfo;
    } catch (err) {
        console.log("requestCameraOutboundRtpStats - err => ", err);
        return null;
    }
}

// 20260731 Android가 앱 정보 표시 중에만 실제 카메라 송출값을 요청하도록 공개한다.
window.requestCameraOutboundRtpStats = requestCameraOutboundRtpStats;

/**
 * audio produce 시작
 * 
 * @param {MediaStreamTrack} track - 프로듀스할 오디오 트랙
 */
export const produceAudio = async (track, intent) => { // 20261030 intent: 이번 웹 획득에서 이어진 호출만 전달, 무인자는 기존 그대로 (web-relay R-262·R-265)
    if (intent !== undefined && !sendExitGuard.isIntentValid(intent)) { console.log("produceAudio - 원래 호출이 무효라 송출하지 않는다."); return SEND_OP_RESULT.OWNER_INVALID; } // 20261030 (R-262·R-265)
    console.log("[produceAudio---000] ----- audioStatus => ", clientInfo.produceInfo.audioStatus);
    clientInfo.produceInfo.audioStatus = "start";
    console.log("[produceAudio---000-1] ----- audioStatus => ", clientInfo.produceInfo.audioStatus);
    if (track !== undefined && track !== null) {
        console.log("[produceAudio---111] ----- Set the audioTrack value to the track value.");
        clientInfo.produceInfo.audioTrack = track;
        console.log("[produceAudio---111-1] ----- The audioTrack value setting is complete.");

        console.log("produceAudio - window.isHandsUpInit => ", window.isHandsUpInit);

        if (window.isHandsUpInit) {
            // 20260917 PBL Group audio helper/replaceTrack은 미리 수신한 학생 소리 상태를 새 track에 적용한다.
            if (getIsPblGroupProAudioMode()) {
                clientInfo.produceInfo.audioTrack.enabled = getMicStatusEnabled();
                console.log("produceAudio(PBL Group) - audioTrack.enabled => ", clientInfo.produceInfo.audioTrack.enabled);
            } else if (ConstData.IS_LOCAL_VERSION) {
                console.log("produceAudio(1) - set audioTrack.enabled = false!!!");
                clientInfo.produceInfo.audioTrack.enabled = false;
            } else {
                console.log("produceAudio(1) - set audioTrack.enabled = true!!!");
                clientInfo.produceInfo.audioTrack.enabled = true;
            }
        } else {
            // 20251119 ... isHandsUpInit = false인 경우에는 마이크 상태 가져와서 설정하도록 수정 ... by hjkim
            if (getMicStatusEnabled()) {
                console.log("produceAudio(2) - set audioTrack.enabled = true!!!");
                clientInfo.produceInfo.audioTrack.enabled = true;
            } else {
                console.log("produceAudio(2) - set audioTrack.enabled = false!!!");
                clientInfo.produceInfo.audioTrack.enabled = false;
            }
        }
    }

    console.log("produceAudio(2) - audioTrack => ", clientInfo.produceInfo.audioTrack);

    console.log("[produceAudio---222] ----- sendTransportStatus => ", clientInfo.sendTransportStatus);
    if (clientInfo.sendTransportStatus === "ended") {
        console.log("[produceAudio---222-1] ----- sendTransport => ", clientInfo.sendTransport);
        if (clientInfo.sendTransport === null) {
            console.log("[produceAudio---333] Creating transport, audio will be produced after connect");
            console.log("(3) set the value clientInfo.sendTransportStatus = 'transport'");
            clientInfo.sendTransportStatus = "transport";
            console.log("[produceAudio---333-1] ----- sendTransportStatus => ", clientInfo.sendTransportStatus);
            sendCreateProducerTransport();
            console.log("[produceAudio---333-2] ----- sendTransportStatus => ", clientInfo.sendTransportStatus);
        } else {
            console.log("[produceAudio---444] ----- sendTransportStatus => ", clientInfo.sendTransportStatus);
            console.log("(4) set the value clientInfo.sendTransportStatus = 'audio'");
            clientInfo.sendTransportStatus = "audio";
            console.log("[produceAudio---444-1] ----- sendTransportStatus => ", clientInfo.sendTransportStatus);
            console.log("[produceAudio---444-2] ----- audioProducer => ", clientInfo.produceInfo.audioProducer);
            if (clientInfo.produceInfo.audioProducer === null) {
                try {
                    console.log("[produceAudio---555]");
                    const isSimulcast = false;
                    const audioOp = intent !== undefined ? { intent, op: sendOpGuard.captureSendOp("produce", "audio", { transport: clientInfo.sendTransport, track: clientInfo.produceInfo.audioTrack }), outcome: null } : undefined; // 20261030 SDK 호출 직전 대상 확보 (R-264)
                    const producer = await produce(clientInfo.sendTransport, clientInfo.produceInfo.audioTrack, isSimulcast, audioOp);
                    if (audioOp) { const opResult = audioOp.outcome !== null && audioOp.outcome !== SEND_OP_RESULT.OK ? audioOp.outcome : sendOpGuard.checkSendOp(intent, audioOp.op); if (opResult !== SEND_OP_RESULT.OK) { if (producer !== null) closeObject(producer); console.log(`produceAudio - ${opResult}, 현재 Producer/status 를 덮지 않는다.`); return opResult; } } // 20261030 (R-262·R-264)
                    console.log("[produceAudio---555-1] ----- producer => ", producer);
                    clientInfo.produceInfo.audioProducer = producer;
                    console.log("[produceAudio---555-2] ----- audioProducer => ", clientInfo.produceInfo.audioProducer);
                } catch (err) {
                    console.log("[produceAudio---(produce)] ----- err => ", err);
                }
            } else {
                console.log("[produceAudio---666] ----- audioProducer.replaceTrackreplaceTrack({ track: clientInfo.produceInfo.audioTrack }) ... ", clientInfo.produceInfo.audioTrack);
                const audioReplaceOp = intent !== undefined ? sendOpGuard.captureSendOp("replace", "audio", { producer: clientInfo.produceInfo.audioProducer, track: clientInfo.produceInfo.audioTrack }) : null; // 20261030 (R-264)
                const releaseAudioReplace = sendOpGuard.holdSendTrack(clientInfo.produceInfo.audioTrack); // 20261030 진행 중 SDK 참조 기록 (R-266)
                try {
                    await clientInfo.produceInfo.audioProducer.replaceTrack({ track: clientInfo.produceInfo.audioTrack });
                } catch (err) {
                    if (audioReplaceOp) { const opResult = sendOpGuard.checkSendOp(intent, audioReplaceOp); if (opResult !== SEND_OP_RESULT.OK) { console.log(`produceAudio(replaceTrack 오류) - ${opResult}`); return opResult; } } // 20261030 거절 경계도 판정, 유효 owner 는 기존대로 throw (R-269)
                    throw err;
                } finally {
                    releaseAudioReplace();
                }
                if (audioReplaceOp) { const opResult = sendOpGuard.checkSendOp(intent, audioReplaceOp); if (opResult !== SEND_OP_RESULT.OK) { console.log(`produceAudio(replaceTrack) - ${opResult}, 후속 쓰기를 건너뛴다.`); return opResult; } } // 20261030 (R-262·R-264)
                relayLive.traceAudio(clientInfo.produceInfo.audioProducer, "audio-replaceTrack", clientInfo.sendTransport); // 20261021 R-148 오디오 수명
                console.log("[produceAudio---666-1] ----- sendTransportStatus => ", clientInfo.sendTransportStatus);
                console.log("(5) set the value clientInfo.sendTransportStatus = 'ended'");
                clientInfo.sendTransportStatus = "ended";
                console.log("[produceAudio---666-2] ----- sendTransportStatus => ", clientInfo.sendTransportStatus);
                console.log("[produceAudio---777] ----- audioStatus => ", clientInfo.produceInfo.audioStatus);
                clientInfo.produceInfo.audioStatus = "ended";
                console.log("[produceAudio---777-1] ----- audioStatus => ", clientInfo.produceInfo.audioStatus);

                /* // 20251105 ... 로컬 버전과 상관없이 마이크 & 시스템 오디오를 사용할 수 있는 상태이면 enabled를 true로 설정 ... by hjkim
                if (getMicStatusEnabled()) {
                    console.log("produceAudio(3) - set audioTrack.enabled = true!!!");
                    clientInfo.produceInfo.audioTrack.enabled = true;

                    // 20251110 ... 선생님께 마이크 & 시스템 오디오 사용 상태 메시지 알림 전송 추가 ... by hjkim
                    // sendP2PSoundOn(clientInfo.liveSeq, clientInfo.userSeq);
                } else {
                    console.log("produceAudio(4) - set audioTrack.enabled = false!!!");
                    clientInfo.produceInfo.audioTrack.enabled = false;

                    // 20251110 ... 선생님께 마이크 & 시스템 오디오 사용 상태 메시지 알림 전송 추가 ... by hjkim
                    // sendP2PSoundOff(clientInfo.liveSeq, clientInfo.userSeq);
                }

                // 20251110 ... 선생님께 마이크 & 시스템 오디오 사용 상태 메시지 알림 전송 추가 ... by hjkim
                console.log("produceAudio - case 3:) call sendMicStatus()");
                sendMicStatus(); */
            }

            // 20251105 ... 로컬 버전과 상관없이 마이크 & 시스템 오디오를 사용할 수 있는 상태이면 enabled를 true로 설정 ... by hjkim
            if (getMicStatusEnabled()) {
                console.log("produceAudio(3) - set audioTrack.enabled = true!!!");
                clientInfo.produceInfo.audioTrack.enabled = true;

                // 20251110 ... 선생님께 마이크 & 시스템 오디오 사용 상태 메시지 알림 전송 추가 ... by hjkim
                // sendP2PSoundOn(clientInfo.liveSeq, clientInfo.userSeq);
            } else {
                console.log("produceAudio(4) - set audioTrack.enabled = false!!!");
                clientInfo.produceInfo.audioTrack.enabled = false;

                // 20251110 ... 선생님께 마이크 & 시스템 오디오 사용 상태 메시지 알림 전송 추가 ... by hjkim
                // sendP2PSoundOff(clientInfo.liveSeq, clientInfo.userSeq);
            }

            // 20251110 ... 선생님께 마이크 & 시스템 오디오 사용 상태 메시지 알림 전송 추가 ... by hjkim
            console.log("produceAudio - case 3:) call sendMicStatus()");
            sendMicStatus();
            console.log("[produceAudio---888]");
        }
    } else {
        console.log(`[produceAudio---222-2] ----- clientInfo.sendTransportStatus[${clientInfo.sendTransportStatus}]`);
    }
    return intent !== undefined ? SEND_OP_RESULT.OK : undefined; // 20261030 intent 호출은 항상 문자열, 무인자는 기존 undefined (R-266)
}

/**
 * video produce 시작
 * 
 * @param {MediaStreamTrack} track - 프로듀스할 비디오 트랙
 * @param {Boolean} isHighQualityMode - 스트림을 고화질 해상도로 보내야하는지 여부
 * @param {Boolean} isCameraStream - 카메라 스트림인지 여부
 */
export const produceVideo = async (track, isHighQualityMode, isCameraStream, displayRotation = 0, intent) => { // 20261030 intent: 이번 웹 획득에서 이어진 호출만 전달 (web-relay R-262·R-265)
    if (intent !== undefined && !sendExitGuard.isIntentValid(intent)) { console.log("produceVideo - 원래 호출이 무효라 송출하지 않는다."); return SEND_OP_RESULT.OWNER_INVALID; } // 20261030 (R-262·R-265)
    // 20260731 Android WebView 카메라와 다른 웹 비디오 소스를 명확히 구분한다.
    clientInfo.produceInfo.videoSource = isCameraStream ? "camera" : "screen";
    // 20260908 Canvas 재인코딩 없이 화면 공유 producer에만 수신 화면 회전 정보를 전달한다.
    clientInfo.produceInfo.displayRotation = !isCameraStream && displayRotation === -90 ? -90 : 0;
    if (clientInfo.produceInfo.displayRotation !== -90) {
        notifyDisplayRotationSendStatus(0); // 20260910 카메라 또는 일반 화면 공유 전환 시 이전 보정 송출 표시는 제거한다.
    }
    if (isCameraStream) {
        notifyCameraCaptureState({ source: "camera", state: "starting" });
    }
    console.log("[produceVideo---000] ----- videoStatus => ", clientInfo.produceInfo.videoStatus);
    clientInfo.produceInfo.videoStatus = "start";
    console.log("[produceVideo---000-1] ----- videoStatus => ", clientInfo.produceInfo.videoStatus);
    if (track !== undefined && track !== null) {
        console.log("[produceVideo---111] ----- Set the videoTrack value to the track value.");
        clientInfo.produceInfo.videoTrack = track;
        console.log("[produceVideo---111-1] ----- The videoTrack value setting is complete.");

        let band_info = {};

        if (isHighQualityMode) {
            if (isCameraStream) {
                console.log("[produceVideo---(1)] ----- isHighQualityMode is true. - now camera stream.");
                console.log("[produceVideo---(1-1)] ----- Set the band_info value to the BandConstraints.Camera value.");
                band_info = BandConstraints.Camera;
            } else {
                console.log("[produceVideo---(2)] ----- isHighQualityMode is true. - now screen stream.");
                console.log("[produceVideo---(2-1)] ----- Set the band_info value to the BandConstraints.Screen value.");
                band_info = BandConstraints.Screen;
            }
        } else {
            console.log("[produceVideo---(3)] ----- isHighQualityMode is false.");
            console.log("[produceVideo---(3-1)] ----- Set the band_info value to the BandConstraints.Thumbnail value.");
            band_info = BandConstraints.Thumbnail;
        }

        console.log("[produceVideo---(4)] ----- The band_info value setting is complete.");
        console.log("[produceVideo---(4-1)] ----- band_info => ", band_info);

        const qualityOp = intent !== undefined ? sendOpGuard.captureSendOp("quality", "video", { track: clientInfo.produceInfo.videoTrack }) : null; // 20261030 (R-264)
        try { // 20261030 quality·constraints 거절 경계도 판정, 유효 owner·무인자는 기존대로 throw (R-269)
        const isRelayQuality = await relayLive.quality(clientInfo.produceInfo.videoTrack, band_info, clientInfo.produceInfo.videoProducer, "produceVideo"); // 20261030 quality → 검사 → applyConstraints 로 분리 (R-262)
        if (qualityOp) { const opResult = sendOpGuard.checkSendOp(intent, qualityOp); if (opResult !== SEND_OP_RESULT.OK) { console.log(`produceVideo(quality) - ${opResult}`); return opResult; } } // 20261030 (R-262·R-264)
        if (!isRelayQuality) await clientInfo.produceInfo.videoTrack.applyConstraints(band_info); // 20261021 C3 sender 화질, legacy constraints 유지
        } catch (err) {
            if (qualityOp) { const opResult = sendOpGuard.checkSendOp(intent, qualityOp); if (opResult !== SEND_OP_RESULT.OK) { console.log(`produceVideo(quality/constraints 오류) - ${opResult}`); return opResult; } } // 20261030 (R-269)
            throw err;
        }
        if (qualityOp) { const opResult = sendOpGuard.checkSendOp(intent, qualityOp); if (opResult !== SEND_OP_RESULT.OK) { console.log(`produceVideo(constraints) - ${opResult}`); return opResult; } } // 20261030 (R-262·R-264)

        console.log("[produceVideo---(5)] ----- videoTrack.applyConstraints is complete.");
    }

    console.log("[produceVideo---222] ----- sendTransportStatus => ", clientInfo.sendTransportStatus);
    if (clientInfo.sendTransportStatus === "ended") {
        console.log("[produceVideo---222-1] ----- sendTransport => ", clientInfo.sendTransport);
        if (clientInfo.sendTransport === null) {
            console.log("[produceVideo---333] Creating transport, video will be produced after connect");
            console.log("(6) set the value clientInfo.sendTransportStatus = 'transport'");
            clientInfo.sendTransportStatus = "transport";
            console.log("[produceVideo---333-1] ----- sendTransportStatus => ", clientInfo.sendTransportStatus);
            sendCreateProducerTransport();
            console.log("[produceVideo---333-2] ----- sendTransportStatus => ", clientInfo.sendTransportStatus);
        } else {
            console.log("[produceVideo---444] ----- sendTransportStatus => ", clientInfo.sendTransportStatus);
            console.log("(7) set the value clientInfo.sendTransportStatus = 'video'");
            clientInfo.sendTransportStatus = "video";
            console.log("[produceVideo---444-1] ----- sendTransportStatus => ", clientInfo.sendTransportStatus);
            console.log("[produceVideo---444-2] ----- videoProducer => ", clientInfo.produceInfo.videoProducer);
            if (clientInfo.produceInfo.videoProducer === null) {
                try {
                    console.log("[produceVideo---555]");
                    const isSimulcast = false;
                    const videoOp = intent !== undefined ? { intent, op: sendOpGuard.captureSendOp("produce", "video", { transport: clientInfo.sendTransport, track: clientInfo.produceInfo.videoTrack }), outcome: null } : undefined; // 20261030 SDK 호출 직전 대상 확보 (R-264)
                    const producer = await produce(clientInfo.sendTransport, clientInfo.produceInfo.videoTrack, isSimulcast, videoOp);
                    if (videoOp) { const opResult = videoOp.outcome !== null && videoOp.outcome !== SEND_OP_RESULT.OK ? videoOp.outcome : sendOpGuard.checkSendOp(intent, videoOp.op); if (opResult !== SEND_OP_RESULT.OK) { if (producer !== null) closeObject(producer); console.log(`produceVideo - ${opResult}, 현재 Producer/status 를 덮지 않는다.`); return opResult; } } // 20261030 (R-262·R-264)
                    console.log("[produceVideo---555-1] ----- producer => ", producer);
                    clientInfo.produceInfo.videoProducer = producer;
                    console.log("[produceVideo---555-2] ----- videoProducer => ", clientInfo.produceInfo.videoProducer);
                } catch (err) {
                    console.log("[produceVideo---(produce)] ----- err => ", err);
                }
            } else {
                console.log("[produceVideo---666]");
                const videoReplaceOp = intent !== undefined ? sendOpGuard.captureSendOp("replace", "video", { producer: clientInfo.produceInfo.videoProducer, track: clientInfo.produceInfo.videoTrack }) : null; // 20261030 (R-264)
                const releaseVideoReplace = sendOpGuard.holdSendTrack(clientInfo.produceInfo.videoTrack); // 20261030 진행 중 SDK 참조 기록 (R-266)
                try {
                    await clientInfo.produceInfo.videoProducer.replaceTrack({ track: clientInfo.produceInfo.videoTrack });
                    if (videoReplaceOp) { const opResult = sendOpGuard.checkSendOp(intent, videoReplaceOp); if (opResult !== SEND_OP_RESULT.OK) { console.log(`produceVideo(replaceTrack) - ${opResult}, 후속 쓰기를 건너뛴다.`); return opResult; } } // 20261030 (R-262·R-264)
                    await relayLive.produced(clientInfo.produceInfo.videoProducer, "video-replaceTrack", clientInfo.sendTransport); // 20261021 교체 뒤 목표 화질 재적용
                    if (videoReplaceOp) { const opResult = sendOpGuard.checkSendOp(intent, videoReplaceOp); if (opResult !== SEND_OP_RESULT.OK) { console.log(`produceVideo(produced) - ${opResult}, 후속 쓰기를 건너뛴다.`); return opResult; } } // 20261030 (R-262·R-264)
                } catch (err) {
                    if (videoReplaceOp) { const opResult = sendOpGuard.checkSendOp(intent, videoReplaceOp); if (opResult !== SEND_OP_RESULT.OK) { console.log(`produceVideo(replaceTrack 오류) - ${opResult}, 알림 없이 끝낸다.`); return opResult; } } // 20261030 (R-262·R-264)
                    // 20260731 카메라 전환 중 트랙 교체 실패를 Android 오류 상태에 전달한다.
                    if (clientInfo.produceInfo.videoSource === "camera") {
                        notifyCameraCaptureState({
                            source: "camera",
                            state: "error",
                            message: (err && err.message) || "camera video track replacement failed"
                        });
                    }
                    throw err;
                } finally {
                    releaseVideoReplace(); // 20261030 (R-266)
                }
                // 20260731 카메라 전환으로 트랙을 교체한 경우에도 실제 송출 중 상태를 갱신한다.
                if (clientInfo.produceInfo.videoSource === "camera") {
                    notifyCameraCaptureState({
                        source: "camera",
                        state: "started",
                        producerId: clientInfo.produceInfo.videoProducer.id || ""
                    });
                }
                console.log("[produceVideo---666-1] ----- sendTransportStatus => ", clientInfo.sendTransportStatus);
                console.log("(8) set the value clientInfo.sendTransportStatus = 'ended'");
                clientInfo.sendTransportStatus = "ended";
                console.log("[produceVideo---666-2] ----- sendTransportStatus => ", clientInfo.sendTransportStatus);
                console.log("[produceVideo---777] ----- videoStatus => ", clientInfo.produceInfo.videoStatus);
                clientInfo.produceInfo.videoStatus = "ended";
                console.log("[produceVideo---777-1] ----- videoStatus => ", clientInfo.produceInfo.videoStatus);
            }
            console.log("[produceVideo---888]");
        }
    } else {
        console.log(`[produceVideo---222-2] ----- clientInfo.sendTransportStatus[${clientInfo.sendTransportStatus}]`);
    }
    return intent !== undefined ? SEND_OP_RESULT.OK : undefined; // 20261030 intent 호출은 항상 문자열, 무인자는 기존 undefined (R-266)
}
/********************************/

/********************************/
// MEDIA SOUP video-produce 비디오 해상도 설정 관련 메서드
/********************************/

/**
 * netImageFrames 수신 시 configFPS 사양 단계에 따라
 * 현재 p2pMode에 맞는 해상도/프레임레이트를 videoProducer track에 반영합니다.
 *
 * 사양 단계별 설정 테이블 (안드로이드와 동일한 기준):
 *   configFPS 0 = 최고사양: Thumbnail=640x360/5, P4P=960x540/16, P2P=1280x720/20, P1P=1920x1080/24
 *   configFPS 1 = 고사양:   Thumbnail=640x360/4, P4P=768x432/14, P2P=960x540/18,  P1P=1280x720/20
 *   configFPS 2 = 중사양:   Thumbnail=480x270/3, P4P=640x360/12, P2P=768x432/15,  P1P=960x540/16
 *   configFPS 3 = 저사양:   Thumbnail=480x270/2, P4P=480x270/10, P2P=640x360/12,  P1P=768x432/12
 *
 * @param {Number} configFPS  - 사양 단계 (0~3)
 * @param {Number} p2pMode    - 현재 p2pMode (enP2PMode)
 * @param {Boolean} isHighQualityMode - isP2PMode || isSmartTVMode
 * @returns {Promise<void>}
 */
export const applyConfigFPS = async (configFPS, p2pMode, isHighQualityMode) => {
    try {
        if (!clientInfo.produceInfo.videoProducer) {
            console.log("applyConfigFPS - videoProducer 없음. 스킵.");
            return;
        }
        if (!clientInfo.produceInfo.videoProducer.track) {
            console.log("applyConfigFPS - videoProducer.track 없음. 스킵.");
            return;
        }

        // ① configFPS × p2pMode 설정 테이블
        //    해상도는 16:9 기준 (PC 환경 FHD 1920x1080 기준)
        const configTable = {
            0: { // 최고사양
                [enP2PMode.Thumbnail]: { width: 640,  height: 360, frameRate: 5  },
                [enP2PMode.P4P]:       { width: 960,  height: 540, frameRate: 16 },
                [enP2PMode.P2P]:       { width: 1280, height: 720, frameRate: 20 },
                [enP2PMode.P1P]:       { width: 1920, height: 1080, frameRate: 24 },
            },
            1: { // 고사양
                [enP2PMode.Thumbnail]: { width: 640, height: 360, frameRate: 4  },
                [enP2PMode.P4P]:       { width: 768, height: 432, frameRate: 14 },
                [enP2PMode.P2P]:       { width: 960, height: 540, frameRate: 18 },
                [enP2PMode.P1P]:       { width: 1280, height: 720, frameRate: 20 },
            },
            2: { // 중사양
                [enP2PMode.Thumbnail]: { width: 480, height: 270, frameRate: 3  },
                [enP2PMode.P4P]:       { width: 640, height: 360, frameRate: 12 },
                [enP2PMode.P2P]:       { width: 768, height: 432, frameRate: 15 },
                [enP2PMode.P1P]:       { width: 960, height: 540, frameRate: 16 },
            },
            3: { // 저사양
                [enP2PMode.Thumbnail]: { width: 480, height: 270, frameRate: 2  },
                [enP2PMode.P4P]:       { width: 480, height: 270, frameRate: 10 },
                [enP2PMode.P2P]:       { width: 640, height: 360, frameRate: 12 },
                [enP2PMode.P1P]:       { width: 768, height: 432, frameRate: 12 },
            },
        };

        const level = configTable[configFPS] ?? configTable[3];
        const config = level[p2pMode] ?? level[enP2PMode.Thumbnail];

        console.log(`applyConfigFPS - configFPS[${configFPS}], p2pMode[${p2pMode}], isHighQualityMode[${isHighQualityMode}]`);
        console.log(`applyConfigFPS - config => `, config);

        // ② BandConstraints 업데이트 (이후 setVideoResolution 호출 시에도 반영되도록)
        if (!isHighQualityMode || p2pMode === enP2PMode.Thumbnail) {
            BandConstraints.Thumbnail.width     = config.width;
            BandConstraints.Thumbnail.height    = config.height;
            BandConstraints.Thumbnail.frameRate = config.frameRate;
        } else if (p2pMode === enP2PMode.P1P) {
            BandConstraints.Screen.width     = config.width;
            BandConstraints.Screen.height    = config.height;
            BandConstraints.Screen.frameRate = config.frameRate;
        } else if (p2pMode === enP2PMode.P2P) {
            BandConstraints.ScreenV2.width     = config.width;
            BandConstraints.ScreenV2.height    = config.height;
            BandConstraints.ScreenV2.frameRate = config.frameRate;
        } else { // P4P
            BandConstraints.ScreenV4.width     = config.width;
            BandConstraints.ScreenV4.height    = config.height;
            BandConstraints.ScreenV4.frameRate = config.frameRate;
        }

        // ③ track에 즉시 적용
        const constraints = {
            width:     { ideal: config.width },
            height:    { ideal: config.height },
            frameRate: { ideal: config.frameRate },
        };

        if (!await relayLive.quality(clientInfo.produceInfo.videoProducer.track, constraints, clientInfo.produceInfo.videoProducer, "applyConfigFPS")) await clientInfo.produceInfo.videoProducer.track.applyConstraints(constraints); // 20261021 C3 sender 화질, legacy constraints 유지

        console.log(`applyConfigFPS - applyConstraints 완료:`, constraints);
        console.log(`applyConfigFPS - track settings after:`, clientInfo.produceInfo.videoProducer.track.getSettings());

    } catch (err) {
        console.log("applyConfigFPS - err => ", err);
    }
}

/**
 * video track Resolution 변경
 * 
 * @param {Boolean} isHighQualityMode - 스트림을 고화질 해상도로 보내야하는지 여부
 * @param {Boolean} isCameraStream - 카메라 스트림인지 여부
 * @param {Boolean} isForPblMode - pbl 지원 모드인지 여부
 * @param {Number} p2pMode - 현재 선택된 p2p 모드
 * @returns {Promise<Boolean>}
 */
export const setVideoResolution = async (isHighQualityMode, isCameraStream, isForPblMode, p2pMode) => {
    return new Promise(async (resolve, reject) => {
        try {
            if (clientInfo.produceInfo.videoProducer) {
                if (clientInfo.produceInfo.videoProducer.track) {
                    // 중복 실행 방지를 위한 debouncing
                    if (resolutionChangeInProgress && !relayLive.ownsVideo(clientInfo.produceInfo.videoProducer.track)) { // 20261021 C3 최신 요청은 sender 큐에 보관
                        console.log("[setVideoResolution] Resolution change already in progress, skipping");
                        resolve();
                        return;
                    }
                    resolutionChangeInProgress = true;

                    let band_info = {};

                    if (isHighQualityMode) {
                        if (isCameraStream) {
                            console.log("[setVideoResolution---(1)] ----- isHighQualityMode is true. - now camera stream.");
                            console.log("[setVideoResolution---(1-1)] ----- Set the band_info value to the BandConstraints.Camera value.");
                            if (isForPblMode) { // pbl 지원 모드인 경우 frameRame와 해상도를 현재 p2p모드와 상관없이 최상위 모드로 설정한다 ... by hjkim 20250905
                                band_info = BandConstraints.CameraPBL;
                            } else {
                                if (p2pMode === enP2PMode.Thumbnail) {
                                    band_info = BandConstraints.Thumbnail;
                                } else {
                                    band_info = BandConstraints.Camera;
                                }
                            }
                        } else {
                            console.log("[setVideoResolution---(2)] ----- isHighQualityMode is true. - now screen stream.");
                            console.log("[setVideoResolution---(2-1)] ----- Set the band_info value to the BandConstraints.Screen value.");
                            if (isForPblMode) { // pbl 지원 모드인 경우 frameRame와 해상도를 현재 p2p모드와 상관없이 최상위 모드로 설정한다 ... by hjkim 20250905
                                band_info = BandConstraints.ScreenPBL;
                            } else {
                                if (p2pMode === enP2PMode.Thumbnail) {
                                    band_info = BandConstraints.Thumbnail;
                                } else if (p2pMode === enP2PMode.P1P) {
                                    band_info = BandConstraints.Screen;
                                } else if (p2pMode === enP2PMode.P2P) {
                                    band_info = BandConstraints.ScreenV2;
                                } else {
                                    band_info = BandConstraints.ScreenV4;
                                }
                            }
                        }
                    } else {
                        console.log("[setVideoResolution---(3)] ----- isHighQualityMode is false.");
                        console.log("[setVideoResolution---(3-1)] ----- Set the band_info value to the BandConstraints.Thumbnail value.");
                        band_info = BandConstraints.Thumbnail;
                    }

                    console.log("[setVideoResolution---(4)] ----- The band_info value setting is complete.");
                    console.log("[setVideoResolution---(4-1)] ----- band_info => ", band_info);
                    console.log("[setVideoResolution] Current track settings before change:", clientInfo.produceInfo.videoProducer.track.getSettings());

                    if (!await relayLive.quality(clientInfo.produceInfo.videoProducer.track, band_info, clientInfo.produceInfo.videoProducer, "setVideoResolution")) await clientInfo.produceInfo.videoProducer.track.applyConstraints(band_info); // 20261021 C3 sender 화질, legacy constraints 유지

                    // MediaSoup producer 재시작 또는 재협상
                    if (clientInfo.produceInfo.videoProducer.paused) {
                        await clientInfo.produceInfo.videoProducer.resume();
                    }

                    console.log("[setVideoResolution] Track settings after change:", clientInfo.produceInfo.videoProducer.track.getSettings());

                    resolutionChangeInProgress = false;

                    console.log("[setVideoResolution---(5)] ----- videoProducer.track.applyConstraints setting is complete.");
                }
            }

            resolve(true);
        } catch (err) {
            resolutionChangeInProgress = false;
            console.log("[setVideoResolution---(1-2)] ----- err => ", err);
            reject(err);
        }
    });
}

/**
 * 화면 공유 비디오 Resolution 변경
 * 
 * @param {Boolean} isHighQualityMode - 스트림을 고화질 해상도로 보내야하는지 여부
 * @param {Boolean} isCameraStream - 카메라 스트림인지 여부
 * @param {Number} width - 해상도 너비
 * @param {Number} height - 해상도 높이
 * @param {Number} frameRate - 초당 스트림(이미지) 전송 속도
 * @returns {Promise<Boolean>}
 */
export const setScreenVideoResolutionValue = async (isHighQualityMode, isCameraStream, width, height, frameRate) => {
    return new Promise(async (resolve, reject) => {
        try {
            if (clientInfo.produceInfo.videoProducer) {
                if (clientInfo.produceInfo.videoProducer.track) {
                    if (isHighQualityMode) {
                        if (isCameraStream) {
                            console.log("[setScreenVideoResolutionValue---(1)] ----- isHighQualityMode is true. - now camera stream.");
                            console.log("[setScreenVideoResolutionValue---(1-1)] ----- Just set the BandConstraints.Screen value.");
                        } else {
                            console.log("[setScreenVideoResolutionValue---(2)] ----- isHighQualityMode is true. - now screen stream.");
                            console.log("[setScreenVideoResolutionValue---(2-1)] ----- Set the BandConstraints.Screen value and change the constraints.");
                        }
                    } else {
                        console.log("[setScreenVideoResolutionValue---(3)] ----- isHighQualityMode is false.");
                        console.log("[setScreenVideoResolutionValue---(3-1)] ----- Just set the BandConstraints.Screen value.");
                    }

                    BandConstraints.Screen.width = width;
                    BandConstraints.Screen.height = height;
                    BandConstraints.Screen.frameRate = frameRate;

                    console.log("[setScreenVideoResolutionValue---(4)] ----- The BandConstraints.Screen value setting is complete.");
                    console.log("[setScreenVideoResolutionValue---(4-1)] ----- BandConstraints.Screen => ", BandConstraints.Screen);

                    if (isHighQualityMode) {
                        if (!isCameraStream) {
                            if (!await relayLive.quality(clientInfo.produceInfo.videoProducer.track, BandConstraints.Screen, clientInfo.produceInfo.videoProducer, "setScreenVideoResolutionValue")) await clientInfo.produceInfo.videoProducer.track.applyConstraints(BandConstraints.Screen); // 20261021 C3 sender 화질, legacy constraints 유지

                            console.log("[setScreenVideoResolutionValue---(5)] ----- videoProducer.track.applyConstraints setting is complete.");
                        }
                    }
                }
            }

            resolve();
        } catch (err) {
            console.log("[setScreenVideoResolutionValue---(1-2)] ----- err => ", err);
        }
    });
}

/**
 * 카메라 비디오 Resolution 변경
 * 
 * @param {Boolean} isHighQualityMode - 스트림을 고화질 해상도로 보내야하는지 여부
 * @param {Boolean} isCameraStream - 카메라 스트림인지 여부
 * @param {Number} width - 해상도 너비
 * @param {Number} height - 해상도 높이
 * @param {Number} frameRate - 초당 스트림(이미지) 전송 속도
 * @returns {Promise<Boolean>}
 */
export const setCameraVideoResolutionValue = async (isHighQualityMode, isCameraStream, width, height, frameRate) => {
    return new Promise(async (resolve, reject) => {
        try {
            if (clientInfo.produceInfo.videoProducer) {
                if (clientInfo.produceInfo.videoProducer.track) {
                    if (isHighQualityMode) {
                        if (isCameraStream) {
                            console.log("[setCameraVideoResolutionValue---(1)] ----- isHighQualityMode is true. - now camera stream.");
                            console.log("[setCameraVideoResolutionValue---(1-1)] ----- Set the BandConstraints.Camera value and change the constraints.");
                        } else {
                            console.log("[setCameraVideoResolutionValue---(2)] ----- isHighQualityMode is true. - now screen stream.");
                            console.log("[setCameraVideoResolutionValue---(2-1)] ----- Just set the BandConstraints.Camera value.");
                        }
                    } else {
                        console.log("[setCameraVideoResolutionValue---(3)] ----- isHighQualityMode is false.");
                        console.log("[setCameraVideoResolutionValue---(3-1)] ----- Just set the BandConstraints.Camera value.");
                    }

                    BandConstraints.Camera.width = width;
                    BandConstraints.Camera.height = height;
                    BandConstraints.Camera.frameRate = frameRate;

                    console.log("[setCameraVideoResolutionValue---(4)] ----- The BandConstraints.Camera value setting is complete.");
                    console.log("[setCameraVideoResolutionValue---(4-1)] ----- BandConstraints.Camera => ", BandConstraints.Camera);

                    if (isHighQualityMode) {
                        if (isCameraStream) {
                            if (!await relayLive.quality(clientInfo.produceInfo.videoProducer.track, BandConstraints.Camera, clientInfo.produceInfo.videoProducer, "setCameraVideoResolutionValue")) await clientInfo.produceInfo.videoProducer.track.applyConstraints(BandConstraints.Camera); // 20261021 C3 sender 화질, legacy constraints 유지

                            console.log("[setCameraVideoResolutionValue---(5)] ----- videoProducer.track.applyConstraints setting is complete.");
                        }
                    }
                }
            }

            resolve();
        } catch (err) {
            console.log("[setCameraVideoResolutionValue---(1-2)] ----- err => ", err);
        }
    });
}
/********************************/

/********************************/
// MEDIA SOUP audio-produce-cotrol 관련
/********************************/

/**
 * Producer의 audio track을 활성화합니다.
 * 
 * @returns {Promise<Boolean>} 오디오 트랙 활성화 성공 여부
 */
export const enableAudioTrack = async () => {
    return new Promise(async (resolve, reject) => {
        try {
            console.log("enableAudioTrack() - clientInfo.produceInfo.audioTrack => ", clientInfo.produceInfo.audioTrack);
            if (clientInfo.produceInfo.audioTrack !== undefined && clientInfo.produceInfo.audioTrack !== null) {
                console.log("enableAudioTrack - set audioTrack.enabled = true!!!");
                clientInfo.produceInfo.audioTrack.enabled = true;
            } else {
                console.log("enableAudioTrack - audioTrack is undefined or null, cannot enable.");
            }

            resolve(true);
        } catch (err) {
            console.log("enableAudioTrack() - err => ", err);
            resolve(false);
        }
    });
}

/**
 * Producer의 audio track을 비활성화합니다.
 * 
 * @returns {Promise<Boolean>} 오디오 트랙 비활성화 성공 여부
 */
export const disableAudioTrack = async () => {
    return new Promise(async (resolve, reject) => {
        try {
            console.log("disableAudioTrack() - clientInfo.produceInfo.audioTrack => ", clientInfo.produceInfo.audioTrack);
            if (clientInfo.produceInfo.audioTrack !== undefined && clientInfo.produceInfo.audioTrack !== null) {
                console.log("disableAudioTrack - set audioTrack.enabled = false!!!");
                clientInfo.produceInfo.audioTrack.enabled = false;
            } else {
                console.log("disableAudioTrack - audioTrack is undefined or null, cannot disable.");
            }

            resolve(true);
        } catch (err) {
            console.log("disableAudioTrack() - err => ", err);
            resolve(false);
        }
    });
}
/********************************/

/********************************/
// MEDIA SOUP produce 관련 send 메서드
/********************************/

/**
 * send live_createProducerTransport request to mediaSoup server
 * 
 * @private
 */
const sendCreateProducerTransport = () => {
    if (!sendExitGuard.canRequestSend()) { console.log("sendCreateProducerTransport - 송출 종료 상태라 생성 요청을 보내지 않는다."); return; } // 20261028 (web-relay R-224)
    console.log(`sendCreateProducerTransport - clientInfo - userSeq[${clientInfo.userSeq}], liveSeq[${clientInfo.liveSeq}], rcvTeacherSeq[${clientInfo.rcvTeacherSeq}], routingKey[${clientInfo.routingKey}]`);
    const data = {
        kind            : "mediaSoup",
        action          : "live_createProducerTransport",
        prodUserSeq     : clientInfo.userSeq,
        liveSeq         : clientInfo.liveSeq,
        teacherSeq      : clientInfo.rcvTeacherSeq,
        sendRotingKey   : clientInfo.routingKey
    };

    sendObjectToRbmq(data);
}

relayLive.bindNativeRecovery(() => androidSendIceRestart, sendCreateProducerTransport, sendRecreateWatch); // 20261026 R-187 C3 MQ 복구는 기존 native 정리/재생성 사용

/**
 * app 에서 사용하는 transport를 생성하기 위해서, 서버에게 요청하는 부분을 대신 호출함
 * send app_live_createProducerTransport request to mediaSoup server
 */
export const sendAppCreateProducerTransport = () => {
    console.log(`sendAppCreateProducerTransport - clientInfo - userSeq[${clientInfo.userSeq}], liveSeq[${clientInfo.liveSeq}], rcvTeacherSeq[${clientInfo.rcvTeacherSeq}], routingKey[${clientInfo.routingKey}]`);
    const data = {
        kind            : "mediaSoup",
        action          : "app_live_createProducerTransport",
        prodUserSeq     : clientInfo.userSeq,
        liveSeq         : clientInfo.liveSeq,
        teacherSeq      : clientInfo.rcvTeacherSeq,
        sendRotingKey   : clientInfo.routingKey
    };

    sendObjectToRbmq(data);
}

/**
 * send live_connectProducerTransport request to mediaSoup server
 * 
 * @param {DtlsParameters} dtlsParameters - 미디어 수프 서버 DTLS(데이터 그램 전송 계층 보안) 매개변수
 * @private
 */
const sendConnectProducerTransport = (dtlsParameters) => {
    console.log(`sendConnectProducerTransport - clientInfo - userSeq[${clientInfo.userSeq}], liveSeq[${clientInfo.liveSeq}], rcvTeacherSeq[${clientInfo.rcvTeacherSeq}], routingKey[${clientInfo.routingKey}]`);
    console.log("sendConnectProducerTransport - dtlsParameters => ", dtlsParameters);

    const data = {
        kind            : "mediaSoup",
        action          : "live_connectProducerTransport",
        liveSeq         : clientInfo.liveSeq,
        prodUserSeq     : clientInfo.userSeq,
        dtlsParameters  : dtlsParameters,
        teacherSeq      : clientInfo.rcvTeacherSeq,
        sendRotingKey   : clientInfo.routingKey
    };

    sendObjectToRbmq(data);
}

/**
 * app 에서 사용하는 transport를 생성하기 위해서, 서버에게 요청하는 부분을 대신 호출함
 * send app_live_connectProducerTransport request to mediaSoup server
 * 
 * @param {DtlsParameters} dtlsParameters - 미디어 수프 서버 DTLS(데이터 그램 전송 계층 보안) 매개변수
 */
export const sendAppConnectProducerTransport = (dtlsParameters) => {
    console.log(`sendAppConnectProducerTransport - clientInfo - userSeq[${clientInfo.userSeq}], liveSeq[${clientInfo.liveSeq}], rcvTeacherSeq[${clientInfo.rcvTeacherSeq}], routingKey[${clientInfo.routingKey}]`);
    const data = {
        kind            : "mediaSoup",
        action          : "app_live_connectProducerTransport",
        liveSeq         : clientInfo.liveSeq,
        prodUserSeq     : clientInfo.userSeq,
        dtlsParameters  : dtlsParameters,
        teacherSeq      : clientInfo.rcvTeacherSeq,
        sendRotingKey   : clientInfo.routingKey
    };

    sendObjectToRbmq(data);
}

/**
 * send live_produce request to mediaSoup server
 * 
 * @param {String} mediaKind - 미디어 유형
 * @param {RtpCapabilities} rtpParameters - RTP 매개변수
 */
const sendProduce = (mediaKind, rtpParameters) => {
    console.log(`sendProduce - mediaKind[${mediaKind}], rtpParameters => `, rtpParameters, `, clientInfo - userSeq[${clientInfo.userSeq}], liveSeq[${clientInfo.liveSeq}], rcvTeacherSeq[${clientInfo.rcvTeacherSeq}], routingKey[${clientInfo.routingKey}]`);

    const data = {
        kind            : "mediaSoup",
        action          : "live_produce",
        mediaKind       : mediaKind,
        liveSeq         : clientInfo.liveSeq,
        prodUserSeq     : clientInfo.userSeq,
        rtpParameters   : rtpParameters,
        displayRotation : mediaKind === "video" ? clientInfo.produceInfo.displayRotation : 0,
        teacherSeq      : clientInfo.rcvTeacherSeq,
        sendRotingKey   : clientInfo.routingKey
    };

    sendObjectToRbmq(data);
}

/**
 * app 에서 사용하는 transport를 생성하기 위해서, 서버에게 요청하는 부분을 대신 호출함
 * send app_live_produce request to mediaSoup server
 * 
 * @param {String} mediaKind - 미디어 유형
 * @param {RtpCapabilities} rtpParameters - RTP 매개변수
 */
export const sendAppProduce = (mediaKind, rtpParameters) => {
    console.log(`sendProduce - mediaKind[${mediaKind}], rtpParameters => `, rtpParameters, `, clientInfo - userSeq[${clientInfo.userSeq}], liveSeq[${clientInfo.liveSeq}], rcvTeacherSeq[${clientInfo.rcvTeacherSeq}], routingKey[${clientInfo.routingKey}]`);

    const data = {
        kind            : "mediaSoup",
        action          : "app_live_produce",
        mediaKind       : mediaKind,
        liveSeq         : clientInfo.liveSeq,
        prodUserSeq     : clientInfo.userSeq,
        rtpParameters   : rtpParameters,
        teacherSeq      : clientInfo.rcvTeacherSeq,
        sendRotingKey   : clientInfo.routingKey
    };

    sendObjectToRbmq(data);
}

/**
 * send live_updateDisplayRotation request to mediaSoup server.
 * 이미 화면 공유 producer가 생성되어 송출 중인 상태에서, 학생이 직접 선택한 화면 회전값을
 * producer 재생성(re-produce) 없이 서버에 갱신 요청한다. 서버는 이 값을 현재 그 화면을
 * 구독 중인 모든 선생님에게 즉시 push 한다.
 *
 * @param {Number} displayRotation - 화면 회전값 (0 | 90 | 180 | 270)
 * @since 2026-09-16.
 */
export const sendUpdateDisplayRotation = (displayRotation) => {
    const rotation = normalizeDisplayRotation(displayRotation);
    console.log(`sendUpdateDisplayRotation - displayRotation[${rotation}], clientInfo - userSeq[${clientInfo.userSeq}], liveSeq[${clientInfo.liveSeq}], routingKey[${clientInfo.routingKey}]`);

    const data = {
        kind            : "mediaSoup",
        action          : "live_updateDisplayRotation",
        liveSeq         : clientInfo.liveSeq,
        prodUserSeq     : clientInfo.userSeq,
        displayRotation : rotation,
        teacherSeq      : clientInfo.rcvTeacherSeq,
        sendRotingKey   : clientInfo.routingKey
    };

    sendObjectToRbmq(data);

    // 260916 서버 응답을 기다리지 않고 로컬에도 즉시 반영한다 (재연결 시 참고용).
    clientInfo.produceInfo.displayRotation = rotation;
}

/**
 * send live_unpublish request to mediaSoup server
 * 
 * @param {String} mediaKind - 미디어 유형
 */
export const sendUnpublish = async (mediaKind) => {
    return new Promise(async (resolve, reject) => {
        console.log(`sendUnpublish - mediaKind[${mediaKind}], clientInfo - userSeq[${clientInfo.userSeq}], liveSeq[${clientInfo.liveSeq}], rcvTeacherSeq[${clientInfo.rcvTeacherSeq}], routingKey[${clientInfo.routingKey}]`);
        if (clientInfo.sendTransport === null) { // mediaSoup server에 아무것도 produce 하고 있지 않은 상태... by hjkim 20220311
            if (mediaKind === "ALL" || mediaKind === "all") {
                await clearAudioInput();
                await clearVideoInput();
            } else if (mediaKind === "video") {
                // 뭔가 여기서 해야하려나..?ㅁ?
            } else if (mediaKind === "audio") {
                // 뭔가 여기서 해야하려나..?ㅁ?
            }
        } else { // mediaSoup server에 audio / video 중 하나 이상 produce 하고 있는 상태... by hjkim 20220311
            if (mediaKind === "ALL" || mediaKind === "all") {
                const data = {
                    kind            : "mediaSoup",
                    action          : "live_unpublish",
                    mediaKind       : mediaKind === "all" ? "ALL" : mediaKind,
                    liveSeq         : clientInfo.liveSeq,
                    prodUserSeq     : clientInfo.userSeq,
                    teacherSeq      : clientInfo.rcvTeacherSeq,
                    sendRotingKey   : clientInfo.routingKey
                };

                sendObjectToRbmq(data);
            } else {
                if (mediaKind === "video" && clientInfo.produceInfo.videoProducer !== null) {
                    const data = {
                        kind            : "mediaSoup",
                        action          : "live_unpublish",
                        mediaKind       : mediaKind,
                        liveSeq         : clientInfo.liveSeq,
                        prodUserSeq     : clientInfo.userSeq,
                        teacherSeq      : clientInfo.rcvTeacherSeq,
                        sendRotingKey   : clientInfo.routingKey
                    };

                    sendObjectToRbmq(data);
                }

                if (mediaKind === "audio" && clientInfo.produceInfo.audioProducer !== null) {
                    const data = {
                        kind            : "mediaSoup",
                        action          : "live_unpublish",
                        mediaKind       : mediaKind,
                        liveSeq         : clientInfo.liveSeq,
                        prodUserSeq     : clientInfo.userSeq,
                        teacherSeq      : clientInfo.rcvTeacherSeq,
                        sendRotingKey   : clientInfo.routingKey
                    };

                    sendObjectToRbmq(data);
                }
            }
        }

        resolve();
    });
}

/**
 * send app_live_unpublish request to mediaSoup server
 * 
 * @param {String} mediaKind - 미디어 유형
 */
export const sendAppUnpublish = (mediaKind) => {
    const data = {
        kind            : "mediaSoup",
        action          : "app_live_unpublish",
        mediaKind       : mediaKind === "all" ? "ALL" : mediaKind,
        liveSeq         : clientInfo.liveSeq,
        prodUserSeq     : clientInfo.userSeq,
        teacherSeq      : clientInfo.rcvTeacherSeq,
        sendRotingKey   : clientInfo.routingKey
    };

    sendObjectToRbmq(data);
}

/**
 * send live_endProduceCallback request to mediaSoup server
 * 
 * @param {String} mediaKind - 미디어 유형
 * @returns {Promise<Boolean>}
 */
export const sendEndProduceCallback = (mediaKind) => {
    console.log(`sendEndProduceCallback - mediaKind[${mediaKind}], clientInfo - userSeq[${clientInfo.userSeq}], liveSeq[${clientInfo.liveSeq}], rcvTeacherSeq[${clientInfo.rcvTeacherSeq}], routingKey[${clientInfo.routingKey}]`);
    return new Promise((resolve, reject) => {
        const data = {
            kind            : "mediaSoup",
            action          : "live_endProduceCallback",
            mediaKind       : mediaKind,
            liveSeq         : clientInfo.liveSeq,
            prodUserSeq     : clientInfo.userSeq,
            teacherSeq      : clientInfo.rcvTeacherSeq,
            sendRotingKey   : clientInfo.routingKey
        };

        sendObjectToRbmq(data);
        resolve(true);
    });
}

/**
 * send app_live_endProduceCallback request to mediaSoup server
 * 
 * @param {String} mediaKind - 미디어 유형
 * @returns {Promise<Boolean>}
 */
export const sendAppEndProduceCallback = (mediaKind) => {
    console.log(`sendEndProduceCallback - mediaKind[${mediaKind}], clientInfo - userSeq[${clientInfo.userSeq}], liveSeq[${clientInfo.liveSeq}], rcvTeacherSeq[${clientInfo.rcvTeacherSeq}], routingKey[${clientInfo.routingKey}]`);
    return new Promise((resolve, reject) => {
        const data = {
            kind            : "mediaSoup",
            action          : "app_live_endProduceCallback",
            mediaKind       : mediaKind,
            liveSeq         : clientInfo.liveSeq,
            prodUserSeq     : clientInfo.userSeq,
            teacherSeq      : clientInfo.rcvTeacherSeq,
            sendRotingKey   : clientInfo.routingKey
        };

        sendObjectToRbmq(data);
        resolve(true);
    });
}
/********************************/

/********************************/
// MEDIA SOUP produce 관련 callback 메서드
/********************************/

/**
 * live_createProducerTransport 요청 후 서버에서 받은 데이터 처리
 * 
 * @param {JSON} rtnValue - 서버에서 받은 JSON 데이터 객체
 */
export const createProducerTransportAfter = async (rtnValue) => {
    const { transportParams } = rtnValue;
    const sendExitEpoch = sendExitGuard.getEpoch(); // 20261028 await 뒤 송출 세대 재검사 (web-relay R-224)
    console.log("createProducerTransportAfter - ", rtnValue.rtpCapabilities, rtnValue.transportParams);

    // 안드로이드 웹뷰 별도 처리 추가 ... by hjkim 20260211
    if (relayLive.nativeScreen(checkAndroidScreenValue())) { // 20261020 C3 relay는 기존 웹 transport/Producer 경로 사용
        console.log("createProducerTransportAfter - 안드로이드 Native WebView로 전달");

        // 260930 네이티브는 이 id 로 송출 transport 를 만든다(createSendTransport(id = 서버 id)).
        // 새 세대이므로 옛 어댑터를 멈추고 이 id 를 지켜보는 어댑터를 새로 세운다 — PC 의 createSendIceRestart 와 같은 자리.
        // 네이티브에 넘기기 전에 세운다. 첫 pro-producerTransportState 가 이보다 먼저 올 수 없게.
        retireAndroidSendIceRestart("새 송출 transport");
        androidSendIceRestart = createAndroidSendIceRestart({
            transportId  : transportParams.id,
            restartAfter : (iceParametersJson, transportId) => window.callRestartProducerTransportAfter(iceParametersJson, transportId),
            restartFailed: (reason, transportId) => window.callRestartProducerTransportFailed(reason, transportId),
            sendRequest  : (transportId) => sendRestartProducerTransport(transportId),
            // 참여 때와 같은 길이다 — 응답이 다시 이 갈래로 와서 네이티브가 복원 생성으로 스스로 produce 한다
            // (Android f757eae · 4b6181b, 「[createProducerTransportAfter---888-restore]」).
            // 261002 재생성 요청을 보내는 순간부터 감시한다 — 새 transport 가 connecting 에서 멈추거나 요청이 사라져도 다시 세운다.
            recreate     : () => {
                sendCreateProducerTransport();
                sendRecreateWatch.arm("android-recreate");
            }
        });

        window.callCreateProducerTransportAfter({
            rtpCapabilities: JSON.stringify(rtnValue.rtpCapabilities),
            id: transportParams.id,
            dtlsParameters: JSON.stringify(transportParams.dtlsParameters),
            iceCandidates: JSON.stringify(transportParams.iceCandidates),
            iceParameters: JSON.stringify(transportParams.iceParameters)
        });
        return;
    }

    console.log("clientInfo.rtpCapabilities => ", clientInfo.rtpCapabilities, ", rtnValue.rtpCapabilities => ", rtnValue.rtpCapabilities);
    if (clientInfo.rtpCapabilities === undefined || clientInfo.rtpCapabilities === null) {
        clientInfo.rtpCapabilities = rtnValue.rtpCapabilities;
    }

    try {
        await loadDevice();
    } catch (err) {
        console.log("createProducerTransportAfter(loadDevice) - err => ", err);
        // 20260904 alert() 대신 누적 오류 로그에 기록 ... by claude
        logMediaDeviceError(err, { consumUserSeq: clientInfo.userSeq });
    } finally {
        if (!sendExitGuard.isEpoch(sendExitEpoch)) { console.log("createProducerTransportAfter - 기다리는 사이 송출이 종료됐다. transport 를 만들지 않는다."); return; } // 20261028 (web-relay R-224)
        if (clientInfo.device === undefined || clientInfo.device === null) {
            console.log("createProducerTransportAfter - clientInfo.device is => ", clientInfo.device);
            return;
        }

        try {
            let canProduceAudio = clientInfo.device.canProduce("audio");
            let canProduceVideo = clientInfo.device.canProduce("video");

            console.log(`createProducerTransportAfter - canProduceAudio[${canProduceAudio}], canProduceVideo[${canProduceVideo}]`);

            clientInfo.produceInfo.canProduceAudio = canProduceAudio;
            clientInfo.produceInfo.canProduceVideo = canProduceVideo;
        } catch (err) {
            console.log("createProducerTransportAfter(canProduce) - err => ", err);
        } finally {
            let transport = null;

            try {
                transport = clientInfo.device.createSendTransport({
                    id: transportParams.id,
                    dtlsParameters: transportParams.dtlsParameters,
                    iceCandidates: transportParams.iceCandidates,
                    iceParameters: transportParams.iceParameters
                });

                if (transport !== null) {
                    transport.on("connect", ({ dtlsParameters }, callback, errback) => {
                        console.log("Producer - transport.on(connect) - dtlsParameters => ", dtlsParameters);
                        clientInfo.sendTransportCallback = callback;
                        clientInfo.sendTransportErrback = errback;
                        sendConnectProducerTransport(dtlsParameters);
                    });

                    transport.on("produce", async ({ kind, rtpParameters }, callback, errback) => {
                        console.log("Producer - transport.on(produce) - kind, rtpParameters => ", kind, rtpParameters);
                        clientInfo.produceInfo.produceCallback = callback;
                        clientInfo.produceInfo.produceErrback = errback;
                        sendProduce(kind, rtpParameters);
                    });

                    // 260923 transport 를 새로 만들었으니 옛 조정자의 타이머부터 끊는다.
                    if (sendIceRestart !== null) sendIceRestart.reset();
                    sendIceRestart = createSendIceRestart(transport);
                    // 260923 아래 핸들러는 이 transport 의 조정자만 움직여야 한다. 모듈 변수를 읽으면
                    // transport 가 교체됐을 때 옛 transport 의 이벤트가 새 조정자를 밀어 버린다.
                    const iceRestart = sendIceRestart;

                    transport.on("connectionstatechange", (state) => {
                        console.log(`produce-transport connectionstatechange ... state[${state}]`);
                        switch (state) {
                            case "connecting": break;
                            // 260923 failed 에서 바로 닫지 않고 ICE 재시작을 한 번 시도한다.
                            // 실패·무응답이면 조정자의 fallback 이 예전처럼 close() 한다.
                            case "connected":
                            case "disconnected":
                            case "failed":
                            case "closed":
                                // 20260904 송신 transport 연결 실패를 누적 오류 로그에 기록한다 ... by claude
                                if (state === "failed") {
                                    addMediaError({ consumUserSeq: clientInfo.userSeq, errorCode: "TRANSPORT_FAILED" });
                                }
                                // 261002 지금 송출 transport 가 붙었다 — 재생성 감시를 끈다.
                                if (state === "connected" && clientInfo.sendTransport === transport) {
                                    sendRecreateWatch.connected();
                                }
                                iceRestart.onState(state);
                                break;
                            default: break;
                        }
                    });

                    clientInfo.sendTransport = transport;

                    // ---------------- 여기부터 기존 코드 주석 처리 ---------------- by hjkim 20251113 //
                    /* if (clientInfo.produceInfo.videoStatus === "start") {
                        clientInfo.sendTransportStatus = "video";
                        try {
                            const track = clientInfo.produceInfo.videoTrack;
                            const isSimulcast = false;
                            const producer = await produce(transport, track, isSimulcast);
                            clientInfo.produceInfo.videoProducer = producer;
                        } catch (err) {
                            console.log("createProducerTransportAfter(produce) - err => ", err);
                        }
                    } else if (clientInfo.produceInfo.audioStatus === "start") {
                        clientInfo.sendTransportStatus = "audio";
                        try {
                            const track = clientInfo.produceInfo.audioTrack;
                            const isSimulcast = false;
                            const producer = await produce(transport, track, isSimulcast);
                            clientInfo.produceInfo.audioProducer = producer;
                        } catch (err) {
                            console.log("createProducerTransportAfter(produce) - err => ", err);
                        }
                    } else {
                        clientInfo.sendTransportStatus = "ended";
                    } */
                    // ---------------- 여기까지 기존 코드 주석 처리 ---------------- by hjkim 20251113 //

                    // 20251113 ... 수정 코드 ... by hjkim
                    // ✅ 수정: transport 생성 후에는 audio -> video 순차적으로 produce 처리
                    // 260928 송출 fallback 이 붙잡아 둔 것이 있으면 게이트를 보기 전에 되돌린다.
                    // 트랙이 아직 살아 있을 때만 쓴다 — stopTracks:false 라 transport.close() 는
                    // 트랙을 멈추지 않지만, 그 사이 정상 정리(unpublishAfter)가 돌았으면 ended 다.
                    if (pendingProducerRestore !== null) {
                        const kept = pendingProducerRestore;
                        pendingProducerRestore = null;

                        // 260928 (나) 가드가 지켜 주면 전역이 살아 있고, 69차 순서면 지워져 있다. 둘 다 받는다.
                        const audioTrack = clientInfo.produceInfo.audioTrack || kept.audioTrack;
                        const videoTrack = clientInfo.produceInfo.videoTrack || kept.videoTrack;
                        const isAudioAlive = audioTrack && audioTrack.readyState === "live";
                        const isVideoAlive = videoTrack && videoTrack.readyState === "live";
                        console.log("createProducerTransportAfter - 송출 fallback 복구: audio[" + isAudioAlive + "], video[" + isVideoAlive + "]");

                        // 260928 ⚠ status 는 「지금 싣고 있다」가 아니라 「실어 달라」는 요청 표시다.
                        // produceAudio() 가 start 를 세우고 endProduceAfter() 가 ended 로 되돌리므로
                        // 평시 송출 중의 값은 ended 다. 붙잡아 둔 값을 그대로 되돌리면 언제나 ended 가 돼
                        // 게이트가 막힌다. fallback 경로에는 produceAudio() 가 없으니 그 표시를 여기서 대신 세운다.
                        // (Pro 실기 71차 §2-2 — (가)·(나) 가 다 걸렸는데도 (12) 로 떨어진 이유)
                        if (isAudioAlive) {
                            clientInfo.produceInfo.audioTrack = audioTrack;
                            clientInfo.produceInfo.audioStatus = "start";
                        }

                        if (isVideoAlive) {
                            clientInfo.produceInfo.videoTrack = videoTrack;
                            clientInfo.produceInfo.videoStatus = "start";
                        }
                    }

                    console.log("(9) set the value clientInfo.sendTransportStatus = 'transport'");
                    clientInfo.sendTransportStatus = "transport";

                    console.log("createProducerTransportAfter - transport created, producing audio first");

                    if (clientInfo.produceInfo.audioStatus === "start" && clientInfo.produceInfo.audioTrack) {
                        // ✅ 수정: audio가 있으면 먼저 produce
                        console.log("createProducerTransportAfter - producing audio first");
                        console.log("(10) set the value clientInfo.sendTransportStatus = 'audio'");
                        clientInfo.sendTransportStatus = "audio";

                        try {
                            const track = clientInfo.produceInfo.audioTrack;
                            const isSimulcast = false;
                            const producer = await produce(clientInfo.sendTransport, track, isSimulcast);
                            if (!sendExitGuard.isEpoch(sendExitEpoch)) { console.log("createProducerTransportAfter - produce 사이 송출이 종료됐다. 이 Producer 를 닫는다."); closeObject(producer); return; } // 20261028 (web-relay R-224)
                            clientInfo.produceInfo.audioProducer = producer;
                            console.log("createProducerTransportAfter - audio produce completed");
                        } catch (err) {
                            console.log("createProducerTransportAfter(produce audio) - err => ", err);
                        }

                        // audio produce 완료 후 잠시 대기
                        await new Promise(resolve => setTimeout(resolve, 100));
                    } else if (clientInfo.produceInfo.videoStatus === "start" && clientInfo.produceInfo.videoTrack) {
                        // ✅ 수정: audio produce 불가능할 경우 video produce
                        console.log("createProducerTransportAfter - producing video after checking audio");
                        console.log("(11) set the value clientInfo.sendTransportStatus = 'video'");
                        clientInfo.sendTransportStatus = "video";

                        try {
                            const track = clientInfo.produceInfo.videoTrack;
                            const isSimulcast = false;
                            const producer = await produce(clientInfo.sendTransport, track, isSimulcast);
                            if (!sendExitGuard.isEpoch(sendExitEpoch)) { console.log("createProducerTransportAfter - produce 사이 송출이 종료됐다. 이 Producer 를 닫는다."); closeObject(producer); return; } // 20261028 (web-relay R-224)
                            clientInfo.produceInfo.videoProducer = producer;
                            console.log("createProducerTransportAfter - video produce completed");
                        } catch (err) {
                            console.log("createProducerTransportAfter(produce video) - err => ", err);
                        }
                    } else {
                        // ✅ 수정: 모든 produce 불가능한 경우 상태 초기화
                        // 260928 왜 떨어졌는지가 한 줄로 보여야 한다 — status 인지 track 인지 (Pro 실기 71차 §3)
                        console.log("createProducerTransportAfter - produce 하지 않는다. audioStatus[" + clientInfo.produceInfo.audioStatus +
                            "], audioTrack[" + (clientInfo.produceInfo.audioTrack !== null && clientInfo.produceInfo.audioTrack !== undefined) +
                            "], videoStatus[" + clientInfo.produceInfo.videoStatus +
                            "], videoTrack[" + (clientInfo.produceInfo.videoTrack !== null && clientInfo.produceInfo.videoTrack !== undefined) + "]");
                        console.log("(12) set the value clientInfo.sendTransportStatus = 'ended'");
                        clientInfo.sendTransportStatus = "ended";
                    }
                } else {
                    console.log(`[Unsupported] can not create send transport ... id[${transportParams.id}], transport => `, transport);
                    // 20260904 alert() 대신 누적 오류 로그에 기록 ... by claude
                    addMediaError({ consumUserSeq: clientInfo.userSeq, errorCode: "UnsupportedError" });
                }
            } catch (err) {
                console.log("createProducerTransportAfter(createSendTransport) - err => ", err);
                // 20260904 alert() 대신 누적 오류 로그에 기록 ... by claude
                logMediaDeviceError(err, { consumUserSeq: clientInfo.userSeq });
            }
        }
    }
}

/**
 * live_connectProducerTransport 요청 후 서버에서 받은 데이터 처리
 * - 수정: transport connect 완료 후 audio를 먼저 produce하고, 완료되면 video produce
 */
export const connectProducerTransportAfter = async () => {
    console.log("connectProducerTransportAfter - start");

    // 안드로이드 웹뷰 별도 처리 추가 ... by hjkim 20260211
    if (relayLive.nativeScreen(checkAndroidScreenValue())) { // 20261020 C3 relay는 기존 웹 transport/Producer 경로 사용
        console.log("connectProducerTransportAfter - 안드로이드 Native WebView로 전달");
        window.callConnectProducerTransportAfter();
        return;
    }

    // transport connect callback 호출
    if (typeof clientInfo.sendTransportCallback !== "function") { console.log("connectProducerTransportAfter - connect callback 이 없다(송출 종료 뒤 응답). 무시한다."); return; } // 20261028 예외 방지 (web-relay R-224)
    clientInfo.sendTransportCallback();

    console.log("connectProducerTransportAfter - transport connected, now producing tracks sequentially");
    console.log(`connectProducerTransportAfter - audioStatus[${clientInfo.produceInfo.audioStatus}], videoStatus[${clientInfo.produceInfo.videoStatus}]`);

    /* // ✅ 수정: audio가 있으면 먼저 produce
    if (clientInfo.produceInfo.audioStatus === "start" && clientInfo.produceInfo.audioTrack) {
        console.log("connectProducerTransportAfter - producing audio first");
        clientInfo.sendTransportStatus = "audio";

        try {
            const track = clientInfo.produceInfo.audioTrack;
            const isSimulcast = false;
            const producer = await produce(clientInfo.sendTransport, track, isSimulcast);
            clientInfo.produceInfo.audioProducer = producer;
            console.log("connectProducerTransportAfter - audio produce completed");
        } catch (err) {
            console.log("connectProducerTransportAfter(produce audio) - err => ", err);
        }

        // audio produce 완료 후 잠시 대기
        await new Promise(resolve => setTimeout(resolve, 100));
    }

    // ✅ 수정: audio produce 완료 후 video produce
    if (clientInfo.produceInfo.videoStatus === "start" && clientInfo.produceInfo.videoTrack) {
        console.log("connectProducerTransportAfter - producing video after audio");
        clientInfo.sendTransportStatus = "video";

        try {
            const track = clientInfo.produceInfo.videoTrack;
            const isSimulcast = false;
            const producer = await produce(clientInfo.sendTransport, track, isSimulcast);
            clientInfo.produceInfo.videoProducer = producer;
            console.log("connectProducerTransportAfter - video produce completed");
        } catch (err) {
            console.log("connectProducerTransportAfter(produce video) - err => ", err);
        }
    }

    // 모든 produce 완료 후 상태 초기화
    if (clientInfo.produceInfo.audioStatus !== "start" && clientInfo.produceInfo.videoStatus !== "start") {
        clientInfo.sendTransportStatus = "ended";
        console.log("connectProducerTransportAfter - no tracks to produce, setting status to ended");
    } */

    console.log("connectProducerTransportAfter - end");
}

/**
 * live_produce 요청 후 서버에서 받은 데이터 처리
 * 
 * @param {JSON} rtnValue - 서버에서 받은 JSON 데이터 객체
 */
export const produceAfter = async (rtnValue) => {
    const { id, kind } = rtnValue;
    console.log(`produceAfter - kind[${kind}], id[${id}]`);

    // 안드로이드 웹뷰 별도 처리 추가 ... by hjkim 20260211
    if (relayLive.nativeScreen(checkAndroidScreenValue())) { // 20261020 C3 relay는 기존 웹 transport/Producer 경로 사용
        console.log("produceAfter - 안드로이드 Native WebView로 전달");
        window.callProduceAfter({
            id: id,
            mediaKind: kind
        });
        return;
    }

    if (typeof clientInfo.produceInfo.produceCallback !== "function") { console.log("produceAfter - produce callback 이 없다(송출 종료 뒤 응답). 무시한다."); return; } // 20261028 예외 방지 (web-relay R-224)
    clientInfo.produceInfo.produceCallback(id);
    if (kind === "video") {
        notifyDisplayRotationSendStatus(clientInfo.produceInfo.displayRotation); // 20260910 기존 producer 성공 응답을 받은 화면 공유만 표시한다.
    }

    try {
        await sendEndProduceCallback(kind);
    } catch (err) {
        console.log("produceAfter() err => ", err);
    } finally {
        endProduceAfter(kind);
    }
}

/**
 * live_produce 요청 후 서버에서 받은 데이터 처리
 * 
 * @param {String} mediaKind - 미디어 유형
 */
const endProduceAfter = async (mediaKind) => {
    console.log(`endProduceAfter - mediaKind[${mediaKind}]`);
    if (mediaKind === "video") {
        clientInfo.produceInfo.videoStatus = "ended";
    } else if (mediaKind === "audio" || (mediaKind === "ALL" || mediaKind === "all")) {
        clientInfo.produceInfo.audioStatus = "ended";
        // sendP2PSoundOn(clientInfo.liveSeq, clientInfo.userSeq);

        console.log("endProduceAfter - case 1:) call sendMicStatus()");
        sendMicStatus();

        /* console.log("endProduceAfter - window.isHandsUpInit => ", window.isHandsUpInit);
        if (window.isHandsUpInit) {
            console.log("endProduceAfter - isAndroidWebView => ", isAndroidWebView());
            if (isAndroidWebView()) {
                console.log("endProduceAfter(1-1) call xmitCmd_AndroidInitDone");
                xmitCmd_AndroidInitDone();
                // androidHandsUpInitDone();
                // window.isHandsUpInit = false;
            } else {
                console.log("endProduceAfter(1-2) do not call xmitCmd_AndroidInitDone");
            }
        } */
    }

    if (clientInfo.produceInfo.videoStatus === "start") {
        console.log("endProduceAfter - producing video after audio");
        console.log("(13) set the value clientInfo.sendTransportStatus = 'video'");
        clientInfo.sendTransportStatus = "video";

        try {
            const track = clientInfo.produceInfo.videoTrack;
            const isSimulcast = false;
            const producer = await produce(clientInfo.sendTransport, track, isSimulcast);
            clientInfo.produceInfo.videoProducer = producer;
            console.log("endProduceAfter - video produce completed");
        } catch (err) {
            console.log("endProduceAfter(produce video) - err => ", err);
        }
    } else if (clientInfo.produceInfo.audioStatus === "start") {
        console.log("endProduceAfter - producing audio after video");
        console.log("(14) set the value clientInfo.sendTransportStatus = 'audio'");
        clientInfo.sendTransportStatus = "audio";

        try {
            const track = clientInfo.produceInfo.audioTrack;
            const isSimulcast = false;
            const producer = await produce(clientInfo.sendTransport, track, isSimulcast);
            clientInfo.produceInfo.audioProducer = producer;
            console.log("endProduceAfter - audio produce completed");
        } catch (err) {
            console.log("endProduceAfter(produce audio) - err => ", err);
        }
    } else {
        console.log("(15) set the value clientInfo.sendTransportStatus = 'ended'");
        clientInfo.sendTransportStatus = "ended";

        console.log("endProduceAfter(produce) - window.isHandsUpInit[", window.isHandsUpInit, "]");

        console.log("endProduceAfter - case 2:) call sendMicStatus()");
        sendMicStatus();

        console.log("endProduceAfter - window.isHandsUpInit => ", window.isHandsUpInit);
        if (window.isHandsUpInit) {
            console.log("endProduceAfter - isAndroidWebView => ", isAndroidWebView());
            if (isAndroidWebView()) {
                console.log("endProduceAfter(1-1) call xmitCmd_AndroidInitDone");
                xmitCmd_AndroidInitDone();
                // androidHandsUpInitDone();
                // window.isHandsUpInit = false;
            } else if (getIsForPblModeBrowser() && getIsPblGroupProAudioMode()) {
                // 20260917 PBL Group audio producer 완료 후 INIT_DONE을 전송해 현재 학생 소리 상태를 track에 적용한다.
                sendHandsUpInitDone(clientInfo.liveSeq, clientInfo.userSeq);
            } else {
                console.log("endProduceAfter(1-2) do not call INIT_DONE yet");
            }
        }

        /* if (!window.isHandsUpInit && isAndroidWebView()) {
            console.log("endProduceAfter - case 2:) call sendMicStatus()");
            sendMicStatus();
        } */

        // 20260917 PBL Group은 video producer 완료만으로 INIT_DONE 대기를 해제하지 않고 audio producer 완료를 기다린다.
        if (window.isHandsUpInit && (!getIsForPblModeBrowser() || getIsPblGroupProAudioMode())) {
            window.isHandsUpInit = false;
        }
    }
}

/**
 * live_unpublish 요청 후 서버에서 받은 데이터 처리
 * 
 * @param {JSON} rtnValue - 서버에서 받은 JSON 데이터 객체
 */
export const unpublishAfter = async (rtnValue) => {
    const { mediaKind } = rtnValue;
    console.log(`unpublishAfter - mediaKind[${mediaKind}]`);

    // 안드로이드 웹뷰 별도 처리 추가 ... by hjkim 20260211
    if (isAndroidWebView()) {
        console.log("unpublishAfter - clientInfo.sendTransport => ", clientInfo.sendTransport);
        if (clientInfo.sendTransport === null) { // 스크린 공유 모드
            console.log("unpublishAfter - 안드로이드 Native WebView로 전달");
            // 260930 송출을 통째로 내렸다. 뒤늦은 보류 타이머가 포기·재생성을 돌려 송출을 되살리지 않게 멈춘다.
            // (네이티브의 closed 로도 멈추지만 그것이 오기 전에 타이머가 울릴 수 있다)
            if (mediaKind === "ALL" || mediaKind === "all") {
                retireAndroidSendIceRestart("unpublish ALL");
                sendRecreateWatch.cancel();   // 261002 송출을 내렸다. 다시 세우지 않는다.
            }
            window.callUnpublishAfter(mediaKind);
            return;
        }
    }

    // 261002 송출을 통째로 내렸다. 재생성 감시가 송출을 되살리지 않게 끈다.
    if (mediaKind === "ALL" || mediaKind === "all") {
        sendRecreateWatch.cancel();
    }

    if (mediaKind === "video" || (mediaKind === "ALL" || mediaKind === "all")) {
        notifyDisplayRotationSendStatus(0); // 20260910 화면 공유 종료 시 송신 상태 배지를 즉시 숨긴다.
        const wasCameraSource = clientInfo.produceInfo.videoSource === "camera";
        if (clientInfo.produceInfo.videoTrack !== null) {
            clientInfo.produceInfo.videoTrack.stop();
            clientInfo.produceInfo.videoTrack = null;
        }

        if (clientInfo.produceInfo.videoProducer !== null) {
            if (!clientInfo.produceInfo.videoProducer.closed) {
                clientInfo.produceInfo.videoProducer.close();
            }
            clientInfo.produceInfo.videoProducer = null;
        }

        // 20260731 카메라 Producer와 트랙 정리가 끝난 뒤 Android 상태를 대기로 전환한다.
        if (wasCameraSource) {
            clientInfo.produceInfo.videoSource = null;
            notifyCameraCaptureState({ source: "camera", state: "stopped" });
        }
    }

    if (mediaKind === "audio" || (mediaKind === "ALL" || mediaKind === "all")) {
        if (clientInfo.produceInfo.audioTrack !== null) {
            clientInfo.produceInfo.audioTrack.stop();
            clientInfo.produceInfo.audioTrack = null;
        }

        if (clientInfo.produceInfo.audioProducer !== null) {
            if (!clientInfo.produceInfo.audioProducer.closed) {
                relayLive.traceAudio(clientInfo.produceInfo.audioProducer, "unpublish-close", clientInfo.sendTransport); // 20261021 R-148 종료 원인
                clientInfo.produceInfo.audioProducer.close();
            }
            clientInfo.produceInfo.audioProducer = null;
        }

        await clearAudioInput();
    }

    if (clientInfo.produceInfo.audioProducer === null && clientInfo.produceInfo.videoProducer === null) {
        if (clientInfo.sendTransport !== undefined && clientInfo.sendTransport !== null) {
            if (!clientInfo.sendTransport.closed) {
                clientInfo.sendTransport.close();
            }
            clientInfo.sendTransport = null;
        }
    }

    if (mediaKind === "ALL" || mediaKind === "all") {
        await clearVideoInput();
    }

    console.log("unpublishAfter -----------");
    console.log("clientInfo", clientInfo.produceInfo, clientInfo.sendTransport);

    console.log(`unpublishAfter - isAndroidWebView() => , ${isAndroidWebView()}, isIOSWebView() => ${isIOSWebView()}`);

    if (isAndroidWebView() || isIOSWebView()) {
        if (clientInfo.sendTransport === null && window.isNeedCallOnScreen) {
            if (isAndroidWebView()) {
                console.log("call checkAndroidPenCamService... window.isHandsUpInit => ", window.isHandsUpInit);
                checkAndroidPenCamService(window.isHandsUpInit);
            } else if (isIOSWebView()) {
                console.log("call sendAppCreateProducerTransport... window.isHandsUpInit => ", window.isHandsUpInit);
                sendAppCreateProducerTransport();
                sendChangeViewKindToApp(); // create 다 된 다음에 이미지 바뀌는지 확인해보기
            }
        }
    }
}
/********************************/

/********************************/
// 선생님 스트림 관련 메서드
/********************************/

/**
 * 듣고 있는 선생님 비디오 스트림을 반환합니다.
 * 
 * @returns {MediaStream | null} - 선생님 비디오 스트림
 * @since 2025-07-11.
 */
export const getTeacherVideoStream = () => {
    return clientInfo.consumeInfo.videoStream;
}

/**
 * 듣고 있는 선생님 오디오 스트림을 반환합니다.
 * 
 * @returns {MediaStream | null} - 선생님 오디오 스트림
 * @since 2025-07-11.
 */
export const getTeacherAudioStream = () => {
    return clientInfo.consumeInfo.audioStream;
}

/**
 * 듣고 있는 선생님 마이크 스트림을 반환합니다.
 * 
 * @returns {MediaStream | null} - 선생님 마이크 스트림
 * @since 2025-07-11.
 */
export const getTeacherMicStream = () => {
    return clientInfo.consumeInfo.micStream;
}
/********************************/

/********************************/
// 오디오 볼륨 조절 관련 메서드
/********************************/

/**
 * 학생이 마이크로 말하는 경우 시스템 스피커 볼륨을 조절.
 * 
 * @param {Number} volume - HTML 오디오 요소 객체 볼륨 크기
 */
export const controlSpeakerVolume = async (volume) => {
    return new Promise(async (resolve, reject) => {
        try {
            if (typeof volume === "number") {
                if (clientInfo.consumeInfo.audioEl) {
                    console.log(`bofore - clientInfo.consumeInfo.audioEl.volume[${clientInfo.consumeInfo.audioEl.volume}]`);
                    clientInfo.consumeInfo.audioEl.volume = volume;

                    if (isIOSWebView()) { // ios 는 volume = N 이 동작하지 않아서 track 활성화로 처리 .... by ykhan 251013
                        const stream = clientInfo.consumeInfo.audioEl.srcObject;
                        stream.getAudioTracks().forEach(track => {
                            track.enabled = true;
                        });
                    }
                    console.log(`after - clientInfo.consumeInfo.audioEl.volume[${clientInfo.consumeInfo.audioEl.volume}]`);
                }

                if (clientInfo.consumeInfo.micEl) {
                    console.log(`bofore - clientInfo.consumeInfo.micEl.volume[${clientInfo.consumeInfo.micEl.volume}]`);
                    clientInfo.consumeInfo.micEl.volume = volume;

                    if (isIOSWebView()) { // ios 는 volume = N 이 동작하지 않아서 track 활성화로 처리 .... by ykhan 251013
                        const stream = clientInfo.consumeInfo.micEl.srcObject;
                        stream.getAudioTracks().forEach(track => {
                            track.enabled = true;
                        });
                    }
                    console.log(`after - clientInfo.consumeInfo.micEl.volume[${clientInfo.consumeInfo.micEl.volume}]`);
                }
            }
        } catch (err) {
            console.log("controlSpeakerVolume() - err => ", err);
            resolve(false);
        }
    });
}

/**
 * HTML 오디오 요소의 소리를 설정합니다.
 * 
 * @param {Number} volume - HTML 오디오 요소 객체 볼륨 크기
 */
export const setVolume = async (volume) => {
    return new Promise(async (resolve, reject) => {
        try {
            console.log("setVolume - newVolume[", volume, "], savedVolume[", clientInfo.consumeInfo.savedVolume, "]");
            clientInfo.consumeInfo.savedVolume = volume;

            if (clientInfo.consumeInfo.audioStream !== null) {
                console.log("setVolume - set the value consumeInfo.audioEl.volume = volume. volume => ", volume);
                clientInfo.consumeInfo.audioEl.volume = volume;
                console.log("setVolume - clientInfo.consumeInfo.audioEl.volume 설정 완료");

                if (isIOSWebView()) { // ios 는 volume = N 이 동작하지 않아서 track 비활성화/활성화로 처리 .... by ykhan 251013
                    const stream = clientInfo.consumeInfo.audioEl.srcObject;
                    stream.getAudioTracks().forEach(track => {
                        if (volume === 0) {
                            track.enabled = false;
                            console.log("setVolume - clientInfo.consumeInfo.audioEl.srcObject의 track.enabled = false 설정 완료");
                        } else {
                            track.enabled = true;
                            console.log("setVolume - clientInfo.consumeInfo.audioEl.srcObject의 track.enabled = true 설정 완료");
                        }
                    });
                }
            }

            if (clientInfo.consumeInfo.micStream !== null) {
                console.log("setVolume - set the value consumeInfo.micEl.volume = volume. volume => ", volume);
                clientInfo.consumeInfo.micEl.volume = volume;
                console.log("setVolume - clientInfo.consumeInfo.micEl.volume 설정 완료");

                if (isIOSWebView()) { // ios 는 volume = N 이 동작하지 않아서 track 비활성화/활성화로 처리 .... by ykhan 251013
                    const stream = clientInfo.consumeInfo.micEl.srcObject;
                    stream.getAudioTracks().forEach(track => {
                        if (volume === 0) {
                            track.enabled = false;
                            console.log("setVolume - clientInfo.consumeInfo.micEl.srcObject의 track.enabled = false 설정 완료");
                        } else {
                            track.enabled = true;
                            console.log("setVolume - clientInfo.consumeInfo.micEl.srcObject의 track.enabled = true 설정 완료");
                        }
                    });
                }
            }

            clientInfo.handsupInfo.list_consumeInfo.forEach(info => {
                if (info.audioStream !== null) {
                    // 20260929 PBL 오디오 수정: 학생 소리듣기 버튼으로 볼륨을 올려도 선생님의 OFF 설정을 지킨다.
                    applyPblStudentAudioListenToElement(info.audioEl);
                    console.log("setVolume - set the value consumeInfo.audioEl.volume = volume. volume => ", volume);
                    info.audioEl.volume = volume;
                    console.log("setVolume - consumeInfo.audioEl.volume 설정 완료");

                    if (isIOSWebView()) { // ios 는 volume = N 이 동작하지 않아서 track 비활성화/활성화로 처리 .... by ykhan 251013
                        const stream = info.audioEl.srcObject;
                        stream.getAudioTracks().forEach(track => {
                            if (volume === 0) {
                                track.enabled = false;
                                console.log("setVolume - p2pInfo.audioEl.srcObject의 track.enabled = false 설정 완료");
                            } else {
                                track.enabled = true;
                                console.log("setVolume - p2pInfo.audioEl.srcObject의 track.enabled = true 설정 완료");
                            }
                        });
                    }
                }
            });

            clientInfo.handsupInfo.list_p2pConsumeInfo.forEach(info => {
                if (info.audioStream !== null) {
                    applyPblStudentAudioListenToElement(info.audioEl);
                    console.log("setVolume - set the value p2pInfo.audioEl.volume = volume. volume => ", volume);
                    info.audioEl.volume = volume;
                    console.log("setVolume - p2pInfo.audioEl.volume 설정 완료");

                    if (isIOSWebView()) { // ios 는 volume = N 이 동작하지 않아서 track 비활성화/활성화로 처리 .... by ykhan 251013
                        const stream = info.audioEl.srcObject;
                        stream.getAudioTracks().forEach(track => {
                            if (volume === 0) {
                                track.enabled = false;
                                console.log("setVolume - p2pInfo.audioEl.srcObject의 track.enabled = false 설정 완료");
                            } else {
                                track.enabled = true;
                                console.log("setVolume - p2pInfo.audioEl.srcObject의 track.enabled = true 설정 완료");
                            }
                        });
                    }
                }
            });

            resolve(true);
        } catch (err) {
            console.log("setVolume() - err => ", err);
            resolve(false);
        }
    });
}
/********************************/

/********************************/
// 관리자 관련 메서드
/********************************/

/**  MEDIA SOUP FOR ADMIN */
/**
 * 미디어 서버에 현재 서버의 상태값 요청
 * 
 * @param {String} routingKey - 미디어 서버 라우팅 키
 */
export const sendGetState = async (routingKey) => {
    console.log(`sendGetState - clientInfo - userSeq[${clientInfo.userSeq}], liveSeq[${clientInfo.liveSeq}], rcvTeacherSeq[${clientInfo.rcvTeacherSeq}], routingKey[${clientInfo.routingKey}]`);
    const data = {
        kind            : "mediaSoup",
        action          : "getState",
        sendRotingKey   : clientInfo.routingKey
    };

    sendCommandToRbmq(routingKey, data);
}

/**
 * getState 요청 후 서버에서 받은 데이터 처리
 * 
 * @param {JSON} rtnValue - 서버에서 받은 JSON 데이터 객체
 */
export const getStateAfter = (rtnValue) => {
    const { roomInfo, liveInfo } = rtnValue;

    let store = window.hiclasstv.store;
    store.dispatch(mqRcvMediaInfo({ roomInfo, liveInfo }));
}

/********************************/

/********************************/
// 디버그 관련 메서드
/********************************/
/**
 * 크롬 개발자 도구 콘솔에서 현재 미디어 consume 상태를 확인하기 위한 디버그 유틸리티
 * 
 * 사용법 (콘솔에서 직접 호출):
 *   window.__mediaSoupDebug.printAll()        - 전체 상태 출력
 *   window.__mediaSoupDebug.printLive()       - live consume 상태만 출력
 *   window.__mediaSoupDebug.printHandsUp()    - handsup consume 상태만 출력
 *   window.__mediaSoupDebug.printList()       - list_consumeInfo / list_p2pConsumeInfo 출력
 */
const registerMediaSoupDebug = () => {

    // ── Consumer 상태 요약 헬퍼 ─────────────────────────────────────────
    const summarizeConsumer = (consumer, label) => {
        if (!consumer) return `${label}: null`;
        return `${label}: { paused: ${consumer.paused}, producerPaused: ${consumer.producerPaused}, closed: ${consumer.closed}, kind: ${consumer.kind}, id: ${consumer.id} }`;
    };

    // ── MediaStream 상태 요약 헬퍼 ──────────────────────────────────────
    const summarizeStream = (stream, label) => {
        if (!stream) return `${label}: null`;
        const tracks = stream.getAudioTracks().concat(stream.getVideoTracks());
        const trackInfo = tracks.map(t => `{ kind: ${t.kind}, enabled: ${t.enabled}, readyState: ${t.readyState} }`).join(", ");
        return `${label}: { id: ${stream.id}, tracks: [${trackInfo}] }`;
    };

    // ── HTMLMediaElement 상태 요약 헬퍼 ────────────────────────────────
    const summarizeEl = (el, label) => {
        if (!el) return `${label}: null`;
        return `${label}: { id: ${el.id || "(no id)"}, paused: ${el.paused}, volume: ${el.volume}, srcObject: ${el.srcObject ? "set" : "null"}, readyState: ${el.readyState} }`;
    };

    // ── live consumeInfo 출력 ────────────────────────────────────────────
    const printLive = () => {
        const c = clientInfo.consumeInfo;
        console.group("📡 [Live] consumeInfo");

        console.log("─ 기본 상태");
        console.log(`  isSelectedMode   : ${c.isSelectedMode}`);
        console.log(`  isAudioStop      : ${c.isAudioStop}`);
        console.log(`  savedVolume      : ${c.savedVolume}`);

        console.log("─ Receiveable / Received");
        console.log(`  video  : receiveable=${c.isVideoReceiveable}, received=${c.isVideoReceived}`);
        console.log(`  audio  : receiveable=${c.isAudioReceiveable}, received=${c.isAudioReceived}`);
        console.log(`  mic    : receiveable=${c.isMicReceiveable},   received=${c.isMicReceived}`);

        console.log("─ Consumer");
        console.log(" ", summarizeConsumer(c.videoConsumer, "videoConsumer"));
        console.log(" ", summarizeConsumer(c.audioConsumer, "audioConsumer"));
        console.log(" ", summarizeConsumer(c.micConsumer,   "micConsumer"));

        console.log("─ Stream");
        console.log(" ", summarizeStream(c.videoStream, "videoStream"));
        console.log(" ", summarizeStream(c.audioStream, "audioStream"));
        console.log(" ", summarizeStream(c.micStream,   "micStream"));

        console.log("─ Element");
        console.log(" ", summarizeEl(c.videoEl, "videoEl"));
        console.log(" ", summarizeEl(c.audioEl, "audioEl"));
        console.log(" ", summarizeEl(c.micEl,   "micEl"));

        console.groupEnd();
    };

    // ── handsup list_consumeInfo / list_p2pConsumeInfo 출력 ──────────────
    const printHandsUpList = (list, listName) => {
        if (!list || list.length === 0) {
            console.log(`  ${listName}: (비어있음)`);
            return;
        }
        list.forEach((info, idx) => {
            console.group(`  [${idx}] rcvSeq: ${info.rcvSeq} | mediaKind: ${info.mediaKind}`);
            console.log(`    isMixedClassMember : ${info.isMixedClassMember}`);
            console.log(`    isMuteAudio        : ${info.isMuteAudio}`);
            console.log(`    isP2PMode          : ${info.isP2PMode}`);
            console.log(`    video : receiveable=${info.isVideoReceiveable}, received=${info.isVideoReceived}`);
            console.log(`    audio : receiveable=${info.isAudioReceiveable}, received=${info.isAudioReceived}`);
            console.log("   ", summarizeConsumer(info.videoConsumer, "videoConsumer"));
            console.log("   ", summarizeConsumer(info.audioConsumer, "audioConsumer"));
            console.log("   ", summarizeStream(info.videoStream, "videoStream"));
            console.log("   ", summarizeStream(info.audioStream, "audioStream"));
            console.log("   ", summarizeEl(info.videoEl, "videoEl"));
            console.log("   ", summarizeEl(info.audioEl, "audioEl"));
            console.groupEnd();
        });
    };

    const printHandsUp = () => {
        console.group("🙋 [HandsUp] handsupInfo");

        console.group("list_consumeInfo");
        printHandsUpList(clientInfo.handsupInfo.list_consumeInfo, "list_consumeInfo");
        console.groupEnd();

        console.group("list_p2pConsumeInfo");
        printHandsUpList(clientInfo.handsupInfo.list_p2pConsumeInfo, "list_p2pConsumeInfo");
        console.groupEnd();

        console.groupEnd();
    };

    // ── 전체 출력 ────────────────────────────────────────────────────────
    const printAll = () => {
        console.group("🔍 MediaSoup Debug Snapshot");
        console.log(`  rcvTeacherSeq : ${clientInfo.rcvTeacherSeq}`);
        console.log(`  userSeq       : ${clientInfo.userSeq}`);
        console.log(`  liveSeq       : ${clientInfo.liveSeq}`);
        printLive();
        printHandsUp();
        console.groupEnd();
    };

    // ── window에 등록 ────────────────────────────────────────────────────
    window.__mediaSoupDebug = {
        printAll,
        printLive,
        printHandsUp,
        printList: printHandsUp,  // 편의용 alias
    };

    console.log("[MediaSoupDebug] 등록 완료. 콘솔에서 window.__mediaSoupDebug.printAll() 로 확인하세요.");
};
